class GenericElementUtils {
  static hideElements(...D) {
    D.forEach((O) => O.style.display = "none");
  }
  static getStyleWidth(D, O) {
    return Number.parseFloat(D.style[O]) || 0;
  }
  static doesElementExistInDom(D) {
    return !!D.parentElement;
  }
  static isFirstChildInParent(D) {
    var O;
    return ((O = D.parentElement) == null ? void 0 : O.firstChild) === D;
  }
}
GenericElementUtils.NOT_SELECTABLE_CLASS = "not-selectable";
class SVGIconUtils {
  // REF-10
  static createSVGElement(D) {
    return new DOMParser().parseFromString(D, "image/svg+xml").documentElement;
  }
}
SVGIconUtils.WHITE_FILTER = `brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(3877%)
    hue-rotate(184deg) brightness(103%) contrast(100%)`;
SVGIconUtils.LIGHT_GREY_FILTER = `brightness(0) saturate(100%) invert(68%) sepia(0%) saturate(317%)
    hue-rotate(84deg) brightness(92%) contrast(93%)`;
SVGIconUtils.HEADER_FILTER = `brightness(0) saturate(100%) invert(34%) sepia(0%) saturate(1075%)
    hue-rotate(211deg) brightness(96%) contrast(90%)`;
SVGIconUtils.DROPDOWN_ITEM_FILTER = `brightness(0) saturate(100%) invert(7%) sepia(23%) saturate(258%)
    hue-rotate(63deg) brightness(99%) contrast(97%)`;
class StaticDropdown {
}
StaticDropdown.DROPDOWN_CLASS = "static-dropdown";
StaticDropdown.ITEM_CLASS = "static-dropdown-item";
StaticDropdown.ACTIVE_ITEM_CLASS = "active-static-dropdown-item";
const _DropdownItemHighlightUtils = class it {
  // Accepted behaviour - fadeFocused is triggered twice when moving to a different item
  static fadeCurrentlyHighlighted(D) {
    const O = D.dropdownItem;
    O && (O.classList.contains(StaticDropdown.ACTIVE_ITEM_CLASS) && O.classList.remove(StaticDropdown.ACTIVE_ITEM_CLASS), O.style.backgroundColor = "", delete D.dropdownItem);
  }
  static highlightNew(D, O) {
    it.fadeCurrentlyHighlighted(D), O.focus(), D.dropdownItem = O, O.classList.contains(StaticDropdown.ITEM_CLASS) ? O.classList.add(StaticDropdown.ACTIVE_ITEM_CLASS) : O.classList.contains(DropdownItem.DROPDOWN_INPUT_CLASS) || (O.style.backgroundColor = it.HOVER_BACKGROUND_COLOR);
  }
};
_DropdownItemHighlightUtils.HOVER_BACKGROUND_COLOR = "#eaeaea";
let DropdownItemHighlightUtils = _DropdownItemHighlightUtils;
class DropdownItemEvents {
  // prettier-ignore
  static addItemEvents(D, O) {
    O.addEventListener(
      "mouseenter",
      DropdownItemHighlightUtils.highlightNew.bind(this, D, O)
    ), O.addEventListener(
      "mouseleave",
      DropdownItemHighlightUtils.fadeCurrentlyHighlighted.bind(this, D)
    );
  }
}
const _DropdownItem = class ee {
  static toggleItem(D, O) {
    D.style.display = O ? ee.DISPLAY : ee.HIDDEN;
  }
  static isDisplayed(D) {
    return D.style.display === ee.DISPLAY;
  }
  static createDropdownItemBaseElement(D) {
    const O = document.createElement(D);
    return O.classList.add(ee.DROPDOWN_ITEM_IDENTIFIER), O;
  }
  static createItem(D) {
    const O = ee.createDropdownItemBaseElement("div");
    return D && (O.tabIndex = D.children.length), O.classList.add(ee.DROPDOWN_ITEM_CLASS, GenericElementUtils.NOT_SELECTABLE_CLASS), O;
  }
  // no need to sanitize paste as input element already does it
  static addInputItem(D, O) {
    const x = ee.createItem(O);
    x.classList.add(ee.DROPDOWN_INPUT_ITEM_CLASS);
    const B = ee.createDropdownItemBaseElement("input");
    B.classList.add(ee.DROPDOWN_INPUT_CLASS), x.appendChild(B), O.appendChild(x), DropdownItemEvents.addItemEvents(D._activeOverlayElements, B);
  }
  // REF-10
  static insertIcon(D, O) {
    const { svgString: x, containerStyles: B } = O, U = document.createElement("div");
    U.classList.add(ee.DROPDOWN_ITEM_ICON_CONTAINER_CLASS), Object.assign(U.style, B == null ? void 0 : B.dropdown);
    const F = SVGIconUtils.createSVGElement(x);
    F.style.filter = SVGIconUtils.DROPDOWN_ITEM_FILTER, U.appendChild(F), D.insertBefore(U, D.children[0]);
  }
  static addPlaneButtonItem(D, O, x) {
    const B = ee.createItem(D), U = ee.createDropdownItemBaseElement("div");
    return U.innerText = O || ee.DROPDOWN_ITEM_EMPTY_PLACEHOLDER_TEXT, O.trim() === "" && U.classList.add(ee.DROPDOWN_ITEM_EMPTY_CLASS), B.append(U), D && (x !== void 0 && D.children[x] ? D.insertBefore(B, D.children[x]) : D.appendChild(B)), B;
  }
  // prettier-ignore
  static createButtonItemNoEvents(D, O, ...x) {
    const B = ee.addPlaneButtonItem(D, O.text);
    return O.iconSettings && ee.insertIcon(B, O.iconSettings), x.length > 0 && B.classList.add(...x), B;
  }
  static addTitle(D, O) {
    const x = ee.createDropdownItemBaseElement("div");
    x.classList.add(ee.DROPDOWN_ITEM_CLASS, ee.DROPDOWN_TITLE_ITEM_CLASS), x.innerText = O, D.appendChild(x);
  }
  static addDivider(D) {
    const O = ee.createDropdownItemBaseElement("div");
    O.classList.add(ee.DROPDOWN_ITEM_DIVIDER_CLASS), D.appendChild(O);
  }
  // prettier-ignore
  static addButtonItem(D, O, x, ...B) {
    const U = ee.createButtonItemNoEvents(O, x, ...B);
    return DropdownItemEvents.addItemEvents(D._activeOverlayElements, U), U;
  }
  // prettier-ignore
  static addNewButtonItems(D, O, x) {
    return x.map((B) => ee.addButtonItem(D, O, B));
  }
  static addButtonItemElements(D, O, x) {
    x.forEach((B) => {
      B.tabIndex = O.children.length, O.appendChild(B), DropdownItemEvents.addItemEvents(D._activeOverlayElements, B);
    });
  }
  static removeItems(D) {
    Array.from(D.children).forEach((O) => O.remove());
  }
  static doesElementContainItemClass(D) {
    return D.classList.contains(ee.DROPDOWN_ITEM_IDENTIFIER);
  }
  static doesElementContainInputClass(D) {
    return D.classList.contains(ee.DROPDOWN_INPUT_CLASS);
  }
  static getInputElement(D) {
    return D.getElementsByClassName(ee.DROPDOWN_INPUT_ITEM_CLASS)[0];
  }
  static toggleUsability(D, O) {
    const x = D.children[0];
    O ? (D.classList.remove(ee.DISABLED_ITEM_CLASS), x.style.filter = "") : (D.classList.add(ee.DISABLED_ITEM_CLASS), x.style.filter = SVGIconUtils.LIGHT_GREY_FILTER);
  }
};
_DropdownItem.DROPDOWN_ITEM_CLASS = "dropdown-item";
_DropdownItem.DISABLED_ITEM_CLASS = "dropdown-disabled-item";
_DropdownItem.ACTIVE_ITEM_CLASS = "active-dropdown-item";
_DropdownItem.DROPDOWN_INPUT_CLASS = "dropdown-input";
_DropdownItem.DROPDOWN_ITEM_ICON_CONTAINER_CLASS = "dropdown-item-icon-container";
_DropdownItem.DROPDOWN_INPUT_ITEM_CLASS = "dropdown-input-item";
_DropdownItem.DROPDOWN_TITLE_ITEM_CLASS = "dropdown-title-item";
_DropdownItem.DROPDOWN_ITEM_DIVIDER_CLASS = "dropdown-item-divider";
_DropdownItem.DROPDOWN_ITEM_EMPTY_CLASS = "dropdown-item-empty";
_DropdownItem.DROPDOWN_ITEM_EMPTY_PLACEHOLDER_TEXT = "...";
_DropdownItem.DROPDOWN_ITEM_IDENTIFIER = "dropdown-item-identifier";
_DropdownItem.HIDDEN = "none";
_DropdownItem.DISPLAY = "";
let DropdownItem = _DropdownItem;
class OuterDropdownItem {
  static unsetHoverColors(D) {
    D.forEach((O) => O.style.backgroundColor = "");
  }
  static unsetActiveItem(D) {
    const O = D.getElementsByClassName(DropdownItem.ACTIVE_ITEM_CLASS)[0];
    O == null || O.classList.remove(DropdownItem.ACTIVE_ITEM_CLASS);
  }
  static setActive(D, O) {
    const x = D.find((B) => B.innerText === O);
    x == null || x.classList.add(DropdownItem.ACTIVE_ITEM_CLASS);
  }
  static setActiveByIndex(D, O) {
    D[O].classList.add(DropdownItem.ACTIVE_ITEM_CLASS);
  }
}
class ElementStyle {
  static setStyle(D, O, x) {
    D.style[O] = x;
  }
  // prettier-ignore
  static moveStyles(D, O, ...x) {
    x.forEach((B) => {
      D.style[B] && ElementStyle.setStyle(O, B, D.style[B]);
    });
  }
  static unsetStyle(D, O) {
    const x = Object.keys(O).reduce((B, U) => (B[U] = "", B), {});
    Object.assign(D.style, x);
  }
  static unsetAllCSSStates(D, O) {
    O.click && ElementStyle.unsetStyle(D, O.click), O.hover && ElementStyle.unsetStyle(D, O.hover), O.default && ElementStyle.unsetStyle(D, O.default);
  }
  static generateStatefulCSS(D, O, x) {
    const B = D.default || {}, U = Object.assign(JSON.parse(JSON.stringify({ ...B, ...O })), D == null ? void 0 : D.hover), F = Object.assign(JSON.parse(JSON.stringify({ ...U, ...x })), D == null ? void 0 : D.click);
    return { default: B, hover: U, click: F };
  }
}
const _ToggleableElement = class Te {
  static set(D, O) {
    D.classList.add(Te.ACTIVE_BUTTON_CLASS), Object.assign(D.style, O);
  }
  static unset(D, O) {
    D.classList.remove(Te.ACTIVE_BUTTON_CLASS), ElementStyle.unsetStyle(D, O);
  }
  static toggleActive(D, O) {
    const x = !!D.classList.contains(Te.ACTIVE_BUTTON_CLASS);
    return x ? (Te.unset(D, O), D.dispatchEvent(new MouseEvent("mouseenter"))) : Te.set(D, O), x;
  }
  static unsetActive(D, O) {
    !!D.classList.contains(Te.ACTIVE_BUTTON_CLASS) && (Te.unset(D, O), D.dispatchEvent(new MouseEvent("mouseleave")));
  }
  static setActive(D, O) {
    !!D.classList.contains(Te.ACTIVE_BUTTON_CLASS) || Te.set(D, O);
  }
};
_ToggleableElement.ACTIVE_BUTTON_CLASS = "toggleable-button-active";
_ToggleableElement.AUTO_STYLING_CLASS = "toggleable-button-auto-styling";
let ToggleableElement = _ToggleableElement;
const _Dropdown = class ve {
  static createBase() {
    const D = document.createElement("div");
    return D.classList.add(ve.DROPDOWN_CLASS), D.style.width = `${ve.DROPDOWN_WIDTH}px`, D.style.paddingTop = ve.DROPDOWN_VERTICAL_PX, D.style.paddingBottom = ve.DROPDOWN_VERTICAL_PX, ve.hide(D), D;
  }
  static isDisplayed(D) {
    return (D == null ? void 0 : D.style.display) === ve.CSS_DISPLAY_VISIBLE;
  }
  static display(...D) {
    D.forEach((O) => {
      O.style.display = ve.CSS_DISPLAY_VISIBLE;
    });
  }
  static hide(...D) {
    GenericElementUtils.hideElements(...D);
  }
  static isPartOfDropdownElement(D) {
    return D.classList.contains(ve.DROPDOWN_CLASS) || DropdownItem.doesElementContainItemClass(D);
  }
};
_Dropdown.DROPDOWN_CLASS = "active-table-dropdown";
_Dropdown.CSS_DISPLAY_VISIBLE = "grid";
_Dropdown.DROPDOWN_WIDTH = 176;
_Dropdown.DROPDOWN_VERTICAL_PX = "4px";
let Dropdown = _Dropdown;
const _OuterDropdownButtonEvents = class xe {
  static mouseClickButton(D, O, x) {
    const { element: B } = O;
    B.classList.contains(xe.DO_NOT_DISPLAY_DROPDOWN_CLASS) ? B.classList.remove(xe.DO_NOT_DISPLAY_DROPDOWN_CLASS) : x(D, O);
  }
  static mouseDownButton(D) {
    const { element: O, button: x, activeButtonStyle: B } = D;
    Dropdown.isDisplayed(O) && (O.classList.add(xe.DO_NOT_DISPLAY_DROPDOWN_CLASS), ToggleableElement.unsetActive(x, B));
  }
  static getDisplayFunc(D) {
    return D.startsWith("top") ? OuterDropdownElement.display : OuterDropdownElement.displayReactToBottomVisibility;
  }
  // prettier-ignore
  static set(D, O, x, B, U) {
    const F = U || xe.getDisplayFunc(x);
    O.addEventListener("mousedown", xe.mouseDownButton.bind(this, B)), O.addEventListener(
      "click",
      xe.mouseClickButton.bind(this, D, B, F)
    );
  }
};
_OuterDropdownButtonEvents.DO_NOT_DISPLAY_DROPDOWN_CLASS = "do-not-display-class";
let OuterDropdownButtonEvents = _OuterDropdownButtonEvents;
const VH = "vh", VW = "vw";
class LITElementTypeConverters {
  static convertToBoolean(z) {
    return typeof z == "string" ? z === "true" : !!z;
  }
  static convertToFunction(value) {
    if (typeof value == "function")
      return value;
    if (typeof value == "string") {
      const evaluatedExpression = eval(value);
      if (typeof evaluatedExpression == "function")
        return evaluatedExpression;
    }
    return () => {
    };
  }
}
class ObjectUtils {
  static createTwoWayObject(D) {
    return Object.keys(D).forEach((O) => {
      D[D[O]] = O;
    }), D;
  }
  static convertStringToFunction(D, O) {
    typeof D[O] == "string" && (D[O] = LITElementTypeConverters.convertToFunction(
      D[O]
    ));
  }
  // method to check if value is not nullish
  static areValuesFullyDefined(...D) {
    return D.findIndex((x) => x == null) === -1;
  }
  static removeProperties(D, ...O) {
    O.forEach((x) => {
      delete D[x];
    });
  }
}
class RegexUtils {
  static extractIntegerStrs(D) {
    return D.match(/\d+/g);
  }
  static extractFloatStrs(D) {
    return D.match(/-?\d+(\.\d+)?$/g);
  }
}
class StringDimensionUtils {
  static processDimension(D, O) {
    return D < O ? O : D;
  }
  // prettier-ignore
  static processPercentageDimension(D, O, x, B) {
    O > 100 && (O = 100);
    const F = (x ? D.getBoundingClientRect().width : D.offsetHeight) * (O / 100);
    return { number: StringDimensionUtils.processDimension(F, B), isPercentage: !0 };
  }
  // can also parse numbers incase the client used that
  // if this returns a number 0 for a %, the likelyhood is that the parent element does not have that dimension set
  // prettier-ignore
  static generateNumberDimensionFromClientString(D, O, x, B, U = 0) {
    const F = O[x], W = typeof F == "string";
    let G = W ? Number(RegexUtils.extractIntegerStrs(F)[0]) : F;
    if (W) {
      if (F.includes("%"))
        return StringDimensionUtils.processPercentageDimension(D, G, B, U);
      F.includes(VH) ? G = window.innerHeight * (G / 100) : F.includes(VW) && (G = window.innerWidth * (G / 100));
    }
    return { number: StringDimensionUtils.processDimension(G, U), isPercentage: !1 };
  }
  static removeAllDimensions(D) {
    if (D)
      return ObjectUtils.removeProperties(D, "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight"), D;
  }
}
class PageButtonStyle {
  // prettier-ignore
  static unsetAllCSSStates(D, O, x) {
    ElementStyle.unsetAllCSSStates(D, O[x]);
  }
  static unsetAll(D, O, x) {
    D.classList.contains(O.activeButtonClass) ? PageButtonStyle.unsetAllCSSStates(D, O, "activeButton") : D.classList.contains(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS) ? ElementStyle.unsetStyle(D, O.disabledButtons) : PageButtonStyle.unsetAllCSSStates(D, O, x ? "actionButtons" : "buttons");
  }
  static setDefault(D, O, x) {
    PageButtonStyle.unsetAll(D, O, x), x ? Object.assign(D.style, O.actionButtons.default) : Object.assign(D.style, O.buttons.default);
  }
  // prettier-ignore
  static setActive(D, O, x) {
    x && (PageButtonStyle.unsetAllCSSStates(x, O, "activeButton"), Object.assign(x.style, O.buttons.default)), D.classList.contains(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS) ? ElementStyle.unsetStyle(D, O.disabledButtons) : PageButtonStyle.unsetAllCSSStates(D, O, "buttons"), Object.assign(D.style, O.activeButton.default);
  }
  static setDisabled(D, O, x) {
    PageButtonStyle.setDefault(D, O, x), Object.assign(D.style, O.disabledButtons);
  }
  static mouseDown(D, O, x) {
    D.classList.contains(O.activeButtonClass) ? Object.assign(D.style, O.activeButton.click) : x ? Object.assign(D.style, O.actionButtons.click) : Object.assign(D.style, O.buttons.click), PaginationVisibleButtonsUtils.overrideOnMouseEvent(D, O);
  }
  static mouseEnter(D, O, x) {
    D.classList.contains(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS) || (D.classList.contains(O.activeButtonClass) ? (PageButtonStyle.unsetAllCSSStates(D, O, "activeButton"), Object.assign(D.style, O.activeButton.default), Object.assign(D.style, O.activeButton.hover)) : (PageButtonStyle.setDefault(D, O, x), x ? Object.assign(D.style, O.actionButtons.hover) : Object.assign(D.style, O.buttons.hover)), PaginationVisibleButtonsUtils.overrideOnMouseEvent(D, O));
  }
  static mouseLeave(D, O, x) {
    D.classList.contains(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS) || (D.classList.contains(O.activeButtonClass) ? (PageButtonStyle.unsetAll(D, O, !1), Object.assign(D.style, O.activeButton.default)) : PageButtonStyle.setDefault(D, O, x), PaginationVisibleButtonsUtils.overrideOnMouseEvent(D, O));
  }
}
const _FilterInputElement = class Pe {
  static setPlaceholder(D, O, x) {
    if (O && O !== "") {
      const B = x || Pe.DEFAULT_PLACEHOLDER_TEMPLATE;
      D.placeholder = B.replace(Pe.TEMPLATE_VARIABLE, O);
    } else
      D.placeholder = Pe.DEFAULT_PLACEHOLDER;
  }
  static createElement(D, O, x) {
    const B = document.createElement("input");
    B.classList.add(Pe.INPUT_CLASS);
    const U = (x == null ? void 0 : x.placeholderColor) || "#656565";
    return B.style.setProperty("--active-table-filter-placeholder-color", U), Object.assign(B.style, x == null ? void 0 : x.input), Pe.setPlaceholder(B, D, O), B;
  }
  static create(D, O, x) {
    const B = FilterInternalUtils.generateDefaultHeaderName(x, D.defaultColumnHeaderName), U = Pe.createElement(B, D.placeholderTemplate, O.styles);
    return D.inputElement = U, U;
  }
};
_FilterInputElement.INPUT_CLASS = "filter-rows-input";
_FilterInputElement.TEMPLATE_VARIABLE = "{headerName}";
_FilterInputElement.DEFAULT_PLACEHOLDER = "Filter";
_FilterInputElement.DEFAULT_PLACEHOLDER_TEMPLATE = `Filter ${_FilterInputElement.TEMPLATE_VARIABLE}...`;
let FilterInputElement = _FilterInputElement;
class FilterInputEvents {
  static unsetEvents(D) {
    D && D.forEach((O) => O.inputElement.oninput = () => {
    });
  }
  static updateSameInputValues(D, O) {
    D.forEach((x) => {
      x.elements === O.elements && (x.inputElement.value = O.inputElement.value);
    });
  }
  static getFilterData(D) {
    return D.map((O) => ({
      filterText: O.isCaseSensitive ? O.inputElement.value : O.inputElement.value.toLocaleLowerCase(),
      colCells: O.elements.slice(1),
      isCaseSensitive: O.isCaseSensitive
    }));
  }
  static splitChunksAndExecute(D, O) {
    const x = D.filter((U) => U.filterText !== "");
    x.length === 0 && x.push(D[0]);
    const B = Math.ceil(x[0].colCells.length / FilterInternalUtils.CHUNK_SIZE);
    for (let U = 0; U < B; U += 1) {
      const F = U * FilterInternalUtils.CHUNK_SIZE, W = x.map((G) => ({ ...G, chunk: G.colCells.slice(F, F + FilterInternalUtils.CHUNK_SIZE) }));
      O(W);
    }
  }
  static setEvents(D, O, x) {
    if (!O.elements)
      return;
    const B = FilterInternalUtils.getFilterFunc(D), U = x.filter((F) => F !== O);
    O.inputElement.oninput = () => {
      FilterInputEvents.updateSameInputValues(U, O), FilterInputEvents.splitChunksAndExecute(FilterInputEvents.getFilterData(x), B);
    };
  }
}
const ARROW_DOWN_SVG_STRING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g transform="translate(-288.000000, 0.000000)">
			<g transform="translate(288.000000, 0.000000)">
				<path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" fill-rule="nonzero"></path>
				<path d="M12.7071,15.7072 C12.3166,16.0977 11.6834,16.0977 11.2929,15.7072 L5.63604,10.0503 C5.24551,9.65982 5.24551,9.02666 5.63604,8.63613 C6.02656,8.24561 6.65973,8.24561 7.05025,8.63613 L12,13.5859 L16.9497,8.63613 C17.3403,8.24561 17.9734,8.24561 18.364,8.63613 C18.7545,9.02666 18.7545,9.65982 18.364,10.0503 L12.7071,15.7072 Z" fill="#09244B"></path>
			</g>
		</g>
	</g>
</svg>`, _FilterButtonElement = class mt {
  static create(D = {}) {
    const O = document.createElement("div");
    O.classList.add("filter-rows-dropdown-button", ToggleableElement.AUTO_STYLING_CLASS), FilterElements.applyStatefulStyles(O, mt.HOVER_STYLE, D);
    const x = SVGIconUtils.createSVGElement(ARROW_DOWN_SVG_STRING);
    return O.appendChild(x), O;
  }
};
_FilterButtonElement.ACTIVE_STYLE = {
  filter: (
    // eslint-disable-next-line max-len
    "brightness(0) saturate(100%) invert(14%) sepia(59%) saturate(2970%) hue-rotate(219deg) brightness(98%) contrast(126%)"
  )
};
_FilterButtonElement.HOVER_STYLE = {
  filter: (
    // eslint-disable-next-line max-len
    "brightness(0) saturate(100%) invert(31%) sepia(1%) saturate(75%) hue-rotate(327deg) brightness(100%) contrast(99%)"
  )
};
let FilterButtonElement = _FilterButtonElement;
class OuterDropdownItemEvents {
  // prettier-ignore
  static itemMouseDownCommon(D, O, x) {
    const { _activeOverlayElements: { outerContainerDropdown: B } } = this, U = x.target.innerText;
    if (!B)
      return;
    D == null || D(this, U, x);
    const F = Array.from(B.element.children);
    O == null || O(this._activeOverlayElements, F), B.element.classList.contains(StaticDropdown.DROPDOWN_CLASS) || (OuterDropdownItem.unsetActiveItem(B.element), OuterDropdownItem.setActive(F, U), DropdownItemHighlightUtils.fadeCurrentlyHighlighted(this._activeOverlayElements));
  }
}
class FilterDropdownItemEvents {
  static resetInput(D, O, x, B) {
    const U = B.target, F = U.tabIndex === -1 ? U.parentElement.tabIndex : U.tabIndex, W = O._columnsDetails[F].elements;
    W !== D.elements && (D.elements = W, FilterInternalUtils.resetInput(O, D), FilterInternalUtils.unsetFilter(D.inputElement));
  }
  static setEvents(D, O, x, B) {
    const U = FilterDropdownItemEvents.resetInput.bind(this, x), F = FilterDropdownElement.hide.bind(this, B);
    O.onmousedown = OuterDropdownItemEvents.itemMouseDownCommon.bind(D, U, F);
  }
}
class FilterDropdownItem {
  static setActive(D, O, x) {
    const B = D._columnsDetails.findIndex((U) => U.elements === x.elements);
    OuterDropdownItem.setActiveByIndex(Array.from(O.children), B);
  }
  static addItems(D, O, x) {
    var U;
    const B = (U = D.data[0]) == null ? void 0 : U.map((F) => String(F));
    B == null || B.forEach((F) => {
      const W = { text: F }, G = DropdownItem.addButtonItem(D, O.element, W);
      FilterDropdownItemEvents.setEvents(D, G, x, O.activeButtonStyle);
    });
  }
  static populate(D, O, x) {
    O.element.replaceChildren(), FilterDropdownItem.addItems(D, O, x), FilterDropdownItem.setActive(D, O.element, x);
  }
}
class FilterDropdownElement {
  static hide(D, O) {
    OuterDropdownElement.hide(O, D);
  }
  // prettier-ignore
  static display(D, O, x, B) {
    x.data[0] && (FilterDropdownItem.populate(x, B, O), D(x, B));
  }
  // prettier-ignore
  static create(D, O, x, B, U) {
    const F = FilterButtonElement.create(U);
    O.appendChild(F);
    const W = (U == null ? void 0 : U.active) || {}, G = { ...FilterButtonElement.ACTIVE_STYLE, ...W }, Y = FilterDropdownElement.hide.bind(this, G, D._activeOverlayElements), X = OuterDropdownButtonEvents.getDisplayFunc(x), J = FilterDropdownElement.display.bind(this, X, B), { element: Q } = OuterDropdownElement.create(
      D,
      F,
      x,
      G,
      ["filter-rows-dropdown"],
      Y,
      J
    );
    return Q;
  }
}
class StatefulCSSEvents {
  static apply(D, O, x) {
    ElementStyle.unsetAllCSSStates(x, D), Object.assign(x.style, O);
  }
  static mouseUp(D, O, x) {
    O && x.classList.contains(O) || (StatefulCSSEvents.apply(D, D.default, x), Object.assign(x.style, D.hover));
  }
  static mouseDown(D, O, x) {
    O && x.classList.contains(O) || Object.assign(x.style, D.click);
  }
  static mouseLeave(D, O, x) {
    O && x.classList.contains(O) || StatefulCSSEvents.apply(D, D.default, x);
  }
  static mouseEnter(D, O, x) {
    O && x.classList.contains(O) || Object.assign(x.style, D.hover);
  }
  // can change the styling on another element by using the otherElement argument
  static getEvents(D, O, x, B) {
    const U = B || D;
    return {
      mouseenter: StatefulCSSEvents.mouseEnter.bind(this, O, x, U),
      mouseleave: StatefulCSSEvents.mouseLeave.bind(this, O, x, U),
      mousedown: StatefulCSSEvents.mouseDown.bind(this, O, x, U),
      mouseup: StatefulCSSEvents.mouseUp.bind(this, O, x, U)
    };
  }
  static setEvents(D, O, x, B) {
    const U = StatefulCSSEvents.getEvents(D, O, x, B);
    return D.addEventListener("mouseenter", U.mouseenter), D.addEventListener("mouseleave", U.mouseleave), D.addEventListener("mousedown", U.mousedown), D.addEventListener("mouseup", U.mouseup), U;
  }
}
class FilterInputCaseEvents {
  static clickButton(D, O, x) {
    const B = x || {}, U = ToggleableElement.toggleActive(D, { color: "#000000", ...B });
    O.isCaseSensitive = !U, FilterInternalUtils.resetInput(this, O), O.inputElement.dispatchEvent(new Event("input"));
  }
  static setEvents(D, O, x, B) {
    O.onclick = FilterInputCaseEvents.clickButton.bind(D, O, x, B);
  }
}
class FilterInputCaseElement {
  static createButton(D = {}) {
    const O = document.createElement("div");
    return O.classList.add("filter-rows-case-button"), O.textContent = "Aa", FilterElements.applyStatefulStyles(O, { color: "#626262" }, D), O;
  }
  static create(D, O, x, B) {
    const U = FilterInputCaseElement.createButton(B == null ? void 0 : B.caseIcon);
    O.appendChild(U), setTimeout(() => {
      var F;
      return FilterInputCaseEvents.setEvents(D, U, x, (F = B == null ? void 0 : B.caseIcon) == null ? void 0 : F.active);
    });
  }
}
const _FilterElements = class He {
  static createContainerElement(D) {
    const O = document.createElement("div");
    return O.classList.add("filter-rows-container"), O.style.order = String(D || 0), O;
  }
  // the order at which the elements are added is very important - please check the css selectors
  // prettier-ignore
  static createComponent(D, O, x) {
    var G;
    const B = x.position || He.DEFAULT_INPUT_POSITION, U = He.createContainerElement(x.order), F = FilterInternalUtils.addConfig(D, x);
    if (x.dropdown !== !1) {
      const Y = FilterDropdownElement.create(
        D,
        U,
        B,
        F,
        (G = x.styles) == null ? void 0 : G.dropdownIcon
      );
      setTimeout(() => U.appendChild(Y));
    }
    x.caseButton !== !1 && FilterInputCaseElement.create(D, U, F, x.styles);
    const W = FilterInputElement.create(F, x, D.data);
    U.appendChild(W), OuterContainerElements.addToContainer(B, O, U);
  }
  static create(D, O) {
    typeof D.filter == "boolean" ? He.createComponent(D, O, {}) : Array.isArray(D.filter) ? D.filter.forEach((x) => {
      He.createComponent(D, O, x);
    }) : D.filter && He.createComponent(D, O, D.filter), setTimeout(() => FilterInternalUtils.resetAllInputs(D));
  }
  static applyStatefulStyles(D, O, x = {}) {
    const B = ElementStyle.generateStatefulCSS(x, O, { color: "#484848" });
    Object.assign(D.style, B.default), setTimeout(() => StatefulCSSEvents.setEvents(D, B, ToggleableElement.ACTIVE_BUTTON_CLASS));
  }
};
_FilterElements.DEFAULT_INPUT_POSITION = "top-right";
let FilterElements = _FilterElements;
const CALENDAR_ICON_SVG_STRING = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10px" viewBox="0 0 10 10" version="1.1">
  <g id="surface1">
    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 1.070312 9.285156 L 8.929688 9.285156 L 8.929688 3.570312 L 1.070312 3.570312 Z M 3.214844 2.5 L 3.214844 0.894531 C 3.214844 0.839844 3.199219 0.796875 3.164062 0.765625 C 3.128906 0.730469 3.085938 0.714844 3.035156 0.714844 L 2.679688 0.714844 C 2.625 0.714844 2.582031 0.730469 2.550781 0.765625 C 2.515625 0.796875 2.5 0.839844 2.5 0.894531 L 2.5 2.5 C 2.5 2.550781 2.515625 2.59375 2.550781 2.628906 C 2.582031 2.660156 2.625 2.679688 2.679688 2.679688 L 3.035156 2.679688 C 3.085938 2.679688 3.128906 2.660156 3.164062 2.628906 C 3.199219 2.59375 3.214844 2.550781 3.214844 2.5 Z M 7.5 2.5 L 7.5 0.894531 C 7.5 0.839844 7.484375 0.796875 7.449219 0.765625 C 7.417969 0.730469 7.375 0.714844 7.320312 0.714844 L 6.964844 0.714844 C 6.914062 0.714844 6.871094 0.730469 6.835938 0.765625 C 6.800781 0.796875 6.785156 0.839844 6.785156 0.894531 L 6.785156 2.5 C 6.785156 2.550781 6.800781 2.59375 6.835938 2.628906 C 6.871094 2.660156 6.914062 2.679688 6.964844 2.679688 L 7.320312 2.679688 C 7.375 2.679688 7.417969 2.660156 7.449219 2.628906 C 7.484375 2.59375 7.5 2.550781 7.5 2.5 Z M 9.644531 2.144531 L 9.644531 9.285156 C 9.644531 9.480469 9.570312 9.648438 9.429688 9.789062 C 9.289062 9.929688 9.121094 10 8.929688 10 L 1.070312 10 C 0.878906 10 0.710938 9.929688 0.570312 9.789062 C 0.429688 9.648438 0.355469 9.480469 0.355469 9.285156 L 0.355469 2.144531 C 0.355469 1.949219 0.429688 1.78125 0.570312 1.640625 C 0.710938 1.5 0.878906 1.429688 1.070312 1.429688 L 1.785156 1.429688 L 1.785156 0.894531 C 1.785156 0.648438 1.875 0.4375 2.046875 0.261719 C 2.222656 0.0859375 2.433594 0 2.679688 0 L 3.035156 0 C 3.28125 0 3.492188 0.0859375 3.667969 0.261719 C 3.839844 0.4375 3.929688 0.648438 3.929688 0.894531 L 3.929688 1.429688 L 6.070312 1.429688 L 6.070312 0.894531 C 6.070312 0.648438 6.160156 0.4375 6.332031 0.261719 C 6.507812 0.0859375 6.71875 0 6.964844 0 L 7.320312 0 C 7.566406 0 7.777344 0.0859375 7.953125 0.261719 C 8.125 0.4375 8.214844 0.648438 8.214844 0.894531 L 8.214844 1.429688 L 8.929688 1.429688 C 9.121094 1.429688 9.289062 1.5 9.429688 1.640625 C 9.570312 1.78125 9.644531 1.949219 9.644531 2.144531 Z M 9.644531 2.144531 "/>
  </g>
</svg>`, _DateCellCalendarIconElement = class je {
  // need a container as mousedown target kept being different parts of svg
  // hence svgIcon has no pointer events
  static createContainer() {
    const D = document.createElement("div");
    return D.classList.add(je.CALENDAR_ICON_CONTAINER_CLASS), D;
  }
  // REF-10
  static createSVGElement() {
    const D = SVGIconUtils.createSVGElement(CALENDAR_ICON_SVG_STRING);
    return D.style.pointerEvents = "none", D.style.height = "25px", D;
  }
  static createSVG() {
    const D = je.createSVGElement(), O = je.createContainer();
    return O.appendChild(D), O;
  }
  static get() {
    return je.CALENDAR_ICON_ELEMENT.cloneNode(!0);
  }
};
_DateCellCalendarIconElement.CALENDAR_ICON_CONTAINER_CLASS = "calender-icon-container";
_DateCellCalendarIconElement.CALENDAR_ICON_ELEMENT = _DateCellCalendarIconElement.createSVG();
let DateCellCalendarIconElement = _DateCellCalendarIconElement;
class ColumnDetailsUtils {
  static getColumnsByWidth(D) {
    var B;
    const O = [], x = [];
    for (let U = 0; U < D.length; U += 1) {
      const F = D[U];
      ((B = F.settings.widths) == null ? void 0 : B.staticWidth) !== void 0 ? x.push(F) : O.push(F);
    }
    return { dynamicWidth: O, staticWidth: x };
  }
  static aggregateItems(D) {
    return D.labelDetails ? Object.keys(D.itemsDetails).map((O) => ({ name: O, backgroundColor: D.itemsDetails[O].backgroundColor })) : Object.keys(D.itemsDetails).map((O) => ({ name: O }));
  }
  static getDetails(D) {
    const O = {
      width: D.elements[0].offsetWidth,
      typeName: D.activeType.name
    };
    return D.activeType.cellDropdownProps && (O.cellDropdownItems = ColumnDetailsUtils.aggregateItems(D.cellDropdown)), O;
  }
  static getAllColumnsDetails(D) {
    return D.map((O) => ColumnDetailsUtils.getDetails(O));
  }
}
class FireEvents {
  // prettier-ignore
  static onCellUpdate(D, O, x, B, U) {
    const F = { text: String(O), rowIndex: x, columnIndex: B, updateType: U };
    D.onCellUpdate(F), D.dispatchEvent(new CustomEvent("cell-update", { detail: F }));
  }
  static onDataUpdate(D) {
    const O = JSON.parse(JSON.stringify(D.data));
    D.onDataUpdate(O), D.dispatchEvent(new CustomEvent("data-update", { detail: O }));
  }
  static onColumnsUpdate(D) {
    const O = ColumnDetailsUtils.getAllColumnsDetails(D._columnsDetails);
    D.onColumnsUpdate(O), D.dispatchEvent(new CustomEvent("columns-update", { detail: O }));
  }
  static onRender(D) {
    D.onRender(), D.dispatchEvent(new CustomEvent("render"));
  }
}
class StaticTable {
  // because we don't set the table width for maxWidth property, its width is made up of columns widths -
  // they don't always add up to a precise expected value, e.g. if expected 500, they can add up to a 498
  // and 499. Hence instead of doing === tableElement.offsetWidth, we do <= tableElement.offsetWidth + 2
  // number 2 seems enough but can increase if this method is returning false in valid scenarios
  static isTableAtMaxWidth(D, O) {
    return O.maxWidth !== void 0 && O.maxWidth <= D.offsetWidth + 2;
  }
  static isStaticTableWidth(D, O) {
    return O.width !== void 0 || StaticTable.isTableAtMaxWidth(D, O);
  }
}
class StaticTableWidthUtils {
  // REF-11
  static togglePreserveNarrowColumns(D, O, x) {
    x || (O.style.display = D ? "block" : "");
  }
  // when the client has not provided the 'width' value for the table, but a 'maxWidth' is present, need to
  // temporarily set the width at the start in order to help the MaximumColumns class to determine what columns fit
  // prettier-ignore
  static toggleWidthUsingMaxWidth(D, O) {
    const { _tableElementRef: x, _tableDimensions: { maxWidth: B, preserveNarrowColumns: U } } = D;
    x && B !== void 0 && (x.style.width = O ? `${B}px` : "", StaticTableWidthUtils.togglePreserveNarrowColumns(O, x, U));
  }
  // prettier-ignore
  static setTableWidth(D) {
    const { _tableDimensions: { preserveNarrowColumns: O, width: x }, _tableElementRef: B } = D;
    B && x !== void 0 && (B.style.width = `${x}px`, StaticTableWidthUtils.togglePreserveNarrowColumns(!0, B, O));
  }
  // This only runs when the table width is set
  // prettier-ignore
  static changeTableWidthForNonDynamicColumns(D, O, x, B, U) {
    D.length === 0 || O.dynamicWidth.length > 0 ? x.offsetWidth !== B && (x.style.width = `${B}px`) : x.style.width = `${U}px`;
  }
  static resetDynamicWidthColumns(D, O) {
    D.forEach((x) => {
      x.elements[0].style.width = `${O.newColumnWidth}px`;
    });
  }
  static setNewColumnWidth(D, O, x) {
    if (O > 0) {
      const B = D - x.staticWidth;
      x.newColumnWidth = B / O;
    }
  }
  static resetColumnSizes(D, O, x) {
    const B = ColumnDetailsUtils.getColumnsByWidth(D);
    return StaticTableWidthUtils.setNewColumnWidth(O, B.dynamicWidth.length, x), StaticTableWidthUtils.resetDynamicWidthColumns(B.dynamicWidth, x), B;
  }
  static changeWidthsBasedOnColumnInsertRemove(D, O) {
    const { _tableElementRef: x, _tableDimensions: B, _columnsDetails: U } = D;
    if (!x)
      return;
    const { width: F, maxWidth: W, staticWidth: G } = B;
    if (F !== void 0) {
      const Y = StaticTableWidthUtils.resetColumnSizes(U, F, B);
      StaticTableWidthUtils.changeTableWidthForNonDynamicColumns(U, Y, x, F, G);
    } else
      O && StaticTable.isTableAtMaxWidth(x, B) && StaticTableWidthUtils.resetColumnSizes(U, W, B);
    setTimeout(() => FireEvents.onColumnsUpdate(D));
  }
}
class ConvertCellTypeUtils {
  static preprocessCell(D) {
    D.style.cursor = "";
  }
}
class CellStructureUtils {
  static setColumn(D, O, x, B) {
    const { elements: U } = D._columnsDetails[O];
    U.slice(1).forEach((F, W) => {
      const G = W + 1;
      x(D, F, O, G), D._columnsDetails[O].settings.isCellTextEditable && B(D, F, G, O);
    });
  }
}
class FocusedCellUtils {
  static createEmpty() {
    return {};
  }
  static setHeaderCell(D, O, x) {
    D.element = O, D.rowIndex = 0, D.columnIndex = x;
  }
  static setIndexCell(D, O, x) {
    D.element = O, D.rowIndex = x, delete D.columnIndex;
  }
  static set(D, O, x, B) {
    D.element = O, D.rowIndex = x, D.columnIndex = B;
  }
  static incrementColumnIndex(D, O) {
    D.columnIndex !== void 0 && O <= D.columnIndex && (D.columnIndex += 1);
  }
  static purge(D) {
    delete D.columnIndex, delete D.element, delete D.rowIndex;
  }
}
var KEYBOARD_KEY = /* @__PURE__ */ ((z) => (z.ESCAPE = "Escape", z.ENTER = "Enter", z.TAB = "Tab", z.ARROW_UP = "ArrowUp", z.ARROW_DOWN = "ArrowDown", z.ARROW_RIGHT = "ArrowRight", z.ARROW_LEFT = "ArrowLeft", z))(KEYBOARD_KEY || {});
const _Browser = class {
  // can't use DateCellInputElement class as this is called before CellElement class can be used
  static createDateInput() {
    const D = document.createElement("input");
    return D.type = "date", D;
  }
  static createColorInput() {
    const D = document.createElement("input");
    return D.type = "color", D;
  }
};
_Browser.IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
_Browser.IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
_Browser.IS_CHROMIUM = window.chrome;
_Browser.IS_INPUT_DATE_SUPPORTED = _Browser.createDateInput().type === "date" && "showPicker" in HTMLInputElement.prototype;
_Browser.IS_COLOR_PICKER_SUPPORTED = _Browser.createColorInput().type === "color" && "showPicker" in HTMLInputElement.prototype;
let Browser = _Browser;
class ColumnSettingsStyleUtils {
  static applySettingsStyleOnCell(D, O, x) {
    var B;
    Object.assign(O.style, D.cellStyle || {}, x ? ((B = D.headerStyles) == null ? void 0 : B.default) || {} : {});
  }
  // prettier-ignore
  static setNewHeaderStyle(D, O) {
    var W;
    const { settings: x, elements: B } = O, U = x.cellStyle || ((W = x.headerStyles) == null ? void 0 : W.default);
    U && ColumnSettingsStyleUtils.applySettingsStyleOnCell(x, B[0], !0);
    const F = U ? x : void 0;
    O.headerStateColors = ColumnDetails.createHeaderStateColors(
      D._defaultColumnsSettings,
      F,
      D._defaultCellHoverColors
    ), ColumnSettingsBorderUtils.overwriteSideBorderIfSiblingsHaveSettings(O, [B[0]]);
  }
  static unsetHeaderSettingStyle(D, O) {
    Object.keys(O).forEach((x) => {
      ElementStyle.setStyle(D, x, "");
    });
  }
  // prettier-ignore
  static resetHeaderStyleToDefault(D, O, x) {
    var F;
    (F = O.headerStyles) != null && F.default && ColumnSettingsStyleUtils.unsetHeaderSettingStyle(D[0], O.headerStyles.default), O.cellStyle && ElementStyle.unsetStyle(D[0], O.cellStyle);
    const { cellStyle: B, headerStyles: U } = x;
    CellElement.setDefaultCellStyle(D[0], B, U == null ? void 0 : U.default);
  }
  // prettier-ignore
  static changeHeaderStyleFunc(D, O) {
    var G, Y, X;
    const x = this._columnsDetails[D], { elements: B, settings: { isHeaderTextEditable: U } } = x;
    ColumnSettingsStyleUtils.resetHeaderStyleToDefault(B, O, this._defaultColumnsSettings), ColumnSettingsStyleUtils.setNewHeaderStyle(this, x);
    const F = (X = (Y = (G = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : G.displaySettings) == null ? void 0 : Y.openMethod) == null ? void 0 : X.cellClick, W = !F && U;
    CellElement.prepContentEditable(
      CellElement.getTextElement(B[0]),
      !!W,
      F
    );
  }
  // prettier-ignore
  static changeStyleFunc(D, O, x) {
    ProcessedDataTextStyle.resetDataCellsStyle(
      D,
      O,
      ColumnSettingsStyleUtils.changeHeaderStyleFunc.bind(D, O, x),
      x.cellStyle
    );
  }
  static doStylesHaveVisibleDimension(D, O) {
    for (let x = 0; x < O.length; x += 1) {
      const B = D[O[x]];
      if (B) {
        const U = RegexUtils.extractIntegerStrs(String(B));
        if (U.length > 0 && Number(U[0]) > 0)
          return !0;
      }
    }
    return !1;
  }
  // REF-23
  // prettier-ignore
  static doesSettingHaveSideBorderStyle(D) {
    var x;
    const O = D.cellStyle || ((x = D.headerStyles) == null ? void 0 : x.default);
    return O ? ColumnSettingsStyleUtils.doStylesHaveVisibleDimension(
      O,
      ["border", "borderLeft", "borderLeftWidth", "borderRight", "borderRightWidth"]
    ) : !1;
  }
}
class ResetColumnStyles {
  static applyDefaultStyles(D, O) {
    const { cellStyle: x, headerStyles: B } = O;
    CellElement.setDefaultCellStyle(D[0], x, B == null ? void 0 : B.default), D.slice(1).forEach((U) => {
      CellElement.setDefaultCellStyle(U, x);
    });
  }
  static unsetLastAppliedStyle(D, O) {
    Object.keys(D.lastAppliedStyle).forEach((x) => {
      ElementStyle.setStyle(O, x, "");
    });
  }
  // if this operation turns out to be expensive - try to save and reuse the default style
  // prettier-ignore
  static setDefaultStyle(D, O, x, B, U) {
    ResetColumnStyles.unsetLastAppliedStyle(O, x), U && ElementStyle.unsetStyle(x, U), CellElement.setDefaultCellStyle(x, B.cellStyle), ColumnSettingsStyleUtils.applySettingsStyleOnCell(D.settings, x, !1);
  }
}
const _ProcessedDataTextStyle = class Ae {
  // prettier-ignore
  static setCustomStyle(D, O, x, B, U, F, W) {
    if (D) {
      ResetColumnStyles.setDefaultStyle(x, U, F, W);
      const G = D(String(O), B);
      Object.assign(F.style, G), U.lastAppliedStyle = G, ColumnSettingsBorderUtils.overwriteSideBorderIfSiblingsHaveSettings(x, [F]);
    }
  }
  // prettier-ignore
  static setFailedValidationStyle(D, O, x) {
    const { textValidation: B } = D.activeType, U = B.failedStyle || Ae.DEFAULT_FAILED_VALIDATION_STYLE;
    Object.assign(x.style, U), O.lastAppliedStyle = U;
  }
  // prettier-ignore
  static setStyle(D, O, x, B, U, F) {
    let W = !1;
    return D ? B != null && B.changeStyleFunc || (ResetColumnStyles.setDefaultStyle(O, x, U, F), x.lastAppliedStyle = {}, W = !0) : (B != null && B.changeStyleFunc && ResetColumnStyles.setDefaultStyle(O, x, U, F), Ae.setFailedValidationStyle(O, x, U), W = !0), W && ColumnSettingsBorderUtils.overwriteSideBorderIfSiblingsHaveSettings(O, [U]), W;
  }
  // prettier-ignore
  static setCellStyle(D, O, x, B = !1) {
    const U = D._columnsDetails[x], F = U.elements[O], W = U.processedStyle[O], G = CellElement.getText(F), { textValidation: { func: Y }, customTextProcessing: X } = U.activeType;
    let J = !1;
    if (Y) {
      const Q = Y(G);
      (B || W.isValid !== Q) && (J = Ae.setStyle(
        Q,
        U,
        W,
        X,
        F,
        D._defaultColumnsSettings
      ), W.isValid = Q);
    }
    !J && (X != null && X.changeStyleFunc) && Ae.setCustomStyle(
      X.changeStyleFunc,
      G,
      U,
      O,
      W,
      F,
      D._defaultColumnsSettings
    );
  }
  static setStyleOnColumn(D, O) {
    const x = D._columnsDetails[O];
    x.elements.slice(1).forEach((B, U) => {
      const F = U + 1;
      Ae.setCellStyle(D, F, O, !0), ColumnSettingsBorderUtils.overwriteSideBorderIfSiblingsHaveSettings(x, [B]);
    });
  }
  static unsetStyleOnColumn(D, O, x) {
    const B = D._columnsDetails[O];
    B.elements.slice(1).forEach((U, F) => {
      const W = F + 1, G = B.processedStyle[W];
      ResetColumnStyles.setDefaultStyle(B, G, U, D._defaultColumnsSettings, x);
    });
  }
  // using this to first unset the previous processed style, allow new settings/type to be applied and then set
  // new style
  // prettier-ignore
  static resetDataCellsStyle(D, O, x, B) {
    Ae.unsetStyleOnColumn(D, O, B), x(), Ae.setStyleOnColumn(D, O);
  }
  // prettier-ignore
  // this is used for a case where the default style has been set and need to reapply the processed style
  // without having to rerun the validation/changeStyleFunc functions
  static reapplyCellsStyle(D, O) {
    const x = D._columnsDetails[O], { textValidation: { func: B }, customTextProcessing: U } = x.activeType;
    (B || U != null && U.changeStyleFunc) && x.elements.slice(1).forEach((F, W) => {
      const G = W + 1;
      Object.assign(F.style, x.processedStyle[G].lastAppliedStyle);
    });
  }
  static getDefaultProcessedTextStyle() {
    return { isValid: !0, lastAppliedStyle: {} };
  }
};
_ProcessedDataTextStyle.DEFAULT_FAILED_VALIDATION_STYLE = { color: "grey" };
let ProcessedDataTextStyle = _ProcessedDataTextStyle;
class NumberOfIdenticalCells {
  // columnsDetails instead of row from data because during startup - data is already be populated and
  // not yet added to the table, hence we are automatically marking headers as duplicate and setting them
  // to default, however the end headers that are not duplicate may not be displayed due to max columns,
  // hence using columnsDetails to mark duplicates as headers are added instead
  // prettier-ignore
  static get(D, O) {
    return O.map((x) => x.elements.length > 0 ? CellElement.getText(x.elements[0]) : "").filter((x) => x === D).length;
  }
}
const EMPTY_STRING = "";
class DataUtils {
  static createEmptyStringDataArray(D) {
    return new Array(D).fill(EMPTY_STRING);
  }
  static isTextEmpty(D, O) {
    return D !== EMPTY_STRING ? (typeof O == "string" ? O.trim() : O) === EMPTY_STRING : !1;
  }
  // note that NumberOfIdenticalCells.get uses the at.data top row, so it needs to be up-to-date
  // prettier-ignore
  static shouldBeSetToDefault(D, O, x, B, U) {
    const { allowDuplicateHeaders: F, _columnsDetails: W } = D;
    return DataUtils.isTextEmpty(x, O) || B === 0 && !F && NumberOfIdenticalCells.get(O, W) > 1 || B > 0 && !(U.func === void 0 || U.func(String(O)));
  }
  // prettier-ignore
  static processCellText(D, O, x, B) {
    let U = typeof B == "string" ? B.trim() : B;
    const F = D._columnsDetails[x];
    if (!F)
      return U;
    const { activeType: { textValidation: W, customTextProcessing: G }, settings: { defaultText: Y } } = F;
    return O > 0 && (G != null && G.changeTextFunc && (U = G.changeTextFunc(String(U), O)), !W.setTextToDefaultOnFail && U !== EMPTY_STRING) ? U : DataUtils.shouldBeSetToDefault(D, U, Y, O, W) ? Y : U;
  }
}
var CELL_UPDATE_TYPE = /* @__PURE__ */ ((z) => (z.UPDATE = "Update", z.ADD = "Add", z.REMOVED = "Removed", z))(CELL_UPDATE_TYPE || {});
class CellEvents {
  static executeUpdateOperation(D, O) {
    return (O == null ? void 0 : O[D]) === void 0 || O[D] === !0;
  }
  // this is directly handled by operations that do not insert new cells as those handle the instructions below
  // in a different order asynchronously for maximum efficiency
  // prettier-ignore
  static updateCell(D, O, x, B, U) {
    return CellEvents.executeUpdateOperation("processText", U) && (O = DataUtils.processCellText(D, x, B, O)), CellEvents.executeUpdateOperation("updateData", U) && (D.data[x][B] = O), U != null && U.element && CellElement.setNewText(D, U.element, O, !1, !1), CellEvents.executeUpdateOperation("updateTableEvent", U) && D.onDataUpdate(D.data), x > 0 && ProcessedDataTextStyle.setCellStyle(D, x, B), CellEvents.executeUpdateOperation("updateCellEvent", U) && FireEvents.onCellUpdate(D, O, x, B, CELL_UPDATE_TYPE.UPDATE), O;
  }
  // this is used for cases where updateCell should only be called if it has to be set to default
  // prettier-ignore
  static setCellToDefaultIfNeeded(D, O, x, B, U = !0) {
    const F = CellElement.getText(B), W = DataUtils.processCellText(D, O, x, F);
    return W !== F ? (CellEvents.updateCell(
      D,
      W,
      O,
      x,
      { element: B, processText: !1, updateTableEvent: U }
    ), !0) : !1;
  }
  // prettier-ignore
  static removeTextIfDefault(D, O, x, B) {
    const { isDefaultTextRemovable: U, defaultText: F } = D._columnsDetails[x].settings;
    U && F !== EMPTY_STRING && F === CellElement.getText(B) && CellEvents.updateCell(
      D,
      EMPTY_STRING,
      O,
      x,
      { element: B, processText: !1 }
    );
  }
}
class CheckboxEvents {
  // REF-29
  static focusCheckbox(D, O, x) {
    Browser.IS_SAFARI || FocusedCellUtils.set(this._focusedElements.cell, D, O, x);
  }
  // REF-29
  static blurCheckbox() {
    Browser.IS_SAFARI || FocusedCellUtils.purge(this._focusedElements.cell);
  }
  static changeValueCheckbox(D, O, x) {
    const B = x.target;
    CellEvents.updateCell(this, String(B.checked), D, O, { processText: !1 });
  }
  static keyDownCheckbox(D) {
    D.key === KEYBOARD_KEY.ENTER && D.target.click();
  }
  static setEvents(D, O, x, B) {
    O.onkeydown = CheckboxEvents.keyDownCheckbox, O.onchange = CheckboxEvents.changeValueCheckbox.bind(D, x, B), O.onfocus = CheckboxEvents.focusCheckbox.bind(D, O, x, B), O.onblur = CheckboxEvents.blurCheckbox.bind(D);
  }
}
class CheckboxCellEvents {
  static mouseDownCell(D) {
    const O = D.target;
    O.classList.contains(CellElement.CELL_CLASS) && O.children[0].click();
  }
  // REF-29
  static focusCell(D) {
    D.target.children[0].focus();
  }
  static setEvents(D, O, x, B) {
    if (!D._columnsDetails[B].settings.isCellTextEditable)
      return;
    O.onblur = () => {
    }, O.onfocus = CheckboxCellEvents.focusCell, O.onmouseenter = () => {
    }, O.onmouseleave = () => {
    }, O.oninput = () => {
    }, O.onmousedown = CheckboxCellEvents.mouseDownCell.bind(D);
    const U = CheckboxCellElement.getCheckboxElement(O);
    CheckboxEvents.setEvents(D, U, x, B);
  }
}
class CheckboxElement {
  static createCheckbox(D) {
    const O = document.createElement("input");
    return O.type = "checkbox", O.style.cursor = D ? "pointer" : "auto", O.style.pointerEvents = D ? "" : "none", O;
  }
  static setCellTextAsCheckbox(D, O) {
    const x = CheckboxElement.createCheckbox(O);
    D.replaceChildren(x);
  }
}
class CheckboxCellElement {
  static isCheckbox(D) {
    return (D == null ? void 0 : D.type) === "checkbox";
  }
  static isCheckboxCell(D) {
    return CheckboxCellElement.isCheckbox(D.children[0]);
  }
  static getCheckboxElement(D) {
    if (CheckboxCellElement.isCheckboxCell(D))
      return D.children[0];
    if (CheckboxCellElement.isCheckbox(D))
      return D;
  }
  static getValue(D) {
    const O = CheckboxCellElement.getCheckboxElement(D);
    if (O)
      return String(O.checked);
  }
  static setValue(D, O) {
    const x = CheckboxCellElement.getCheckboxElement(D);
    return x ? (x.checked = O === "true", !0) : !1;
  }
  // prettier-ignore
  static setCellTextAsAnElement(D, O, x, B) {
    const { settings: { isCellTextEditable: U } } = D._columnsDetails[B], F = CellElement.getText(O);
    CheckboxElement.setCellTextAsCheckbox(O, U), O.contentEditable = "false", O.style.cursor = U ? "pointer" : "default", CellEvents.updateCell(D, F, x, B, { element: O });
  }
  // prettier-ignore
  static setCellCheckboxStructure(D, O, x, B) {
    ConvertCellTypeUtils.preprocessCell(O), CheckboxCellElement.setCellTextAsAnElement(D, O, B, x);
  }
  // prettier-ignore
  static setColumnCheckboxStructure(D, O) {
    CellStructureUtils.setColumn(
      D,
      O,
      CheckboxCellElement.setCellCheckboxStructure,
      CheckboxCellEvents.setEvents
    );
  }
}
class CaretPosition {
  static setSelectionToEndOfText(D, O) {
    const x = CellElement.getTextElement(D), B = document.createRange();
    B.setStart(x.childNodes[0], CellElement.getText(x).length || 0), B.collapse(!0), O.removeAllRanges(), O.addRange(B);
  }
  static getSelection(D) {
    var B;
    const O = D.shadowRoot;
    return O.getSelection ? O.getSelection() : ((B = window.document.activeElement) == null ? void 0 : B.shadowRoot) === O ? window.document.getSelection() : null;
  }
  static setToEndOfText(D, O) {
    if (CheckboxCellElement.isCheckboxCell(O))
      return;
    let x = CaretPosition.getSelection(D);
    Browser.IS_SAFARI && !x && (O.focus(), x = CaretPosition.getSelection(D)), x && CaretPosition.setSelectionToEndOfText(O, x);
  }
}
class ArrayUtils {
  static transpose(D) {
    if (D.length === 0)
      return D;
    const O = [], x = Math.max(D.length, D[0].length);
    e:
      for (let B = 0; B < x; B += 1) {
        const U = [];
        for (let F = 0; F < x && D[F] !== void 0; F += 1) {
          if (D[F][B] === void 0)
            break e;
          U.push(D[F][B]);
        }
        O.push(U);
      }
    return O;
  }
  static shuffle(D) {
    return D.sort(() => Math.random() - 0.5);
  }
  static swap(D, O, x) {
    const B = D[O];
    D[O] = D[x], D[x] = B;
  }
}
const _LabelColorUtils = class Be {
  static generateNewPasteleColor() {
    return `hsl(${Math.floor(Math.random() * 360)}, 95%, 90%)`;
  }
  static setNewLatestPasteleColor() {
    Be.LATEST_PASTELE_COLOR = Be.generateNewPasteleColor();
  }
  static getLatestPasteleColor() {
    return Be.LATEST_PASTELE_COLOR;
  }
  static getLatestPasteleColorAndSetNew() {
    const D = Be.getLatestPasteleColor();
    return Be.setNewLatestPasteleColor(), D;
  }
  // REF-34
  // these colors are used before the above
  static generateDefaultColors() {
    return ArrayUtils.shuffle([
      "hsl(154deg 96% 90%)",
      "hsl(50deg 96% 90%)",
      "hsl(171deg 96% 90%)",
      "hsl(76deg 96% 90%)",
      "hsl(315deg 96% 90%)",
      "hsl(251deg 96% 90%)",
      "hsl(209deg 84% 92%)",
      "hsl(0deg 100% 81%)",
      "hsl(29deg 100% 79%)",
      "hsl(31deg 73% 75%)",
      "hsl(137deg 80% 80%)",
      "hsl(60deg 100% 82%)",
      "hsl(219deg 100% 84%)",
      "hsl(93deg 62% 74%)",
      "hsl(54deg 93% 84%)",
      "hsl(146deg 100% 90%)",
      "hsl(334deg 100% 87%)",
      "hsl(19deg 95% 84%)",
      "hsl(203deg 95% 84%)",
      "hsl(76deg 100% 78%)",
      "hsl(0deg 100% 86%)",
      "hsl(42deg 82% 82%)",
      "hsl(97deg 100% 87%)"
    ]);
  }
  // this is a solution for same label text across different columns to have the same colors
  static generateGlobalItemColors() {
    return {
      newColors: Be.generateDefaultColors(),
      existingColors: {}
    };
  }
};
_LabelColorUtils.LATEST_PASTELE_COLOR = _LabelColorUtils.generateNewPasteleColor();
let LabelColorUtils = _LabelColorUtils;
class ScrollbarUtils {
  static isVerticalPresent(D) {
    return D.scrollHeight > D.clientHeight;
  }
  static isHorizontalPresent(D) {
    return D.scrollWidth > D.clientWidth;
  }
}
const _CellDropdownHorizontalScrollFix = class lt {
  static setPropertiesIfHorizontalScrollPresent(D) {
    const { element: O, scrollbarPresence: x, customDropdownStyle: B } = D;
    ScrollbarUtils.isHorizontalPresent(O) && ScrollbarUtils.isVerticalPresent(O) ? (x.horizontal = !0, O.style.paddingBottom = lt.NEW_BOTTOM_PADDING_IF_PRESENT) : (x.horizontal = !1, O.style.paddingBottom = (B == null ? void 0 : B.paddingBottom) || Dropdown.DROPDOWN_VERTICAL_PX);
  }
  static scrollDownFurther(D) {
    D.scrollTop += lt.SCROLL_FURTHER_BOTTOM_PX;
  }
};
_CellDropdownHorizontalScrollFix.NEW_BOTTOM_PADDING_IF_PRESENT = "8px";
_CellDropdownHorizontalScrollFix.SCROLL_FURTHER_BOTTOM_PX = 14;
let CellDropdownHorizontalScrollFix = _CellDropdownHorizontalScrollFix;
const _RGBAToHex = class rt {
  static extractIndividualNumbers(D) {
    return D.match(rt.REGEX);
  }
  static convert(D) {
    return `#${rt.extractIndividualNumbers(D).slice(1).map(
      (O, x) => (x === 3 ? Math.round(parseFloat(O) * 255) : parseFloat(O)).toString(16).padStart(2, "0").replace("NaN", "")
    ).join("")}`;
  }
};
_RGBAToHex.REGEX = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/;
let RGBAToHex = _RGBAToHex;
const _OptionColorButton = class we {
  // buttonLevelElement is either input or button
  static extractRelativeParentElements(D) {
    var U;
    const O = D.parentElement, x = (U = O.previousSibling) == null ? void 0 : U.previousSibling, B = O.parentElement;
    return { containerElement: O, textElement: x, dropdownItemElement: B };
  }
  static changeVisibility(D, O, x) {
    const B = D.children[2];
    if (B.style.display = x ? "block" : "none", x) {
      const U = B.children[0], F = Browser.IS_SAFARI ? 9 : 5;
      U.style.left = `${x.offsetWidth - O + F}px`;
      const W = B.children[1];
      W.style.left = `${x.offsetWidth - O}px`;
    }
  }
  static createIcon() {
    const D = document.createElement("div");
    return D.innerText = we.COLOR_ICON_TEXT, D.classList.add(we.COLOR_BUTTON_ICON_CLASS), D;
  }
  static createButton() {
    const D = document.createElement("div");
    D.classList.add(OptionButton.BUTTON_CLASS, we.COLOR_BUTTON_CLASS);
    const O = we.createIcon();
    return D.appendChild(O), D;
  }
  static createInput() {
    const D = document.createElement("input");
    return D.type = "color", D.style.top = Browser.IS_SAFARI ? "0px" : "14px", D.classList.add(we.COLOR_INPUT_CLASS), D;
  }
  static createContainer() {
    const D = document.createElement("div");
    return D.classList.add(OptionButton.BUTTON_CONTAINER_CLASS), D;
  }
  static create(D, O) {
    const x = we.createContainer(), B = we.createInput();
    x.appendChild(B);
    const U = we.createButton();
    return x.appendChild(U), OptionColorButtonEvents.setEvents(x, B, D, O), x;
  }
};
_OptionColorButton.COLOR_INPUT_CLASS = "color-input";
_OptionColorButton.COLOR_BUTTON_CLASS = "option-color-button";
_OptionColorButton.COLOR_BUTTON_ICON_CLASS = "cell-dropdown-option-color-button-icon";
_OptionColorButton.COLOR_ICON_TEXT = "c";
let OptionColorButton = _OptionColorButton;
class OptionColorButtonEvents {
  static updateCellElements(D, O) {
    const { itemText: x, backgroundColor: B } = O;
    D.elements.slice(1).forEach((U) => {
      const F = U.children[0];
      F.innerText === x && (F.style.backgroundColor = B);
    });
  }
  // prettier-ignore
  static updateIfUpdatable(D, O, x) {
    const { itemText: B, backgroundColor: U } = x, F = D.cellDropdown.itemsDetails[B];
    F && (!F.isCustomBackgroundColor || O === D.activeType.name) && (F.backgroundColor = U, OptionColorButtonEvents.updateCellElements(D, x));
  }
  // prettier-ignore
  static updateElements(D, O, x) {
    D.forEach((B) => {
      B.cellDropdown.labelDetails && OptionColorButtonEvents.updateIfUpdatable(B, O, x);
    });
  }
  static updateColorStates(D, O) {
    var F, W, G;
    const { itemText: x, backgroundColor: B } = O;
    (W = (F = D.activeType.cellDropdownProps) == null ? void 0 : F.options) == null || W.forEach((Y) => {
      Y.text === x && (Y.backgroundColor = B);
    });
    const U = (G = D.cellDropdown.labelDetails) == null ? void 0 : G.globalItemColors.existingColors;
    U != null && U[x] && (U[x] = B);
  }
  // prettier-ignore
  static updateColumnLabelColors(D, O) {
    const { cellDropdown: { labelDetails: x }, activeType: B } = O;
    !x || !x.colorPickerNewValue || (OptionColorButtonEvents.updateColorStates(O, x.colorPickerNewValue), OptionColorButtonEvents.updateElements(D, B.name, x.colorPickerNewValue), delete x.colorPickerNewValue, setTimeout(() => O.fireColumnsUpdate()));
  }
  // important to note that mouse/key down events are not fired when clicked on picker
  static windowEventClosePicker(D, O) {
    if (O.cellDropdown) {
      const x = O.cell.columnIndex;
      OptionButton.hideAfterColorPickerContainerClose(D, D[x]);
    }
  }
  // bug fix comments are for code that fixes a firefox bug where color picker is still open after closing the dropdown
  static inputEvent(D, O) {
    if (!Dropdown.isDisplayed(D.element))
      return;
    const x = O.target, { containerElement: B, textElement: U, dropdownItemElement: F } = OptionColorButton.extractRelativeParentElements(x), W = U.textContent, G = x.value;
    F.style.backgroundColor = G;
    const Y = D.itemsDetails[W];
    Y.backgroundColor !== G && (Y.backgroundColor = G, D.labelDetails.colorPickerNewValue = { backgroundColor: G, itemText: W }, setTimeout(() => {
      var X;
      (X = D.labelDetails).colorPickerContainer ?? (X.colorPickerContainer = B);
    }));
  }
  // prettier-ignore
  static mouseDownContainer(D, O, x) {
    const { cellDropdown: { labelDetails: B } } = O;
    if (!B)
      return;
    if (B.colorPickerContainer) {
      delete B.colorPickerContainer, OptionColorButtonEvents.updateColumnLabelColors(D, O);
      return;
    }
    const U = x.target, { containerElement: F, dropdownItemElement: W } = OptionColorButton.extractRelativeParentElements(U), G = U.previousSibling;
    G.value = RGBAToHex.convert(getComputedStyle(W).backgroundColor), G.showPicker(), setTimeout(() => B.colorPickerContainer = F);
  }
  // prettier-ignore
  static setEvents(D, O, x, B) {
    D.onmousedown = OptionColorButtonEvents.mouseDownContainer.bind(this, x, B), O.oninput = OptionColorButtonEvents.inputEvent.bind(this, B.cellDropdown);
  }
}
class FocusNextRowCell {
  // does not work in Safari
  static focus(D, O, x, B) {
    B.preventDefault();
    const U = x[O + 1];
    U && (U.focus(), CaretPosition.setToEndOfText(D, U));
  }
  static focusOrBlurSelect(D, O) {
    const x = D[O + 1];
    if (x)
      return x.dispatchEvent(new Event("mousedown")), x.scrollIntoView({ block: "nearest" }), x;
    D[O].children[0].blur();
  }
}
const ARROW_DOWN_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12">
  <g style="pointer-events: none" transform="matrix(0.6315789 0 0 0.6315789 0 0)">
    <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
      <path d="M0 87.5L350 507.5L700 87.5L0 87.5z" stroke="none" fill="#3e3e3e" fill-rule="nonzero" />
    </g>
  </g>
</svg>
`, _ArrowDownIconElement = class Ve {
  static toggle(D, O) {
    if (!D)
      return;
    const x = D.children[1];
    x.style.display = O ? "block" : "none";
    const B = x.children[0];
    !O && B.style.filter && (B.style.filter = "");
  }
  static setActive(D) {
    const O = D.children[1].children[0];
    O.style.filter = `brightness(0) saturate(100%) invert(24%) sepia(73%) saturate(631%)
      hue-rotate(171deg) brightness(98%) contrast(98%)`;
  }
  // need a container to allow absolute positioning for the icon
  static createContainer() {
    const D = document.createElement("div");
    return D.classList.add(Ve.ARROW_ICON_CONTAINER_CLASS), D.style.display = "none", D;
  }
  // REF-10
  static createSVGElement() {
    const D = SVGIconUtils.createSVGElement(ARROW_DOWN_ICON_SVG_STRING);
    return D.classList.add(Ve.ARROW_ICON_CLASS), D;
  }
  static createSVG() {
    const D = Ve.createSVGElement(), O = Ve.createContainer();
    return O.appendChild(D), O;
  }
  static get() {
    return Ve.ARROW_ICON_ELEMENT.cloneNode(!0);
  }
};
_ArrowDownIconElement.ARROW_ICON_CLASS = "arrow-down-icon";
_ArrowDownIconElement.ARROW_ICON_CONTAINER_CLASS = "arrow-down-icon-container";
_ArrowDownIconElement.ARROW_ICON_ELEMENT = _ArrowDownIconElement.createSVG();
let ArrowDownIconElement = _ArrowDownIconElement;
class TableBorderDimensionsUtils {
  static generateDefault() {
    return {
      leftWidth: 0,
      rightWidth: 0,
      topWidth: 0,
      bottomWidth: 0
    };
  }
  static getWidth(D, O) {
    return D.style[O] === "" ? 1 : Number.parseFloat(D.style[O]) || 0;
  }
  static generateUsingElement(D) {
    return {
      leftWidth: TableBorderDimensionsUtils.getWidth(D, "borderLeftWidth"),
      rightWidth: TableBorderDimensionsUtils.getWidth(D, "borderRightWidth"),
      topWidth: TableBorderDimensionsUtils.getWidth(D, "borderTopWidth"),
      bottomWidth: TableBorderDimensionsUtils.getWidth(D, "borderBottomWidth")
    };
  }
}
const _UpdateIndexColumnWidth = class te {
  static wrapColumnTextAndGetDefaultWidth(D) {
    const { _tableBodyElementRef: O, data: x, _tableDimensions: B } = D;
    return ExtractElements.textRowsArrFromTBody(O, x).forEach((U) => {
      U.children[0].classList.remove(IndexColumn.INDEX_CELL_OVERFLOW_CLASS);
    }), B.isColumnIndexCellTextWrapped = !0, ToggleAdditionElements.update(D, !0, AddNewColumnElement.toggle), IndexColumn.DEFAULT_WIDTH;
  }
  static changeTableWidths(D, O) {
    const x = O - D._tableDimensions.indexColumnWidth;
    D._tableDimensions.indexColumnWidth = O, TableElement.changeStaticWidthTotal(D._tableDimensions, x), StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, !0);
  }
  static changeCellAndTableWidths(D, O, x) {
    const B = O.children[0];
    te.changeTableWidths(D, x), B.style.width = `${x}px`;
  }
  static forceWrap(D, O) {
    const x = te.wrapColumnTextAndGetDefaultWidth(D);
    te.changeCellAndTableWidths(D, O, x);
  }
  static shouldTextBeWrapped(D) {
    return !D._tableDimensions.isColumnIndexCellTextWrapped && TableDimensionsUtils.hasSetTableWidthBeenBreached(D);
  }
  static changeWidth(D, O, x) {
    te.changeCellAndTableWidths(D, O, x), te.shouldTextBeWrapped(D) && te.forceWrap(D, O);
  }
  // important to note that on initial render if the font library has not been downloaded
  // scrollWidth will give the wrong number. This is usually not a problem when using
  // small numbers or cache
  static getCellWidth(D) {
    return D.scrollWidth + (Number.parseInt(getComputedStyle(D).borderRightWidth) || 0);
  }
  // need to keep track of first cell because upon using pagination and uploading a new file, drag and droping a new file,
  // or using updateData method with a lot of data does not refresh the cell with original value
  // to reproduce the error, simply set the code in timeout to: firstCell.textContent = firstCellContent
  static temporarilySetFirstRowCellWithLastNumber(D, O, x) {
    const B = D.textContent;
    D.id || (D.id = O ? te.TEMPORARY_INDEX_NUMBER : te.TEMPORARY_INVISIBLE_INDEX_NUMBER), D.textContent = x.textContent, setTimeout(() => {
      D.id !== "" && (D.textContent = B, D.removeAttribute("id"));
    });
  }
  static getIndexColumnWidthWithAsyncFix(D, O, x) {
    if (x.scrollWidth === 0) {
      const B = D.children[0];
      return te.temporarilySetFirstRowCellWithLastNumber(B, O, x), te.getCellWidth(B);
    }
    return te.getCellWidth(x);
  }
  // this works because the 'block' display style is not set on the table
  // checking if the cells width is overflown and if so - increase its width (cannot decrease the width)
  static updateColumnWidthWhenOverflow(D, O, x) {
    const B = !!D.dataStartsAtHeader, U = te.getIndexColumnWidthWithAsyncFix(O, B, x);
    if (D._tableDimensions.indexColumnWidth !== U && U !== 0) {
      const F = U + (Browser.IS_FIREFOX ? 4 : 0);
      Browser.IS_SAFARI ? setTimeout(() => te.changeWidth(D, O, F)) : te.changeWidth(D, O, F);
    }
  }
  // when the table element display property is 'block', the 'overflow: hidden;' property does not actually work
  // and instead the lastCell width is changed automatically, all we do here is check if the expected width
  // (at.tableDimensions.indexColumnWidth) is different to the actual one and if so, we change it to actual
  static checkAutoColumnWidthUpdate(D, O) {
    if (O.offsetWidth !== D._tableDimensions.indexColumnWidth) {
      let x = O.offsetWidth;
      D.offsetWidth !== D.scrollWidth && (x = te.wrapColumnTextAndGetDefaultWidth(D)), te.changeTableWidths(D, x);
    }
  }
  static updatedBasedOnTableStyle(D, O, x, B = !1) {
    B ? te.forceWrap(D, O) : D._tableDimensions.preserveNarrowColumns || D._tableDimensions.maxWidth !== void 0 ? te.updateColumnWidthWhenOverflow(D, O, x) : D._tableDimensions.width !== void 0 && te.checkAutoColumnWidthUpdate(D, x);
  }
  static getFirstVisibleRow(D) {
    const { _pagination: O, _tableBodyElementRef: x, dataStartsAtHeader: B } = D;
    return B && O ? O.visibleRows[0] : x == null ? void 0 : x.children[0];
  }
  static updatedBasedOnVisiblity(D, O, x = !1) {
    const B = te.getFirstVisibleRow(D);
    D._pagination && D.filter ? B ? te.updatedBasedOnTableStyle(D, B, O, x) : setTimeout(() => {
      const U = te.getFirstVisibleRow(D);
      U && te.updatedBasedOnTableStyle(D, U, O, x);
    }) : B && te.updatedBasedOnTableStyle(D, B, O, x);
  }
  // used when a new row is added
  // forceWrap - REF-19
  static update(D, O, x = !1) {
    var U;
    if (D._tableDimensions.isColumnIndexCellTextWrapped)
      return;
    if (!O) {
      const { _tableBodyElementRef: F, data: W } = D;
      O = ExtractElements.textRowsArrFromTBody(F, W);
    }
    const B = (U = O[O.length - 1]) == null ? void 0 : U.children[0];
    B && te.updatedBasedOnVisiblity(D, B, x);
  }
  // used when a new column is added to see if wrapping is needed
  // CAUTION-2 - this runs before re-render but stay cautions
  static wrapTextWhenNarrowColumnsBreached(D) {
    D._frameComponents.displayIndexColumn && te.shouldTextBeWrapped(D) && te.update(D, void 0, !0);
  }
};
_UpdateIndexColumnWidth.TEMPORARY_INDEX_NUMBER = "temp-index-number";
_UpdateIndexColumnWidth.TEMPORARY_INVISIBLE_INDEX_NUMBER = "temp-invisible-index-number";
let UpdateIndexColumnWidth = _UpdateIndexColumnWidth;
const _IndexColumn = class be {
  static updateIndexes(D, O) {
    const { _tableBodyElementRef: x, data: B, dataStartsAtHeader: U } = D, F = ExtractElements.textRowsArrFromTBody(x, B, O), W = Number(U);
    F.forEach((G, Y) => {
      const X = G.children[0], J = O + Y + W;
      X.innerText = String(J);
    }), UpdateIndexColumnWidth.update(D, F.length === 0 ? void 0 : F);
  }
  // prettier-ignore
  static createCell(D, O) {
    var J, Q;
    const { _tableDimensions: x, _defaultColumnsSettings: B, _frameComponents: { styles: U, cellColors: F, inheritHeaderColors: W } } = D, G = CellElement.createBaseCell(O);
    G.classList.add(be.INDEX_CELL_CLASS, GenericElementUtils.NOT_SELECTABLE_CLASS);
    const { displaySettings: Y, canEditHeaderRow: X } = D.rowDropdown;
    return G.style.cursor = (J = Y.openMethod) != null && J.cellClick && (!O || X) ? "pointer" : "default", x.isColumnIndexCellTextWrapped || G.classList.add(be.INDEX_CELL_OVERFLOW_CLASS), Object.assign(G.style, B.cellStyle, (U == null ? void 0 : U.default) || {}), O && Object.assign(
      G.style,
      W ? (Q = B.headerStyles) == null ? void 0 : Q.default : {},
      F.header.default
    ), G;
  }
  static createHeaderCell(D) {
    const O = be.createCell(D, !0);
    return D.dataStartsAtHeader && (O.innerText = "1"), O.style.width = be.DEFAULT_WIDTH_PX, Browser.IS_SAFARI && setTimeout(() => O.style.width = be.DEFAULT_WIDTH_PX), O;
  }
  static createDataCell(D, O) {
    const x = be.createCell(D, !1), B = D.dataStartsAtHeader ? O + 1 : O;
    return x.innerText = String(B), x;
  }
  static createAndPrependToRow(D, O, x) {
    const B = x === 0 ? be.createHeaderCell(D) : be.createDataCell(D, x);
    D._columnsDetails[0] && ColumnSettingsBorderUtils.unsetSubjectBorder([B], D._columnsDetails[0].elements, "right", 0), O.appendChild(B);
  }
};
_IndexColumn.INDEX_CELL_CLASS = "index-cell";
_IndexColumn.INDEX_CELL_OVERFLOW_CLASS = "index-cell-overflow";
_IndexColumn.DEFAULT_WIDTH = 30;
_IndexColumn.DEFAULT_WIDTH_PX = `${_IndexColumn.DEFAULT_WIDTH}px`;
let IndexColumn = _IndexColumn;
const UNSET_NUMBER_IDENTIFIER = -1, _TableDimensionsUtils = class $e {
  // REF-19
  static setIsColumnIndexCellTextWrapped(D, O) {
    O && (typeof O == "object" && O.wrapIndexCellText ? D.isColumnIndexCellTextWrapped = !0 : D.isColumnIndexCellTextWrapped === void 0 && (D.isColumnIndexCellTextWrapped = !1));
  }
  static setPreserveNarrowColumnsProp(D, O) {
    O.preserveNarrowColumns = D.preserveNarrowColumns;
  }
  // prettier-ignore
  static setDimension(D, O) {
    const { tableStyle: x, _tableDimensions: B, _tableElementRef: U, parentElement: F } = D;
    if (!U || !F)
      return;
    const W = StringDimensionUtils.generateNumberDimensionFromClientString(
      F,
      x,
      O,
      !0,
      $e.MINIMAL_TABLE_WIDTH
    );
    W.number > 0 && (D.overflow && OverflowUtils.processNumberDimension(B, W), B[O] = W.number, B.isPercentage = W.isPercentage);
  }
  // CAUTION-3
  // prettier-ignore
  static setTableDimensions(D) {
    const { tableStyle: O, _tableDimensions: x, _frameComponents: { displayIndexColumn: B } } = D;
    O.width !== void 0 ? $e.setDimension(D, "width") : O.maxWidth !== void 0 && $e.setDimension(D, "maxWidth"), $e.setPreserveNarrowColumnsProp(D, x), $e.setIsColumnIndexCellTextWrapped(x, B);
  }
  static hasSetTableWidthBeenBreached(D) {
    const { width: O, maxWidth: x } = D._tableDimensions, B = D.offsetWidth, U = O || x;
    return U ? Math.ceil(U) < B : !1;
  }
  static record(D) {
    D._tableDimensions.recordedParentWidth = D.parentElement.offsetWidth, D._tableDimensions.recordedParentHeight = D.parentElement.offsetHeight, D._tableDimensions.recordedWindowWidth = window.innerWidth, D._tableDimensions.recordedWindowHeight = window.innerHeight;
  }
  static getDefault() {
    return {
      recordedParentWidth: 0,
      recordedParentHeight: 0,
      recordedWindowWidth: 0,
      recordedWindowHeight: 0,
      border: TableBorderDimensionsUtils.generateDefault(),
      staticWidth: UNSET_NUMBER_IDENTIFIER,
      newColumnWidth: 140,
      indexColumnWidth: IndexColumn.DEFAULT_WIDTH
    };
  }
};
_TableDimensionsUtils.MINIMAL_TABLE_WIDTH = 70;
let TableDimensionsUtils = _TableDimensionsUtils;
class MaximumRows {
  static canAddMore(D) {
    var U;
    const { _columnsDetails: O, maxRows: x } = D, B = (U = O[0]) == null ? void 0 : U.elements.length;
    return !(B !== void 0 && x !== void 0 && x > 0 && x <= B);
  }
}
class FrameComponentsColors {
  // prettier-ignore
  static getInheritedHeaderColors(D) {
    var B, U, F, W, G, Y;
    const { _defaultColumnsSettings: { headerStyles: O, cellStyle: x } } = D;
    return {
      default: {
        backgroundColor: ((B = O == null ? void 0 : O.default) == null ? void 0 : B.backgroundColor) || (x == null ? void 0 : x.backgroundColor) || "",
        color: ((U = O == null ? void 0 : O.default) == null ? void 0 : U.color) || (x == null ? void 0 : x.color) || ""
      },
      hover: {
        backgroundColor: ((F = O == null ? void 0 : O.hoverColors) == null ? void 0 : F.backgroundColor) || ((W = O == null ? void 0 : O.default) == null ? void 0 : W.backgroundColor) || (x == null ? void 0 : x.backgroundColor) || D._defaultCellHoverColors.backgroundColor,
        color: ((G = O == null ? void 0 : O.hoverColors) == null ? void 0 : G.color) || ((Y = O == null ? void 0 : O.default) == null ? void 0 : Y.color) || (x == null ? void 0 : x.color) || D._defaultCellHoverColors.color
      }
    };
  }
  // prettier-ignore
  static getHoverColorValue(D, O) {
    var U, F, W;
    const { _frameComponents: { styles: x }, _defaultCellHoverColors: B } = D;
    return ((U = x == null ? void 0 : x.hoverColors) == null ? void 0 : U[O]) || ((F = x == null ? void 0 : x.default) == null ? void 0 : F[O]) || ((W = D._defaultColumnsSettings.cellStyle) == null ? void 0 : W[O]) || B[O];
  }
  static getDefaultColorValue(D, O) {
    var x, B, U;
    return ((B = (x = D._frameComponents.styles) == null ? void 0 : x.default) == null ? void 0 : B[O]) || ((U = D._defaultColumnsSettings.cellStyle) == null ? void 0 : U[O]) || "";
  }
  // prettier-ignore
  static setEventColors(D) {
    const O = {
      default: {
        backgroundColor: FrameComponentsColors.getDefaultColorValue(D, "backgroundColor"),
        color: FrameComponentsColors.getDefaultColorValue(D, "color")
      },
      hover: {
        backgroundColor: FrameComponentsColors.getHoverColorValue(D, "backgroundColor"),
        color: FrameComponentsColors.getHoverColorValue(D, "color")
      }
    }, { _frameComponents: { cellColors: x, inheritHeaderColors: B } } = D;
    x.data = O, x.header = B ? FrameComponentsColors.getInheritedHeaderColors(D) : O;
  }
  static getColorsBasedOnParam(D, O) {
    const { data: x, header: B } = D;
    return O === 0 ? B : x;
  }
  static getDefaultCellColors() {
    return {
      data: {
        default: { backgroundColor: "", color: "" },
        hover: { backgroundColor: "", color: "" }
      },
      header: {
        default: { backgroundColor: "", color: "" },
        hover: { backgroundColor: "", color: "" }
      }
    };
  }
}
class CellHighlightUtils {
  static fade(D, O) {
    D.style.backgroundColor = (O == null ? void 0 : O.backgroundColor) || "", D.style.color = (O == null ? void 0 : O.color) || "";
  }
  static highlight(D, O) {
    O != null && O.backgroundColor && (D.style.backgroundColor = O.backgroundColor), O != null && O.color && (D.style.color = O.color);
  }
  static unsetDefaultHoverProperties(D) {
    D.backgroundColor = "", D.color = "";
  }
  static getDefaultHoverProperties() {
    return { backgroundColor: "#f7f7f7", color: "" };
  }
}
class ElementOffset {
  static processLeft(D, O) {
    return Browser.IS_FIREFOX ? D += O.leftWidth : Browser.IS_SAFARI && (D -= O.leftWidth), D;
  }
  static processTop(D, O) {
    return Browser.IS_FIREFOX ? D += O.topWidth : Browser.IS_SAFARI && (D -= O.topWidth), D;
  }
  static processWidth(D, O) {
    return Browser.IS_FIREFOX && (D += O.leftWidth), D;
  }
}
class VisibilityUtils {
  static headerChanged(D) {
    setTimeout(() => {
      D._visiblityInternal.filters && FilterInternalUtils.resetAllInputs(D);
    });
  }
  static completeReset(D) {
    D._visiblityInternal.filters && FilterInternalUtils.completeReset(D);
  }
}
const _CaretDisplayFix = class _e {
  static removeContentEditable(D) {
    D.removeAttribute(_e.CONTENT_EDITABLE);
  }
  // THIS HAS TO BE CALLED IN A FOCUS EVENT!!!!!!!!!!!!!!!!!
  static setContentEditable(D) {
    D.setAttribute(_e.CONTENT_EDITABLE, "true");
  }
  static removeTabIndex(D) {
    D.removeAttribute(_e.TAB_INDEX);
  }
  static setTabIndex(D) {
    D.setAttribute(_e.TAB_INDEX, "0");
  }
  static removeBRPadding(D, O) {
    const B = CellElement.getTextElement(O).childNodes[0];
    B.tagName === _e.BR_TAG_NAME && (B.remove(), CaretPosition.setToEndOfText(D, O));
  }
  static addBRPaddingToEmptyCell(D, O) {
    const x = CellElement.getTextElement(D);
    O === EMPTY_STRING && x.childNodes.length === 0 && x.appendChild(document.createElement(_e.BR_TAG_NAME));
  }
  // caret is placed too far on top left
  // this happens when cell text is programmatically set to empty or when the user doubeclicks text and clicks backspace
  // natively firefox adds a 'br' element to replace the text when the user deletes it when clicking backspace for each
  // letter however it does not for the cases outlined previously, hence this is needed
  static toggleCellTextBRPadding(D, O, x) {
    const B = CellElement.getText(O);
    x && B !== EMPTY_STRING ? _e.removeBRPadding(D, O) : _e.addBRPaddingToEmptyCell(O, B);
  }
  static isIssueBrowser() {
    return Browser.IS_FIREFOX || Browser.IS_SAFARI;
  }
};
_CaretDisplayFix.CONTENT_EDITABLE = "contenteditable";
_CaretDisplayFix.TAB_INDEX = "tabindex";
_CaretDisplayFix.BR_TAG_NAME = "BR";
let CaretDisplayFix = _CaretDisplayFix;
const _CellTextElement = class et {
  static set(D, O) {
    D.innerText = "", D.contentEditable = "false", CaretDisplayFix.isIssueBrowser() && CaretDisplayFix.removeTabIndex(D), D.appendChild(O);
  }
  static createTextElement(D, O) {
    const x = document.createElement("div");
    return x.innerText = D, D === "" && CaretDisplayFix.addBRPaddingToEmptyCell(x, ""), x.classList.add(et.CELL_TEXT_DIV_CLASS), CellElement.prepContentEditable(x, O), x;
  }
  static setCellTextAsAnElement(D, O) {
    const x = CellElement.getText(D), B = et.createTextElement(x, O);
    return et.set(D, B), B;
  }
};
_CellTextElement.CELL_TEXT_DIV_CLASS = "cell-text-div";
let CellTextElement = _CellTextElement;
const _HeaderIconCellElement = class ye {
  static createTextElement(D, O) {
    const x = CellTextElement.setCellTextAsAnElement(D, O);
    return x.classList.add(ye.TEXT_CLASS), x.style.pointerEvents = O ? "" : "none", x;
  }
  static setScale(D, O) {
    const x = (O == null ? void 0 : O.x) || 1.2, B = (O == null ? void 0 : O.y) || 1.2, U = `scale(${x}, ${B})`;
    D.style.transform = U, D.style.webkitTransform = U;
  }
  static createSvgIcon(D, O) {
    var B, U;
    const x = SVGIconUtils.createSVGElement(D.svgString);
    return ye.setScale(x, (B = O.headerIconStyle) == null ? void 0 : B.scale), x.style.filter = ((U = O.headerIconStyle) == null ? void 0 : U.filterColor) || SVGIconUtils.HEADER_FILTER, x;
  }
  static createSVGContainer(D) {
    const O = document.createElement("div"), { containerStyles: x } = D;
    return x != null && x.dropdown && Object.assign(O.style, x == null ? void 0 : x.dropdown), x != null && x.headerCorrections && Object.assign(O.style, x == null ? void 0 : x.headerCorrections), O.classList.add(ye.ICON_CONTAINER_CLASS), O;
  }
  static createSVG(D, O) {
    const x = ye.createSVGContainer(D), B = ye.createSvgIcon(D, O);
    return x.appendChild(B), x;
  }
  static changeHeaderIcon(D) {
    const { elements: O, activeType: x, settings: B } = D, U = ye.createSVG(x.dropdownItem.settings.iconSettings, B), F = O[0];
    F.replaceChild(U, F.children[0]);
  }
  static setHeaderIconStructure(D, O, x) {
    var X, J, Q;
    const { activeType: B, settings: U } = D._columnsDetails[x], F = ye.createSVG(B.dropdownItem.settings.iconSettings, U), W = (Q = (J = (X = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : X.displaySettings) == null ? void 0 : J.openMethod) == null ? void 0 : Q.cellClick, G = U.isHeaderTextEditable && !W, Y = ye.createTextElement(O, G);
    O.insertBefore(F, Y);
  }
};
_HeaderIconCellElement.TEXT_CLASS = "header-icon-side-text";
_HeaderIconCellElement.ICON_CONTAINER_CLASS = "header-icon-container";
let HeaderIconCellElement = _HeaderIconCellElement;
const _DateCellInputElement = class Se {
  static isInputElement(D) {
    return (D == null ? void 0 : D.type) === Se.ELEMENT_TYPE;
  }
  static toggle(D, O) {
    if (!D)
      return;
    const x = D.children[1];
    x.style.display = O ? "block" : "none";
  }
  static extractInputElementFromCell(D) {
    return D.children[1].children[0];
  }
  static convertTextToInputValue(D, O) {
    if (O.calendar && (O.textValidation.func === void 0 || O.textValidation.func(D))) {
      const B = O.calendar.toYMDFunc(D);
      return [B[0], B[1].padStart(2, "0"), B[2].padStart(2, "0")].join("-");
    }
    return "-";
  }
  static updateInputBasedOnTextDiv(D, O) {
    const x = Se.convertTextToInputValue(CellElement.getText(D), O);
    Se.extractInputElementFromCell(D).value = x;
  }
  static createInputElement(D, O) {
    const x = document.createElement("input");
    return x.type = Se.ELEMENT_TYPE, x.classList.add(Se.DATE_INPUT_CLASS), x.value = Se.convertTextToInputValue(D, O), x;
  }
  static createInputElementContainer() {
    const D = document.createElement("div");
    return D.classList.add(Se.DATE_INPUT_CONTAINER_CLASS), D.style.display = "none", D;
  }
  static addDateInputElement(D, O, x) {
    const B = Se.createInputElementContainer(), U = Se.createInputElement(CellElement.getText(O), x);
    B.appendChild(U);
    const F = DateCellCalendarIconElement.get();
    B.appendChild(F), D.appendChild(B);
  }
};
_DateCellInputElement.ELEMENT_TYPE = "date";
_DateCellInputElement.DATE_INPUT_CLASS = "date-input";
_DateCellInputElement.DATE_INPUT_CONTAINER_CLASS = "date-input-container";
let DateCellInputElement = _DateCellInputElement;
class DateCellTextElement {
  static convertInputValueToText(D, O, x) {
    const B = RegexUtils.extractIntegerStrs(D);
    return B ? x.fromYMDFunc(B) : O;
  }
  static setCellTextAsAnElement(D, O) {
    const x = CellTextElement.setCellTextAsAnElement(D, O);
    return x.style.float = "left", x;
  }
}
const _DateCellCalendarIconEvents = class at {
  static mouseDownIcon(D, O, x) {
    const { _focusedElements: B, _activeOverlayElements: U } = this, W = x.target.previousSibling, G = CellElement.getCellElement(W);
    setTimeout(() => {
      FocusedCellUtils.set(B.cell, G, D, O), U.datePickerCell = G, Browser.IS_SAFARI ? W.dispatchEvent(new MouseEvent("click")) : W.showPicker();
    }, at.PICKER_DISPLAY_DELAY_ML);
  }
  static setEvents(D, O, x, B) {
    O.onmousedown = at.mouseDownIcon.bind(D, x, B);
  }
};
_DateCellCalendarIconEvents.PICKER_DISPLAY_DELAY_ML = Browser.IS_FIREFOX ? 190 : 0;
let DateCellCalendarIconEvents = _DateCellCalendarIconEvents;
var MOUSE_EVENT = /* @__PURE__ */ ((z) => (z.DOWN = "Down", z))(MOUSE_EVENT || {});
class DateCellInputEvents {
  // outstanding bug is when the user opens picker and moves with arrow keys, then clicks escape
  // the picker fires a clear event and does not actually close itself and instead goes to the
  // initially opened up date. The key up event for the escape button is also not fired.
  static escapeKeyInput(D) {
    if (D._activeOverlayElements.datePickerCell) {
      const O = D._focusedElements.cell.element;
      D._hoveredElements.dateCell !== O && DateCellInputElement.toggle(O, !1), delete D._activeOverlayElements.datePickerCell;
    }
  }
  // this is triggered when a date is selected via the date picker
  // prettier-ignore
  static inputInput(D, O, x) {
    const { elements: B, settings: { defaultText: U }, activeType: { calendar: F } } = this._columnsDetails[O];
    if (!F)
      return;
    const W = x.target.value, G = DateCellTextElement.convertInputValueToText(W, U, F), Y = B[D];
    CellEvents.updateCell(this, G, D, O, { element: Y });
  }
  // this is triggered when the user clicks on picker buttons
  static changeInput() {
    const D = this._focusedElements.cell.element;
    // this.userKeyEventsState[MOUSE_EVENT.DOWN] is used to prevent a bug where if the user opens the date picker,
    // uses arrow keys to navigate and clicks mouse down back on the cell - this event is fired
    !this._userKeyEventsState[MOUSE_EVENT.DOWN] && // do not hide icon when currently hovered
    this._hoveredElements.dateCell !== D && DateCellInputElement.toggle(D, !1), delete this._activeOverlayElements.datePickerCell;
  }
  // the user does not use the actual input element and the events are triggered via the date picker
  static setEvents(D, O, x, B) {
    O.onchange = DateCellInputEvents.changeInput.bind(D), O.oninput = DateCellInputEvents.inputInput.bind(D, x, B);
  }
}
class FocusNextColumnCellFromTextDiv {
  static focusDifferentColumnCell(D, O, x) {
    const { elements: B, activeType: U, settings: F } = D._columnsDetails[O], W = B[x];
    if (!F.isCellTextEditable || x === 0 && !F.isHeaderTextEditable || // REF-29
    Browser.IS_SAFARI && CheckboxCellElement.isCheckboxCell(W))
      return FocusNextColumnCellFromTextDiv.focusOrBlurNext(D, O, x);
    U.cellDropdownProps ? W.dispatchEvent(new Event("mousedown")) : (CellWithTextEvents.programmaticBlur(D), CellElement.getTextElement(W).focus()), W.scrollIntoView({ block: "nearest" });
  }
  static focusOrBlurNextRowFirstCell(D, O) {
    const x = D._columnsDetails[0], B = O + 1;
    x.elements[B] ? FocusNextColumnCellFromTextDiv.focusDifferentColumnCell(D, 0, B) : D._focusedElements.cell.element.children[0].blur();
  }
  static focusOrBlurNext(D, O, x) {
    D._columnsDetails[O + 1] ? FocusNextColumnCellFromTextDiv.focusDifferentColumnCell(D, O + 1, x) : FocusNextColumnCellFromTextDiv.focusOrBlurNextRowFirstCell(D, x);
  }
}
class CellTextEvents {
  static tabOutOfCell(D, O, x, B) {
    B.preventDefault(), DataCellEvents.keyDownCell.bind(D, O, x)(B), FocusNextColumnCellFromTextDiv.focusOrBlurNext(D, x, O);
  }
}
class DateCellTextEvents {
  static keyDownOnText(D, O, x) {
    x.key === KEYBOARD_KEY.TAB && CellTextEvents.tabOutOfCell(this, D, O, x);
  }
  static inputText(D, O) {
    if (Browser.IS_INPUT_DATE_SUPPORTED) {
      const { activeType: x } = this._columnsDetails[D], B = CellElement.getCellElement(O.target);
      DateCellInputElement.updateInputBasedOnTextDiv(B, x);
    }
  }
  static blurText(D, O, x) {
    const B = x.target;
    DataCellEvents.blur(this, D, O, B);
  }
  static setEvents(D, O, x, B) {
    D._columnsDetails[B].settings.isCellTextEditable && (O.onfocus = CellWithTextEvents.focusText.bind(D, x, B, null), O.onblur = DateCellTextEvents.blurText.bind(D, x, B), O.oninput = DateCellTextEvents.inputText.bind(D, B), O.onkeydown = DateCellTextEvents.keyDownOnText.bind(D, x, B));
  }
}
class DateCellEvents {
  static mouseLeaveCell(D) {
    if (delete this._hoveredElements.dateCell, Browser.IS_INPUT_DATE_SUPPORTED) {
      const O = D.target;
      if (this._activeOverlayElements.datePickerCell === O)
        return;
      DateCellInputElement.toggle(O, !1);
    }
  }
  static mouseEnterCell(D) {
    this._hoveredElements.dateCell = D.target, Browser.IS_INPUT_DATE_SUPPORTED && DateCellInputElement.toggle(this._hoveredElements.dateCell, !0);
  }
  static setEvents(D, O, x, B) {
    if (!D._columnsDetails[B].settings.isCellTextEditable)
      return;
    O.onblur = () => {
    }, O.onfocus = () => {
    }, O.onmouseenter = DateCellEvents.mouseEnterCell.bind(D), O.onmouseleave = DateCellEvents.mouseLeaveCell.bind(D), O.onmousedown = CellWithTextEvents.mouseDown.bind(D, null);
    const U = O.children[0];
    if (DateCellTextEvents.setEvents(D, U, x, B), Browser.IS_INPUT_DATE_SUPPORTED) {
      const F = O.children[1];
      DateCellInputEvents.setEvents(D, F, x, B);
      const W = F.children[1];
      DateCellCalendarIconEvents.setEvents(D, W, x, B);
    }
  }
}
class DateCellElement {
  // prettier-ignore
  static setCellDateStructure(D, O, x) {
    ConvertCellTypeUtils.preprocessCell(O), O.style.cursor = "text";
    const { isCellTextEditable: B } = D._columnsDetails[x].settings, U = DateCellTextElement.setCellTextAsAnElement(O, B);
    Browser.IS_INPUT_DATE_SUPPORTED && DateCellInputElement.addDateInputElement(
      O,
      U,
      D._columnsDetails[x].activeType
    );
  }
  static setColumnDateStructure(D, O) {
    CellStructureUtils.setColumn(D, O, DateCellElement.setCellDateStructure, DateCellEvents.setEvents);
  }
}
const _SelectCellTextElement = class Ct {
  static setCellTextAsAnElement(D, O, x) {
    const { isCellTextEditable: B } = D._columnsDetails[x].settings;
    CellTextElement.setCellTextAsAnElement(O, B).classList.add(Ct.TEXT_CLASS);
  }
  // prettier-ignore
  static finaliseEditedText(D, O, x) {
    var X, J;
    const B = D._columnsDetails[x], { cellDropdown: U, activeType: F, settings: W } = B, G = CellElement.getText(O), Y = !!((X = U.itemsDetails[G]) != null && X.backgroundColor);
    (J = F.cellDropdownProps) != null && J.canAddMoreOptions && G !== EMPTY_STRING && !Y && (!W.isDefaultTextRemovable || G !== W.defaultText) && CellDropdownItem.addNewItem(D, O, B, O.style.backgroundColor);
  }
};
_SelectCellTextElement.TEXT_CLASS = "select-cell-text";
let SelectCellTextElement = _SelectCellTextElement;
class SelectCellBaseEvents {
  static blurIfDropdownFocused(D) {
    D._focusedElements.cellDropdown && CellWithTextEvents.programmaticBlur(D);
  }
}
class SelectCellEvents {
  static mouseLeaveCell(D, O) {
    delete this._hoveredElements.selectCell;
    const x = O.target, { cellDropdown: B } = this._columnsDetails[D];
    (!Dropdown.isDisplayed(B.element) || B.displayedCellElement !== x) && ArrowDownIconElement.toggle(x, !1);
  }
  static mouseEnterCell(D) {
    this._hoveredElements.selectCell = D.target, ArrowDownIconElement.toggle(this._hoveredElements.selectCell, !0);
  }
  static mouseDownCell(D) {
    var x;
    const O = D.target;
    if (O.classList.contains(CellElement.CELL_CLASS))
      CellWithTextEvents.mouseDownCell(this, SelectCellBaseEvents.blurIfDropdownFocused, O, D);
    else if (O.classList.contains(ArrowDownIconElement.ARROW_ICON_CLASS)) {
      const B = (x = O.parentElement) == null ? void 0 : x.parentElement;
      CellWithTextEvents.mouseDownCell(this, SelectCellBaseEvents.blurIfDropdownFocused, B, D);
    }
  }
  static setEvents(D, O, x, B) {
    if (!D._columnsDetails[B].settings.isCellTextEditable)
      return;
    O.onblur = () => {
    }, O.onfocus = () => {
    }, O.onmouseenter = SelectCellEvents.mouseEnterCell.bind(D), O.onmouseleave = SelectCellEvents.mouseLeaveCell.bind(D, B), O.onmousedown = SelectCellEvents.mouseDownCell.bind(D);
    const U = O.children[0];
    SelectCellTextBaseEvents.setEvents(D, U, x, B);
  }
}
class SelectCellElement {
  static setCellSelectStructure(D, O, x) {
    ConvertCellTypeUtils.preprocessCell(O), SelectCellTextElement.setCellTextAsAnElement(D, O, x), O.appendChild(ArrowDownIconElement.get()), SelectCell.setPointerCursorIfCantAdd(O, D._columnsDetails[x].activeType);
  }
  static setColumnSelectStructure(D, O) {
    CellStructureUtils.setColumn(D, O, SelectCellElement.setCellSelectStructure, SelectCellEvents.setEvents);
  }
}
class LabelCellEvents {
  static setEvents(D, O, x, B) {
    if (!D._columnsDetails[B].settings.isCellTextEditable)
      return;
    O.onblur = () => {
    }, O.onfocus = () => {
    }, O.onmouseenter = () => {
    }, O.onmouseleave = () => {
    }, O.onmousedown = CellWithTextEvents.mouseDown.bind(D, SelectCellBaseEvents.blurIfDropdownFocused);
    const U = O.children[0];
    SelectCellTextBaseEvents.setEvents(D, U, x, B);
  }
}
class LabelCellElement {
  // prettier-ignore
  static setCellLabelStructure(D, O, x) {
    var W;
    ConvertCellTypeUtils.preprocessCell(O);
    const { cellDropdown: { itemsDetails: B }, settings: { isCellTextEditable: U } } = D._columnsDetails[x], F = ((W = B[CellElement.getText(O)]) == null ? void 0 : W.backgroundColor) || "";
    LabelCellTextElement.setCellTextAsAnElement(O, F, U), SelectCell.setPointerCursorIfCantAdd(O, D._columnsDetails[x].activeType);
  }
  static setColumnLabelStructure(D, O) {
    CellStructureUtils.setColumn(D, O, LabelCellElement.setCellLabelStructure, LabelCellEvents.setEvents);
  }
}
class SelectCell {
  static convertCell(D, O, x) {
    var U;
    (U = D._columnsDetails[O].activeType.cellDropdownProps) != null && U.isBasicSelect ? SelectCellElement.setCellSelectStructure(D, x, O) : LabelCellElement.setCellLabelStructure(D, x, O);
  }
  static convertColumn(D, O, x) {
    var B;
    (B = x.cellDropdownProps) != null && B.isBasicSelect ? SelectCellElement.setColumnSelectStructure(D, O) : LabelCellElement.setColumnLabelStructure(D, O);
  }
  static setEvents(D, O, x, B) {
    var F;
    const { activeType: U } = D._columnsDetails[B];
    (F = U.cellDropdownProps) != null && F.isBasicSelect ? SelectCellEvents.setEvents(D, O, x, B) : LabelCellEvents.setEvents(D, O, x, B);
  }
  // prettier-ignore
  static finaliseEditedText(D, O, x, B = !1) {
    var F;
    const { activeType: U } = D._columnsDetails[x];
    (F = U.cellDropdownProps) != null && F.isBasicSelect ? SelectCellTextElement.finaliseEditedText(D, O, x) : LabelCellTextElement.finaliseEditedText(D, O, x, B);
  }
  static setPointerCursorIfCantAdd(D, O) {
    var x;
    if (D.style.cursor = "pointer", !((x = O.cellDropdownProps) != null && x.canAddMoreOptions)) {
      const B = D.children[0];
      B.style.caretColor = "transparent", B.style.cursor = "pointer";
    }
  }
}
class DataCellElement {
  static setCellDataStructure(D, O, x) {
    O.innerText = CellElement.getTextElement(O).innerText;
    const { isCellTextEditable: B } = D._columnsDetails[x].settings;
    CellElement.prepContentEditable(O, B);
  }
  static setColumnDataStructure(D, O) {
    CellStructureUtils.setColumn(D, O, DataCellElement.setCellDataStructure, DataCellEvents.setEvents);
  }
}
class ChangeColumnType {
  static setInvalidCellToDefault(D, O, x) {
    const B = O + 1, U = D._columnsDetails[x].elements[B];
    return CellEvents.setCellToDefaultIfNeeded(D, B, x, U, !1);
  }
  static setInvalidCellsToDefault(D, O) {
    let x = !1;
    D.data.slice(1).forEach((B, U) => {
      ChangeColumnType.setInvalidCellToDefault(D, U, O) && !x && (x = !0);
    }), x && setTimeout(() => FireEvents.onDataUpdate(D));
  }
  static setNew(D, O, x) {
    const B = D._columnsDetails[x];
    return B.activeType = B.settings.types.find((U) => U.name === O), B.activeType;
  }
  static setNewStructureBasedOnType(D, O, x) {
    delete D._columnsDetails[O].cellDropdown.labelDetails, x.cellDropdownProps ? (CellDropdown.setUpDropdown(D, O), SelectCell.convertColumn(D, O, x)) : x.calendar ? DateCellElement.setColumnDateStructure(D, O) : x.checkbox ? CheckboxCellElement.setColumnCheckboxStructure(D, O) : DataCellElement.setColumnDataStructure(D, O);
  }
  // this is required as switching to another type makes it difficult to overwrite text element (as there isn't one) for
  // checkboxes when validation fails
  static resetCheckboxElements(D) {
    D.elements.slice(1).forEach((O) => {
      O.innerText = CellElement.getText(O);
    });
  }
  static resetAndChangeFunc(D, O, x) {
    const B = D._columnsDetails[x];
    B.activeType.checkbox && ChangeColumnType.resetCheckboxElements(B);
    const U = ChangeColumnType.setNew(D, O, x);
    U.textValidation.func && U.textValidation.setTextToDefaultOnFail && ChangeColumnType.setInvalidCellsToDefault(D, x), ChangeColumnType.setNewStructureBasedOnType(D, x, U), D.displayHeaderIcons && HeaderIconCellElement.changeHeaderIcon(D._columnsDetails[x]), setTimeout(() => FireEvents.onColumnsUpdate(D));
  }
  // prettier-ignore
  static change(D, O) {
    const x = this._columnsDetails[O].activeType;
    D !== x.name && ProcessedDataTextStyle.resetDataCellsStyle(
      this,
      O,
      ChangeColumnType.resetAndChangeFunc.bind(this, this, D, O)
    );
  }
}
class CheckboxValidationFunc {
  // cannot place this inside the CheckboxCellElement class as certain dependencies are not imported in time
  static getDefault() {
    return (D) => {
      const O = String(D).trim().toLocaleLowerCase();
      return O === "" || O === "0" || O === "00" || O === "false" ? "false" : "true";
    };
  }
}
const CURRENCY_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16">
	<g transform="matrix(0.84210527 0 0 0.84210527 0 0)">
		<g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
			<g>
				<path d="M441.1 297.29C 422.358 282.915 397.057 271.728 364.155 263.138L364.155 263.138L364.155 113.058C 378.792 114.1439 405.382 119.14 452.362 140.058C 458.8308 142.9291 466.339 142.1322 472.061 137.97209C 477.7837 133.81189 480.854 126.91709 480.1157 119.87809C 479.38132 112.84289 474.9477 106.73009 468.4867 103.843094C 413.2097 79.230095 381.8067 74.17909 364.15668 73.300095L364.15668 73.300095L364.15668 42.152092C 364.15668 34.335693 357.82077 27.996092 350.00067 27.996092C 342.18057 27.996092 335.84467 34.33589 335.84467 42.152092L335.84467 42.152092L335.84467 73.93709C 307.65366 76.28479 280.86768 87.23009 259.09866 105.29208C 234.52066 125.13208 220.09067 154.91309 219.75467 186.49509C 219.5242 216.7761 234.14967 245.24908 258.89966 262.7021C 277.64166 277.0771 302.94266 288.2641 335.84467 296.8541L335.84467 296.8541L335.84467 446.93408C 321.20767 445.84818 294.60666 440.84818 247.63766 419.93408L247.63766 419.93408L247.63766 419.93018C 241.16887 417.05908 233.66066 417.856 227.93866 422.01608C 222.21596 426.17627 219.14566 433.07108 219.88396 440.11008C 220.61833 447.14526 225.05196 453.2581 231.51295 456.14508C 286.72797 480.73108 318.18097 485.80908 335.84296 486.69608L335.84296 486.69608L335.84296 517.8371C 335.84296 525.6535 342.17886 531.9931 349.99896 531.9931C 357.81906 531.9931 364.15497 525.6533 364.15497 517.8371L364.15497 517.8371L364.15497 486.0521C 392.34598 483.7044 419.13196 472.7591 440.90097 454.69708C 465.47897 434.8571 479.90897 405.07608 480.24496 373.49408C 480.47543 343.21307 465.84998 314.74008 441.09998 297.28708L441.09998 297.28708L441.1 297.29zM282.99 231.22801C 268.099 221.23581 259.232 204.42702 259.392 186.49802C 259.81778 166.59201 269.1029 147.90802 284.712 135.54501C 299.302 123.52501 317.06 115.99001 335.841 113.85401L335.841 113.85401L335.841 255.71402C 316.907 250.75702 299.013 242.46402 282.989 231.22601zM415.27997 424.448L415.28387 424.448C 400.69388 436.468 382.93588 444.003 364.15488 446.139L364.15488 446.139L364.15488 304.279C 383.08887 309.236 400.98288 317.529 417.00687 328.767C 431.89786 338.7592 440.76486 355.568 440.60486 373.497C 440.17908 393.403 430.89395 412.087 415.28485 424.45z" stroke="none" fill="#000000" fill-rule="nonzero" />
			</g>
		</g>
	</g>
</svg>`, CHECKBOX_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="13">
  <g transform="matrix(0.68421054 0 0 0.68421054 0 0)">
    <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
      <g>
        <path d="M521.77 0L178.24002 0C 119.416016 0 70.01002 49.41 70.01002 108.23L70.01002 108.23L70.01002 454.11002C 70.01002 512.934 119.42001 562.34 178.24002 562.34L178.24002 562.34L524.12 562.34C 582.944 562.34 632.35 512.93005 632.35 454.11002L632.35 454.11002L632.35 108.23001C 629.99835 49.40601 582.94 7.6293945E-06 521.76 7.6293945E-06L521.76 7.6293945E-06L521.77 0zM587.653 451.77C 587.653 487.063 559.419 515.30096 524.122 515.30096L524.122 515.30096L178.242 515.29706C 142.949 515.29706 114.711006 487.06305 114.711006 451.76605L114.711006 451.76605L114.71491 108.23605C 114.71491 72.943054 142.94891 44.705055 178.24591 44.705055L178.24591 44.705055L524.1259 44.705055C 559.41895 44.705055 587.6569 72.93906 587.6569 108.23605z" stroke="none" fill="#010101" fill-rule="nonzero" />
        <path d="M479.41 164.71L293.53 350.59003L222.94 280.00003C 213.5298 270.58984 201.764 270.58984 192.35 280.00003C 182.9398 289.41022 182.9398 301.17603 192.35 310.59003L192.35 310.59003L279.409 397.64902C 281.7684 400.0006 286.4715 402.3521 293.534 402.3521C 300.5926 402.3521 305.3 400.00052 307.651 395.29352L307.651 395.29352L510.001 192.94351C 517.05963 185.88492 517.05963 171.76752 510.001 164.70952C 500.59082 155.29543 486.47 155.29543 479.411 164.70952L479.411 164.70952L479.41 164.71z" stroke="none" fill="#010101" fill-rule="nonzero" />
      </g>
    </g>
  </g>
</svg>`, SELECT_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="14">
	<g transform="matrix(0.9 0 0 0.93333334 0 0)">
		<g transform="matrix(0.03 0 0 0.03 2.5000005 -0)">
			<g transform="matrix(1 0 0 1 -86.77152 -33.81399)">
				<g transform="matrix(1 0 0 1 -13.737094 17.33647)">
					<path d="M399.537 218.885L277.33 218.885C 262.315 218.885 254.544 236.996 265.421 247.859L265.421 247.859L328.596 310.981C 335.328 317.708 346.201 317.708 352.933 310.466L352.933 310.466L411.966 247.343C 421.805 236.476 414.555 218.885 399.537 218.885z" stroke="none" fill="#000000" fill-rule="nonzero" />
					<path d="M340.559 56.069C 226.133 56.069 128.026 151.307 128.026 265.753C 128.026 380.198 224.339 475.408 338.765 475.408C 453.191 475.408 547.665 380.561 547.665 266.116C 547.665 151.67 454.985 56.069 340.559 56.069zM338.765 452.542C 235.73 452.542 152.37 369.168 152.37 266.116C 152.37 163.063 235.73 79.689 338.765 79.689C 441.8 79.689 525.16 163.063 525.16 266.116C 525.157 369.168 441.797 452.542 338.765 452.542z" stroke="none" fill="#000000" fill-rule="nonzero" />
				</g>
			</g>
		</g>
	</g>
</svg>`, NUMBER_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14">
	<g transform="matrix(0.7368421 0 0 0.7368421 0 0)">
		<g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
			<path d="M577.5 175L471.36 175L489.78598 55.160004C 490.4813 49.101402 487.96957 43.117004 483.15707 39.367004C 478.34848 35.620903 471.93008 34.644302 466.22308 36.796703C 460.51608 38.949005 456.34418 43.917805 455.2071 49.909702L455.2071 49.909702L435.9371 174.9997L296.35712 174.9997L314.7831 55.1597C 315.66983 50.4917 314.61905 45.6597 311.87292 41.7807C 309.12292 37.901802 304.91592 35.308 300.21692 34.5971C 295.51773 33.88226 290.7325 35.11272 286.95493 37.999397C 283.18152 40.886097 280.74402 45.186897 280.20493 49.909397L280.20493 49.909397L260.93494 174.99939L157.49493 174.99939C 151.24103 174.99939 145.46393 178.3353 142.33893 183.74939C 139.21393 189.16348 139.21393 195.83539 142.33893 201.24939C 145.46393 206.66339 151.24123 209.99939 157.49493 209.99939L157.49493 209.99939L255.49493 209.99939L234.02194 349.9994L122.49194 349.9994C 116.238045 349.9994 110.460945 353.3353 107.335945 358.7494C 104.210945 364.16348 104.210945 370.8354 107.335945 376.2494C 110.460945 381.6634 116.23824 384.9994 122.49194 384.9994L122.49194 384.9994L228.63194 384.9994L210.20595 504.8394C 209.31923 509.5074 210.37001 514.33936 213.11615 518.2184C 215.86615 522.0973 220.07315 524.6911 224.77216 525.402C 229.47136 526.1168 234.25656 524.88635 238.03415 521.9997C 241.80756 519.113 244.24506 514.8122 244.78415 510.0897L244.78415 510.0897L264.05414 384.9997L403.63416 384.9997L385.20816 504.8397C 384.32144 509.5077 385.37222 514.3397 388.11835 518.2187C 390.86835 522.0976 395.07535 524.6914 399.77435 525.4023C 404.47354 526.1171 409.25876 524.88666 413.03635 522C 416.80975 519.1133 419.24725 514.8125 419.78635 510.09L419.78635 510.09L439.05634 385L542.49634 385C 548.75024 385 554.52734 381.6641 557.65234 376.25C 560.77734 370.8359 560.77734 364.164 557.65234 358.75C 554.52734 353.336 548.75006 350 542.49634 350L542.49634 350L444.49634 350L466.03934 210L577.4993 210C 583.75323 210 589.53033 206.6641 592.65533 201.25C 595.78033 195.8359 595.78033 189.164 592.65533 183.75C 589.53033 178.336 583.75305 175 577.4993 175L577.4993 175L577.5 175zM430.5 210L408.957 350L269.497 350L291.04 210z" stroke="none" fill="#000000" fill-rule="nonzero" />
		</g>
	</g>
</svg>`, LABEL_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14">
	<g transform="matrix(0.7368421 0 0 0.7368421 0 0)">
		<g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
			<g>
				<path d="M279.16 122.86L470.53 122.86L470.53 95.829C 470.53 82.16901 464.9362 69.755005 455.913 60.735C 446.8896 51.7116 434.475 46.118 420.835 46.118L420.835 46.118L165.825 46.118C 152.165 46.118 139.75099 51.7118 130.73099 60.735C 121.70759 69.7584 116.11399 82.173004 116.11399 95.829L116.11399 95.829L116.11399 350.839C 116.11399 364.47998 121.707794 376.913 130.73099 385.917C 139.7544 394.9404 152.16899 400.534 165.82498 400.534L165.82498 400.534L192.85599 400.534L192.85599 209.164C 192.85599 185.41 202.5669 163.836 218.19199 148.195C 233.81708 132.55402 255.40298 122.85901 279.16098 122.85901L279.16098 122.85901L279.16 122.86zM507.14 122.86L534.171 122.86C 557.92505 122.86 579.499 132.5709 595.14 148.196C 610.765 163.821 620.476 185.407 620.476 209.16501L620.476 209.16501L620.476 464.175C 620.476 487.929 610.76514 509.503 595.14 525.144C 579.499 540.785 557.929 550.48 534.171 550.48L534.171 550.48L279.161 550.48C 255.40701 550.48 233.83301 540.7691 218.19202 525.144C 202.55103 509.51886 192.85602 487.93298 192.85602 464.175L192.85602 464.175L192.85602 437.14398L165.82501 437.14398C 142.07101 437.14398 120.49701 427.43307 104.85601 411.80798C 89.23101 396.18298 79.52001 374.597 79.52001 350.839L79.52001 350.839L79.52001 95.828995C 79.52001 72.075 89.23091 50.500996 104.85601 34.859993C 120.49701 19.234993 142.06702 9.523993 165.82501 9.523993L165.82501 9.523993L420.83502 9.523993C 444.58902 9.523993 466.16302 19.234894 481.80402 34.859993C 497.445 50.50099 507.14 72.07099 507.14 95.828995zM534.171 159.469L279.161 159.469C 265.52002 159.469 253.087 165.06279 244.08301 174.086C 235.0596 183.1094 229.466 195.524 229.466 209.18L229.466 209.18L229.466 464.19C 229.466 477.831 235.0598 490.264 244.08301 499.284C 253.10641 508.3074 265.521 513.901 279.161 513.901L279.161 513.901L534.171 513.901C 547.831 513.901 560.245 508.3072 569.265 499.284C 578.2884 490.2606 583.882 477.846 583.882 464.19L583.882 464.19L583.882 209.18001C 583.882 195.539 578.2882 183.106 569.265 174.086C 560.24164 165.06259 547.827 159.469 534.171 159.469z" stroke="none" fill="#000000" fill-rule="nonzero" />
			</g>
		</g>
	</g>
</svg>`, TEXT_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12">
  <g transform="matrix(0.6315789 0 0 0.6315789 0 0)">
    <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
      <g>
        <path d="M84 32.48L616 32.48L616 92.96L84 92.96L84 32.48z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M84 177.52L470.4 177.52L470.4 238L84 238L84 177.52z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M84 322.56L616 322.56L616 383.04L84 383.04L84 322.56z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M84 467.6L470.4 467.6L470.4 528.08L84 528.08L84 467.6z" stroke="none" fill="#000000" fill-rule="nonzero" />
      </g>
    </g>
  </g>
</svg>`;
var DEFAULT_COLUMN_TYPES = /* @__PURE__ */ ((z) => (z.TEXT = "Text", z.NUMBER = "Number", z.CURRENCY = "Currency", z.DATE_DMY = "Date d-m-y", z.DATE_MDY = "Date m-d-y", z.CHECKBOX = "Checkbox", z.SELECT = "Select", z.LABEL = "Label", z))(DEFAULT_COLUMN_TYPES || {});
const _CalendarFunctionalityUtils = class {
  static mdYCellTextToYMD(D) {
    const O = RegexUtils.extractIntegerStrs(D);
    return [O[2], O[0], O[1]];
  }
  static yMDToMDYCellText(D) {
    return [D[1], D[2], D[0]].join("-");
  }
  static dMYCellTextToYMD(D) {
    const O = RegexUtils.extractIntegerStrs(D);
    return [O[2], O[1], O[0]];
  }
  static yMDToDMYCellText(D) {
    return [D[2], D[1], D[0]].join("-");
  }
};
_CalendarFunctionalityUtils.DEFAULT_TYPES_FUNCTIONALITY = {
  [DEFAULT_COLUMN_TYPES.DATE_DMY]: {
    toYMDFunc: (z) => _CalendarFunctionalityUtils.dMYCellTextToYMD(z),
    fromYMDFunc: (z) => _CalendarFunctionalityUtils.yMDToDMYCellText(z)
  },
  [DEFAULT_COLUMN_TYPES.DATE_MDY]: {
    toYMDFunc: (z) => _CalendarFunctionalityUtils.mdYCellTextToYMD(z),
    fromYMDFunc: (z) => _CalendarFunctionalityUtils.yMDToMDYCellText(z)
  }
};
let CalendarFunctionalityUtils = _CalendarFunctionalityUtils;
const _Validation = class {
  static setSelectValidation(D, O, x) {
    var U, F;
    if (!((U = D.cellDropdownProps) != null && U.options) || (F = D.cellDropdownProps) != null && F.canAddMoreOptions)
      return;
    const B = new Set(D.cellDropdownProps.options.map((W) => W.text));
    D.textValidation ?? (D.textValidation = {}), D.textValidation.func = (W) => !!B.has(W) || !O && W === x;
  }
};
_Validation.DEFAULT_TYPES_REGEX = {
  [DEFAULT_COLUMN_TYPES.CURRENCY]: new RegExp(
    // eslint-disable-next-line max-len
    /^(([$€£¥]\s*?-?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?)|(-?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?\s*?[$€£¥]))$/
  ),
  // \s*? is used to allow spaces between symbols
  [DEFAULT_COLUMN_TYPES.DATE_DMY]: new RegExp(
    /^(0?[1-9]|[12][0-9]|3[01])\s*?[/-]\s*?(0?[1-9]|1[012])\s*?[/-]\s*?\d{4}$/
  ),
  [DEFAULT_COLUMN_TYPES.DATE_MDY]: new RegExp(
    /^(0?[1-9]|1[012])\s*?[/-]\s*?(0?[1-9]|[12][0-9]|3[01])\s*?[/-]\s*?\d{4}$/
  )
};
_Validation.DEFAULT_TYPES_FUNCTIONALITY = {
  [DEFAULT_COLUMN_TYPES.NUMBER]: (z) => z !== EMPTY_STRING && !isNaN(z),
  [DEFAULT_COLUMN_TYPES.CURRENCY]: (z) => _Validation.DEFAULT_TYPES_REGEX[DEFAULT_COLUMN_TYPES.CURRENCY].test(z),
  [DEFAULT_COLUMN_TYPES.DATE_DMY]: (z) => _Validation.DEFAULT_TYPES_REGEX[DEFAULT_COLUMN_TYPES.DATE_DMY].test(z),
  [DEFAULT_COLUMN_TYPES.DATE_MDY]: (z) => _Validation.DEFAULT_TYPES_REGEX[DEFAULT_COLUMN_TYPES.DATE_MDY].test(z)
};
let Validation = _Validation;
class CellElementIndex {
  static getViaColumnIndex(D, O) {
    const x = Number(O);
    return D * 2 + x;
  }
}
const _Sort = class pe {
  static extractNumberFromString(D) {
    const O = RegexUtils.extractFloatStrs(D);
    return O && O.length > 0 ? Number(O[0]) : 0;
  }
  // cannot safely identify if nothing has been changed, hence need to send out an update for all cells
  // prettier-ignore
  static update(D, O) {
    const { _tableBodyElementRef: x, _frameComponents: { displayIndexColumn: B }, data: U } = D, F = x.children;
    O.forEach((W, G) => {
      const Y = G + 1, X = F[Y].children;
      W.forEach((J, Q) => {
        const le = CellElementIndex.getViaColumnIndex(Q, !!B), re = X[le];
        CellEvents.updateCell(
          D,
          J,
          Y,
          Q,
          { processText: !1, element: re, updateTableEvent: !1, updateData: !1 }
        ), ColumnTypesUtils.updateDataElements(D, G, Q, re);
      });
    }), U.splice(1, O.length, ...O), setTimeout(() => FireEvents.onDataUpdate(D));
  }
  static sortStringsColumnAscending(D, O) {
    D.sort((x, B) => String(x[O]).localeCompare(String(B[O])));
  }
  static sortStringsColumnDescending(D, O) {
    D.sort((x, B) => String(B[O]).localeCompare(String(x[O])));
  }
  static sortStrings(D, O, x) {
    x ? pe.sortStringsColumnAscending(D, O) : pe.sortStringsColumnDescending(D, O);
  }
  // prettier-ignore
  static parseComparedText(D, O, x, B) {
    const U = B(D);
    if (U === void 0)
      return x ? 1 : -1;
    const F = B(O);
    return F === void 0 ? x ? -1 : 1 : [U, F];
  }
  static validateType(D, O) {
    return D === void 0 || D(O) ? O : void 0;
  }
  // prettier-ignore
  static validateAndSort(D, O, x, B, U) {
    const F = pe.parseComparedText(D, O, U, pe.validateType.bind(this, B));
    return typeof F == "number" ? F : (U ? x.ascendingFunc : x.descendingFunc)(F[0], F[1]);
  }
  static sortViaSortFuncs(D, O, x, B) {
    const { sorting: U, textValidation: F } = D;
    U && O.sort(
      (W, G) => pe.validateAndSort(W[x], G[x], U, F.func, B)
    );
  }
  static compareDates(D, O) {
    return new Date(...D) - new Date(...O);
  }
  static parseYMDFormat(D, O, x) {
    return pe.validateType(D, x) ? O.toYMDFunc(x) : void 0;
  }
  // prettier-ignore
  static sortDates(D, O, x, B) {
    const { calendar: U, textValidation: F } = D;
    U && O.sort((W, G) => {
      const Y = pe.parseComparedText(
        W[x],
        G[x],
        !0,
        pe.parseYMDFormat.bind(this, F.func, U)
      );
      return typeof Y == "number" ? Y : B ? pe.compareDates(Y[0], Y[1]) : pe.compareDates(Y[1], Y[0]);
    });
  }
  static sortColumn(D, O, x) {
    const B = D.data.slice(1), { activeType: U } = D._columnsDetails[O];
    U.calendar ? pe.sortDates(U, B, O, x) : U.sorting ? pe.sortViaSortFuncs(U, B, O, x) : pe.sortStrings(B, O, x), pe.update(D, B);
  }
};
_Sort.DEFAULT_TYPES_SORT_FUNCS = {
  [DEFAULT_COLUMN_TYPES.NUMBER]: {
    ascendingFunc: (z, D) => Number(z) - Number(D),
    descendingFunc: (z, D) => Number(D) - Number(z)
  },
  [DEFAULT_COLUMN_TYPES.CURRENCY]: {
    ascendingFunc: (z, D) => _Sort.extractNumberFromString(z) - _Sort.extractNumberFromString(D),
    descendingFunc: (z, D) => _Sort.extractNumberFromString(D) - _Sort.extractNumberFromString(z)
  }
};
let Sort = _Sort;
const _DefaultColumnTypes = class Et {
  // REF-28
  static createDropdownItemsForDefaultTypes() {
    Et.DEFAULT_TYPES.forEach((D) => {
      const O = {
        text: D.name,
        iconSettings: D.iconSettings || DropdownButtonItemConf.DEFAULT_ITEM.iconSettings
      };
      D.dropdownItem = {
        element: DropdownItem.createButtonItemNoEvents(void 0, O),
        settings: O
      };
    });
  }
};
_DefaultColumnTypes.FALLBACK_TYPE = {
  name: DEFAULT_COLUMN_TYPES.TEXT,
  iconSettings: {
    svgString: TEXT_ICON_SVG_STRING,
    containerStyles: {
      dropdown: { marginLeft: "-0.25px", marginRight: "6px", marginTop: "2.5px" },
      headerCorrections: { marginTop: "2.5px" }
    }
  }
};
_DefaultColumnTypes.DEFAULT_TYPES = [
  _DefaultColumnTypes.FALLBACK_TYPE,
  {
    name: DEFAULT_COLUMN_TYPES.NUMBER,
    textValidation: { func: Validation.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.NUMBER] },
    sorting: Sort.DEFAULT_TYPES_SORT_FUNCS[DEFAULT_COLUMN_TYPES.NUMBER],
    iconSettings: {
      svgString: NUMBER_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginLeft: "-1px", marginRight: "4.5px", marginTop: "2px" },
        headerCorrections: { marginTop: "2.5px" }
      }
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.CURRENCY,
    textValidation: { func: Validation.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.CURRENCY] },
    sorting: Sort.DEFAULT_TYPES_SORT_FUNCS[DEFAULT_COLUMN_TYPES.CURRENCY],
    iconSettings: {
      svgString: CURRENCY_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginLeft: "-2px", marginRight: "4px", marginTop: "1px" },
        headerCorrections: { marginRight: "3px", marginTop: "2px" }
      }
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.SELECT,
    select: {},
    iconSettings: {
      svgString: SELECT_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginTop: "0px", marginRight: "3px", marginLeft: "-2.75px" },
        headerCorrections: { marginTop: "1px" }
      }
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.LABEL,
    label: {},
    iconSettings: {
      svgString: LABEL_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginTop: "1.5px", marginRight: "5.5px", marginLeft: "-1px" },
        headerCorrections: { marginTop: "2.5px", marginRight: "5.5px", marginLeft: "0px" }
      }
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.CHECKBOX,
    iconSettings: {
      svgString: CHECKBOX_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginRight: "6px", marginTop: "2px" },
        headerCorrections: { marginRight: "5px", marginLeft: "1px", marginTop: "3px" }
      }
    },
    checkbox: !0,
    customTextProcessing: {
      changeTextFunc: CheckboxValidationFunc.getDefault()
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.DATE_DMY,
    textValidation: { func: Validation.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.DATE_DMY] },
    calendar: CalendarFunctionalityUtils.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.DATE_DMY],
    iconSettings: {
      svgString: CALENDAR_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginLeft: "1.25px", marginRight: "8px", marginTop: "-1.5px" },
        headerCorrections: { marginTop: "0px" }
      }
    }
  },
  {
    name: DEFAULT_COLUMN_TYPES.DATE_MDY,
    textValidation: { func: Validation.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.DATE_MDY] },
    calendar: CalendarFunctionalityUtils.DEFAULT_TYPES_FUNCTIONALITY[DEFAULT_COLUMN_TYPES.DATE_MDY],
    iconSettings: {
      svgString: CALENDAR_ICON_SVG_STRING,
      containerStyles: {
        dropdown: { marginLeft: "1.25px", marginRight: "8px", marginTop: "-1.5px" },
        headerCorrections: { marginTop: "0px" }
      }
    }
  }
];
let DefaultColumnTypes = _DefaultColumnTypes;
class DropdownButtonItemConf {
}
DropdownButtonItemConf.DEFAULT_ITEM = {
  text: DefaultColumnTypes.FALLBACK_TYPE.name,
  iconSettings: DefaultColumnTypes.FALLBACK_TYPE.iconSettings
};
class ColumnTypesUtils {
  static getTypeByName(D, O) {
    return D.find((x) => x.name.toLocaleLowerCase() === (O == null ? void 0 : O.toLocaleLowerCase()));
  }
  static getTypeBasedOnProperties(D, O) {
    if (O) {
      const x = ColumnTypesUtils.getTypeByName(D.types, O);
      if (x)
        return x;
    }
    if (D.defaultColumnTypeName) {
      const x = ColumnTypesUtils.getTypeByName(D.types, D.defaultColumnTypeName);
      if (x)
        return x;
    }
  }
  static getActiveType(D, O) {
    const x = ColumnTypesUtils.getTypeBasedOnProperties(D, O);
    if (x)
      return x;
    const B = D.types.find((F) => !F.textValidation.func);
    if (B)
      return B;
    const U = D.types[0];
    return U || DefaultColumnTypes.FALLBACK_TYPE;
  }
  // prettier-ignore
  static getReusableDefaultIcon(D) {
    var B;
    const O = (B = D.reusableIconName) == null ? void 0 : B.toLocaleLowerCase(), x = DefaultColumnTypes.DEFAULT_TYPES.find((U) => U.name.toLocaleLowerCase() === O);
    return x != null && x.iconSettings ? x.iconSettings : DropdownButtonItemConf.DEFAULT_ITEM.iconSettings;
  }
  static processDropdownItemSettings(D) {
    const { name: O, iconSettings: x } = D;
    let B;
    x ? x.reusableIconName ? B = ColumnTypesUtils.getReusableDefaultIcon(x) : (B = x, Object.keys(x).length === 0 ? B = DropdownButtonItemConf.DEFAULT_ITEM.iconSettings : x.svgString || (B.svgString ?? (B.svgString = DropdownButtonItemConf.DEFAULT_ITEM.iconSettings.svgString), B.containerStyles ?? (B.containerStyles = DropdownButtonItemConf.DEFAULT_ITEM.iconSettings.containerStyles))) : B = DropdownButtonItemConf.DEFAULT_ITEM.iconSettings;
    const U = { text: O, iconSettings: B }, F = D;
    F.dropdownItem ?? (F.dropdownItem = { element: null, settings: U }), setTimeout(() => {
      var W;
      (W = F.dropdownItem).element ?? (W.element = DropdownItem.createButtonItemNoEvents(void 0, U));
    });
  }
  static processTextValidationProps(D) {
    var O;
    D.textValidation ?? (D.textValidation = {}), (O = D.textValidation).setTextToDefaultOnFail ?? (O.setTextToDefaultOnFail = !0);
  }
  static processCheckbox(D) {
    var O;
    D.checkbox && !((O = D.customTextProcessing) != null && O.changeTextFunc) && (D.customTextProcessing ?? (D.customTextProcessing = {}), D.customTextProcessing.changeTextFunc = CheckboxValidationFunc.getDefault());
  }
  static processSelectOptions(D) {
    if (typeof D.select == "object" && D.select.options) {
      const O = D.select;
      O.options = D.select.options.map((x) => ({ text: x }));
    } else if (typeof D.label == "object" && D.label.options) {
      const O = D.label;
      O.options = JSON.parse(JSON.stringify(D.label.options));
    }
  }
  static processSelect(D, O, x) {
    var U;
    const B = D;
    D.select === !0 || D.label === !0 ? B.cellDropdownProps = { isBasicSelect: !D.label } : (typeof D.select == "object" || typeof D.label == "object") && (B.cellDropdownProps = D.select || D.label, B.cellDropdownProps.isBasicSelect = !D.label, ColumnTypesUtils.processSelectOptions(D), Validation.setSelectValidation(B, O, x)), B.cellDropdownProps && B.cellDropdownProps.canAddMoreOptions === void 0 && (B.cellDropdownProps.canAddMoreOptions = !((U = B.cellDropdownProps) != null && U.options));
  }
  // the reason why this is needed is when the argument is JSON stringified, properties that hold functions are removed,
  // hence they can only be applied to the component as strings
  static convertStringFunctionsToRealFunctions(D) {
    D.textValidation && ObjectUtils.convertStringToFunction(D.textValidation, "func"), D.customTextProcessing && (ObjectUtils.convertStringToFunction(D.customTextProcessing, "changeTextFunc"), ObjectUtils.convertStringToFunction(D.customTextProcessing, "changeStyleFunc")), D.sorting && (ObjectUtils.convertStringToFunction(D.sorting, "ascendingFunc"), ObjectUtils.convertStringToFunction(D.sorting, "descendingFunc")), D.calendar && (ObjectUtils.convertStringToFunction(D.calendar, "toYMDFunc"), ObjectUtils.convertStringToFunction(D.calendar, "fromYMDFunc"));
  }
  // this is important because when types get processed - their resultant structure is not be the same, hence if
  // the same one is used in different settings (e.g. defaultColumnTypes set in default and custom settings),
  // the processing of the same type again would not work
  // JSON.stringify loses element and function references, hence they need to be manually reassigned
  static createTypeDeepCopy(D) {
    const O = JSON.parse(JSON.stringify(D));
    return D.dropdownItem && (O.dropdownItem = D.dropdownItem), D.textValidation && (O.textValidation = D.textValidation), D.customTextProcessing && (O.customTextProcessing = D.customTextProcessing), D.sorting && (O.sorting = D.sorting), D.calendar && (O.calendar = D.calendar), O;
  }
  static process(D, O, x) {
    return D.map((B) => {
      const U = ColumnTypesUtils.createTypeDeepCopy(B);
      return ColumnTypesUtils.convertStringFunctionsToRealFunctions(U), ColumnTypesUtils.processSelect(U, O, x), ColumnTypesUtils.processCheckbox(U), ColumnTypesUtils.processTextValidationProps(U), ColumnTypesUtils.processDropdownItemSettings(U), U;
    });
  }
  static getAvailableTypes(D) {
    let O = [...DefaultColumnTypes.DEFAULT_TYPES];
    const { availableDefaultColumnTypes: x, customColumnTypes: B } = D;
    if (x) {
      const U = x.map((F) => F.toLocaleLowerCase());
      O = O.filter((F) => U.indexOf(F.name.toLocaleLowerCase()) > -1);
    }
    return B && O.push(...B), O.length === 0 && O.push(DefaultColumnTypes.FALLBACK_TYPE), O;
  }
  static getProcessedTypes(D) {
    const { isDefaultTextRemovable: O, defaultText: x } = D, B = ColumnTypesUtils.getAvailableTypes(D);
    return ColumnTypesUtils.process(B, O, x);
  }
  // updates label color, date input etc.
  // prettier-ignore
  static updateDataElements(D, O, x, B) {
    const { _columnsDetails: U, _tableDimensions: F } = D, W = U[x];
    O !== 0 && (W.activeType.cellDropdownProps ? (CellDropdown.updateCellDropdown(
      B,
      W.cellDropdown,
      F.border,
      W.settings.defaultText,
      !0
    ), SelectCell.finaliseEditedText(D, B.children[0], x, !0)) : Browser.IS_INPUT_DATE_SUPPORTED && W.activeType.calendar && DateCellInputElement.updateInputBasedOnTextDiv(B, W.activeType));
  }
}
class MoveUtils {
  // prettier-ignore
  static setNewElementText(D, O, x, B, U) {
    const F = CellElement.getText(x);
    return CellEvents.updateCell(D, O, U, B, { element: x, processText: !1 }), ColumnTypesUtils.updateDataElements(D, U, B, x), F;
  }
}
class MoveColumn {
  // prettier-ignore
  static overwriteDataElements(D, O, x, B) {
    O.slice(1).forEach((U, F) => {
      const W = F + 1, G = B[W];
      MoveUtils.setNewElementText(D, G, U, x, W);
    });
  }
  // prettier-ignore
  static changeSettings(D, O, x, B, U) {
    HeaderText.onAttemptChange(D, x, O, { colMove: !0 }), U !== B.activeType && ChangeColumnType.change.bind(D)(U.name, O);
  }
  // prettier-ignore
  static overwrite(D, O, x, B, U, F) {
    const { elements: W, activeType: G } = O;
    MoveUtils.setNewElementText(D, B[0], W[0], x, 0), MoveColumn.changeSettings(D, x, W[0], O, U), MoveColumn.overwriteDataElements(D, W, x, B);
    const Y = W[0].style.width;
    return W[0].style.width = F, { overwrittenType: G, overwrittenWidth: Y };
  }
  static firstChangeSettingsIfSettingsChanged(D, O) {
    const { areSettingsDifferent: x } = ColumnSettingsUtils.parseSettingsChange(D);
    if (x) {
      const B = D._columnsDetails[O];
      HeaderText.onAttemptChange(D, B.elements[0], O);
    }
  }
  // prettier-ignore
  static move(D, O, x) {
    MoveColumn.firstChangeSettingsIfSettingsChanged(D, O);
    const B = D._columnsDetails[O], U = D._columnsDetails[O].elements.map((J) => CellElement.getText(J));
    CellHighlightUtils.fade(B.elements[0], B == null ? void 0 : B.headerStateColors.default);
    const F = x ? O + 1 : O - 1, W = D._columnsDetails[F], G = W.elements.map((J) => CellElement.getText(J)), Y = W.elements[0].style.width, X = MoveColumn.overwrite(
      D,
      B,
      O,
      G,
      W.activeType,
      Y
    );
    FocusedCellUtils.set(D._focusedElements.cell, W.elements[0], 0, F), MoveColumn.overwrite(
      D,
      W,
      F,
      U,
      X.overwrittenType,
      X.overwrittenWidth
    ), setTimeout(() => FireEvents.onColumnsUpdate(D));
  }
}
class ColumnSizerGenericUtils {
  // the current solution for using first row position as 'relative' with divider having 100% height only works for
  // these browsers
  static canHeightBeInherited() {
    return Browser.IS_CHROMIUM || Browser.IS_FIREFOX;
  }
  static getSizerDetailsViaElementId(D, O) {
    const x = Number(RegexUtils.extractIntegerStrs(D)[0]), B = O[x];
    return { columnSizer: B.columnSizer, headerCell: B.elements[0], sizerNumber: x };
  }
  static findNextResizableColumnHeader(D, O) {
    const x = D.slice(O + 1).find((B) => {
      var U;
      return !((U = B.settings.widths) != null && U.staticWidth);
    });
    return x == null ? void 0 : x.elements[0];
  }
}
const _UpdateRowElement = class Ke {
  // required to allow the divider and all its elements to inherit its height (in non chrome or firefox browsers)
  static updateHeaderRowHeight(D) {
    ColumnSizerGenericUtils.canHeightBeInherited() || (D.style.height = Ke.UNSET, D.style.height = getComputedStyle(D).height);
  }
  // if this does not capture all events - use in HeaderText.onAttemptChange method instead
  static updateHeadRowHeightOnKeyDown(D) {
    var O;
    if (!ColumnSizerGenericUtils.canHeightBeInherited()) {
      const x = (O = D.children) == null ? void 0 : O[0];
      x && x.style.height !== Ke.UNSET && (x.style.height = Ke.UNSET, setTimeout(() => {
        x.style.height = `${x.offsetHeight}px`;
      }));
    }
  }
  static getUnsetHeightFunc(D, O) {
    if (!ColumnSizerGenericUtils.canHeightBeInherited() && O === 0)
      return () => D.style.height = Ke.UNSET;
  }
};
_UpdateRowElement.UNSET = "unset";
let UpdateRowElement = _UpdateRowElement;
class RowHoverEvents {
  static canStyleBeApplied(D, O, x) {
    return (x > 0 || D.header) && (!AddNewRowElement.isAddNewRowRow(O) || D.addNewRowButton);
  }
  static getRemoveColorFunc(D, O, x, B) {
    const U = D.rowHoverStyles;
    if (U != null && U.style && RowHoverEvents.canStyleBeApplied(U, O, x))
      return () => {
        ElementStyle.unsetStyle(O, U.style), Object.assign(O.style, B);
      };
  }
  static addMouseLeaveEvent(D, O, x, B) {
    const U = RowHoverEvents.getRemoveColorFunc(D, O, x, B), F = UpdateRowElement.getUnsetHeightFunc(O, x);
    O.onmouseleave = () => {
      U == null || U(), F == null || F();
    };
  }
  // prettier-ignore
  static addMouseEnterEvent(D, O, x) {
    const { rowHoverStyles: B, _focusedElements: { rowDragEl: U } } = D, F = B != null && B.style && RowHoverEvents.canStyleBeApplied(B, O, x) ? () => Object.assign(O.style, B == null ? void 0 : B.style) : void 0;
    O.onmouseenter = () => {
      U || F == null || F();
    };
  }
  static addEvents(D, O, x, B) {
    RowHoverEvents.addMouseEnterEvent(D, O, x), RowHoverEvents.addMouseLeaveEvent(D, O, x, B);
  }
  static process(D, O) {
    D != null && D.style && (D.header ?? (D.header = !0), D.addNewRowButton ?? (D.addNewRowButton = !0), CellHighlightUtils.unsetDefaultHoverProperties(O));
  }
}
const _StripedRows = class tt {
  static setRowStyle(D, O, x) {
    const B = O % 2 ? x.even : x.odd;
    return Object.assign(D.style, B), B;
  }
  static process(D) {
    const { stripedRows: O, _defaultCellHoverColors: x } = D;
    O && (typeof O == "boolean" ? D._stripedRows = tt.DEFAULT_PROPERTIES : D._stripedRows = {
      even: O.even || tt.DEFAULT_PROPERTIES.even,
      odd: O.odd || tt.DEFAULT_PROPERTIES.odd
    }, CellHighlightUtils.unsetDefaultHoverProperties(x));
  }
};
_StripedRows.DEFAULT_PROPERTIES = {
  odd: { backgroundColor: "" },
  even: { backgroundColor: "#dcdcdc7a" }
};
let StripedRows = _StripedRows;
class CustomRowProperties {
  static setStyle(D, O, x, B) {
    if (D._stripedRows)
      return B && AddNewRowElement.isAddNewRowRow(O) && (x = +!D.dataStartsAtHeader), StripedRows.setRowStyle(O, x, D._stripedRows);
  }
  // prettier-ignore
  static updateRow(D, O, x, B, U) {
    const F = CustomRowProperties.setStyle(D, O, x, B);
    x === U ? RowHoverEvents.addEvents(D, O, x, F) : setTimeout(() => {
      RowHoverEvents.addEvents(D, O, x, F);
    });
  }
  // REF-32
  static isAddRowRowSame(D) {
    return !!(D.pagination && D._frameComponents.displayAddNewRow && PaginationUtils.getLastPossiblePageNumber(D) !== D._pagination.activePageNumber);
  }
  // this can be considered to be wasteful if no striped rows are used and we are resetting the same row events
  // every time this is called, however we are still traversing all rows from startIndex for code simplicity
  static update(D, O = 0) {
    if (!D._tableBodyElementRef)
      return;
    const x = Array.from(D._tableBodyElementRef.children), B = CustomRowProperties.isAddRowRowSame(D), U = x.length - 1;
    x.slice(O).forEach((F, W) => {
      const G = W + O;
      CustomRowProperties.updateRow(D, F, G, B, U);
    });
  }
}
class MoveRow {
  // prettier-ignore
  static overwrite(D, O, x) {
    const B = [];
    return D._columnsDetails.forEach((U, F) => {
      const W = MoveUtils.setNewElementText(
        D,
        O[F],
        U.elements[x],
        F,
        x
      );
      B.push(W);
    }), B;
  }
  static moveDataRows(D, O, x) {
    const B = D._columnsDetails.map(({ elements: F }) => CellElement.getText(F[x])), U = MoveRow.overwrite(D, B, O);
    MoveRow.overwrite(D, U, x);
  }
  static resetFocusedCell(D, O) {
    const { _frameComponents: x, _focusedElements: B } = D, { element: U, rowIndex: F, columnIndex: W } = O;
    x.displayIndexColumn ? FocusedCellUtils.setIndexCell(B.cell, U, F) : FocusedCellUtils.set(B.cell, U, F, W);
  }
  static moveHeaderToDataRow(D) {
    const { _columnsDetails: O, _focusedElements: x } = D, B = { ...x.cell }, U = O.map(({ elements: W }) => CellElement.getText(W[1])), F = MoveRow.overwrite(D, U, 0);
    O.forEach((W, G) => {
      FocusedCellUtils.set(x.cell, W.elements[0], 0, G), HeaderText.onAttemptChange(D, W.elements[0], G);
    }), MoveRow.overwrite(D, F, 1), MoveRow.resetFocusedCell(D, B);
  }
  static move(D, O, x) {
    const B = x ? O + 1 : O - 1;
    O === 0 || B === 0 ? MoveRow.moveHeaderToDataRow(D) : MoveRow.moveDataRows(D, O, B), CustomRowProperties.update(D, O), D.pagination && PaginationUtils.updateOnRowMove(D, B);
  }
}
const _Drag = class gt {
  static move(D, O, x) {
    if (O === 0)
      return;
    const B = O > 0, U = B ? 1 : -1;
    for (let F = 0; F < Math.abs(O); F += 1)
      x(D, gt.ORIGINAL_INDEX + F * U, B);
    setTimeout(() => FocusedCellUtils.purge(D._focusedElements.cell), 5);
  }
};
_Drag.CELL_HIDDEN_CLASS = "cell-hidden";
_Drag.DRAG_PX_TO_MOVE = 10;
_Drag.ORIGINAL_INDEX = 0;
let Drag = _Drag;
const _DragRow = class K extends Drag {
  static resetElements(D) {
    var x, B;
    (x = K.CLONE_ROW) == null || x.remove(), Array.from(D.children || []).forEach((U) => {
      U.classList.remove(Drag.CELL_HIDDEN_CLASS);
    }), (B = K.TARGET_LINE) == null || B.remove();
  }
  static appendTargetLine(D) {
    K.TARGET_LINE = document.createElement("div"), K.TARGET_LINE.classList.add("row-drag-target-line"), K.TARGET_LINE.style.opacity = "0", D.appendChild(K.TARGET_LINE);
  }
  static prepareElements(D, O, x) {
    O.classList.add(K.ROW_CLONE_CLASS), O.style.top = `${x.offsetTop}px`;
    const B = `${x.children[0].offsetHeight}px`, U = Array.from(x.children || []);
    Array.from(O.children).forEach((F, W) => {
      F.style.width = `${U[W].offsetWidth}px`, F.style.height = B;
    }), U.forEach((F) => {
      F.classList.add(Drag.CELL_HIDDEN_CLASS);
    }), K.appendTargetLine(D);
  }
  static calculateThresholdDown(D) {
    K.TARGET_DOWN_ROW && D && (K.THRESHOLD_DOWN = K.TARGET_DOWN_ROW.offsetTop + K.TARGET_DOWN_ROW.offsetHeight / 2 - D.offsetHeight);
  }
  static calculateThresholdUp() {
    K.TARGET_UP_ROW && (K.THRESHOLD_UP = K.TARGET_UP_ROW.offsetTop + K.TARGET_UP_ROW.offsetHeight / 2);
  }
  static initiateDragState(D, O, x) {
    var F;
    if (K.TARGET_UP_ROW = x.previousSibling, K.TARGET_DOWN_ROW = (F = x.nextSibling) == null ? void 0 : F.nextSibling, !K.TARGET_UP_ROW && AddNewRowElement.isAddNewRowRow(K.TARGET_DOWN_ROW.children[0]))
      return;
    K.CLONE_ROW = O, K.ACTIVE_ROW_TOP_PX = x.offsetTop, K.ACTIVE_INDEX = 0, K.calculateThresholdUp(), K.calculateThresholdDown(x);
    const B = Array.from(D.children);
    Drag.ORIGINAL_INDEX = B.findIndex((W) => W === x);
    const U = B[B.length - 2].offsetHeight;
    K.MAX_DOWN = D.offsetHeight - x.offsetHeight - U;
  }
  static processRowCellsToDrag(D, O) {
    const x = O.parentElement;
    x.dispatchEvent(new MouseEvent("mouseleave"));
    const B = x.cloneNode(!0);
    return x == null || x.insertAdjacentElement("afterend", B), K.prepareElements(D, B, x), K.initiateDragState(D, B, x), x;
  }
  static applyEventsToElement(D, O, x) {
    K.isDisabled(D) || (O.onmousedown = () => {
      K.IS_MOUSE_DOWN = !0;
    }, O.onmousemove = () => {
      K.IS_MOUSE_DOWN && !D._focusedElements.rowDragEl && D._tableBodyElementRef && (K.INITIALISING_DRAG_PX += 1, K.INITIALISING_DRAG_PX > Drag.DRAG_PX_TO_MOVE && (D._focusedElements.rowDragEl = K.processRowCellsToDrag(D._tableBodyElementRef, x), FocusedCellUtils.set(D._focusedElements.cell, x, 0, Drag.ORIGINAL_INDEX)));
    });
  }
  static moveTargetLine(D, O) {
    D.style.opacity = "1", D.style.top = `${O}px`;
  }
  // Upon approaching the original row the target line is hidden
  static removeLineOnMoveDown(D) {
    D.style.opacity = "0", K.ACTIVE_INDEX = 0, K.THRESHOLD_TO_NO_LINE_DOWN = -1, K.calculateThresholdUp();
  }
  static attemptSwitchUp(D, O) {
    var x;
    K.TARGET_UP_ROW && O && (((x = K.TARGET_UP_ROW.previousSibling) == null ? void 0 : x.previousSibling) === O ? (K.THRESHOLD_TO_NO_LINE_UP = O.offsetTop + O.offsetHeight / 2, K.THRESHOLD_DOWN = K.TARGET_UP_ROW.offsetTop + K.TARGET_UP_ROW.offsetHeight / 2, K.TARGET_DOWN_ROW = K.TARGET_UP_ROW, K.TARGET_UP_ROW = O.previousSibling, K.TARGET_UP_ROW ? K.calculateThresholdUp() : K.THRESHOLD_UP = -1) : (K.moveTargetLine(D, K.TARGET_UP_ROW.offsetTop - 3), K.THRESHOLD_DOWN = K.THRESHOLD_UP, K.TARGET_DOWN_ROW = K.TARGET_UP_ROW, K.TARGET_UP_ROW = K.TARGET_UP_ROW.previousSibling, K.calculateThresholdUp(), K.ACTIVE_INDEX -= 1));
  }
  // Upon approaching the original row the target line is hidden
  static removeLineOnMoveUp(D, O) {
    D.style.opacity = "0", K.ACTIVE_INDEX = 0, K.THRESHOLD_TO_NO_LINE_UP = -1, K.calculateThresholdDown(O);
  }
  static attemptSwitchDown(D, O) {
    var x;
    K.TARGET_DOWN_ROW && (K.TARGET_DOWN_ROW.nextSibling === O ? (K.THRESHOLD_TO_NO_LINE_DOWN = K.TARGET_DOWN_ROW.offsetTop + K.TARGET_DOWN_ROW.offsetHeight / 2, K.TARGET_UP_ROW = K.TARGET_DOWN_ROW, K.THRESHOLD_UP = K.TARGET_UP_ROW.offsetTop - K.TARGET_UP_ROW.offsetHeight / 2, K.TARGET_DOWN_ROW = (x = O == null ? void 0 : O.nextSibling) == null ? void 0 : x.nextSibling, K.calculateThresholdDown(O)) : (K.moveTargetLine(D, K.TARGET_DOWN_ROW.offsetTop + K.TARGET_DOWN_ROW.offsetHeight - 3), K.THRESHOLD_UP = K.THRESHOLD_DOWN, K.TARGET_UP_ROW = K.TARGET_DOWN_ROW, K.TARGET_DOWN_ROW = K.TARGET_DOWN_ROW.nextSibling, K.calculateThresholdDown(O), K.ACTIVE_INDEX += 1));
  }
  static windowDrag(D, O) {
    if (K.isDisabled(D) || !K.TARGET_LINE || !D._focusedElements.rowDragEl || !K.CLONE_ROW)
      return;
    const x = Math.max(0, K.ACTIVE_ROW_TOP_PX + O.movementY), B = Math.min(x, K.MAX_DOWN);
    K.ACTIVE_ROW_TOP_PX = B, K.CLONE_ROW.style.top = `${K.ACTIVE_ROW_TOP_PX}px`, K.ACTIVE_ROW_TOP_PX > K.THRESHOLD_DOWN ? K.attemptSwitchDown(K.TARGET_LINE, D._focusedElements.rowDragEl) : K.ACTIVE_ROW_TOP_PX < K.THRESHOLD_UP ? K.attemptSwitchUp(K.TARGET_LINE, D._focusedElements.rowDragEl) : K.THRESHOLD_TO_NO_LINE_DOWN >= 0 && K.THRESHOLD_TO_NO_LINE_DOWN < K.ACTIVE_ROW_TOP_PX ? K.removeLineOnMoveDown(K.TARGET_LINE) : K.THRESHOLD_TO_NO_LINE_UP >= 0 && K.THRESHOLD_TO_NO_LINE_UP > K.ACTIVE_ROW_TOP_PX && K.removeLineOnMoveUp(K.TARGET_LINE, D._focusedElements.rowDragEl);
  }
  static windowMouseUp(D) {
    K.IS_MOUSE_DOWN = !1, !K.isDisabled(D) && D._focusedElements.rowDragEl && (K.resetElements(D._focusedElements.rowDragEl), delete D._focusedElements.rowDragEl, K.INITIALISING_DRAG_PX = 0, K.move(D, K.ACTIVE_INDEX, MoveRow.move));
  }
  // row dragging is cumbersome when filter/pagination enabled as some rows are hidden
  static isDisabled(D) {
    return D.dragRows === !1 || D.filter || D.pagination;
  }
};
_DragRow.ROW_CLONE_CLASS = "row-clone";
_DragRow.INITIALISING_DRAG_PX = 0;
_DragRow.ACTIVE_ROW_TOP_PX = 0;
_DragRow.CLONE_ROW = null;
_DragRow.IS_MOUSE_DOWN = !1;
_DragRow.ACTIVE_INDEX = 0;
_DragRow.THRESHOLD_UP = 0;
_DragRow.THRESHOLD_DOWN = 0;
_DragRow.MAX_DOWN = 0;
_DragRow.THRESHOLD_TO_NO_LINE_DOWN = -1;
_DragRow.THRESHOLD_TO_NO_LINE_UP = -1;
let DragRow = _DragRow;
const _DragColumn = class q extends Drag {
  static setHeaderElementsToDefault(D) {
    var x;
    const O = (x = D.parentElement) == null ? void 0 : x.children;
    q.CLONE_CELLS.forEach((B) => B.remove()), Array.from(O || []).forEach((B) => {
      B.tagName === CellElement.HEADER_TAG && B.classList.remove(Drag.CELL_HIDDEN_CLASS);
    }), q.DIVIDERS.forEach((B) => {
      B.style.pointerEvents = "";
    });
  }
  static applyCloneHeaderCell(D, O, x, B) {
    O.classList.add(Drag.CELL_HIDDEN_CLASS), D.classList.add(q.HEADER_CELL_CLONE_CLASS), D.classList.add(q.HEADER_CELL_CLONE_ANIMATION_CLASS), D.style.left = `${O.offsetLeft}px`, D.style.height = B, x == null || x.insertAdjacentElement("beforebegin", D), q.CLONE_CELLS.push(D), q.REAL_CELLS.push(O);
  }
  static getThreshold(D, O) {
    const x = q.REAL_CELLS[q.ACTIVE_INDEX + O], B = Math.min(D.offsetWidth / 2, (x == null ? void 0 : x.offsetWidth) / 2) * O;
    return D.offsetLeft + B;
  }
  static initiateDragState(D, O) {
    if (q.ACTIVE_INDEX = q.REAL_CELLS.findIndex((W) => O === W), q.ACTIVE_INDEX + 2 >= q.CLONE_CELLS.length && q.ACTIVE_INDEX - 1 <= 0)
      return;
    D._focusedElements.colDragEl = q.CLONE_CELLS[q.ACTIVE_INDEX], D._focusedElements.colDragEl.classList.remove(q.HEADER_CELL_CLONE_ANIMATION_CLASS), q.ACTIVE_CELL_LEFT_PX = O.offsetLeft, q.THRESHOLD_LEFT = q.getThreshold(O, -1), q.THRESHOLD_RIGHT = q.getThreshold(O, 1);
    const x = q.REAL_CELLS[0];
    q.MIN_LEFT = x.classList.contains(IndexColumn.INDEX_CELL_CLASS) ? x.offsetWidth : 0;
    const B = q.REAL_CELLS[q.REAL_CELLS.length - 1], U = B.classList.contains(AddNewColumnElement.ADD_COLUMN_CELL_CLASS) ? 0 : B.offsetWidth;
    q.MAX_LEFT = B.offsetLeft + U - O.offsetWidth;
    const F = q.REAL_CELLS[0].classList.contains(IndexColumn.INDEX_CELL_CLASS);
    Drag.ORIGINAL_INDEX = q.ACTIVE_INDEX - (F ? 1 : 0);
  }
  static processHeaderCellsToDrag(D, O, x) {
    var U;
    const B = `${O.offsetHeight}px`;
    Array.from(((U = O.parentElement) == null ? void 0 : U.children) || []).forEach((F) => {
      if (F.tagName === CellElement.HEADER_TAG) {
        const W = F.cloneNode(!0);
        q.applyCloneHeaderCell(W, F, x, B);
      } else
        F.style.pointerEvents = "none", q.DIVIDERS.push(F);
    }), q.initiateDragState(D, O);
  }
  static applyEventsToElement(D, O, x) {
    D.dragColumns !== !1 && (O.onmousedown = () => {
      q.IS_MOUSE_DOWN = !0;
    }, O.onmousemove = () => {
      var B;
      if (q.IS_MOUSE_DOWN && !D._focusedElements.colDragEl && (q.INITIALISING_DRAG_PX += 1, q.INITIALISING_DRAG_PX > Drag.DRAG_PX_TO_MOVE)) {
        const U = (B = x.parentElement) == null ? void 0 : B.children[x.parentElement.children.length - 1];
        q.processHeaderCellsToDrag(D, x, U), FocusedCellUtils.set(D._focusedElements.cell, x, 0, Drag.ORIGINAL_INDEX);
      }
    });
  }
  static switch(D) {
    const O = q.CLONE_CELLS[q.ACTIVE_INDEX], x = q.CLONE_CELLS[q.ACTIVE_INDEX + D];
    D > 0 ? (q.THRESHOLD_LEFT = q.THRESHOLD_RIGHT - 5, q.THRESHOLD_RIGHT = O.offsetLeft + x.offsetWidth, x.style.left = `${x.offsetLeft - O.offsetWidth}px`) : (q.THRESHOLD_RIGHT = q.THRESHOLD_LEFT + 5, q.THRESHOLD_LEFT = O.offsetLeft - x.offsetWidth, x.style.left = `${x.offsetLeft + O.offsetWidth}px`), ArrayUtils.swap(q.CLONE_CELLS, q.ACTIVE_INDEX, q.ACTIVE_INDEX + D), q.ACTIVE_INDEX += D;
  }
  static windowDrag(D, O, x) {
    if (D.dragColumns === !1)
      return;
    const B = Math.max(q.MIN_LEFT, q.ACTIVE_CELL_LEFT_PX + x.movementX), U = Math.min(B, q.MAX_LEFT);
    q.ACTIVE_CELL_LEFT_PX = U, O.style.left = `${q.ACTIVE_CELL_LEFT_PX}px`, q.ACTIVE_CELL_LEFT_PX > q.THRESHOLD_RIGHT ? q.switch(1) : q.ACTIVE_CELL_LEFT_PX < q.THRESHOLD_LEFT && q.switch(-1);
  }
  static windowMouseUp(D) {
    if (q.IS_MOUSE_DOWN = !1, D.dragColumns === !1 || !D._focusedElements.colDragEl)
      return;
    q.setHeaderElementsToDefault(D._focusedElements.colDragEl), delete D._focusedElements.colDragEl, q.INITIALISING_DRAG_PX = 0, q.ACTIVE_CELL_LEFT_PX = 0, q.CLONE_CELLS = [], q.DIVIDERS = [];
    const O = q.REAL_CELLS[0].classList.contains(IndexColumn.INDEX_CELL_CLASS);
    DragRow.move(D, q.ACTIVE_INDEX - Drag.ORIGINAL_INDEX - (O ? 1 : 0), MoveColumn.move), q.REAL_CELLS = [];
  }
};
_DragColumn.HEADER_CELL_CLONE_CLASS = "header-cell-clone";
_DragColumn.HEADER_CELL_CLONE_ANIMATION_CLASS = "header-cell-clone-animation";
_DragColumn.INITIALISING_DRAG_PX = 0;
_DragColumn.ACTIVE_CELL_LEFT_PX = 0;
_DragColumn.IS_MOUSE_DOWN = !1;
_DragColumn.CLONE_CELLS = [];
_DragColumn.REAL_CELLS = [];
_DragColumn.DIVIDERS = [];
_DragColumn.ACTIVE_INDEX = 0;
_DragColumn.THRESHOLD_RIGHT = 0;
_DragColumn.THRESHOLD_LEFT = 0;
_DragColumn.MAX_LEFT = 0;
_DragColumn.MIN_LEFT = 0;
let DragColumn = _DragColumn;
class DropdownCellOverlay {
}
DropdownCellOverlay.HIDDEN_PX = "0px";
DropdownCellOverlay.VISIBLE_PX = "10px";
DropdownCellOverlay.DROPDOWN_CELL_OVERLAY_CLASS = "dropdown-cell-overlay";
const _ColumnDropdownCellOverlay = class Le {
  static setDefault(D, O) {
    var x;
    D.style.backgroundColor = ((x = O == null ? void 0 : O.default) == null ? void 0 : x.backgroundColor) || "";
  }
  static resetDefaultColor(D, O) {
    var B;
    const x = O == null ? void 0 : O.overlayStyles;
    (B = x == null ? void 0 : x.hover) != null && B.backgroundColor && Le.setDefault(D, x);
  }
  static setHoverColor(D, O) {
    var B, U;
    const x = (U = (B = O == null ? void 0 : O.overlayStyles) == null ? void 0 : B.hover) == null ? void 0 : U.backgroundColor;
    x && (D.columnDropdownCellOverlay.style.backgroundColor = x);
  }
  static hide(D, O) {
    const { columnDropdownCellOverlay: x } = O, B = D._hoveredElements.headerCell;
    setTimeout(() => {
      B !== D._hoveredElements.headerCell && (x.style.height = DropdownCellOverlay.HIDDEN_PX);
    });
  }
  static setHorizontalDimensions(D) {
    const { columnDropdownCellOverlay: O, elements: x } = D, B = x[0].offsetWidth / 100;
    O.style.width = `${B * 50}px`, O.style.right = `${B * 25}px`;
  }
  static display(D) {
    D.columnDropdownCellOverlay.style.height = DropdownCellOverlay.VISIBLE_PX, Le.setHorizontalDimensions(D);
  }
  static isDisplayed(D) {
    return D.style.height === DropdownCellOverlay.VISIBLE_PX;
  }
  static updateIfDisplayed(D) {
    Le.isDisplayed(D.columnDropdownCellOverlay) && Le.setHorizontalDimensions(D);
  }
  static create(D, O, x) {
    const B = document.createElement("div");
    return B.classList.add(DropdownCellOverlay.DROPDOWN_CELL_OVERLAY_CLASS), B.classList.add(Le.COLUMN_DROPDOWN_CELL_OVERLAY_CLASS), B.style.height = DropdownCellOverlay.HIDDEN_PX, Le.setDefault(B, x), DragColumn.applyEventsToElement(D, B, O), B;
  }
  static add(D, O) {
    var W, G;
    const x = (G = (W = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : W.displaySettings) == null ? void 0 : G.overlayStyles, B = D._columnsDetails[O].elements[0], U = Le.create(D, B, x);
    return B.nextSibling.appendChild(U), U;
  }
};
_ColumnDropdownCellOverlay.COLUMN_DROPDOWN_CELL_OVERLAY_CLASS = "column-dropdown-cell-overlay";
let ColumnDropdownCellOverlay = _ColumnDropdownCellOverlay;
const _MovableColumnSizerElement = class Ie {
  // this is recalculated as it depends on the column index that the sizer is on
  static setStaticProperties(D, O, x) {
    D.style.marginRight = O, D.style.width = x;
  }
  // the vertical line has no pointer events, hence it should not be expected to be passed in here
  static isMovableColumnSizer(D) {
    return D.classList.contains(Ie.MOVABLE_SIZER_CLASS);
  }
  static getVerticalLineHeight(D, O) {
    let x = D.offsetHeight;
    if (O) {
      const B = D.lastChild.offsetHeight;
      x -= B;
    }
    return x;
  }
  static display(D, O, x) {
    const B = O.movableElement;
    B.style.display = "flex";
    const U = B.children[0];
    U.style.height = `${Ie.getVerticalLineHeight(D, x)}px`;
  }
  static hide(D) {
    D.style.display = "none", D.style.left = "";
  }
  static createVerticalLine(D) {
    const O = document.createElement("div");
    return O.style.backgroundColor = D, O.classList.add(Ie.VERTICAL_LINE_CLASS), O;
  }
  static getMovableBackgroundColor(D) {
    return D.click || D.hover || Ie.DEFAULT_BACKGROUND_COLOR;
  }
  static create(D) {
    const O = Ie.getMovableBackgroundColor(D), x = document.createElement("div");
    x.style.backgroundColor = O, x.classList.add(Ie.MOVABLE_SIZER_CLASS), Ie.hide(x);
    const B = Ie.createVerticalLine(O);
    return x.appendChild(B), x;
  }
};
_MovableColumnSizerElement.DEFAULT_BACKGROUND_COLOR = "#4668ed";
_MovableColumnSizerElement.MOVABLE_SIZER_CLASS = "movable-column-sizer";
_MovableColumnSizerElement.VERTICAL_LINE_CLASS = "movable-column-sizer-vertical-line";
let MovableColumnSizerElement = _MovableColumnSizerElement;
class MoveLimits {
  // Borders of the side cells tend to breach over the limits of the table (when no side frame elements),
  // causing the offsets to give incorrect data and set the limits beyond the table. The breach magnitude is
  // influenced by the sizer start position when cells have borders - which is the very center position of
  // the total of those two borders width.
  // prettier-ignore
  static getSideLimitDelta(D) {
    const O = ExtractElements.getRightColumnSiblingCell(D);
    return ((Number.parseFloat(getComputedStyle(D).borderRightWidth) || 0) - (Number.parseFloat(getComputedStyle(O).borderLeftWidth) || 0)) / 2;
  }
  static getRightLimitDynamicWidthTable() {
    return window.innerWidth;
  }
  // prettier-ignore
  static getRightLimitForMaxWidth(D, O, x) {
    return StaticTable.isTableAtMaxWidth(D, O) ? x ? Number.parseFloat(x.style.width) : 0 : O.maxWidth - D.offsetWidth;
  }
  static getRightLimit(D, O) {
    return D._tableDimensions.width !== void 0 ? Number.parseFloat(O.style.width) : D._tableDimensions.maxWidth !== void 0 && D._tableElementRef ? MoveLimits.getRightLimitForMaxWidth(D._tableElementRef, D._tableDimensions, O) : MoveLimits.getRightLimitDynamicWidthTable();
  }
  static getLeftLimit(D, O) {
    let x = -D.offsetWidth;
    return O !== void 0 && (x += O), x;
  }
  // prettier-ignore
  static generate(D, O, x, B, U, F) {
    const W = O || x ? MoveLimits.getSideLimitDelta(F) : 0;
    return {
      left: MoveLimits.getLeftLimit(F, O ? W : void 0) + B,
      right: MoveLimits.getRightLimit(D, U)
    };
  }
}
class SelectedColumnSizer {
  // prettier-ignore
  static generateObj(D, O, x, B, U, F) {
    const W = O.movableElement.offsetLeft;
    return {
      element: O.element,
      moveLimits: MoveLimits.generate(D, x, B, W, F, U),
      // this is to reflect the initial sizer offset to center itself in the cell divider
      initialOffset: W,
      mouseMoveOffset: W,
      fireColumnsUpdate: FireEvents.onColumnsUpdate.bind(this, D)
    };
  }
  static get(D, O) {
    const x = D._columnsDetails[O].columnSizer, B = O === 0, U = D._columnsDetails.length - 2 === O, F = D._columnsDetails[O].elements[0], W = ColumnSizerGenericUtils.findNextResizableColumnHeader(D._columnsDetails, O);
    return SelectedColumnSizer.generateObj(D, x, B, U, F, W);
  }
}
const SEMI_TRANSPARENT_COLOR = "#ffffff01";
class ColumnSizer {
  static shouldWidthBeIncreased(D) {
    return D > 4;
  }
  // prettier-ignore
  static getBackgroundImage(D, O, x, B, U) {
    if (B && U) {
      if (Number.parseInt(getComputedStyle(U).borderRightWidth) > 0 && (O > 0 || x === void 0 || x > 0))
        return ColumnSizerElement.EMPTY_BACKGROUND_IMAGE;
    } else if (D > 0)
      return ColumnSizerElement.EMPTY_BACKGROUND_IMAGE;
    return ColumnSizerElement.FILLED_BACKGROUND_IMAGE;
  }
  static getMarginRight(D, O) {
    return O || !D ? "0px" : `${D.leftCellRight - D.rightCellLeft}px`;
  }
  static getTotalCellBorderWidth(D) {
    return D ? D.rightCellLeft + D.leftCellRight : 0;
  }
  static generateBorderWidthsInfo(D, O) {
    var W, G, Y;
    const x = {
      rightCellLeft: 0,
      leftCellLeft: 0,
      leftCellRight: 0,
      beforeLeftCellRight: void 0
    }, B = (W = D[O - 1]) == null ? void 0 : W.elements[0];
    B && (x.beforeLeftCellRight = Number.parseInt(getComputedStyle(B).borderRightWidth) || 0);
    const U = (G = D[O]) == null ? void 0 : G.elements[0];
    if (U) {
      const X = getComputedStyle(U);
      x.leftCellLeft = Number.parseInt(X.borderLeftWidth) || 0, x.leftCellRight = Number.parseInt(X.borderRightWidth) || 0;
    }
    const F = (Y = D[O + 1]) == null ? void 0 : Y.elements[0];
    return F && (x.rightCellLeft = Number.parseInt(getComputedStyle(F).borderLeftWidth) || 0), x;
  }
  // prettier-ignore
  static createObject(D, O, x, B, U, F, W) {
    const G = ColumnSizer.generateBorderWidthsInfo(O, x), Y = ColumnSizer.getTotalCellBorderWidth(G), X = O.length - 1 === x, J = ColumnSizer.getMarginRight(G, X), Q = ColumnSizer.getBackgroundImage(
      Y,
      G.leftCellLeft,
      G.beforeLeftCellRight,
      X,
      B
    ), le = ColumnSizer.shouldWidthBeIncreased(Y), re = {
      element: D,
      styles: {
        default: {
          width: le ? `${Y + 2}px` : "1.5px",
          backgroundImage: Q
        },
        hover: {
          width: le ? `${(Y + 2) * 1.5}px` : "9px"
        },
        static: {
          marginRight: J
        }
      },
      isSideCellHovered: !1,
      isSizerHovered: !1,
      isMouseUpOnSizer: !1
    };
    return W && (re.hoverColor = W.hover || ColumnSizerElement.DEFAULT_HOVER_COLOR), F && (re.movableElement = F), U && (re.overlayElement = U), re;
  }
  // prettier-ignore
  static create(D, O) {
    const { _columnsDetails: x, _tableElementRef: B, columnResizerColors: U } = D, F = ColumnSizerElement.create(O, U.hover), W = MovableColumnSizerElement.create(U), G = ColumnSizerOverlayElement.create(), Y = ColumnSizer.createObject(
      F,
      x,
      O,
      B,
      G,
      W,
      U
    );
    return ColumnSizerOverlayElement.applyEvents(D, Y), Y;
  }
}
const _ColumnSizerFillerElement = class ft {
  static create(D) {
    const O = document.createElement("div");
    return O.classList.add(ft.SIZER_FILLER_CLASS), O.style.backgroundColor = D || ColumnSizerElement.DEFAULT_HOVER_COLOR, O.style.display = "none", O;
  }
  static setWidth(D, O) {
    const x = Number.parseInt(O);
    D.style.width = `${ColumnSizer.shouldWidthBeIncreased(x) ? x : 4}px`;
  }
  static display(D) {
    D.style.display = "block";
  }
  static hide(D) {
    D.style.display = "none";
  }
};
_ColumnSizerFillerElement.SIZER_FILLER_CLASS = "column-sizer-filler";
let ColumnSizerFillerElement = _ColumnSizerFillerElement;
const _ColumnSizerElement = class me {
  static isHovered(D) {
    return D.style.backgroundImage === me.EMPTY_BACKGROUND_IMAGE;
  }
  static setBackgroundImage(D, O) {
    D.style.backgroundImage = O;
  }
  static unsetBackgroundImage(D) {
    D.style.backgroundImage = me.EMPTY_BACKGROUND_IMAGE;
  }
  static setBackgroundColor(D, O) {
    D.style.backgroundColor = O;
  }
  static setTransitionTime(D) {
    D.style.transition = me.TRANSITION_TIME;
  }
  static unsetTransitionTime(D) {
    D.style.transition = "0.0s";
  }
  // is not used to unset background image
  static unsetElementsToDefault(D, O, x = !0) {
    x && me.setBackgroundColor(D, SEMI_TRANSPARENT_COLOR), ColumnSizerFillerElement.hide(D.children[0]), D.style.width = O;
  }
  // this is recalculated as it depends on the column index that the sizer is on
  static setStaticProperties(D, O) {
    D.style.marginRight = O;
  }
  static setElementId(D, O) {
    D.id = `${me.COLUMN_SIZER_ID_PREFIX}${O}`;
  }
  static create(D, O) {
    const x = document.createElement("div");
    me.setElementId(x, D), x.classList.add(me.COLUMN_SIZER_CLASS);
    const B = ColumnSizerFillerElement.create(O);
    return x.append(B), me.hide(x), x;
  }
  static display(D) {
    var O;
    UpdateRowElement.updateHeaderRowHeight((O = D.parentElement) == null ? void 0 : O.parentElement), D.style.display = "flex";
  }
  static hide(D) {
    D.style.display = "none";
  }
  static hideWithBlurAnimation(D) {
    setTimeout(() => {
      me.hide(D);
    }, me.HALF_TRANSITION_TIME_ML);
  }
  static hideWhenCellNotHovered(D, O) {
    D.isSideCellHovered || (O ? me.hideWithBlurAnimation(D.element) : me.hide(D.element));
  }
  static setHoverStyle(D, O, x, B) {
    const { element: U, hoverColor: F } = D;
    ColumnSizerFillerElement.display(U.children[0]), x && me.setTransitionTime(U), me.setBackgroundColor(U, B || F), U.style.width = O;
  }
};
_ColumnSizerElement.FILLED_BACKGROUND_IMAGE = "linear-gradient(180deg, #cdcdcd, #cdcdcd 75%, transparent 75%, transparent 100%)";
_ColumnSizerElement.EMPTY_BACKGROUND_IMAGE = "none";
_ColumnSizerElement.DEFAULT_HOVER_COLOR = "grey";
_ColumnSizerElement.COLUMN_SIZER_CLASS = "column-sizer";
_ColumnSizerElement.COLUMN_SIZER_ID_PREFIX = `${_ColumnSizerElement.COLUMN_SIZER_CLASS}-`;
_ColumnSizerElement.TRANSITION_TIME_ML = 200;
_ColumnSizerElement.TRANSITION_TIME = `${_ColumnSizerElement.TRANSITION_TIME_ML / 1e3}s`;
_ColumnSizerElement.HALF_TRANSITION_TIME_ML = _ColumnSizerElement.TRANSITION_TIME_ML / 2;
let ColumnSizerElement = _ColumnSizerElement;
const _ColumnSizerOverlayEvents = class st {
  static overlayMouseEnter(D) {
    if (D.isSizerHovered = !0, D.isMouseUpOnSizer || this._activeOverlayElements.selectedColumnSizer)
      return;
    const { width: O } = D.styles.hover;
    ColumnSizerElement.display(D.element), ColumnSizerElement.setTransitionTime(D.element), setTimeout(() => {
      D.isSizerHovered && ColumnSizerElement.setHoverStyle(D, O, !1);
    }, 1), setTimeout(() => {
      D.isSizerHovered && ColumnSizerElement.unsetBackgroundImage(D.element);
    }, st.MOUSE_PASSTHROUGH_TIME_ML);
  }
  // the constant if statement checking is used to prevent a bug where if a mouse leaves the sizer and immediately reenters
  // the timeouts would still proceed to execute the code below
  static unsetColorDuringTransition(D) {
    setTimeout(() => {
      D.isSizerHovered || (ColumnSizerElement.setBackgroundImage(D.element, D.styles.default.backgroundImage), setTimeout(() => {
        D.isSizerHovered || (ColumnSizerElement.unsetTransitionTime(D.element), ColumnSizerElement.setBackgroundColor(D.element, SEMI_TRANSPARENT_COLOR));
      }, ColumnSizerElement.HALF_TRANSITION_TIME_ML));
    }, ColumnSizerElement.HALF_TRANSITION_TIME_ML);
  }
  static overlayMouseLeave(D) {
    if (D.isSizerHovered = !1, this._activeOverlayElements.selectedColumnSizer || D.isMouseUpOnSizer)
      return;
    const { element: O, styles: x } = D;
    ColumnSizerElement.unsetElementsToDefault(O, x.default.width);
    const B = ColumnSizerElement.isHovered(O);
    setTimeout(() => {
      !this._activeOverlayElements.selectedColumnSizer && !D.isSizerHovered && (st.unsetColorDuringTransition(D), ColumnSizerElement.hideWhenCellNotHovered(D, B));
    }, st.MOUSE_PASSTHROUGH_TIME_ML);
  }
  // we need to pass down the sizer element instead of the id as the id can change when columns are inserted/removed
  // prettier-ignore
  static overlayMouseDown(D) {
    const { _columnsDetails: O, _tableBodyElementRef: x, _frameComponents: { displayAddNewRow: B } } = this, { columnSizer: U, sizerNumber: F } = ColumnSizerGenericUtils.getSizerDetailsViaElementId(D.id, O), { element: W, styles: G } = U;
    MovableColumnSizerElement.display(x, U, B), ColumnSizerElement.unsetElementsToDefault(W, G.default.width), ColumnSizerElement.setBackgroundImage(W, G.default.backgroundImage), this._activeOverlayElements.selectedColumnSizer = SelectedColumnSizer.get(this, F);
  }
};
_ColumnSizerOverlayEvents.MOUSE_PASSTHROUGH_TIME_ML = 50;
let ColumnSizerOverlayEvents = _ColumnSizerOverlayEvents;
const _ColumnSizerOverlayElement = class ht {
  // this is recalculated as it depends on the column index that the sizer is on
  static setStaticProperties(D, O, x) {
    D.style.marginRight = O, D.style.width = x;
  }
  static applyEvents(D, O) {
    O.overlayElement.onmouseenter = ColumnSizerOverlayEvents.overlayMouseEnter.bind(D, O), O.overlayElement.onmouseleave = ColumnSizerOverlayEvents.overlayMouseLeave.bind(D, O), O.overlayElement.onmousedown = ColumnSizerOverlayEvents.overlayMouseDown.bind(D, O.element);
  }
  static create() {
    const D = document.createElement("div");
    return D.classList.add(ht.SIZER_OVERLAY_CLASS), D;
  }
};
_ColumnSizerOverlayElement.SIZER_OVERLAY_CLASS = "column-sizer-overlay";
let ColumnSizerOverlayElement = _ColumnSizerOverlayElement;
class InsertRemoveColumnSizer {
  static updateIdsOfAllSubsequent(D, O) {
    D.slice(O).forEach((x, B) => {
      if (!x.columnSizer)
        return;
      const U = O + B;
      ColumnSizerElement.setElementId(x.columnSizer.element, U);
    });
  }
  static applySizerStateToElements(D) {
    const { element: O, movableElement: x, overlayElement: B, styles: U } = D;
    ColumnSizerElement.unsetElementsToDefault(O, U.default.width), ColumnSizerFillerElement.setWidth(O.children[0], U.default.width), ColumnSizerElement.setStaticProperties(O, U.static.marginRight), ColumnSizerElement.setBackgroundImage(O, U.default.backgroundImage), MovableColumnSizerElement.setStaticProperties(x, U.static.marginRight, U.hover.width), ColumnSizerOverlayElement.setStaticProperties(B, U.static.marginRight, U.hover.width);
  }
  static insertAtIndex(D, O, x) {
    const B = O.elements[0].nextSibling, U = ColumnSizer.create(D, x);
    O.columnSizer = U, B.appendChild(U.element), B.appendChild(U.overlayElement), B.appendChild(U.movableElement), InsertRemoveColumnSizer.applySizerStateToElements(U);
  }
  // prettier-ignore
  static updateSizer(D, O, x, B) {
    const U = ColumnSizer.createObject(D.element, O, x, B);
    Object.assign(D, U), InsertRemoveColumnSizer.applySizerStateToElements(D);
  }
  static updatePrevious(D, O, x) {
    var F;
    const B = O - 1;
    if (B < 0)
      return;
    const { columnSizer: U } = D[B];
    ((F = D[B].settings.widths) == null ? void 0 : F.staticWidth) !== void 0 || !U || InsertRemoveColumnSizer.updateSizer(U, D, O, x);
  }
  static getNewColumnIndexIfWidthSet(D, O) {
    var x;
    return D.length - 1 === O ? (x = D[O - 1]) != null && x.columnSizer ? -1 : O - 1 : O;
  }
  static isNotResizable(D) {
    const { widths: O, isColumnResizable: x } = D.settings;
    return (O == null ? void 0 : O.staticWidth) !== void 0 || !x;
  }
  // REF-13
  static insert(D, O) {
    const { _columnsDetails: x } = D;
    if (!InsertRemoveColumnSizer.isNotResizable(x[O])) {
      if (D._tableDimensions.width !== void 0) {
        if (O = InsertRemoveColumnSizer.getNewColumnIndexIfWidthSet(D._columnsDetails, O), O === -1 || InsertRemoveColumnSizer.isNotResizable(x[O]))
          return;
      } else
        InsertRemoveColumnSizer.updatePrevious(x, O, D._tableElementRef);
      InsertRemoveColumnSizer.insertAtIndex(D, x[O], O), InsertRemoveColumnSizer.updateIdsOfAllSubsequent(x, O + 1);
    }
  }
  // this is only used for when table width is static, otherwise it is removed directly with the column
  static removeSizer(D) {
    var O, x, B, U, F, W;
    (x = (O = D.columnSizer) == null ? void 0 : O.element) == null || x.remove(), (U = (B = D.columnSizer) == null ? void 0 : B.movableElement) == null || U.remove(), (W = (F = D.columnSizer) == null ? void 0 : F.overlayElement) == null || W.remove(), delete D.columnSizer;
  }
  // need to remove the sizer of the new last column as when width is set - last column does not have a sizer
  static removeIfLastColumn(D, O) {
    return D.length === O && D[O] && (O -= 1, InsertRemoveColumnSizer.removeSizer(D[O])), O;
  }
  static remove(D, O) {
    const { _tableDimensions: x, _columnsDetails: B, _tableElementRef: U } = D;
    x.width !== void 0 && (O = InsertRemoveColumnSizer.removeIfLastColumn(B, O)), InsertRemoveColumnSizer.updatePrevious(B, O, U), InsertRemoveColumnSizer.updateIdsOfAllSubsequent(B, O);
  }
  // This is used to cleanup sizers for columns that have or had static widths because they do not have sizers,
  // additionally when the table width is set the last column that is not static also does not have a sizer.
  static cleanUpCustomColumnSizers(D, O) {
    const { _tableDimensions: x, _columnsDetails: B } = D;
    if (x.width === void 0)
      return;
    let U = !1;
    for (let F = B.length - 1; F >= 0; F -= 1) {
      const W = B[F];
      if (InsertRemoveColumnSizer.isNotResizable(W))
        W.columnSizer && InsertRemoveColumnSizer.removeSizer(W);
      else if (U === !1) {
        if (U = !0, W.columnSizer && InsertRemoveColumnSizer.removeSizer(W), F < O)
          break;
      } else if (!W.columnSizer && B.length - 1 !== F && InsertRemoveColumnSizer.insertAtIndex(D, W, F), U === !0 && F < O)
        break;
    }
  }
}
class DropdownDisplaySettingsUtil {
  static process(D) {
    D.isAvailable ?? (D.isAvailable = !0), D.isAvailable ? (D.openMethod ?? (D.openMethod = {}), D.openMethod.overlayClick ? delete D.openMethod.cellClick : D.openMethod.cellClick ? delete D.openMethod.overlayClick : D.openMethod.overlayClick = !0) : (delete D.openMethod, delete D.overlayStyles);
  }
}
class ColumnSettingsDefaultTextUtils {
  static unsetDefaultText(D, O, x) {
    O.elements.slice(1).forEach((B, U) => {
      const F = U + 1;
      CellEvents.removeTextIfDefault(D, F, x, B);
    });
  }
  static setDefaultText(D, O, x) {
    O.elements.slice(1).forEach((B, U) => {
      const F = U + 1;
      CellEvents.setCellToDefaultIfNeeded(D, F, x, B, !1);
    }), setTimeout(() => FireEvents.onDataUpdate(D));
  }
}
class ColumnSettingsWidthUtils {
  // prettier-ignore
  static getSettingsWidthNumber(D, O, x = !0) {
    return StringDimensionUtils.generateNumberDimensionFromClientString(
      D,
      O,
      x ? "staticWidth" : "initialWidth",
      !0,
      ColumnDetails.MINIMAL_COLUMN_WIDTH
    );
  }
  static updateColumnWidth(D, O, x, B) {
    const { _tableDimensions: U, _tableElementRef: F } = D, { number: W } = ColumnSettingsWidthUtils.getSettingsWidthNumber(F, x);
    O.style.width = `${W}px`, TableElement.changeStaticWidthTotal(U, B ? W : -W);
  }
  // prettier-ignore
  static changeWidth(D, O, x, B) {
    let U = !1;
    x != null && x.staticWidth && (ColumnSettingsWidthUtils.updateColumnWidth(D, O, x, !1), U = !0), B != null && B.staticWidth && (ColumnSettingsWidthUtils.updateColumnWidth(D, O, B, !0), U = !0), U && StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, !0);
  }
}
class ColumnDropdownCellOverlayEvents {
  static mouseClick(D, O) {
    ColumnDropdown.display(this, D);
    const x = O.elements[0];
    setTimeout(() => FocusedCellUtils.setHeaderCell(this._focusedElements.cell, x, D));
  }
  // prettier-ignore
  static mouseLeave(D) {
    var O;
    ColumnDropdownCellOverlay.hide(this, D), delete this._hoveredElements.headerCell, ColumnDropdownCellOverlay.resetDefaultColor(
      D.columnDropdownCellOverlay,
      (O = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : O.displaySettings
    );
  }
  static mouseEnter(D) {
    var x;
    const O = D.elements[0];
    this._hoveredElements.headerCell = O, ColumnDropdownCellOverlay.setHoverColor(D, (x = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : x.displaySettings);
  }
  static setEvents(D, O) {
    const x = D._columnsDetails[O], { columnDropdownCellOverlay: B } = x;
    B && (B.onmouseenter = ColumnDropdownCellOverlayEvents.mouseEnter.bind(D, x), B.onmouseleave = ColumnDropdownCellOverlayEvents.mouseLeave.bind(D, x), B.onclick = ColumnDropdownCellOverlayEvents.mouseClick.bind(D, O, x));
  }
}
class EditableHeaderIconTextEvents {
  static keyDownOnText(D, O, x) {
    UpdateRowElement.updateHeadRowHeightOnKeyDown(this._tableBodyElementRef), x.key === KEYBOARD_KEY.TAB && CellTextEvents.tabOutOfCell(this, D, O, x);
  }
  // REF-15
  static blurText(D, O, x) {
    const B = x.target, U = CellElement.getCellElement(B);
    HeaderText.onAttemptChange(this, U, O), DataCellEvents.blur(this, D, O, B);
  }
  static setEvents(D, O, x, B) {
    D._columnsDetails[B].settings.isHeaderTextEditable && (O.onfocus = CellWithTextEvents.focusText.bind(D, x, B, null), O.onblur = EditableHeaderIconTextEvents.blurText.bind(D, x, B), O.onkeydown = EditableHeaderIconTextEvents.keyDownOnText.bind(D, x, B));
  }
}
class ColumnSizerCellEvents {
  static hideColumnSizer(D) {
    if (!D)
      return;
    D.isSideCellHovered = !1;
    const O = ColumnSizerElement.isHovered(D.element);
    setTimeout(() => {
      D.isSizerHovered || ColumnSizerElement.hideWhenCellNotHovered(D, O);
    });
  }
  static cellMouseLeave(D, O) {
    var x, B;
    ColumnSizerCellEvents.hideColumnSizer((x = D[O - 1]) == null ? void 0 : x.columnSizer), ColumnSizerCellEvents.hideColumnSizer((B = D[O]) == null ? void 0 : B.columnSizer);
  }
  static displayColumnSizer(D) {
    D && (ColumnSizerElement.display(D.element), D.isSideCellHovered = !0);
  }
  static cellMouseEnter(D, O) {
    var x, B;
    ColumnSizerCellEvents.displayColumnSizer((x = D[O - 1]) == null ? void 0 : x.columnSizer), ColumnSizerCellEvents.displayColumnSizer((B = D[O]) == null ? void 0 : B.columnSizer);
  }
}
class HeaderCellEvents {
  static mouseEnterCell(D, O) {
    var x, B, U, F;
    if (!this._activeOverlayElements.selectedColumnSizer) {
      const W = this._columnsDetails[D], G = O.target;
      CellHighlightUtils.highlight(G, (x = W.headerStateColors) == null ? void 0 : x.hover), ColumnSizerCellEvents.cellMouseEnter(this._columnsDetails, D), ((F = (U = (B = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : B.displaySettings) == null ? void 0 : U.openMethod) == null ? void 0 : F.overlayClick) && ColumnDropdownCellOverlay.display(W), this._hoveredElements.headerCell = G;
    }
  }
  static mouseLeaveCell(D, O) {
    var x, B, U, F;
    Dropdown.isDisplayed(this._activeOverlayElements.columnDropdown) || (CellHighlightUtils.fade(O.target, (x = this._columnsDetails[D].headerStateColors) == null ? void 0 : x.default), ColumnDropdownCellOverlay.hide(this, this._columnsDetails[D]), (F = (U = (B = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : B.displaySettings) == null ? void 0 : U.openMethod) != null && F.overlayClick && delete this._hoveredElements.headerCell), this._activeOverlayElements.selectedColumnSizer || ColumnSizerCellEvents.cellMouseLeave(this._columnsDetails, D);
  }
  static mouseClick(D, O) {
    var U, F, W;
    const x = O.target;
    CellEvents.removeTextIfDefault(this, 0, D, x), ((W = (F = (U = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : U.displaySettings) == null ? void 0 : F.openMethod) == null ? void 0 : W.cellClick) && ColumnDropdown.display(this, D), setTimeout(() => FocusedCellUtils.setHeaderCell(this._focusedElements.cell, x, D));
  }
  static setEvents(D, O, x) {
    O.onmouseenter = HeaderCellEvents.mouseEnterCell.bind(D, x), O.onmouseleave = HeaderCellEvents.mouseLeaveCell.bind(D, x), O.onclick = HeaderCellEvents.mouseClick.bind(D, x), DragColumn.applyEventsToElement(D, O, O);
  }
}
class EditableHeaderCellEvents {
  static mouseClickCell(D, O) {
    const x = O.target;
    FocusedCellUtils.purge(this._focusedElements.cell), setTimeout(() => FocusedCellUtils.setHeaderCell(this._focusedElements.cell, x, D));
  }
  static setEvents(D, O, x, B) {
    if (O.onmouseenter = HeaderCellEvents.mouseEnterCell.bind(D, B), O.onmouseleave = HeaderCellEvents.mouseLeaveCell.bind(D, B), D.displayHeaderIcons) {
      O.onfocus = () => {
      }, O.onblur = () => {
      }, O.onmousedown = CellWithTextEvents.mouseDown.bind(D, null), O.onclick = EditableHeaderCellEvents.mouseClickCell.bind(D, B);
      const U = CellElement.getTextElement(O);
      EditableHeaderIconTextEvents.setEvents(D, U, x, B);
    } else
      O.onclick = HeaderCellEvents.mouseClick.bind(D, B);
  }
}
class CellEventsReset {
  static unset(D) {
    D.onfocus = () => {
    }, D.onblur = () => {
    }, D.onmouseenter = () => {
    }, D.onmouseleave = () => {
    }, D.onmousedown = () => {
    }, D.oninput = () => {
    }, D.onpaste = () => {
    }, D.onkeydown = () => {
    };
  }
  static setDataCellEvents(D, O, x, B) {
    const { settings: U, activeType: F } = D._columnsDetails[B];
    if (!U.isCellTextEditable)
      return;
    DataCellEvents.setEvents(D, O, x, B);
    const { cellDropdownProps: W, calendar: G, checkbox: Y } = F;
    W ? SelectCell.setEvents(D, O, x, B) : G ? DateCellEvents.setEvents(D, O, x, B) : Y && CheckboxCellEvents.setEvents(D, O, x, B);
  }
  static setHeaderCellEvents(D, O, x, B) {
    var U, F, W;
    (W = (F = (U = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : U.displaySettings) == null ? void 0 : F.openMethod) != null && W.cellClick ? HeaderCellEvents.setEvents(D, O, B) : (DataCellEvents.setEvents(D, O, x, B), EditableHeaderCellEvents.setEvents(D, O, 0, B), ColumnDropdownCellOverlayEvents.setEvents(D, B));
  }
  // REF-33
  static reset(D, O, x, B) {
    x === 0 ? CellEventsReset.setHeaderCellEvents(D, O, x, B) : CellEventsReset.setDataCellEvents(D, O, x, B), !D._frameComponents.displayIndexColumn && B === 0 && RowDropdownCellOverlayEvents.addCellEvents(D, x, O);
  }
}
class ResetColumnStructure {
  static reset(D, O, x) {
    const { elements: B, activeType: U, settings: F } = O;
    B.slice(1).forEach((W) => {
      F.isCellTextEditable || CellEventsReset.unset(W);
    }), ChangeColumnType.setNewStructureBasedOnType(D, x, U), ColumnSettingsBorderUtils.resetBorderOverwritingState(O), setTimeout(() => FireEvents.onColumnsUpdate(D));
  }
}
class ColumnSettingsUtils {
  static updateSizer(D, O) {
    const { _columnsDetails: x, _tableElementRef: B } = D;
    if (!B)
      return;
    const { columnSizer: U } = x[O];
    U || InsertRemoveColumnSizer.insert(D, O), InsertRemoveColumnSizer.cleanUpCustomColumnSizers(D, O), U && InsertRemoveColumnSizer.updateSizer(U, x, O, B);
    const F = O - 1;
    if (O > 0 && x[F].columnSizer) {
      const { columnSizer: W } = x[F];
      InsertRemoveColumnSizer.updateSizer(W, x, F, B);
    }
  }
  // prettier-ignore
  static change(D, O, x, B, U, F) {
    const W = D._columnsDetails[x];
    ColumnSettingsDefaultTextUtils.unsetDefaultText(D, W, x), W.settings = U, W.activeType = ColumnTypesUtils.getActiveType(U, W.settings.defaultColumnTypeName), ResetColumnStructure.reset(D, W, x), ColumnSettingsDefaultTextUtils.setDefaultText(D, W, x), F || ColumnSettingsWidthUtils.changeWidth(D, O, B.widths, U.widths), ColumnSettingsStyleUtils.changeStyleFunc(D, x, B), ColumnSettingsBorderUtils.updateSiblingColumns(D, x), ColumnSettingsUtils.updateSizer(D, x), D.displayHeaderIcons && HeaderIconCellElement.changeHeaderIcon(D._columnsDetails[x]), ColumnDropdownCellOverlay.updateIfDisplayed(W), AddNewColumnElement.toggle(D, !0);
  }
  // prettier-ignore
  static parseSettingsChange(D) {
    const { _customColumnsSettings: O, _columnsDetails: x, _focusedElements: { cell: { element: B, columnIndex: U } } } = D, W = x[U].settings, G = O[CellElement.getText(B)];
    return { oldSettings: W, newSettings: G, areSettingsDifferent: G ? W !== G : !1 };
  }
  // prettier-ignore
  static changeColumnSettingsIfNameDifferent(D, O, x, B = !1) {
    const { oldSettings: U, newSettings: F, areSettingsDifferent: W } = ColumnSettingsUtils.parseSettingsChange(D);
    W && ColumnSettingsUtils.change(D, O, x, U, F, B);
  }
  static setDropdownSettings(D, O) {
    !D || !O || (D.isSortAvailable ?? (D.isSortAvailable = O.isSortAvailable), D.isDeleteAvailable ?? (D.isDeleteAvailable = O.isDeleteAvailable), D.isInsertLeftAvailable ?? (D.isInsertLeftAvailable = O.isInsertLeftAvailable), D.isInsertRightAvailable ?? (D.isInsertRightAvailable = O.isInsertRightAvailable), D.isMoveAvailable ?? (D.isMoveAvailable = O.isMoveAvailable));
  }
  static processCellDimensions(D) {
    const O = D.cellStyle;
    if (!O)
      return;
    const x = D;
    if (O.width) {
      const B = D.isColumnResizable === !1 ? "staticWidth" : "initialWidth";
      x.widths = { [B]: O.width };
    } else
      x.widths && D.isColumnResizable && x.widths.staticWidth && (x.widths = { initialWidth: x.widths.staticWidth });
    StringDimensionUtils.removeAllDimensions(O);
  }
  static createInternalSettings(D, O) {
    const x = D;
    return ColumnSettingsStyleUtils.doesSettingHaveSideBorderStyle(x) && (x.stylePrecedence = !0), ColumnSettingsUtils.setDropdownSettings(D.columnDropdown, O.columnDropdown), Object.keys(O).forEach((B) => {
      x[B] ?? (x[B] = O[B]);
    }), x.types = ColumnTypesUtils.getProcessedTypes(x), ColumnSettingsUtils.processCellDimensions(D), x;
  }
  static createInternalMap(D, O) {
    return D.reduce((x, B) => (x[B.headerName] = ColumnSettingsUtils.createInternalSettings(B, O), x), {});
  }
  static setDefaultTypeProperties(D) {
    const { _defaultColumnsSettings: O } = D;
    O.availableDefaultColumnTypes = D.availableDefaultColumnTypes, O.customColumnTypes = D.customColumnTypes, O.defaultColumnTypeName = D.defaultColumnTypeName, O.types = ColumnTypesUtils.getProcessedTypes(O);
  }
  static setDefaultDropdownProperties(D) {
    var B, U, F, W, G, Y;
    const { _defaultColumnsSettings: O } = D, x = { openMethod: { cellClick: !0 } };
    O.columnDropdown = D.columnDropdown || { displaySettings: x }, (B = O.columnDropdown).displaySettings ?? (B.displaySettings = x), DropdownDisplaySettingsUtil.process(O.columnDropdown.displaySettings), (U = O.columnDropdown).isSortAvailable ?? (U.isSortAvailable = !0), (F = O.columnDropdown).isDeleteAvailable ?? (F.isDeleteAvailable = !0), (W = O.columnDropdown).isInsertLeftAvailable ?? (W.isInsertLeftAvailable = !0), (G = O.columnDropdown).isInsertRightAvailable ?? (G.isInsertRightAvailable = !0), (Y = O.columnDropdown).isMoveAvailable ?? (Y.isMoveAvailable = !0);
  }
  static setDefaultGenericProperties(D) {
    const { _defaultColumnsSettings: O } = D;
    O.defaultText = D.defaultText ?? EMPTY_STRING, O.isDefaultTextRemovable = D.isDefaultTextRemovable ?? !0, O.cellStyle = D.cellStyle, O.isCellTextEditable = D.isCellTextEditable ?? !0, O.headerStyles = D.headerStyles, O.isHeaderTextEditable = D.isHeaderTextEditable ?? O.isCellTextEditable, O.headerIconStyle = D.headerIconStyle, O.isColumnResizable = D.isColumnResizable ?? !0;
  }
  static setDefaultColumnsSettings(D) {
    const { _defaultColumnsSettings: O } = D;
    ColumnSettingsUtils.setDefaultGenericProperties(D), ColumnSettingsUtils.processCellDimensions(O), ColumnSettingsUtils.setDefaultDropdownProperties(D), ColumnSettingsUtils.setDefaultTypeProperties(D);
  }
  // REF-21
  static setUpInternalSettings(D) {
    ColumnSettingsUtils.setDefaultColumnsSettings(D), D._customColumnsSettings = ColumnSettingsUtils.createInternalMap(
      D.customColumnsSettings,
      D._defaultColumnsSettings
    );
  }
}
class HeaderText {
  static onAttemptChange(D, O, x, B) {
    const U = B == null ? void 0 : B.colRemove;
    U || ColumnSettingsUtils.changeColumnSettingsIfNameDifferent(D, O, x, B == null ? void 0 : B.colMove), D._visiblityInternal.filters && FilterInternalUtils.wasHeaderChanged(D._columnsDetails, D._visiblityInternal.filters, x, U) && VisibilityUtils.headerChanged(D);
  }
}
class NestedDropdownItem {
  static resetItemStyle(D) {
    Array.from(D.children).forEach((O) => {
      const x = O;
      x.style.backgroundColor = "", x.style.color = "";
    });
  }
}
NestedDropdownItem.NESTED_DROPDOWN_ITEM = "nested-dropdown-item";
class DropdownItemNavigation {
  static focusInputElement(D) {
    D.children[0].dispatchEvent(new MouseEvent("mouseenter"));
  }
  // either at the end when isNext is true or the start when isNext is false
  static focusItemWhenOnEdge(D, O, x) {
    var F;
    if (DropdownItem.doesElementContainInputClass(D)) {
      const W = D.parentElement;
      return DropdownItemNavigation.focusSiblingItem(W, O, x);
    }
    ((F = D.parentElement) == null ? void 0 : F.parentElement).classList.contains(DropdownItem.DROPDOWN_ITEM_CLASS) && (O = D.parentElement);
    const U = x ? O.children[0] : O.children[O.children.length - 1];
    return DropdownItemNavigation.focusSiblingItem(U, O, x, !0);
  }
  // isEdgeItem means is it a start/end or inside item
  // prettier-ignore
  static focusSiblingItem(D, O, x, B = !1) {
    if (D.classList.contains(NestedDropdownItem.NESTED_DROPDOWN_ITEM)) {
      const F = D.children[2];
      Dropdown.isDisplayed(F) && Dropdown.hide(F);
    }
    const U = B ? D : D[x ? "nextSibling" : "previousSibling"];
    if (U) {
      if (!DropdownItem.isDisplayed(U) || U.classList.contains(DropdownItem.DROPDOWN_TITLE_ITEM_CLASS) || U.classList.contains(DropdownItem.DROPDOWN_ITEM_DIVIDER_CLASS))
        return DropdownItemNavigation.focusSiblingItem(U, O, x);
      if (U.classList.contains(DropdownItem.DROPDOWN_INPUT_ITEM_CLASS))
        return DropdownItemNavigation.focusInputElement(U);
    } else
      return DropdownItemNavigation.focusItemWhenOnEdge(D, O, x);
    U.dispatchEvent(new MouseEvent("mouseenter"));
  }
  static focusFirstNestedDropdownItem(D) {
    if (D.classList.contains(NestedDropdownItem.NESTED_DROPDOWN_ITEM)) {
      const O = D.children[2];
      Dropdown.isDisplayed(O) && O.children[0].dispatchEvent(new MouseEvent("mouseenter"));
    }
  }
  static focusNestedDropdownParentItem(D) {
    var x;
    const O = (x = D.parentElement) == null ? void 0 : x.parentElement;
    O.classList.contains(DropdownItem.DROPDOWN_ITEM_CLASS) && (Dropdown.hide(D.parentElement), O.dispatchEvent(new MouseEvent("mouseenter")));
  }
}
class ColumnTypeDropdownItemEvents {
  static onClickMiddleware(D) {
    ColumnSettingsUtils.parseSettingsChange(this).areSettingsDifferent || D(), ColumnDropdown.processTextAndHide(this);
  }
  // prettier-ignore
  static set(D, O, x) {
    O.forEach((B) => {
      const U = B;
      U.onclick = ColumnTypeDropdownItemEvents.onClickMiddleware.bind(
        D,
        ChangeColumnType.change.bind(D, U.innerText.trim(), x)
      );
    });
  }
}
class ColumnTypeDropdownItem {
  static unsetActiveItem(D) {
    const O = D.getElementsByClassName(DropdownItem.ACTIVE_ITEM_CLASS)[0];
    O && (O.children[0].style.filter = "", O.classList.remove(DropdownItem.ACTIVE_ITEM_CLASS));
  }
  static reset(D) {
    ColumnTypeDropdownItem.unsetActiveItem(D), DropdownItem.removeItems(D);
  }
  static setActiveItem(D, O) {
    const x = D.find((B) => CellElement.getText(B) === O);
    x && (x.classList.add(DropdownItem.ACTIVE_ITEM_CLASS), x.children[0].style.filter = SVGIconUtils.WHITE_FILTER);
  }
  // the items are repopulated every time column dropdown is opened
  static setUp(D, O) {
    const { columnTypeDropdown: x } = D._activeOverlayElements, B = D._columnsDetails[O], U = B.settings.types.map((F) => F.dropdownItem.element);
    DropdownItem.addButtonItemElements(D, x, U), ColumnTypeDropdownItemEvents.set(D, U, O), ColumnTypeDropdownItem.setActiveItem(U, B.activeType.name);
  }
}
class DropdownEvents {
  static itemKeyNavigation(D, O, x) {
    if (x.key === KEYBOARD_KEY.TAB || x.key === KEYBOARD_KEY.ARROW_DOWN) {
      x.preventDefault();
      const B = D != null && D.activeElement ? x.target : O.children[0];
      DropdownItemNavigation.focusSiblingItem(B, O, !0);
    } else
      x.key === KEYBOARD_KEY.ARROW_UP ? DropdownItemNavigation.focusSiblingItem(x.target, O, !1) : x.key === KEYBOARD_KEY.ARROW_RIGHT ? DropdownItemNavigation.focusFirstNestedDropdownItem(x.target) : x.key === KEYBOARD_KEY.ARROW_LEFT && DropdownItemNavigation.focusNestedDropdownParentItem(x.target);
  }
}
class ColumnDropdownEvents {
  static focusNextColumnDropdown(D, O) {
    var U, F, W;
    O.preventDefault(), ColumnDropdown.processTextAndHide(D);
    let x = D._focusedElements.cell.columnIndex;
    x === D._columnsDetails.length - 1 && (x = -1);
    const B = D._columnsDetails[x + 1];
    (W = (F = (U = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : U.displaySettings) == null ? void 0 : F.openMethod) != null && W.cellClick ? B.elements[0].click() : B.columnDropdownCellOverlay.click();
  }
  static onKeyDown(D, O) {
    if (O.key === KEYBOARD_KEY.ENTER) {
      const x = O.target;
      DropdownItem.doesElementContainInputClass(x) ? ColumnDropdown.processTextAndHide(this) : (x.dispatchEvent(new Event("mouseenter")), x.dispatchEvent(new Event("click")));
    } else
      O.key === KEYBOARD_KEY.ESCAPE ? ColumnDropdown.processTextAndHide(this) : O.key === KEYBOARD_KEY.TAB && this._columnsDetails.length > 0 ? ColumnDropdownEvents.focusNextColumnDropdown(this, O) : DropdownEvents.itemKeyNavigation(this.shadowRoot, D, O);
  }
  static set(D, O) {
    O.onkeydown = ColumnDropdownEvents.onKeyDown.bind(D, O);
  }
}
function buildIcon$4(z) {
  return `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" style="transform: ${z}">
      <g transform="matrix(0.84210527 0 0 0.84210527 0 0)">
        <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
          <path d="M186.67 193.5L186.67 58.33C 186.67 51.888603 191.8927 46.666 198.334 46.666C 204.7793 46.666 210.002 51.888702 210.002 58.33L210.002 58.33L210.002 193.5L260.08398 143.418C 264.64258 138.8594 272.029 138.8594 276.58398 143.418C 281.14258 147.9727 281.14258 155.359 276.58398 159.918L276.58398 159.918L206.58398 229.918C 202.02928 234.4727 194.64299 234.4727 190.08398 229.918L190.08398 229.918L120.083984 159.918C 115.52928 155.3594 115.52928 147.97299 120.083984 143.418C 124.642586 138.8594 132.02899 138.8594 136.58398 143.418L136.58398 143.418L186.67 193.5zM396.66998 93.33L326.66998 93.33L326.66998 443.33002L396.66998 443.33002zM420.00198 93.33L420.00198 443.33002L490.00198 443.33002L490.00198 93.33002zM151.672 490C 145.2267 490 140.004 484.7773 140.004 478.332L140.004 478.332L140.004 268.332C 140.004 261.8906 145.2267 256.668 151.672 256.668L151.672 256.668L245.004 256.668C 251.4454 256.668 256.672 261.8907 256.672 268.332L256.672 268.332L256.672 478.332C 256.672 484.7773 251.4454 490 245.004 490zM163.336 466.668L233.336 466.668L233.336 279.998L163.336 279.998zM315.00598 466.668C 308.56458 466.668 303.33798 461.4414 303.33798 455L303.33798 455L303.33798 81.67001C 303.33798 75.22472 308.56458 70.002014 315.00598 70.002014L315.00598 70.002014L501.67596 70.002014C 508.11737 70.002014 513.33997 75.22472 513.33997 81.67001L513.33997 81.67001L513.33997 455C 513.33997 461.4414 508.11728 466.668 501.67596 466.668z" stroke="none" fill="#000000" fill-rule="nonzero" />
        </g>
      </g>
    </svg>`;
}
const INSERT_LEFT_ICON_SVG_STRING = buildIcon$4(""), INSERT_RIGHT_ICON_SVG_STRING = buildIcon$4("rotate(180deg) scale(1, -1)"), INSERT_UP_ICON_SVG_STRING = buildIcon$4("rotate(90deg) scale(1, -1)"), INSERT_DOWN_ICON_SVG_STRING = buildIcon$4("rotate(-90deg)");
function buildIcon$3(z) {
  return `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9" height="9" style="transform: ${z}">
      <g transform="matrix(0.47368425 0 0 0.47368425 0 0)">
        <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
          <g>
            <path d="M169 139.73L308.72998 0L349.175 40.484L109.124985 280.544L348.645 520.054L308.74698 559.999L169.01698 420.26904C 92.164986 343.42105 29.286987 280.29904 29.286987 279.99902C 29.286987 279.699 92.165985 216.57303 169.01698 139.72902L169.01698 139.72902L169 139.73zM490.55 139.73L630.27997 0L670.725 40.484L430.675 280.544L670.195 520.054L630.297 559.999L490.56702 420.26904C 413.71503 343.42105 350.83704 280.29904 350.83704 279.99902C 350.83704 279.699 413.71603 216.57303 490.56702 139.72902z" stroke="none" fill="#000000" fill-rule="nonzero" />
          </g>
        </g>
      </g>
    </svg>`;
}
const MOVE_LEFT_ICON_SVG_STRING = buildIcon$3(""), MOVE_RIGHT_ICON_SVG_STRING = buildIcon$3("rotate(180deg)"), MOVE_UP_ICON_SVG_STRING = buildIcon$3("rotate(90deg)"), MOVE_DOWN_ICON_SVG_STRING = buildIcon$3("rotate(-90deg)");
function buildIcon$2(z) {
  return `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9" height="12" style="transform: ${z}">
      <g transform="matrix(0.5 0 0 0.5 0 0)">
        <path d="M0 0L24 0L24 24L0 24L0 0z" stroke="none" fill="none" />
        <path d="M3 18L9 18L9 16L3 16L3 18zM3 6L3 8L21 8L21 6L3 6zM3 13L15 13L15 11L3 11L3 13z" stroke="none" fill="#000000" fill-rule="nonzero" />
      </g>
    </svg>`;
}
const SORT_ASC_ICON_SVG_STRING = buildIcon$2("scale(1, -1)"), SORT_DESC_ICON_SVG_STRING = buildIcon$2(""), TRASH_ICON_SVG_STRING = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="15">
  <g transform="matrix(1.0666668 0 0 1.0714285 0 0)">
    <g transform="matrix(0.027142858 0 0 0.027142858 0 0)">
      <g>
        <path d="M459.21 156.28L448.835 436.32C 448.6592 441.1247 444.4248 445.195 439.6006 445.195L439.6006 445.195L260.40057 445.195C 255.58028 445.195 251.34198 441.1091 251.16617 436.32L251.16617 436.32L240.79117 156.28C 240.50601 148.5534 234.00996 142.522 226.28317 142.807C 218.55658 143.09607 212.52518 149.58821 212.81018 157.315L212.81018 157.315L223.18118 437.355C 223.91946 457.195 240.51718 473.195 260.40018 473.195L260.40018 473.195L439.60016 473.195C 459.47516 473.195 476.08017 457.22202 476.81915 437.355L476.81915 437.355L487.19016 157.315C 487.4753 149.58841 481.44406 143.09601 473.71716 142.807C 465.99057 142.52185 459.49417 148.5531 459.20917 156.28L459.20917 156.28L459.21 156.28z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M338.8 212.8L338.8 403.2C 338.8 409.3875 343.81168 414.39902 349.999 414.39902C 356.1863 414.39902 361.198 409.38733 361.198 403.2L361.198 403.2L361.198 212.80002C 361.198 206.61252 356.1863 201.60101 349.999 201.60101C 343.81168 201.60101 338.8 206.61272 338.8 212.80002L338.8 212.80002L338.8 212.8z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M277.2 213.13L282.8016 403.53C 282.9852 409.7136 288.14142 414.581 294.32462 414.397C 300.5082 414.21732 305.3756 409.0572 305.19162 402.874L305.19162 402.874L299.59003 212.474C 299.41034 206.2904 294.2502 201.423 288.06702 201.607C 281.88342 201.78668 277.02002 206.9468 277.2 213.12999L277.2 213.12999L277.2 213.13z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M400.41 212.47L394.8084 402.87C 394.62482 409.0536 399.492 414.214 405.6754 414.393C 411.859 414.5766 417.0154 409.7094 417.19843 403.526L417.19843 403.526L422.80002 213.126C 422.9797 206.94241 418.11642 201.78201 411.933 201.60301C 405.74942 201.41942 400.58902 206.2866 400.41 212.47002L400.41 212.47002L400.41 212.47z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M210 162.4L490 162.4C 497.7305 162.4 504 156.1344 504 148.4C 504 140.6695 497.7305 134.4 490 134.4L490 134.4L210 134.4C 202.2695 134.4 196 140.6695 196 148.4C 196 156.1344 202.2695 162.4 210 162.4z" stroke="none" fill="#000000" fill-rule="nonzero" />
        <path d="M307.46 143.85L313.2881 123.44401C 314.5381 119.076805 320.20218 114.803406 324.75308 114.803406L324.75308 114.803406L375.2451 114.803406C 379.7959 114.803406 385.46008 119.07291 386.71008 123.44401L386.71008 123.44401L392.53818 143.85L419.46017 136.15471L413.63208 115.75271C 408.94458 99.35771 392.29608 86.80371 375.2451 86.80371L375.2451 86.80371L324.75308 86.80371C 307.7021 86.80371 291.05008 99.36271 286.3661 115.75271L286.3661 115.75271L280.538 136.15471L307.46 143.85z" stroke="none" fill="#000000" fill-rule="nonzero" />
      </g>
    </g>
  </g>
</svg>`;
class ColumnDropdownButtonItemConf {
}
ColumnDropdownButtonItemConf.ITEMS = [
  {
    text: "Sort Ascending",
    iconSettings: {
      svgString: SORT_ASC_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginRight: "9px", marginTop: "2px" } }
    }
  },
  {
    text: "Sort Descending",
    iconSettings: {
      svgString: SORT_DESC_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginRight: "9px", marginTop: "1px" } }
    }
  },
  {
    text: "Insert Left",
    iconSettings: {
      svgString: INSERT_LEFT_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "-2px", marginRight: "3px", marginTop: "1px" } }
    }
  },
  {
    text: "Insert Right",
    iconSettings: {
      svgString: INSERT_RIGHT_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "-3px", marginRight: "4px", marginTop: "1px" } }
    }
  },
  {
    text: "Move Left",
    iconSettings: {
      svgString: MOVE_LEFT_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "1px", marginRight: "7px", marginTop: "3.5px" } }
    }
  },
  {
    text: "Move Right",
    iconSettings: {
      svgString: MOVE_RIGHT_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "1px", marginRight: "7px", marginTop: "1.5px" } }
    }
  },
  {
    text: "Delete",
    iconSettings: {
      svgString: TRASH_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "-4px", marginRight: "5px", marginTop: "-1px" } }
    }
  }
];
class UpdateCellsForColumns {
  // prettier-ignore
  static updateColumn(D, O, x, B, U) {
    U !== CELL_UPDATE_TYPE.REMOVED && CellEventsReset.reset(D, x, O, B), FireEvents.onCellUpdate(D, CellElement.getText(x), O, B, U);
  }
  // prettier-ignore
  static updateNextBeforeLastColumns(D, O, x, B) {
    ExtractElements.textCellsArrFromRow(O.element).slice(x, B).forEach((F, W) => {
      const G = W + x;
      UpdateCellsForColumns.updateColumn(D, O.index, F, G, CELL_UPDATE_TYPE.UPDATE);
    });
  }
  // the reason why last column details need to be passed here is because after removal of last element, its details are
  // no longer present here as this class's methods are run in setTimeouts, hence those details need to be captured
  // before these methods are executed
  // prettier-ignore
  static rebindAndFireUpdates(D, O, x, B, U) {
    UpdateCellsForColumns.updateNextBeforeLastColumns(D, O, x, U.index), UpdateCellsForColumns.updateColumn(D, O.index, U.element, U.index, B);
  }
}
class LastColumn {
  // the reason why last column details are used is because after removal of the last column element, its details are
  // no longer present and update methods are run in setTimeouts, hence those details need to be captured before
  // their methods are executed
  static getDetails(D, O) {
    const x = D.length - 1;
    return { element: D[x].elements[O], index: x };
  }
}
class RemoveColumn {
  static reduceStaticWidthTotal(D, O) {
    var x;
    if ((x = O.widths) != null && x.staticWidth) {
      const { number: B } = ColumnSettingsWidthUtils.getSettingsWidthNumber(
        D._tableElementRef,
        O.widths
      );
      TableElement.changeStaticWidthTotal(D._tableDimensions, -B);
    }
  }
  static updateTableDimensions(D, O) {
    RemoveColumn.reduceStaticWidthTotal(D, O), StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, !1);
  }
  static cleanUpData(D) {
    D.length > 0 && D[0].length === 0 && D.splice(0);
  }
  static removeElements(D, O, x) {
    const B = CellElementIndex.getViaColumnIndex(O, x);
    D.children[B].remove(), D.children[B].remove();
  }
  static removeCell(D, O, x, B) {
    const U = LastColumn.getDetails(D._columnsDetails, x);
    RemoveColumn.removeElements(O, B, !!D._frameComponents.displayIndexColumn), D.data[x].splice(B, 1), setTimeout(() => {
      const F = { element: O, index: x };
      UpdateCellsForColumns.rebindAndFireUpdates(D, F, B, CELL_UPDATE_TYPE.REMOVED, U);
    });
  }
  static removeCellFromAllRows(D, O) {
    ExtractElements.textRowsArrFromTBody(D._tableBodyElementRef, D.data).forEach((U, F) => {
      RemoveColumn.removeCell(D, U, F, O);
    }), RemoveColumn.cleanUpData(D.data), HeaderText.onAttemptChange(D, D._columnsDetails[O].elements[0], O, { colRemove: !0 });
    const B = D._columnsDetails.splice(O, 1)[0];
    return RemoveColumn.updateTableDimensions(D, B.settings), B;
  }
  static remove(D, O) {
    const x = RemoveColumn.removeCellFromAllRows(D, O);
    ToggleAdditionElements.update(D, !1, AddNewColumnElement.toggle), ColumnSettingsBorderUtils.updateSiblingColumns(D, O), setTimeout(() => {
      x.cellDropdown.element.remove(), InsertRemoveColumnSizer.remove(D, O), InsertRemoveColumnSizer.cleanUpCustomColumnSizers(D, O), O === 0 && D._columnsDetails.length > 0 && RowDropdownCellOverlay.resetOverlays(D), setTimeout(() => {
        FireEvents.onDataUpdate(D), FireEvents.onColumnsUpdate(D);
      });
    });
  }
  static removeEvent(D) {
    RemoveColumn.remove(this, D);
  }
}
class ElementSiblingIterator {
  static create(D) {
    let O = D;
    return {
      next: () => {
        const x = O.nextSibling;
        return x && (O = x), x;
      },
      currentElement: () => O
    };
  }
}
class ColumnDropdownItemEvents {
  static onClickMiddleware(D) {
    D(), ColumnDropdown.processTextAndHide(this);
  }
  // prettier-ignore
  static setItemEvents(D, O, x) {
    const B = x.getElementsByClassName(ColumnDropdownItem.SORT_ITEM_CLASS)[0], U = ElementSiblingIterator.create(B);
    U.currentElement().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      Sort.sortColumn.bind(this, D, O, !0)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      Sort.sortColumn.bind(this, D, O, !1)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      InsertNewColumn.insert.bind(this, D, O)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      InsertNewColumn.insert.bind(this, D, O + 1)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      MoveColumn.move.bind(this, D, O, !1)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      MoveColumn.move.bind(this, D, O, !0)
    ), U.next().onclick = ColumnDropdownItemEvents.onClickMiddleware.bind(
      D,
      RemoveColumn.remove.bind(this, D, O)
    );
  }
  // reason why using onInput for updating cells is because it works for paste
  // prettier-ignore
  static onInput(D, O, x, B) {
    setTimeout(() => {
      CellEvents.updateCell(this, B.value, 0, D, { element: O, processText: !1 }), x.style.top = ColumnDropdown.getTopPosition(this, O);
    });
  }
  // prettier-ignore
  static setInputItemEvent(D, O, x, B, U) {
    B.oninput = ColumnDropdownItemEvents.onInput.bind(
      D,
      O,
      x,
      U,
      B
    );
  }
}
var SIDE = /* @__PURE__ */ ((z) => (z[z.LEFT = 0] = "LEFT", z[z.RIGHT = 1] = "RIGHT", z[z.TOP = 2] = "TOP", z[z.BOTTOM = 3] = "BOTTOM", z))(SIDE || {});
class NestedDropdown {
  static create(D, O) {
    const x = Dropdown.createBase();
    return x.style.top = `-${Number.parseInt(x.style.paddingTop) + 22}px`, D && O && DropdownItem.addNewButtonItems(D, x, O), x;
  }
  static resetPosition(D) {
    D.style.left = "";
  }
  static hideDropdown(D) {
    const O = D.target.children[2];
    O.style.display = "none", NestedDropdown.resetPosition(O);
  }
  // prettier-ignore
  static correctPosition(D, O, x) {
    const B = ElementVisibility.getDetailsInWindow(D, x);
    if (!B.isFullyVisible && B.blockingSides.has(SIDE.RIGHT)) {
      D.style.left = `-${O.style.width}`;
      const U = ElementVisibility.getDetailsInWindow(D, x);
      !U.isFullyVisible && U.blockingSides.has(SIDE.LEFT) && (D.style.left = "");
    }
  }
  // prettier-ignore
  static correctPositionForOverflow(D, O, x) {
    const { _tableElementRef: B, _overflow: U } = D;
    !B || !U || B.offsetWidth !== U.overflowContainer.scrollWidth && (O.style.left = `-${x.style.width}`, O.getBoundingClientRect().x < 0 && (O.style.left = ""));
  }
  static displayAndSetDropdownPosition(D) {
    const O = D.target.children[2], x = D.target.parentElement;
    O.style.left = x.style.width, O.style.display = x.style.display, this._overflow && OverflowUtils.isOverflowElement(this._overflow.overflowContainer) ? NestedDropdown.correctPositionForOverflow(this, O, x) : NestedDropdown.correctPosition(O, x, this._tableDimensions.border);
  }
}
class NestedDropdownItemEvents {
  // prettier-ignore
  static addEvents(D, O) {
    O.addEventListener("mouseenter", NestedDropdown.displayAndSetDropdownPosition.bind(D)), O.addEventListener("mouseleave", NestedDropdown.hideDropdown), O.children[1].addEventListener(
      "mouseenter",
      DropdownItemHighlightUtils.highlightNew.bind(this, D._activeOverlayElements, O)
    );
  }
}
const _ColumnTypeDropdown = class nt {
  static setupParentItemData(D, O) {
    var W;
    const { name: x, dropdownItem: B } = O, U = ((W = B.element) == null ? void 0 : W.children[0]).cloneNode(!0);
    D.replaceChild(U, D.children[0]);
    const F = D.children[1];
    F.innerText = x;
  }
  static setUp(D, O, x) {
    const { activeType: B, settings: U } = D._columnsDetails[x], F = O.getElementsByClassName(nt.COLUMN_TYPE_ITEM_CLASS)[0];
    if (nt.setupParentItemData(F, B), U.types.length < 2)
      return F.style.pointerEvents = "none";
    F.style.pointerEvents = "", setTimeout(() => ColumnTypeDropdownItem.setUp(D, x));
  }
  // prettier-ignore
  static create(D, O) {
    const x = DropdownItem.addButtonItem(
      D,
      O,
      DropdownButtonItemConf.DEFAULT_ITEM,
      NestedDropdownItem.NESTED_DROPDOWN_ITEM,
      nt.COLUMN_TYPE_ITEM_CLASS
    );
    NestedDropdownItemEvents.addEvents(D, x);
    const B = NestedDropdown.create();
    x.appendChild(B), D._activeOverlayElements.columnTypeDropdown = B;
  }
};
_ColumnTypeDropdown.COLUMN_TYPE_ITEM_CLASS = "dropdown-column-type-item";
let ColumnTypeDropdown = _ColumnTypeDropdown;
const _ColumnDropdownItem = class Oe {
  static resetItems(D) {
    Array.from(D.children).forEach((x) => DropdownItem.toggleItem(x, !0));
  }
  static addItems(D, O) {
    setTimeout(() => {
      DropdownItem.addTitle(O, "Property type"), ColumnTypeDropdown.create(D, O), DropdownItem.addDivider(O), ColumnDropdownButtonItemConf.ITEMS.slice(0, 2).forEach((x) => {
        DropdownItem.addButtonItem(D, O, x, Oe.SORT_ITEM_CLASS);
      }), ColumnDropdownButtonItemConf.ITEMS.slice(2).forEach((x) => {
        DropdownItem.addButtonItem(D, O, x);
      });
    });
  }
  // hide divider when there are no items below
  static hideDivider(D) {
    D.slice(4).find((x) => x.style.display !== "none") || DropdownItem.toggleItem(D[3], !1);
  }
  static toggleItems(D, O) {
    const { isSortAvailable: x, isDeleteAvailable: B, isInsertLeftAvailable: U, isInsertRightAvailable: F, isMoveAvailable: W } = D;
    x || (DropdownItem.toggleItem(O[4], !1), DropdownItem.toggleItem(O[5], !1)), U || DropdownItem.toggleItem(O[6], !1), F || DropdownItem.toggleItem(O[7], !1), W || (DropdownItem.toggleItem(O[8], !1), DropdownItem.toggleItem(O[9], !1)), B || DropdownItem.toggleItem(O[10], !1), Oe.hideDivider(O);
  }
  // prettier-ignore
  static setUpInputElement(D, O, x, B, U) {
    var G, Y, X;
    const { isCellTextEditable: F, isHeaderTextEditable: W } = D._columnsDetails[O].settings;
    if ((X = (Y = (G = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : G.displaySettings) == null ? void 0 : Y.openMethod) != null && X.overlayClick || (ObjectUtils.areValuesFullyDefined(W) ? !W : !F))
      DropdownItem.toggleItem(B, !1);
    else {
      const J = B.children[0];
      J.value = D.data[0][O], ColumnDropdownItemEvents.setInputItemEvent(D, O, x, J, U);
    }
  }
  static setUp(D, O, x, B) {
    ColumnTypeDropdown.setUp(D, O, x);
    const U = Array.from(O.children);
    Oe.setUpInputElement(D, x, B, U[0], O), Oe.toggleItems(D._columnsDetails[x].settings.columnDropdown, U), Oe.updateItemsStyle(D, x, O), ColumnDropdownItemEvents.setItemEvents(D, x, O);
  }
  static updateMoveColumnItemsStyle(D, O, x) {
    const { isMoveAvailable: B } = D._columnsDetails[O].settings.columnDropdown;
    B && (DropdownItem.toggleUsability(x[8], !0), DropdownItem.toggleUsability(x[9], !0), O === 0 && DropdownItem.toggleUsability(x[8], !1), O === D._columnsDetails.length - 1 && DropdownItem.toggleUsability(x[9], !1));
  }
  static updateInsertColumnItemsStyle(D, O) {
    MaximumColumns.canAddMore(D) ? (DropdownItem.toggleUsability(O[6], !0), DropdownItem.toggleUsability(O[7], !0)) : (DropdownItem.toggleUsability(O[6], !1), DropdownItem.toggleUsability(O[7], !1));
  }
  static updateItemsStyle(D, O, x) {
    const B = Array.from(x.children);
    Oe.updateInsertColumnItemsStyle(D, B), Oe.updateMoveColumnItemsStyle(D, O, B);
  }
};
_ColumnDropdownItem.SORT_ITEM_CLASS = "dropdown-sort-item";
let ColumnDropdownItem = _ColumnDropdownItem;
class ColumnDropdown {
  static resetDropdownPosition(D) {
    D.style.left = "";
  }
  // prettier-ignore
  static processTextAndHide(D) {
    var Y;
    const { _activeOverlayElements: O, _columnsDetails: x, _focusedElements: { cell: { element: B, columnIndex: U } } } = D, { columnDropdown: F, columnTypeDropdown: W, fullTableOverlay: G } = O;
    !F || !G || !W || !B || (GenericElementUtils.doesElementExistInDom(B) && (CellEvents.setCellToDefaultIfNeeded(D, 0, U, B), HeaderText.onAttemptChange(D, B, U)), CellHighlightUtils.fade(B, (Y = x[U]) == null ? void 0 : Y.headerStateColors.default), Dropdown.hide(F, G, W), ColumnTypeDropdownItem.reset(W), ColumnDropdown.resetDropdownPosition(F), ColumnDropdownItem.resetItems(F), DropdownItemHighlightUtils.fadeCurrentlyHighlighted(O));
  }
  static create(D) {
    const O = Dropdown.createBase();
    return ColumnDropdownEvents.set(D, O), DropdownItem.addInputItem(D, O), ColumnDropdownItem.addItems(D, O), O;
  }
  // prettier-ignore
  static getDefaultDropdownTopPosition(D, O, x) {
    return x ? `${Browser.IS_FIREFOX ? 1 + O.topWidth : 1}px` : `${ElementOffset.processTop(D.offsetTop + D.offsetHeight, O)}px`;
  }
  static getTopPosition(D, O) {
    var B, U, F;
    const x = (F = (U = (B = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : B.displaySettings) == null ? void 0 : U.openMethod) == null ? void 0 : F.overlayClick;
    if (D._overflow) {
      const W = D._overflow.overflowContainer;
      return `${x ? W.scrollTop + 1 : W.scrollTop + O.offsetHeight}px`;
    } else if (D._stickyProps.header) {
      const W = O.parentElement.offsetTop;
      return `${(x ? 1 : O.offsetHeight) + W}px`;
    }
    return ColumnDropdown.getDefaultDropdownTopPosition(O, D._tableDimensions.border, x);
  }
  static getLeftPropertyToCenterDropdown(D, O) {
    return `${ElementOffset.processLeft(D.offsetLeft + D.offsetWidth / 2, O) - Dropdown.DROPDOWN_WIDTH / 2}px`;
  }
  static displayAndSetDropdownPosition(D, O, x) {
    x.style.left = ColumnDropdown.getLeftPropertyToCenterDropdown(O, D._tableDimensions.border), x.style.top = ColumnDropdown.getTopPosition(D, O), Dropdown.display(x);
    const B = ElementVisibility.getDetailsInWindow(x, D._tableDimensions.border);
    B.isFullyVisible || (B.blockingSides.has(SIDE.LEFT) ? x.style.left = "0px" : B.blockingSides.has(SIDE.RIGHT) && (x.style.left = `${O.offsetLeft + O.offsetWidth - Dropdown.DROPDOWN_WIDTH}px`));
  }
  // no active table based overflow - REF-37
  static displayAndSetPositionForSticky(D, O, x) {
    x.style.left = ColumnDropdown.getLeftPropertyToCenterDropdown(O, D._tableDimensions.border), x.style.top = ColumnDropdown.getTopPosition(D, O), Dropdown.display(x);
  }
  // prettier-ignore
  static displayAndSetPositionForOverflow(D, O, x) {
    const { _tableElementRef: B, _overflow: U, _tableDimensions: F } = D;
    if (!B || !(U != null && U.overflowContainer))
      return;
    const W = U.overflowContainer;
    x.style.left = ColumnDropdown.getLeftPropertyToCenterDropdown(O, F.border), x.style.top = ColumnDropdown.getTopPosition(D, O), Dropdown.display(x), B.offsetWidth !== W.scrollWidth ? x.style.left = `${B.offsetWidth - x.offsetWidth}px` : x.offsetLeft < 0 && (x.style.left = "0px");
  }
  static display(D, O) {
    const x = D._activeOverlayElements.columnDropdown, B = D._columnsDetails[O].elements[0];
    ColumnDropdownItem.setUp(D, x, O, B), D._overflow ? ColumnDropdown.displayAndSetPositionForOverflow(D, B, x) : D._stickyProps.header ? ColumnDropdown.displayAndSetPositionForSticky(D, B, x) : ColumnDropdown.displayAndSetDropdownPosition(D, B, x);
    const U = DropdownItem.getInputElement(x);
    U && DropdownItemNavigation.focusInputElement(U), FullTableOverlayElement.display(D);
  }
}
class FullTableOverlayEvents {
  // prettier-ignore
  static onMouseDown(D) {
    const { _activeOverlayElements: { columnDropdown: O, rowDropdown: x } } = this;
    Dropdown.isDisplayed(O) && !Dropdown.isPartOfDropdownElement(D.target) && ColumnDropdown.processTextAndHide(this), Dropdown.isDisplayed(x) && RowDropdown.hide(this);
  }
}
class FullTableOverlayElement {
  // at offsets is a bug fix for a situation where the user was able to click the table border, focus and unfocus a cell
  // and therefore not allow the column dropdown to close because there is nothing focused
  static display(D) {
    var x;
    const O = D._activeOverlayElements.fullTableOverlay;
    if (O.style.width = `${D.offsetWidth}px`, O.style.height = `${D.offsetHeight}px`, (x = D._overflow) != null && x.overflowContainer)
      O.style.top = `${D.offsetTop}px`, O.style.left = `${D.offsetLeft}px`;
    else {
      const B = D._tableElementRef.offsetTop - D.offsetTop;
      O.style.top = `-${Browser.IS_FIREFOX ? B : B + D._tableDimensions.border.topWidth}px`, O.style.left = `-${Browser.IS_FIREFOX ? 0 : D._tableDimensions.border.leftWidth}px`;
    }
    Dropdown.display(O);
  }
  static create(D) {
    const O = document.createElement("div");
    return O.id = "full-table-overlay", O.style.backgroundColor = SEMI_TRANSPARENT_COLOR, O.style.display = "none", O.onmousedown = FullTableOverlayEvents.onMouseDown.bind(D), O;
  }
}
class RowDropdownEvents {
  // the reason why we track window key events is because the table is not actually focused when it is displayed,
  // (unlike column dropdown which has an input), hence initially clicking tab does not focus the dropdown and
  // instead we need to focus it programmatically here. Once focused, the actual dropdown events can take over.
  // prettier-ignore
  static windowOnKeyDown(D, O) {
    const { _activeOverlayElements: { rowDropdown: x, fullTableOverlay: B }, shadowRoot: U } = D;
    D._focusedElements.rowDropdown || !x || !B || (O.key === KEYBOARD_KEY.ENTER || O.key === KEYBOARD_KEY.ESCAPE ? RowDropdown.hide(D) : U != null && U.activeElement || (O.key === KEYBOARD_KEY.TAB || O.key === KEYBOARD_KEY.ARROW_DOWN ? (O.preventDefault(), D._focusedElements.rowDropdown = x, DropdownItemNavigation.focusSiblingItem(x.children[0], x, !0, !0)) : O.key === KEYBOARD_KEY.ARROW_UP && (D._focusedElements.rowDropdown = x, DropdownItemNavigation.focusSiblingItem(
      x.children[x.children.length - 1],
      x,
      !1,
      !0
    ))));
  }
  static dropdownOnKeyDown(D, O) {
    if (O.key === KEYBOARD_KEY.ENTER) {
      const x = O.target;
      x.dispatchEvent(new Event("mouseenter")), x.dispatchEvent(new Event("click"));
    } else
      O.key === KEYBOARD_KEY.ESCAPE && RowDropdown.hide(this);
    DropdownEvents.itemKeyNavigation(this.shadowRoot, D, O);
  }
  static set(D, O) {
    O.onkeydown = RowDropdownEvents.dropdownOnKeyDown.bind(D, O);
  }
}
class RowDropdownButtonItemConf {
}
RowDropdownButtonItemConf.ITEMS = [
  {
    text: "Insert Up",
    iconSettings: {
      svgString: INSERT_UP_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginRight: "1px" } }
    }
  },
  {
    text: "Insert Down",
    iconSettings: {
      svgString: INSERT_DOWN_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginRight: "1px" } }
    }
  },
  {
    text: "Move Up",
    iconSettings: {
      svgString: MOVE_UP_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginRight: "8px", marginTop: "3.5px" } }
    }
  },
  {
    text: "Move Down",
    iconSettings: {
      svgString: MOVE_DOWN_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "2px", marginRight: "6px", marginTop: "3.5px" } }
    }
  },
  {
    text: "Delete",
    iconSettings: {
      svgString: TRASH_ICON_SVG_STRING,
      containerStyles: { dropdown: { marginLeft: "-4px", marginRight: "5px", marginTop: "-1px" } }
    }
  }
];
class IndexColumnEvents {
  static mouseEnterCell(D, O) {
    const x = O.target, { cellColors: B } = this._frameComponents, U = FrameComponentsColors.getColorsBasedOnParam(B, D);
    CellHighlightUtils.highlight(x, U.hover);
  }
  static mouseLeaveCell(D, O) {
    if (!Dropdown.isDisplayed(this._activeOverlayElements.rowDropdown)) {
      const { cellColors: x } = this._frameComponents, B = FrameComponentsColors.getColorsBasedOnParam(x, D);
      CellHighlightUtils.fade(O.target, B.default);
    }
  }
  static setEvents(D, O, x) {
    var F;
    O.onmouseenter = IndexColumnEvents.mouseEnterCell.bind(D, x), O.onmouseleave = IndexColumnEvents.mouseLeaveCell.bind(D, x);
    const { displaySettings: B, canEditHeaderRow: U } = D.rowDropdown;
    !U && x === 0 || (B.isAvailable && ((F = B.openMethod) != null && F.cellClick) ? O.onclick = RowDropdown.display.bind(D, x, O) : RowDropdownCellOverlayEvents.addCellEvents(D, x, O));
  }
}
class UpdateCellsForRows {
  // prettier-ignore
  static updateRowCells(D, O, x, B, U = !0) {
    var W;
    if (ExtractElements.textCellsArrFromRow(O).forEach((G, Y) => {
      B !== CELL_UPDATE_TYPE.REMOVED && CellEventsReset.reset(D, G, x, Y), U && FireEvents.onCellUpdate(D, CellElement.getText(G), x, Y, B);
    }), B !== CELL_UPDATE_TYPE.REMOVED) {
      const G = O.children[0];
      if (D._frameComponents.displayIndexColumn && (IndexColumnEvents.setEvents(D, G, x), DragRow.applyEventsToElement(D, G, G)), (W = D.rowDropdown.displaySettings.openMethod) != null && W.overlayClick) {
        const Y = RowDropdownCellOverlayEvents.setOverlayEvents(D, x, G);
        DragRow.applyEventsToElement(D, Y, G);
      }
    }
  }
  static updateLastRow(D, O, x) {
    var B;
    (B = D._tableBodyElementRef) != null && B.children && UpdateCellsForRows.updateRowCells(D, x.element, x.index, O);
  }
  static updateLowerBeforeLastRows(D, O, x) {
    var U;
    const B = (U = D._tableBodyElementRef) == null ? void 0 : U.children;
    B && Array.from(B).slice(O, x).forEach((W, G) => {
      const Y = G + O, X = W;
      UpdateCellsForRows.updateRowCells(D, X, Y, CELL_UPDATE_TYPE.UPDATE);
    });
  }
  // REF-20
  // the reason why last row details need to be passed here is because after removal of last row, the last element details
  // are no longer available as this class's methods are run in setTimeouts, hence those details need to be captured
  // before these methods are executed
  // CAUTION-2 if the addition or removal of row causes the parent div to change width, this is indeed run after rerender,
  // however the onCellUpdate messages are required and event rebinding here still appears to be valid
  // prettier-ignore
  static rebindAndFireUpdates(D, O, x, B) {
    UpdateCellsForRows.updateLowerBeforeLastRows(D, O, B.index), UpdateCellsForRows.updateLastRow(D, x, B);
  }
}
class RemoveRow {
  // when the last row has been removed, there are no more columns
  static removeAllColumnsDetails(D) {
    const { _columnsDetails: O } = D;
    O.forEach((x) => RemoveColumn.reduceStaticWidthTotal(D, x.settings)), O.splice(0, O.length);
  }
  static update(D, O, x, B) {
    const U = { element: x, index: B };
    UpdateCellsForRows.rebindAndFireUpdates(D, O, CELL_UPDATE_TYPE.REMOVED, U), setTimeout(() => FireEvents.onDataUpdate(D)), !D._isRendering && (D.data.length === 0 && RemoveRow.removeAllColumnsDetails(D), D._addColumnCellsElementsRef.splice(O, 1));
  }
  static rowToBeRemovedIndexWhenPagination(D, O) {
    var B;
    const x = (B = D._tableBodyElementRef) == null ? void 0 : B.children[O];
    return D._pagination.visibleRows.findIndex((U) => U === x);
  }
  static removeRow(D, O) {
    var U;
    const x = D.pagination ? RemoveRow.rowToBeRemovedIndexWhenPagination(D, O) : 0;
    (U = D._tableBodyElementRef) == null || U.children[O].remove(), D._rowDropdownCellOverlays.splice(O, 1);
    const B = D.data.splice(O, 1);
    return B[0].forEach((F, W) => {
      D._columnsDetails[W].elements.splice(O, 1), D._columnsDetails[W].processedStyle.splice(O, 1);
    }), D.pagination && PaginationUtils.updateOnRowChange(D, x), B[0];
  }
  // REF-27
  static changeRowIndexIfRemoveHeaderWithDataBelow(D, O) {
    return O === 0 && D._columnsDetails[0].elements.length > 1 ? (MoveRow.move(D, 0, !0), 1) : O;
  }
  static remove(D, O) {
    var U;
    O = RemoveRow.changeRowIndexIfRemoveHeaderWithDataBelow(D, O);
    const x = D.data.length - 1, B = (U = D._tableBodyElementRef) == null ? void 0 : U.children[x];
    RemoveRow.removeRow(D, O), ToggleAdditionElements.update(D, !1, AddNewRowElement.toggle), D._frameComponents.displayIndexColumn && IndexColumn.updateIndexes(D, O), CustomRowProperties.update(D, O), setTimeout(() => RemoveRow.update(D, O, B, x));
  }
}
class RowDropdownItemEvents {
  static onClickMiddleware(D) {
    D(), RowDropdown.hide(this);
  }
  // prettier-ignore
  static set(D, O, x) {
    const B = O.getElementsByClassName(DropdownItem.DROPDOWN_ITEM_CLASS)[0], U = ElementSiblingIterator.create(B);
    U.currentElement().onclick = RowDropdownItemEvents.onClickMiddleware.bind(
      D,
      InsertNewRow.insert.bind(this, D, x, !0)
    ), U.next().onclick = RowDropdownItemEvents.onClickMiddleware.bind(
      D,
      InsertNewRow.insert.bind(this, D, x + 1, !0)
    ), U.next().onclick = RowDropdownItemEvents.onClickMiddleware.bind(
      D,
      MoveRow.move.bind(this, D, x, !1)
    ), U.next().onclick = RowDropdownItemEvents.onClickMiddleware.bind(
      D,
      MoveRow.move.bind(this, D, x, !0)
    ), U.next().onclick = RowDropdownItemEvents.onClickMiddleware.bind(
      D,
      RemoveRow.remove.bind(this, D, x)
    );
  }
}
class RowDropdownItem {
  static updateDeleteRowItemStyle(D, O, x) {
    DropdownItem.toggleUsability(x[4], !!(O > 0 || D.rowDropdown.canEditHeaderRow));
  }
  static updateMoveRowsItemsStyle(D, O, x) {
    const { isMoveAvailable: B, canEditHeaderRow: U } = D.rowDropdown;
    B && (DropdownItem.toggleUsability(x[2], !0), DropdownItem.toggleUsability(x[3], !0), (O === 0 || O === 1 && !U) && DropdownItem.toggleUsability(x[2], !1), (O === D._columnsDetails[0].elements.length - 1 || O === 0 && !U) && DropdownItem.toggleUsability(x[3], !1));
  }
  static updateInsertRowsItemsStyle(D, O, x) {
    MaximumRows.canAddMore(D) ? (O === 0 && !D.rowDropdown.canEditHeaderRow ? DropdownItem.toggleUsability(x[0], !1) : DropdownItem.toggleUsability(x[0], !0), DropdownItem.toggleUsability(x[1], !0)) : (DropdownItem.toggleUsability(x[0], !1), DropdownItem.toggleUsability(x[1], !1));
  }
  static updateItemStyle(D, O, x) {
    const B = Array.from(O.children);
    RowDropdownItem.updateInsertRowsItemsStyle(D, x, B), RowDropdownItem.updateMoveRowsItemsStyle(D, x, B), RowDropdownItem.updateDeleteRowItemStyle(D, x, B);
  }
  static update(D, O, x) {
    RowDropdownItem.updateItemStyle(D, O, x), RowDropdownItemEvents.set(D, O, x);
  }
  static setUpItems(D, O) {
    setTimeout(() => {
      const { rowDropdown: x } = D, { isInsertUpAvailable: B, isInsertDownAvailable: U, isMoveAvailable: F, isDeleteAvailable: W } = x, G = RowDropdownButtonItemConf.ITEMS.map((Y) => DropdownItem.addButtonItem(D, O, Y));
      B || DropdownItem.toggleItem(G[0], !1), U || DropdownItem.toggleItem(G[1], !1), F || (DropdownItem.toggleItem(G[2], !1), DropdownItem.toggleItem(G[3], !1)), W || DropdownItem.toggleItem(G[4], !1);
    });
  }
}
class RowDropdown {
  // prettier-ignore
  static hide(D) {
    const {
      _activeOverlayElements: { rowDropdown: O, fullTableOverlay: x },
      _focusedElements: { cell: { element: B, rowIndex: U } },
      _frameComponents: { cellColors: F, displayIndexColumn: W }
    } = D;
    if (!O || !x || !B)
      return;
    Dropdown.hide(O, x);
    const G = FrameComponentsColors.getColorsBasedOnParam(F, U);
    W && CellHighlightUtils.fade(B, G.default), DropdownItemHighlightUtils.fadeCurrentlyHighlighted(D._activeOverlayElements), setTimeout(() => {
      delete D._focusedElements.rowDropdown, FocusedCellUtils.purge(D._focusedElements.cell);
    });
  }
  static focusCell(D, O, x) {
    const { _frameComponents: B, _focusedElements: U } = D;
    B.displayIndexColumn ? FocusedCellUtils.setIndexCell(U.cell, x, O) : FocusedCellUtils.set(U.cell, x, O, 0);
  }
  // prettier-ignore
  static correctPositionWhenBottomOverflow(D, O, x) {
    const { top: B } = O.parentElement.getBoundingClientRect(), U = B + D.border.topWidth;
    let F = window.innerHeight - U - O.offsetHeight;
    Browser.IS_FIREFOX && (F += D.border.topWidth), O.style.top = `${F}px`;
    const W = ElementVisibility.getDetailsInWindow(O, D.border);
    !W.isFullyVisible && W.blockingSides.has(SIDE.TOP) && (O.style.top = x);
  }
  static getLeft(D, O) {
    var B;
    const x = (B = D.rowDropdown.displaySettings.openMethod) == null ? void 0 : B.cellClick;
    return `${ElementOffset.processWidth(x ? O.offsetWidth : 5, D._tableDimensions.border)}px`;
  }
  static displayAndSetPosition(D, O, x) {
    const B = `${ElementOffset.processTop(O.offsetTop, D._tableDimensions.border)}px`;
    x.style.top = B, x.style.left = RowDropdown.getLeft(D, O), Dropdown.display(x);
    const U = ElementVisibility.getDetailsInWindow(x, D._tableDimensions.border);
    U.isFullyVisible || U.blockingSides.has(SIDE.BOTTOM) && RowDropdown.correctPositionWhenBottomOverflow(D._tableDimensions, x, B);
  }
  // prettier-ignore
  static setOverflowPosition(D, O, x, B) {
    if (D._stickyProps.header && O.tagName === CellElement.HEADER_TAG)
      if (D._overflow)
        x.style.top = `${B.scrollTop}px`;
      else {
        const U = O.parentElement.offsetTop, F = Number.parseInt(getComputedStyle(O).borderTopWidth);
        x.style.top = `${U + F}px`;
      }
    else
      x.style.top = `${ElementOffset.processTop(O.offsetTop, D._tableDimensions.border)}px`;
    x.style.left = RowDropdown.getLeft(D, O);
  }
  // no active table based overflow
  static displayAndSetPositionForSticky(D, O, x) {
    const B = D.parentElement;
    RowDropdown.setOverflowPosition(D, O, x, B), Dropdown.display(x);
  }
  static displayAndSetPositionOverflow(D, O, x) {
    const { _tableElementRef: B, _overflow: U, _stickyProps: F } = D;
    if (!B || !(U != null && U.overflowContainer))
      return;
    RowDropdown.setOverflowPosition(D, O, x, U.overflowContainer), Dropdown.display(x);
    const W = F.header && O.tagName === CellElement.HEADER_TAG;
    B.offsetHeight !== U.overflowContainer.scrollHeight && !W && (x.style.top = `${B.offsetHeight - x.offsetHeight}px`);
  }
  static display(D, O) {
    var B;
    const x = this._activeOverlayElements.rowDropdown;
    RowDropdownItem.update(this, x, D), (B = this._overflow) != null && B.overflowContainer ? RowDropdown.displayAndSetPositionOverflow(this, O, x) : this._stickyProps.header ? RowDropdown.displayAndSetPositionForSticky(this, O, x) : RowDropdown.displayAndSetPosition(this, O, x), FullTableOverlayElement.display(this), setTimeout(() => RowDropdown.focusCell(this, D, O));
  }
  static create(D) {
    const O = Dropdown.createBase();
    return RowDropdownEvents.set(D, O), RowDropdownItem.setUpItems(D, O), O;
  }
}
class RowDropdownCellOverlayEvents {
  static mouseLeave(D, O) {
    RowDropdownCellOverlay.hide(this, D), delete this._hoveredElements.leftMostCell, RowDropdownCellOverlay.resetDefaultColor(this.rowDropdown.displaySettings, O);
  }
  static mouseEnter(D, O) {
    this._hoveredElements.leftMostCell = D, RowDropdownCellOverlay.setHoverColor(this.rowDropdown.displaySettings, O);
  }
  // prettier-ignore
  static setOverlayEvents(D, O, x) {
    const B = D._rowDropdownCellOverlays[O].element;
    return B.onmouseenter = RowDropdownCellOverlayEvents.mouseEnter.bind(
      D,
      x,
      B
    ), B.onmouseleave = RowDropdownCellOverlayEvents.mouseLeave.bind(
      D,
      O,
      B
    ), B.onclick = RowDropdown.display.bind(D, O, x), B;
  }
  static cellMouseLeave(D) {
    RowDropdownCellOverlay.hide(this, D), delete this._hoveredElements.leftMostCell;
  }
  static cellMouseEnter(D, O) {
    RowDropdownCellOverlay.display(this, D), this._hoveredElements.leftMostCell = O;
  }
  // This method is adding more events to existing cells instead of overwriting them, the reason for using this approach is
  // because we would instead need to add logic inside data cell events, select/label events, header events and more as
  // row dropdown overlay can appear above them if index column is not displayed
  // Interestingly using setting events like .onmousenter does not overwrite the events that have been added via
  // addEventListener, hence they need to be removed here before adding again
  static addCellEvents(D, O, x) {
    const { displaySettings: B, canEditHeaderRow: U } = D.rowDropdown;
    if (!B.isAvailable || !U && O === 0)
      return;
    const F = D._rowDropdownCellOverlays[O];
    if (F != null && F.cellElement) {
      const { cellElement: W, enter: G, leave: Y } = F;
      W.removeEventListener("mouseenter", G), W.removeEventListener("mouseleave", Y);
    }
    F.cellElement = x, F.enter = RowDropdownCellOverlayEvents.cellMouseEnter.bind(D, O, x), F.leave = RowDropdownCellOverlayEvents.cellMouseLeave.bind(D, O), x.addEventListener("mouseenter", F.enter), x.addEventListener("mouseleave", F.leave);
  }
}
const _RowDropdownCellOverlay = class Ue {
  static setDefault(D, O) {
    var x;
    D.style.backgroundColor = ((x = O == null ? void 0 : O.default) == null ? void 0 : x.backgroundColor) || "";
  }
  static resetDefaultColor(D, O) {
    var B;
    const x = D.overlayStyles;
    (B = x == null ? void 0 : x.hover) != null && B.backgroundColor && Ue.setDefault(O, x);
  }
  static setHoverColor(D, O) {
    var B, U;
    const x = (U = (B = D.overlayStyles) == null ? void 0 : B.hover) == null ? void 0 : U.backgroundColor;
    x && (O.style.backgroundColor = x);
  }
  static hide(D, O) {
    const x = D._hoveredElements.leftMostCell;
    setTimeout(() => {
      if (x !== D._hoveredElements.leftMostCell) {
        const B = D._rowDropdownCellOverlays[O].element;
        B.style.width = DropdownCellOverlay.HIDDEN_PX;
      }
    });
  }
  static display(D, O) {
    const x = D._columnsDetails[0], B = D._rowDropdownCellOverlays[O].element;
    B.style.width = DropdownCellOverlay.VISIBLE_PX;
    const U = x.elements[O], { displayIndexColumn: F } = D._frameComponents, W = F ? U.previousSibling : U, G = W.offsetHeight / 100;
    B.style.height = `${G * 60}px`, B.style.top = `${G * 20}px`;
    const Y = F ? x.elements[0].offsetWidth : 0;
    B.style.left = `-${W.offsetWidth + Y}px`;
  }
  static create(D) {
    const O = document.createElement("div");
    return O.classList.add(Ue.ROW_DROPDOWN_CELL_OVERLAY_CLASS), O.classList.add(DropdownCellOverlay.DROPDOWN_CELL_OVERLAY_CLASS), O.style.width = DropdownCellOverlay.HIDDEN_PX, Ue.setDefault(O, D), O;
  }
  static getCellDividerElement(D, O) {
    let x = D.nextSibling;
    return O && (x = x.nextSibling), x;
  }
  static add(D, O, x) {
    const B = Ue.create(D.rowDropdown.displaySettings.overlayStyles), { displayIndexColumn: U } = D._frameComponents;
    Ue.getCellDividerElement(x, !!U).appendChild(B), D._rowDropdownCellOverlays.splice(O, 0, {
      element: B,
      // these events are stubs and will be replaced by real ones in RowDropdownCellOverlayEvents.addCellEvents
      enter: () => {
      },
      leave: () => {
      }
    });
  }
  static resetOverlays(D) {
    var x;
    if (!((x = D.rowDropdown.displaySettings.openMethod) != null && x.overlayClick))
      return;
    D._rowDropdownCellOverlays.splice(0, D._rowDropdownCellOverlays.length), ExtractElements.textRowsArrFromTBody(D._tableBodyElementRef, D.data).forEach((B, U) => {
      const F = B.children[0];
      Ue.add(D, U, F), RowDropdownCellOverlayEvents.setOverlayEvents(D, U, F);
    });
  }
};
_RowDropdownCellOverlay.ROW_DROPDOWN_CELL_OVERLAY_CLASS = "row-dropdown-cell-overlay";
let RowDropdownCellOverlay = _RowDropdownCellOverlay;
class PaginationRowIndexes {
  static getVisibleRowRealIndex(D, O, x) {
    const B = Array.from(D.children), U = x === void 0 ? O.visibleRows.length - 1 : x, F = O.visibleRows[U];
    return B.findIndex((W) => W === F);
  }
  static getVisibleRowIndex(D, O, x) {
    const B = D.children[x];
    return O.visibleRows.findIndex((U) => U === B);
  }
  static getFilteredMaxVisibleRowIndex(D, O) {
    const { rowsPerPage: x, visibleRows: B } = O, U = PaginationRowIndexes.getVisibleRowRealIndex(D, O);
    return B.length === x ? U : U + (x - B.length);
  }
  static getRawMaxVisibleRowIndex(D) {
    const { _pagination: O, _tableBodyElementRef: x, data: B, _visiblityInternal: U } = D, { activePageNumber: F, rowsPerPage: W, isAllRowsOptionSelected: G } = O;
    return G ? B.length + 1 : U.filters ? PaginationRowIndexes.getFilteredMaxVisibleRowIndex(x, O) : F * W;
  }
  static getMaxVisibleRowIndex(D) {
    const { dataStartsAtHeader: O } = D;
    let x = PaginationRowIndexes.getRawMaxVisibleRowIndex(D);
    return O || (x += 1), x;
  }
}
const _RowElement = class Re {
  static create() {
    const D = document.createElement("tr");
    return D.classList.add("row"), D;
  }
  static moveClassToLastVisibleRow(D, O) {
    O && (O.id = ""), D.id = Re.LAST_VISIBLE_ROW_ID;
  }
  static toggleNonAddRow(D, O, x) {
    if (D.pagination && D._pagination) {
      const U = D._pagination.visibleRows[D._pagination.visibleRows.length - 1];
      if (U)
        return Re.moveClassToLastVisibleRow(U, x);
    }
    const { previousElementSibling: B } = O;
    B && Re.moveClassToLastVisibleRow(B, x);
  }
  // REF-25
  // Add new row element is always appended to the table, but not always visible (e.g. if the user has
  // chosen not to display it or max rows has been reached), hence we must always monitor its current
  // visibility and given that it can be safely assumed that it is the last row element, we can use
  // its isDisplayed method to help assign the last-visible row id to the correct row
  static toggleLastRowClass(D) {
    const O = D.shadowRoot, x = D._addRowCellElementRef.parentElement, B = O.getElementById(Re.LAST_VISIBLE_ROW_ID);
    AddNewRowElement.isDisplayed(x.children[0]) ? x.id !== Re.LAST_VISIBLE_ROW_ID && Re.moveClassToLastVisibleRow(x, B) : Re.toggleNonAddRow(D, x, B);
  }
};
_RowElement.LAST_VISIBLE_ROW_ID = "last-visible-row";
let RowElement = _RowElement;
class CellDividerElement {
  static create(D) {
    const O = document.createElement("div");
    return O.classList.add("cell-divider"), D === 0 && (O.style.height = ColumnSizerGenericUtils.canHeightBeInherited() ? "100%" : "inherit"), O;
  }
}
class InsertNewCell {
  // prettier-ignore
  static insertElementsToRow(D, O, x, B, U) {
    const F = CellElementIndex.getViaColumnIndex(B, U);
    D.insertBefore(O, D.children[F]);
    const W = CellDividerElement.create(x);
    D.insertBefore(W, D.children[F + 1]);
  }
  static updateColumnDetailsAndSizers(D, O, x, B) {
    const U = D._columnsDetails[x];
    if (U && O === 0) {
      const F = ColumnDropdownCellOverlay.add(D, x);
      ColumnDetails.updateWithNoSizer(U, F), InsertRemoveColumnSizer.insert(D, x), B && (InsertRemoveColumnSizer.cleanUpCustomColumnSizers(D, x), UpdateIndexColumnWidth.wrapTextWhenNarrowColumnsBreached(D));
    }
  }
  // prettier-ignore
  static insert(D, O, x, B, U, F, W) {
    const { _frameComponents: { displayIndexColumn: G }, data: Y, _columnsDetails: X } = D, J = X[W];
    J.elements.splice(F, 0, x), J.processedStyle.splice(F, 0, ProcessedDataTextStyle.getDefaultProcessedTextStyle()), InsertNewCell.insertElementsToRow(O, x, F, W, !!G), Y[F].splice(W, U ? 0 : 1, B);
  }
  static convertCell(D, O, x, B) {
    const U = D._columnsDetails[x];
    O === 0 && D.displayHeaderIcons && HeaderIconCellElement.setHeaderIconStructure(D, B, x), U.activeType && (U.activeType.cellDropdownProps ? O === 0 ? CellDropdown.setUpDropdown(D, x) : (SelectCell.convertCell(D, x, B), SelectCell.finaliseEditedText(D, B.children[0], x, !0)) : O > 0 && (U.activeType.checkbox && CheckboxCellElement.setCellCheckboxStructure(D, B, x, O), U.activeType.calendar && DateCellElement.setCellDateStructure(D, B, x)));
  }
  // REF-13
  // prettier-ignore
  static insertInitialColumnDetails(D, O, x) {
    const { _columnsDetails: B, _customColumnsSettings: U, _cellDropdownContainer: F, _defaultColumnsSettings: W } = D, G = CellDropdown.createAndAppend(F), Y = ColumnDetails.createInitial(
      W,
      G,
      U[O],
      D._defaultCellHoverColors,
      FireEvents.onColumnsUpdate.bind(this, D)
    );
    B.splice(x, 0, Y);
  }
  // isNewText indicates whether rowData is already in the data state or if it needs to be added
  // prettier-ignore
  static insertToRow(D, O, x, B, U, F) {
    x === 0 && InsertNewCell.insertInitialColumnDetails(D, U, B);
    const W = DataUtils.processCellText(D, x, B, U), G = CellElement.createCellElement(D, W, B, x === 0);
    InsertNewCell.insert(D, O, G, W, F, x, B), InsertNewCell.convertCell(D, x, B, G), x === 0 ? (F && StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, !0), ColumnSettingsBorderUtils.updateSiblingColumns(D, B)) : ProcessedDataTextStyle.setCellStyle(D, x, B), setTimeout(() => InsertNewCell.updateColumnDetailsAndSizers(D, x, B, F));
  }
}
class InsertNewRow {
  // CAUTION-2 if the addition or removal of row causes the parent div to change width, this is indeed run after rerender,
  // however the notification messages are necessary and the rebinding does not seem to cause issues, nevertheless take
  // note of this if editing any of the logic below
  static bindAndfireCellUpdates(D, O) {
    var F;
    const x = D.data.length - 1, U = { element: (F = D._tableBodyElementRef) == null ? void 0 : F.children[x], index: x };
    UpdateCellsForRows.rebindAndFireUpdates(D, O, CELL_UPDATE_TYPE.ADD, U), setTimeout(() => FireEvents.onDataUpdate(D));
  }
  static canStartRenderCellBeAdded(D, O, x) {
    return O === 0 ? MaximumColumns.canAddMore(D) : D._columnsDetails[x];
  }
  // prettier-ignore
  static addCells(D, O, x, B, U) {
    const { _frameComponents: { displayIndexColumn: F, displayAddNewColumn: W } } = D;
    F && IndexColumn.createAndPrependToRow(D, x, B), O.forEach((G, Y) => {
      (U || InsertNewRow.canStartRenderCellBeAdded(D, B, Y)) && InsertNewCell.insertToRow(D, x, B, Y, G, U);
    }), W && AddNewColumnElement.createAndAppendToRow(D, x, B), setTimeout(() => RowDropdownCellOverlay.add(D, B, x.children[0]));
  }
  static updatePagination(D, O, x, B) {
    x ? PaginationUtils.updateOnRowChange(D, O, B) : PaginationUtils.initialRowUpdates(D, O, B);
  }
  static insertNewRow(D, O, x, B) {
    var W, G;
    const U = B || DataUtils.createEmptyStringDataArray(((W = D.data[0]) == null ? void 0 : W.length) || 1), F = RowElement.create();
    return D.pagination && InsertNewRow.updatePagination(D, O, x, F), (G = D._tableBodyElementRef) == null || G.insertBefore(F, D._tableBodyElementRef.children[O]), x && D.data.splice(O, 0, []), InsertNewRow.addCells(D, U, F, O, x), F;
  }
  // isNewText indicates whether rowData is already in the data state or if it needs to be added
  static insert(D, O, x, B) {
    if (!MaximumRows.canAddMore(D))
      return;
    const U = x && O === 0 && D._columnsDetails.length > 0;
    U && (O = 1);
    const F = InsertNewRow.insertNewRow(D, O, x, B);
    x && (ToggleAdditionElements.update(D, !0, AddNewRowElement.toggle), D._frameComponents.displayIndexColumn && IndexColumn.updateIndexes(D, O + 1), CustomRowProperties.update(D, O)), U && MoveRow.move(D, 0, !0), setTimeout(() => {
      D._isPopulatingTable ? UpdateCellsForRows.updateRowCells(D, F, O, CELL_UPDATE_TYPE.ADD) : B ? O === D.data.length - 1 && InsertNewRow.bindAndfireCellUpdates(D, 0) : InsertNewRow.bindAndfireCellUpdates(D, O);
    });
  }
  // prettier-ignore
  static insertEvent() {
    let D = this.data.length;
    if (this.pagination)
      if (this._visiblityInternal.filters && this._tableBodyElementRef)
        D = this.data.length === 1 && !this.dataStartsAtHeader ? 1 : PaginationRowIndexes.getVisibleRowRealIndex(this._tableBodyElementRef, this._pagination) + 1;
      else {
        const O = PaginationRowIndexes.getMaxVisibleRowIndex(this);
        O < D && (D = O);
      }
    InsertNewRow.insert(this, D, !0);
  }
}
class AddNewRowEvents {
  static mouseEnterCell(D, O) {
    CellHighlightUtils.highlight(O.target, D.hover);
  }
  static mouseLeaveCell(D, O) {
    CellHighlightUtils.fade(O.target, D.default);
  }
  static setCellEvents(D, O) {
    O.onclick = InsertNewRow.insertEvent.bind(D);
    const x = D._frameComponents.cellColors.data;
    O.onmouseenter = AddNewRowEvents.mouseEnterCell.bind(this, x), O.onmouseleave = AddNewRowEvents.mouseLeaveCell.bind(this, x);
  }
}
const _AddNewRowElement = class Ee {
  static isDisplayed(D) {
    return D.style.display === Ee.VISIBLE;
  }
  static setDisplay(D, O) {
    Ee.isDisplayed(D) !== O && (D.style.display = O ? Ee.VISIBLE : Ee.HIDDEN);
  }
  static setDefaultStyle(D) {
    D.innerText = "+ New", D.style.width = "";
  }
  // prettier-ignore
  static createCell(D) {
    const { _defaultColumnsSettings: { cellStyle: O }, _frameComponents: { displayAddNewRow: x, styles: B }, rootCell: U } = D, F = CellElement.createDataCell(!1, O, B == null ? void 0 : B.default);
    return F.id = Ee.ID, x ? Ee.setDefaultStyle(F) : (RootCellElement.convertToRootCell(F, U == null ? void 0 : U.text), F.addEventListener("click", Ee.setDisplay.bind(this, F, !1))), Ee.setDisplay(F, x), F.colSpan = Ee.DEFAULT_COL_SPAN, AddNewRowEvents.setCellEvents(D, F), F;
  }
  static create(D) {
    const O = RowElement.create(), x = Ee.createCell(D);
    return O.appendChild(x), x;
  }
  // prettier-ignore
  static toggle(D) {
    const { _tableBodyElementRef: O, _addRowCellElementRef: x, _frameComponents: { displayAddNewRow: B } } = D;
    !(x != null && x.parentElement) || !O || (B && Ee.setDisplay(x, MaximumRows.canAddMore(D)), RowElement.toggleLastRowClass(D));
  }
  static isAddNewRowRow(D) {
    var O;
    return ((O = D == null ? void 0 : D.children[0]) == null ? void 0 : O.id) === Ee.ID;
  }
};
_AddNewRowElement.DEFAULT_COL_SPAN = 1e9;
_AddNewRowElement.HIDDEN = "none";
_AddNewRowElement.VISIBLE = "";
_AddNewRowElement.ID = "add-new-row-cell";
let AddNewRowElement = _AddNewRowElement;
class ElementEvents {
  static toggleListeners(D, O, x) {
    Object.keys(O).forEach((B) => {
      (O[B] || []).forEach((F) => {
        D[x ? "addEventListener" : "removeEventListener"](B, F);
      });
    });
  }
  static convertToArrayObj(D) {
    return Object.keys(D).reduce((O, x) => {
      const B = x, U = D[B];
      return B && U && (O[B] = [U]), O;
    }, {});
  }
  static getDefault() {
    return { rootCell: { styles: {} } };
  }
}
class RootCellEvents {
  static removeEvents(D, O) {
    AddNewRowElement.setDefaultStyle(D), ElementEvents.toggleListeners(D, O.styles, !1), D.dispatchEvent(new MouseEvent("mouseenter")), delete O.applied;
  }
  // setting, not apply here as this is only triggered once
  static setEventFunctions(D, O, x) {
    if (x && (D._eventFunctions.rootCell.styles = ElementEvents.convertToArrayObj(
      StatefulCSSEvents.getEvents(O, x)
    )), D._frameComponents.displayAddNewRow) {
      const B = RootCellElement.convertFromRootCell.bind(this, D), { styles: U } = D._eventFunctions.rootCell;
      U.click ?? (U.click = []), U.click.push(B);
    }
  }
  static applyStyles(D, O, x) {
    var U, F, W, G;
    const B = ElementStyle.generateStatefulCSS(O, {}, {});
    (U = B.default) != null && U.width && (x.style.width = B.default.width), (F = B.default) == null || delete F.width, (W = B.hover) == null || delete W.width, (G = B.click) == null || delete G.width, Object.assign(D.style, B.default);
  }
  // prettier-ignore
  static applyEvents(D, O) {
    const { _tableElementRef: x, rootCell: B, _eventFunctions: { rootCell: U } } = D, F = B != null && B.styles ? JSON.parse(JSON.stringify(B.styles)) : null;
    F && x && RootCellEvents.applyStyles(O, F, x), Object.keys(U.styles).length === 0 && RootCellEvents.setEventFunctions(D, O, F), ElementEvents.toggleListeners(O, U.styles, !0), U.applied = !0;
  }
}
const _RootCellElement = class Je {
  // prettier-ignore
  static convertFromRootCell(D) {
    const { _addRowCellElementRef: O, rootCell: x, _eventFunctions: { rootCell: B } } = D;
    O && (O.classList.remove(Je.ROOT_CELL_CLASS), x != null && x.styles && ElementStyle.unsetAllCSSStates(O, x.styles), RootCellEvents.removeEvents(O, B));
  }
  static convertToRootCell(D, O) {
    D.classList.add(Je.ROOT_CELL_CLASS), D.innerText = O || "+", D.style.width = `${TableDimensionsUtils.MINIMAL_TABLE_WIDTH}px`;
  }
  // addNewRowCell is preserved as it is reused as the root cell
  static removeRows(D) {
    Array.from(D.children).slice(0, D.children.length - 1).forEach((O) => O.remove());
  }
  // prettier-ignore
  static display(D) {
    const {
      _tableBodyElementRef: O,
      _addColumnCellsElementsRef: x,
      _addRowCellElementRef: B,
      rootCell: U,
      _frameComponents: { displayAddNewColumn: F, displayAddNewRow: W }
    } = D;
    if (!B)
      return;
    const G = O;
    F && x.splice(0, x.length), Je.removeRows(G), W && Je.convertToRootCell(B, U == null ? void 0 : U.text), D._eventFunctions.rootCell.applied || RootCellEvents.applyEvents(D, B), AddNewRowElement.setDisplay(B, !0);
  }
};
_RootCellElement.ROOT_CELL_CLASS = "root-cell";
let RootCellElement = _RootCellElement;
class ToggleAdditionElements {
  static update(D, O, x) {
    D.data.length === 0 || D._columnsDetails.length === 0 ? RootCellElement.display(D) : x(D, O);
  }
}
class InsertNewColumn {
  static updateColumns(D, O, x, B) {
    const U = { element: O, index: x }, F = LastColumn.getDetails(D._columnsDetails, x);
    UpdateCellsForColumns.rebindAndFireUpdates(D, U, B, CELL_UPDATE_TYPE.ADD, F);
  }
  static insertToAllRows(D, O, x) {
    ExtractElements.textRowsArrFromTBody(D._tableBodyElementRef, D.data).forEach((U, F) => {
      const W = x ? x[F] : EMPTY_STRING;
      InsertNewCell.insertToRow(D, U, F, O, W, !0), setTimeout(() => InsertNewColumn.updateColumns(D, U, F, O));
    });
  }
  // columnData is in a row format to populate the column by iterating through each row
  static insert(D, O, x) {
    MaximumColumns.canAddMore(D) && (FocusedCellUtils.incrementColumnIndex(D._focusedElements.cell, O), InsertNewColumn.insertToAllRows(D, O, x), ToggleAdditionElements.update(D, !0, AddNewColumnElement.toggle), setTimeout(() => {
      FireEvents.onDataUpdate(D), FireEvents.onColumnsUpdate(D);
    }));
  }
  static insertEvent() {
    InsertNewColumn.insert(this, this._columnsDetails.length);
  }
}
class InsertMatrix {
  // prettier-ignore
  static removeDataThatIsNotEditableFromNewRows(D, O, x) {
    return D.slice(x).forEach((U, F) => {
      U.settings.isCellTextEditable || O.forEach((W) => {
        W[F] = EMPTY_STRING;
      });
    }), O;
  }
  // if the data does not fill the 2D array, fill cells with empty strings
  static createRowDataArrayWithEmptyCells(D, O, x) {
    const B = DataUtils.createEmptyStringDataArray(D);
    return B.splice(x, O.length, ...O), B;
  }
  // prettier-ignore
  static createNewRows(D, O, x) {
    InsertMatrix.removeDataThatIsNotEditableFromNewRows(
      D._columnsDetails,
      O,
      x
    ).forEach((U) => {
      var W;
      const F = InsertMatrix.createRowDataArrayWithEmptyCells(
        ((W = D.data[0]) == null ? void 0 : W.length) || 0,
        U,
        x
      );
      InsertNewRow.insert(D, D.data.length, !0, F);
    });
  }
  static changeColumnSettings(D, O) {
    const { elements: x } = D._columnsDetails[O];
    FocusedCellUtils.set(D._focusedElements.cell, x[0], 0, O), HeaderText.onAttemptChange(D, x[0], O);
  }
  static processNewColumn(D) {
    const O = D._columnsDetails.length - 1;
    CellEvents.setCellToDefaultIfNeeded(D, 0, O, D._columnsDetails[O].elements[0], !1), InsertMatrix.changeColumnSettings(D, O);
  }
  static createNewColumns(D, O, x) {
    ArrayUtils.transpose(O).forEach((U) => {
      const F = InsertMatrix.createRowDataArrayWithEmptyCells(D.data.length, U, x);
      InsertNewColumn.insert(D, D.data[0].length, F), InsertMatrix.processNewColumn(D);
    });
  }
  // prettier-ignore
  static overwriteCell(D, O, x, B, U) {
    const { _frameComponents: { displayIndexColumn: F }, _columnsDetails: W } = D, G = CellElementIndex.getViaColumnIndex(B, !!F), Y = O.children[G], X = W[B];
    x === 0 && !X.settings.isHeaderTextEditable || x > 0 && !X.settings.isCellTextEditable || (x === 0 && CellElement.setNewText(D, Y, U, !1, !1), CellEvents.updateCell(D, U, x, B, { element: Y, updateTableEvent: !1 }), ColumnTypesUtils.updateDataElements(D, x, B, Y), x === 0 && InsertMatrix.changeColumnSettings(D, B));
  }
  // prettier-ignore
  static overwriteRowData(D, O, x, B, U) {
    O.forEach((F, W) => {
      const G = B + W;
      InsertMatrix.overwriteCell(D, U, x, G, F);
    });
  }
  // prettier-ignore
  static setCaretToEndAndHighlightIfSelect(D, O, x) {
    const { activeType: B, cellDropdown: U, settings: { defaultText: F } } = D._columnsDetails[x];
    CaretPosition.setToEndOfText(D, O), B.cellDropdownProps && CellDropdown.updateCellDropdown(O, U, D._tableDimensions.border, F, !0);
  }
  // prettier-ignore
  static overwriteExistingCells(D, O, x, B) {
    const U = [];
    O.forEach((W, G) => {
      var re;
      const Y = x + G, X = (re = D._tableBodyElementRef) == null ? void 0 : re.children[Y], J = D.data[0].length - B, Q = W.slice(0, J);
      InsertMatrix.overwriteRowData(D, Q, Y, B, X);
      const le = W.slice(J);
      U.push(le);
    });
    const F = D._focusedElements.cell.element;
    return setTimeout(() => InsertMatrix.setCaretToEndAndHighlightIfSelect(D, F, B)), U;
  }
  // no new rows should be created if no columns that are to be overwritten/created allow text edit
  static canNewRowsBeCreated(D, O, x) {
    return D._columnsDetails.slice(x, x + O[0].length).find((B) => B.settings.isCellTextEditable);
  }
  static insertColumnsInsideIfCantInsertRight(D, O, x) {
    const U = D._columnsDetails.slice(x).findIndex((F) => F.settings.columnDropdown.isInsertRightAvailable === !1);
    if (U !== -1)
      if (U === 0)
        O.forEach((F) => F.splice(1, F.length - 1));
      else {
        const F = O[0].length - (U + 1);
        for (let W = 0; W < F; W += 1)
          InsertNewColumn.insert(D, x + U + W);
      }
  }
  static getNewMatrixBasedOnColumns(D, O, x) {
    var U, F;
    const B = (((U = D[0]) == null ? void 0 : U.length) || 0) - (((F = O[0]) == null ? void 0 : F.length) || 0) - x;
    return B > 0 ? new Array(O.length).fill(new Array(B).fill(EMPTY_STRING)) : [];
  }
  // A matrix is a complete 2D array
  // prettier-ignore
  static insert(D, O, x, B, U) {
    const F = D.data.length - x;
    U || InsertMatrix.insertColumnsInsideIfCantInsertRight(D, O, B);
    const W = O.slice(0, F), G = U ? InsertMatrix.getNewMatrixBasedOnColumns(O, D.data, B) : InsertMatrix.overwriteExistingCells(D, W, x, B);
    if (InsertMatrix.createNewColumns(D, G, x), !U && !InsertMatrix.canNewRowsBeCreated(D, O, B))
      return;
    const Y = O.slice(F);
    InsertMatrix.createNewRows(D, Y, B), setTimeout(() => FireEvents.onDataUpdate(D));
  }
}
const _ParseCSVClipboardText = class fe {
  static preprocessText(D) {
    let O = D;
    return D.charAt(0) === fe.STRING_QUOTE_SYMBOL && (O = O.substring(1)), D.charAt(D.length - 1) === fe.STRING_QUOTE_SYMBOL && (O = O.substring(0, D.length - 2)), O;
  }
  static getSeparatorSymbols(D) {
    return D.indexOf(fe.EXPLICIT_NEW_LINE_SYMBOL) > -1 || D.indexOf(fe.EXPLICIT_TAB_SYMBOL) > -1 ? { newLine: fe.EXPLICIT_NEW_LINE_SYMBOL, tab: fe.EXPLICIT_TAB_SYMBOL } : { newLine: fe.NEW_LINE_SYMBOL, tab: fe.TAB_SYMBOL };
  }
  static parse(D) {
    const O = fe.preprocessText(D), { newLine: x, tab: B } = fe.getSeparatorSymbols(O);
    return O.split(x).map((F) => F.split(B).map((G) => G.replace(/\\"/g, "")));
  }
};
_ParseCSVClipboardText.STRING_QUOTE_SYMBOL = '"';
_ParseCSVClipboardText.TAB_SYMBOL = "\\t";
_ParseCSVClipboardText.NEW_LINE_SYMBOL = "\\n";
_ParseCSVClipboardText.EXPLICIT_TAB_SYMBOL = "\\\\t";
_ParseCSVClipboardText.EXPLICIT_NEW_LINE_SYMBOL = "\\\\n";
let ParseCSVClipboardText = _ParseCSVClipboardText;
class OverwriteCellsViaCSVOnPaste {
  static trimCSVRowsIfPaginationAsync(D, O, x, B) {
    var G;
    const U = D.length + x;
    O.length < U && (D = D.slice(0, D.length - (U - O.length)));
    const F = ((G = O[0]) == null ? void 0 : G.length) || 0, W = D[0].length + B;
    if (F < W) {
      const Y = D[0].length - (W - F);
      D.forEach((X) => X.splice(Y));
    }
    return D;
  }
  static focusOriginalCellAfterProcess(D, O) {
    const { element: x, rowIndex: B, columnIndex: U } = D._focusedElements.cell;
    O(), FocusedCellUtils.set(D._focusedElements.cell, x, B, U);
  }
  // prettier-ignore
  static overwrite(D, O, x, B, U) {
    x.preventDefault();
    let F = ParseCSVClipboardText.parse(O);
    D._pagination.async && (F = OverwriteCellsViaCSVOnPaste.trimCSVRowsIfPaginationAsync(F, D.data, B, U)), OverwriteCellsViaCSVOnPaste.focusOriginalCellAfterProcess(
      D,
      InsertMatrix.insert.bind(this, D, F, B, U)
    );
  }
  static isCSVData(D) {
    return D.indexOf(ParseCSVClipboardText.NEW_LINE_SYMBOL) > -1 || D.indexOf(ParseCSVClipboardText.TAB_SYMBOL) > -1;
  }
}
var KEYBOARD_COMBINATION_EVENT = /* @__PURE__ */ ((z) => (z.PASTE = "Paste", z))(KEYBOARD_COMBINATION_EVENT || {});
const KEYBOARD_EVENT = { ...KEYBOARD_COMBINATION_EVENT, [KEYBOARD_KEY.TAB]: KEYBOARD_KEY.TAB }, _UserKeyEventsStateUtils = class Tt {
  static createNew() {
    return { [KEYBOARD_KEY.TAB]: !1, [KEYBOARD_EVENT.PASTE]: !1, [MOUSE_EVENT.DOWN]: !1 };
  }
  static temporarilyIndicateEvent(D, O) {
    D[O] = !0, setTimeout(() => D[O] = !1, Tt.KEY_PRESS_STATE_TIMEOUT_ML);
  }
};
_UserKeyEventsStateUtils.KEY_PRESS_STATE_TIMEOUT_ML = 5;
let UserKeyEventsStateUtils = _UserKeyEventsStateUtils;
const _PasteUtils = class St {
  static sanitizePastedTextData(D) {
    var x, B;
    D.preventDefault();
    const O = (x = D.clipboardData) == null ? void 0 : x.getData("text/plain");
    (B = document.execCommand) == null || B.call(document, "insertHTML", !1, O);
  }
  static extractClipboardText(D) {
    var O;
    return JSON.stringify((O = D.clipboardData) == null ? void 0 : O.getData(St.TEXT_DATA_FORMAT));
  }
};
_PasteUtils.TEXT_DATA_FORMAT = "text/plain";
let PasteUtils = _PasteUtils;
const UNDO_INPUT_TYPE = "historyUndo";
class DataCellEvents {
  static keyDownCell(D, O, x) {
    const { elements: B, activeType: U } = this._columnsDetails[O];
    x.key === KEYBOARD_KEY.TAB ? UserKeyEventsStateUtils.temporarilyIndicateEvent(this._userKeyEventsState, KEYBOARD_KEY.TAB) : x.key === KEYBOARD_KEY.ENTER && this.enterKeyMoveDown && !U.cellDropdownProps && FocusNextRowCell.focus(this, D, B, x);
  }
  // using this instead of keydown because when this is fired the new cell text is available
  // prettier-ignore
  static inputCell(D, O, x) {
    const B = x, U = B.target;
    if (DateCellInputElement.isInputElement(U))
      return;
    const F = CellElement.getText(U);
    if (!this._userKeyEventsState[KEYBOARD_EVENT.PASTE]) {
      const W = B.inputType === UNDO_INPUT_TYPE;
      CellElement.setNewText(this, U, F, !1, W, !1);
      const G = this._columnsDetails[O];
      G.activeType.cellDropdownProps && D > 0 && CellDropdown.updateCellDropdown(
        U,
        G.cellDropdown,
        this._tableDimensions.border,
        G.settings.defaultText,
        !0
      ), CellEvents.updateCell(this, F, D, O, { processText: !1 });
    }
  }
  // prettier-ignore
  static pasteCell(D, O, x) {
    UserKeyEventsStateUtils.temporarilyIndicateEvent(this._userKeyEventsState, KEYBOARD_EVENT.PASTE), PasteUtils.sanitizePastedTextData(x);
    const B = PasteUtils.extractClipboardText(x);
    if (OverwriteCellsViaCSVOnPaste.isCSVData(B))
      OverwriteCellsViaCSVOnPaste.overwrite(this, B, x, D, O);
    else {
      const U = x.target, { cellDropdown: F, settings: { defaultText: W }, activeType: G } = this._columnsDetails[O], Y = U.tagName === "BR" ? U.parentElement : U;
      setTimeout(() => {
        G.cellDropdownProps && CellDropdown.updateCellDropdown(
          Y,
          F,
          this._tableDimensions.border,
          W,
          !0
        ), CellEvents.updateCell(this, CellElement.getText(Y), D, O, { processText: !1 });
      });
    }
  }
  // prettier-ignore
  // textContainerElement can be cell element for data cell, text element for select/label and date cells
  static blur(D, O, x, B) {
    CaretDisplayFix.isIssueBrowser() && CaretDisplayFix.removeContentEditable(B), CellEvents.setCellToDefaultIfNeeded(D, O, x, B), FocusedCellUtils.purge(D._focusedElements.cell);
  }
  static blurCell(D, O, x) {
    var B, U, F;
    D === 0 && !((F = (U = (B = this._defaultColumnsSettings.columnDropdown) == null ? void 0 : B.displaySettings) == null ? void 0 : U.openMethod) != null && F.cellClick) && HeaderText.onAttemptChange(this, x.target, O), DataCellEvents.blur(this, D, O, x.target);
  }
  // textContainerElement can be cell element for data cell, text element for select/label and date cells
  static prepareText(D, O, x, B) {
    var F, W, G;
    const U = (G = (W = (F = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : F.displaySettings) == null ? void 0 : W.openMethod) == null ? void 0 : G.cellClick;
    CaretDisplayFix.isIssueBrowser() && (O > 0 || !U) && CaretDisplayFix.setContentEditable(B), CellEvents.removeTextIfDefault(D, O, x, B);
  }
  static focusCell(D, O, x) {
    const B = x.target;
    DataCellEvents.prepareText(this, D, O, B);
    const { _userKeyEventsState: U, _focusedElements: F } = this;
    U[KEYBOARD_KEY.TAB] && CaretPosition.setToEndOfText(this, B), FocusedCellUtils.set(F.cell, B, D, O);
  }
  static setEvents(D, O, x, B) {
    O.onfocus = DataCellEvents.focusCell.bind(D, x, B), O.onblur = DataCellEvents.blurCell.bind(D, x, B), O.onmouseenter = () => {
    }, O.onmouseleave = () => {
    }, O.onmousedown = () => {
    }, O.oninput = DataCellEvents.inputCell.bind(D, x, B), O.onpaste = DataCellEvents.pasteCell.bind(D, x, B), O.onkeydown = DataCellEvents.keyDownCell.bind(D, x, B);
  }
}
class SelectCellTextBaseEvents {
  // the reason why this is triggered by window is because when the user clicks on dropdown padding or delete button
  // keydown events will no longer be fired through the cell text - however we need to maintain the same behaviour
  // prettier-ignore
  static keyDownText(D, O, x, B) {
    const { cellDropdown: { activeItems: U, canAddMoreOptions: F }, elements: W } = D._columnsDetails[x];
    B.key === KEYBOARD_KEY.ESCAPE ? CellWithTextEvents.programmaticBlur(D) : B.key === KEYBOARD_KEY.TAB ? CellTextEvents.tabOutOfCell(D, O, x, B) : B.key === KEYBOARD_KEY.ENTER ? (B.preventDefault(), FocusNextRowCell.focusOrBlurSelect(W, O)) : B.key === KEYBOARD_KEY.ARROW_UP ? (B.preventDefault(), CellDropdownItem.setSiblingItemOnCell(D, U, "previousSibling")) : B.key === KEYBOARD_KEY.ARROW_DOWN ? (B.preventDefault(), CellDropdownItem.setSiblingItemOnCell(D, U, "nextSibling")) : (D.dataStartsAtHeader || O > 0) && !F && B.preventDefault();
  }
  static displayDropdown(D, O, x) {
    var W;
    const B = CellDropdown.display(D, O, x), { activeType: U, cellDropdown: F } = D._columnsDetails[O];
    (W = U.cellDropdownProps) != null && W.isBasicSelect && B && (F.displayedCellElement = x, ArrowDownIconElement.toggle(x, !0), ArrowDownIconElement.setActive(x));
  }
  static clearTypeSpecificProps(D, O) {
    const { cellDropdown: x, activeType: B } = O;
    B.cellDropdownProps && (B.cellDropdownProps.isBasicSelect ? (ArrowDownIconElement.toggle(x.displayedCellElement, !1), delete x.displayedCellElement) : OptionButton.hideAfterColorPickerContainerClose(D, O));
  }
  static blurring(D, O, x, B) {
    const U = D._columnsDetails[x];
    Dropdown.hide(U.cellDropdown.element), U.cellDropdown.itemsDetails[CellElement.getText(B)] || SelectCell.finaliseEditedText(D, B, x), SelectCellTextBaseEvents.clearTypeSpecificProps(D._columnsDetails, U), DataCellEvents.blur(D, O, x, B);
  }
  static blurText(D, O, x) {
    this._focusedElements.cellDropdown || SelectCellTextBaseEvents.blurring(this, D, O, x.target);
  }
  // prettier-ignore
  static setEvents(D, O, x, B) {
    O.onblur = SelectCellTextBaseEvents.blurText.bind(D, x, B), O.onfocus = CellWithTextEvents.focusText.bind(
      D,
      x,
      B,
      SelectCellTextBaseEvents.displayDropdown
    );
  }
}
class CellWithTextEvents {
  // prettier-ignore
  static focusText(D, O, x, B) {
    const U = B.target, F = CellElement.getCellElement(U);
    DataCellEvents.prepareText(this, D, O, U), x == null || x(this, O, F), FocusedCellUtils.set(this._focusedElements.cell, F, D, O), this._userKeyEventsState[KEYBOARD_KEY.TAB] && CaretPosition.setToEndOfText(this, U);
  }
  static programmaticBlur(D) {
    const { rowIndex: O, columnIndex: x, element: B } = D._focusedElements.cell, U = CellElement.getTextElement(B);
    U.blur(), D._focusedElements.cellDropdown && (SelectCellTextBaseEvents.blurring(D, O, x, U), delete D._focusedElements.cellDropdown);
  }
  // prettier-ignore
  static mouseDownCell(D, O, x, B) {
    D._focusedElements.cellDropdown && CellWithTextEvents.programmaticBlur(D);
    const U = CellElement.getTextElement(x);
    B.preventDefault(), O == null || O(D), CaretDisplayFix.isIssueBrowser() && U.focus(), CaretPosition.setToEndOfText(D, U);
  }
  static mouseDown(D, O) {
    if (O.target.classList.contains(CellElement.CELL_CLASS)) {
      const B = O.target;
      CellWithTextEvents.mouseDownCell(this, D, B, O);
    }
  }
}
class CellDropdownScrollbar {
  static setProperties(D) {
    const { element: O, scrollbarPresence: x } = D;
    CellDropdownHorizontalScrollFix.setPropertiesIfHorizontalScrollPresent(D), x.vertical = ScrollbarUtils.isVerticalPresent(O);
  }
}
class OptionDeleteButtonEvents {
  static delete(D, O) {
    const { cellDropdown: x } = D, F = O.target.parentElement.parentElement;
    delete x.itemsDetails[CellElement.getText(F.children[0])], F.remove(), Object.keys(x.itemsDetails).length === 0 ? CellWithTextEvents.programmaticBlur(this) : CellDropdownScrollbar.setProperties(x), setTimeout(() => FireEvents.onColumnsUpdate(this));
  }
  static addEvents(D, O, x) {
    x.onclick = OptionDeleteButtonEvents.delete.bind(D, O);
  }
}
const _OptionDeleteButton = class Ge {
  static createIcon() {
    const D = document.createElement("div");
    return D.classList.add(Ge.DELETE_BUTTON_ICON_CLASS), D.innerText = Ge.DELETE_ICON_TEXT, D;
  }
  static createButton(D, O) {
    const x = document.createElement("div");
    return x.classList.add(DropdownItem.DROPDOWN_ITEM_IDENTIFIER, OptionButton.BUTTON_CLASS), OptionDeleteButtonEvents.addEvents(D, O, x), x;
  }
  static createContainer() {
    const D = document.createElement("div");
    return D.classList.add(OptionButton.BUTTON_CONTAINER_CLASS), D;
  }
  static create(D, O) {
    const x = Ge.createContainer(), B = Ge.createButton(D, O), U = Ge.createIcon();
    return B.appendChild(U), x.appendChild(B), x;
  }
  static changeVisibility(D, O, x) {
    const B = D.children[1];
    if (B.style.display = x ? "block" : "none", x) {
      const U = B.children[0];
      U.style.left = `${x.offsetWidth - O}px`;
    }
  }
};
_OptionDeleteButton.DELETE_BUTTON_ICON_CLASS = "cell-dropdown-option-delete-button-icon";
_OptionDeleteButton.DELETE_ICON_TEXT = "×";
let OptionDeleteButton = _OptionDeleteButton;
class OptionButton {
  static changeVisibility(D, O, x) {
    if (D.isTrusted) {
      const B = D.target, U = O.scrollbarPresence.vertical ? 31 : 16;
      OptionDeleteButton.changeVisibility(B, U, x), Browser.IS_COLOR_PICKER_SUPPORTED && O.labelDetails && !O.labelDetails.colorPickerContainer && OptionColorButton.changeVisibility(B, U + 18, x);
    }
  }
  // prettier-ignore
  static hideAfterColorPickerContainerClose(D, O) {
    const { cellDropdown: { labelDetails: x } } = O;
    if (x != null && x.colorPickerContainer) {
      x.colorPickerContainer.style.display = "none";
      const B = x.colorPickerContainer.previousElementSibling;
      B.style.display = "none", delete x.colorPickerContainer, OptionColorButtonEvents.updateColumnLabelColors(D, O);
    }
  }
}
OptionButton.BUTTON_CONTAINER_CLASS = "cell-dropdown-option-button-container";
OptionButton.BUTTON_CLASS = "cell-dropdown-option-button";
class CellDropdownItemEvents {
  // prettier-ignore
  static blurItem(D, O, x) {
    var W;
    const { activeItems: B, labelDetails: U } = D;
    if (U != null && U.colorPickerContainer)
      return;
    const F = B[O];
    F !== void 0 && (O === "matchingWithCellText" || O === "hovered" && F !== B.matchingWithCellText) && (F.style.backgroundColor = "", U || (F.style.color = ((W = D.customItemStyle) == null ? void 0 : W.textColor) || ""), delete B[O]), x && D.canAddMoreOptions && OptionButton.changeVisibility(x, D);
  }
  // prettier-ignore
  static scrollToItem(D, O, x, B, U) {
    if (U.isTrusted)
      return;
    const F = ElementVisibility.isVerticallyVisibleInsideParent(O, D);
    F.isFullyVisible || (O.scrollIntoView({ block: "nearest" }), x && F.blockingSides.has(SIDE.BOTTOM) && CellDropdownHorizontalScrollFix.scrollDownFurther(B));
  }
  static highlightItem(D, O) {
    const { scrollbarPresence: x, activeItems: B, labelDetails: U, canAddMoreOptions: F, element: W, itemsDetails: G } = D;
    if (U != null && U.colorPickerContainer)
      return;
    B.hovered && (B.hovered.style.backgroundColor = "", U || (B.hovered.style.color = ""));
    const Y = O.target, X = Y.children[0].innerText;
    Y.style.backgroundColor = G[X].backgroundColor;
    const J = Y.parentElement;
    CellDropdownItemEvents.scrollToItem(this, Y, x.horizontal, J, O), Y === B.matchingWithCellText ? (U || (Y.style.color = "white"), delete B.hovered) : (U || (Y.style.backgroundColor = DropdownItemHighlightUtils.HOVER_BACKGROUND_COLOR), B.hovered = Y), F && OptionButton.changeVisibility(O, D, W);
  }
  static set(D, O, x) {
    O.onmouseenter = CellDropdownItemEvents.highlightItem.bind(D, x), O.onmouseleave = CellDropdownItemEvents.blurItem.bind(this, x, "hovered");
  }
}
const _CellDropdownItem = class ae {
  // prettier-ignore
  static updateCellElementIfNotUpdated(D, O, x, B, U) {
    D.data[x][B] !== O && CellEvents.updateCell(D, O, x, B, { processText: !1, element: U });
  }
  // prettier-ignore
  static selectExistingItem(D, O, x, B, U) {
    var W;
    const F = CellElement.getText(O.children[0]);
    ae.updateCellElementIfNotUpdated(D, F, x, B, U), LabelCellTextElement.isLabelText(U) && (U.style.backgroundColor = (W = D._columnsDetails[B].cellDropdown.itemsDetails[F]) == null ? void 0 : W.backgroundColor);
  }
  // prettier-ignore
  static addNewItem(D, O, x, B) {
    const { cellDropdown: { labelDetails: U } } = x, F = CellElement.getText(O);
    if (F === EMPTY_STRING)
      return;
    let W = "";
    if (U) {
      const { globalItemColors: { newColors: G, existingColors: Y } } = U;
      W = B || Y[F] || G[G.length - 1] || LabelColorUtils.getLatestPasteleColor(), O.style.backgroundColor = W, Y[F] ?? (Y[F] = W), G.pop() || LabelColorUtils.setNewLatestPasteleColor();
    } else
      W = ae.ACTIVE_ITEM_BACKGROUND_COLOR;
    ae.addItem(D, F, W, x), setTimeout(() => FireEvents.onColumnsUpdate(D));
  }
  // prettier-ignore
  static updateCellTextBgColor(D, O, x, B) {
    const U = CellElement.getText(O);
    if (D)
      O.style.backgroundColor = x.itemsDetails[U].backgroundColor;
    else if (!x.canAddMoreOptions || U === EMPTY_STRING || U === B)
      O.style.backgroundColor = "";
    else if (x.labelDetails) {
      const { globalItemColors: { newColors: F, existingColors: W } } = x.labelDetails;
      O.style.backgroundColor = W[U] || (F == null ? void 0 : F[F.length - 1]) || LabelColorUtils.getLatestPasteleColor();
    }
  }
  static updateItemColor(D, O) {
    D && (O.matchingWithCellText = D, D.dispatchEvent(new MouseEvent("mouseenter")));
  }
  static hideHoveredItemHighlight(D) {
    const { hovered: O, matchingWithCellText: x } = D;
    O ? O.style.backgroundColor = "" : D.hovered = x;
  }
  // prettier-ignore
  static attemptHighlightMatchingItemWithCell(D, O, x, B, U) {
    var X;
    const { activeItems: F, itemsDetails: W } = O, G = CellElement.getText(D), Y = U || ((X = W[G]) == null ? void 0 : X.element);
    (!Y || F.matchingWithCellText !== Y) && (ae.hideHoveredItemHighlight(F), CellDropdownItemEvents.blurItem(O, "matchingWithCellText")), ae.updateItemColor(Y, F), B && O.labelDetails && ae.updateCellTextBgColor(Y, D, O, x);
  }
  // prettier-ignore
  static setItemOnCell(D, O) {
    const { element: x, rowIndex: B, columnIndex: U } = D._focusedElements.cell, { cellDropdown: F, settings: { defaultText: W } } = D._columnsDetails[U], G = x.children[0], Y = CellElement.getText(O.children[0]);
    ae.updateCellElementIfNotUpdated(D, Y, B, U, G), ae.attemptHighlightMatchingItemWithCell(G, F, W, !0, O), CaretPosition.setToEndOfText(D, G);
  }
  // prettier-ignore
  static setSiblingItemOnCell(D, O, x) {
    const { hovered: B, matchingWithCellText: U } = O, F = B || U, W = F == null ? void 0 : F[x];
    if (W)
      ae.setItemOnCell(D, W);
    else {
      const { columnIndex: G } = D._focusedElements.cell, Y = D._columnsDetails[G].cellDropdown.element;
      if (x === "nextSibling") {
        const X = Y.children[0];
        X && ae.setItemOnCell(D, X);
      } else {
        const X = Y.children[Y.children.length - 1];
        X && ae.setItemOnCell(D, X);
      }
    }
  }
  static addItemElement(D, O, x, B = !1) {
    const { cellDropdown: U } = x, F = DropdownItem.addPlaneButtonItem(U.element, O, B ? 0 : void 0);
    if (U.customItemStyle && (F.style.color = U.customItemStyle.textColor), U.canAddMoreOptions) {
      const W = OptionDeleteButton.create(D, x);
      if (F.appendChild(W), Browser.IS_COLOR_PICKER_SUPPORTED && U.labelDetails) {
        const G = OptionColorButton.create(D._columnsDetails, x);
        F.appendChild(G);
      }
    }
    return CellDropdownItemEvents.set(D.shadowRoot, F, U), F;
  }
  static addItem(D, O, x, B, U = !1) {
    B.cellDropdown.itemsDetails[O] = {
      backgroundColor: x,
      isCustomBackgroundColor: U,
      element: ae.addItemElement(D, O, B)
    };
  }
  static addItems(D, O, x) {
    x.cellDropdown.element.replaceChildren(), x.cellDropdown.itemsDetails = {}, Object.keys(O).forEach((B) => {
      ae.addItem(D, B, O[B].color, x, !!O[B].isCustom);
    });
  }
  static postProcessItemToColor(D, O, x) {
    D && delete O[x];
  }
  // prettier-ignore
  static processNewItemsToColor(D, O, x, B) {
    D.slice(1).reduce((U, F) => {
      const W = F[O];
      if (W !== EMPTY_STRING && !U[W])
        if (B) {
          const { globalItemColors: { newColors: G, existingColors: Y } } = B;
          U[W] = { color: Y[W] || G.pop() || LabelColorUtils.getLatestPasteleColorAndSetNew() }, Y[W] ?? (Y[W] = U[W].color);
        } else
          U[W] = { color: ae.ACTIVE_ITEM_BACKGROUND_COLOR };
      return U;
    }, x);
  }
  // prettier-ignore
  static changeUserOptionsToItemToColor(D, O) {
    return D.reduce((x, B) => {
      var U;
      if (O) {
        const { globalItemColors: { newColors: F, existingColors: W } } = O;
        x[B.text] = { color: B.backgroundColor || W[B.text] || F.pop() || LabelColorUtils.getLatestPasteleColorAndSetNew(), isCustom: !0 }, W[U = B.text] ?? (W[U] = x[B.text].color);
      } else
        x[B.text] = { color: ae.ACTIVE_ITEM_BACKGROUND_COLOR, isCustom: !0 };
      return x;
    }, {});
  }
  // prettier-ignore
  static populateItems(D, O) {
    const { data: x, _columnsDetails: B } = D, U = B[O], {
      cellDropdown: { labelDetails: F },
      settings: { defaultText: W, isDefaultTextRemovable: G },
      activeType: { cellDropdownProps: Y }
    } = U;
    if (!Y)
      return;
    let X = {};
    Y.options && (X = ae.changeUserOptionsToItemToColor(Y.options, F)), Y.canAddMoreOptions && ae.processNewItemsToColor(x, O, X, F), ae.postProcessItemToColor(G, X, W), ae.addItems(D, X, U);
  }
};
_CellDropdownItem.ACTIVE_ITEM_BACKGROUND_COLOR = "#4a69d4";
let CellDropdownItem = _CellDropdownItem;
const _LabelCellTextElement = class ct {
  static isLabelText(D) {
    return D.classList.contains(ct.TEXT_CLASS);
  }
  static setCellTextAsAnElement(D, O, x) {
    const B = CellTextElement.setCellTextAsAnElement(D, x);
    B.classList.add(ct.TEXT_CLASS), B.style.backgroundColor = O;
  }
  // prettier-ignore
  static finaliseEditedText(D, O, x, B = !1) {
    var J;
    const U = D._columnsDetails[x], { cellDropdown: F, activeType: { cellDropdownProps: W }, settings: { defaultText: G, isDefaultTextRemovable: Y } } = U, X = (J = F.itemsDetails[CellElement.getText(O)]) == null ? void 0 : J.backgroundColor;
    CellElement.getText(O) === EMPTY_STRING || Y && CellElement.getText(O) === G ? O.style.backgroundColor = "" : B && X ? O.style.backgroundColor = X : W != null && W.canAddMoreOptions && CellDropdownItem.addNewItem(D, O, U, O.style.backgroundColor);
  }
};
_LabelCellTextElement.TEXT_CLASS = "label-cell-text";
let LabelCellTextElement = _LabelCellTextElement;
class CellDropdownEvents {
  // instead of binding click event handlers with the context of current row index to individual item elements every
  // time the dropdown is displayed, click events are handled on the dropdown instead, the reason for this is
  // because it can be expensive to rebind an arbitrary amount of items e.g. 10000+
  // prettier-ignore
  static click(D) {
    const O = D.target;
    if (O.classList.contains(Dropdown.DROPDOWN_CLASS) || O.classList.contains(OptionButton.BUTTON_CLASS))
      return;
    const { rowIndex: x, columnIndex: B, element: U } = this._focusedElements.cell, F = O.classList.contains(DropdownItem.DROPDOWN_ITEM_CLASS) ? O : O.parentElement;
    CellDropdownItem.selectExistingItem(
      this,
      F,
      x,
      B,
      U.children[0]
    ), CellWithTextEvents.programmaticBlur(this);
  }
  // this is required to record to stop cell blur from closing the dropdown
  // additionally if the user clicks on dropdown scroll or padding, this will record it
  static mouseDown(D, O) {
    D.cellDropdown = O;
  }
  static set(D, O) {
    O.onmousedown = CellDropdownEvents.mouseDown.bind(this, D._focusedElements, O), O.onclick = CellDropdownEvents.click.bind(D);
  }
}
const _CellDropdown2 = class ce {
  static generateRightPosition() {
    return "4px";
  }
  // prettier-ignore
  static generateBottomPosition(D, O, x) {
    const B = D.offsetParent, U = x.bottomWidth + x.topWidth;
    return `${B.offsetHeight - U - D.offsetTop - O.offsetTop + 6}px`;
  }
  // prettier-ignore
  static generateTopPosition(D, O, x) {
    const B = LabelCellTextElement.isLabelText(O) ? O.offsetTop + O.offsetHeight + 2 : D.offsetHeight - 8;
    return `${ElementOffset.processTop(D.offsetTop + B, x)}px`;
  }
  // prettier-ignore
  static generateLeftPosition(D, O, x) {
    const B = LabelCellTextElement.isLabelText(O) ? O.offsetLeft : 1;
    return `${ElementOffset.processLeft(D.offsetLeft + B, x)}px`;
  }
  // prettier-ignore
  static correctPosition(D, O, x, B) {
    const U = ElementVisibility.getDetailsInWindow(D, B);
    U.isFullyVisible || (U.blockingSides.has(SIDE.RIGHT) && (D.style.left = "", D.style.right = ce.generateRightPosition()), U.blockingSides.has(SIDE.BOTTOM) && (D.style.top = "", D.style.bottom = ce.generateBottomPosition(
      O,
      x,
      B
    )));
  }
  // prettier-ignore
  static correctPositionForOverflow(D, O, x) {
    O.offsetHeight !== x.scrollHeight && (D.style.top = `${O.offsetHeight - D.offsetHeight}px`), O.offsetWidth !== x.scrollWidth && (D.style.left = `${O.offsetWidth - D.offsetWidth}px`);
  }
  static setPosition(D, O, x) {
    const B = O.children[0];
    D.style.bottom = "", D.style.right = "", D.style.left = ce.generateLeftPosition(O, B, x), D.style.top = ce.generateTopPosition(O, B, x);
    const U = D.parentElement.parentElement, F = U.parentElement;
    OverflowUtils.isOverflowElement(F) ? ce.correctPositionForOverflow(D, U, F) : ce.correctPosition(D, O, B, x);
  }
  // prettier-ignore
  static updateCellDropdown(D, O, x, B, U, F) {
    const W = CellElement.getTextElement(D);
    CellDropdownItem.attemptHighlightMatchingItemWithCell(
      W,
      O,
      B,
      U,
      F
    ), U && ce.setPosition(O.element, W.parentElement, x);
  }
  static focusItemOnDropdownOpen(D, O, x) {
    CellDropdownItem.attemptHighlightMatchingItemWithCell(D, O, x, !1);
  }
  // prettier-ignore
  static correctWidthForOverflow(D) {
    if (D.clientWidth !== D.scrollWidth) {
      const O = D.clientHeight !== D.scrollHeight ? 16 : 0, x = D.scrollWidth + O;
      D.style.width = `${Math.min(x, ce.MAX_WIDTH)}px`;
    }
    D.children.length > 0 && D.scrollWidth < D.children[0].getBoundingClientRect().width && (D.style.width = `${D.clientWidth + 1}px`);
  }
  static getWidth(D, O, x) {
    if (x != null && x.width)
      return Number.parseInt(x.width);
    if (!O.labelDetails)
      return Math.max(D.offsetWidth - 2, ce.MIN_WIDTH);
    const B = D.children[0];
    return Math.max(D.offsetWidth - B.offsetLeft * 2, ce.MIN_WIDTH);
  }
  // prettier-ignore
  static display(D, O, x) {
    const { cellDropdown: B, settings: { defaultText: U }, activeType: { cellDropdownProps: F } } = D._columnsDetails[O], { element: W, itemsDetails: G } = B;
    if (Object.keys(G).length > 0 && F) {
      CellDropdownEvents.set(D, W), CellDropdownItemEvents.blurItem(B, "hovered"), CellDropdownItemEvents.blurItem(B, "matchingWithCellText"), W.style.width = `${ce.getWidth(x, B, F.dropdownStyle)}px`, Dropdown.display(W), W.scrollLeft = 0, ce.correctWidthForOverflow(W), CellDropdownScrollbar.setProperties(B), ce.setPosition(W, x, D._tableDimensions.border);
      const Y = x.children[0];
      return ce.focusItemOnDropdownOpen(Y, B, U), !0;
    }
    return !1;
  }
  static setCustomStyle(D, O) {
    const { paddingTop: x, paddingBottom: B, marginTop: U, marginLeft: F, border: W, textAlign: G } = O;
    D.element.style.paddingTop = x || Dropdown.DROPDOWN_VERTICAL_PX, D.element.style.paddingBottom = B || Dropdown.DROPDOWN_VERTICAL_PX, D.element.style.marginTop = U || "0px", D.element.style.marginLeft = F || "0px", D.element.style.border = W || "none", D.element.style.textAlign = G || "left";
  }
  static setCustomState(D, O) {
    D.customDropdownStyle = O.dropdownStyle, D.customItemStyle = O.optionStyle, D.canAddMoreOptions = !!O.canAddMoreOptions;
  }
  // prettier-ignore
  static setUpDropdown(D, O) {
    const { _columnsDetails: x, _globalItemColors: B } = D, { activeType: { cellDropdownProps: U }, cellDropdown: F } = x[O];
    U && (F.labelDetails = U.isBasicSelect ? void 0 : { globalItemColors: B }, ce.setCustomState(F, U), CellDropdownItem.populateItems(D, O), U.dropdownStyle && ce.setCustomStyle(F, U.dropdownStyle));
  }
  // REF-8 - Created for every column
  static createAndAppend(D) {
    const O = Dropdown.createBase();
    return O.style.maxHeight = ce.MAX_HEIGHT_PX, O.classList.add(ce.CELL_DROPDOWN_CLASS), D.appendChild(O), O;
  }
  static getDefaultObj(D) {
    return {
      itemsDetails: {},
      activeItems: {},
      element: D,
      canAddMoreOptions: !0,
      scrollbarPresence: {
        horizontal: !1,
        vertical: !1
      }
    };
  }
  static createContainerElement() {
    return document.createElement("div");
  }
};
_CellDropdown2.CELL_DROPDOWN_CLASS = "cell-dropdown";
_CellDropdown2.MAX_HEIGHT_PX = "147px";
_CellDropdown2.MIN_WIDTH = 70;
_CellDropdown2.MAX_WIDTH = 200;
let CellDropdown = _CellDropdown2;
const _ColumnDetails = class Fe {
  // prettier-ignore
  static getHeaderDefaultColor(D, O, x, B) {
    var U, F, W, G, Y, X;
    return ((F = (U = B == null ? void 0 : B.headerStyles) == null ? void 0 : U.default) == null ? void 0 : F[O]) || ((W = B == null ? void 0 : B.cellStyle) == null ? void 0 : W[O]) || ((Y = (G = D.headerStyles) == null ? void 0 : G.default) == null ? void 0 : Y[O]) || ((X = D.cellStyle) == null ? void 0 : X[O]) || x;
  }
  // prettier-ignore
  static getHeaderHoverColor(D, O, x, B) {
    var U, F, W, G;
    return ((F = (U = B == null ? void 0 : B.headerStyles) == null ? void 0 : U.hoverColors) == null ? void 0 : F[O]) || ((G = (W = D.headerStyles) == null ? void 0 : W.hoverColors) == null ? void 0 : G[O]) || Fe.getHeaderDefaultColor(D, O, x, B);
  }
  // settings variable is a variable attached to columnDetails and can be either default or custom
  // prettier-ignore
  static createHeaderStateColors(D, O, x) {
    return {
      hover: {
        color: Fe.getHeaderHoverColor(D, "color", x.color, O),
        backgroundColor: Fe.getHeaderHoverColor(
          D,
          "backgroundColor",
          x.backgroundColor,
          O
        )
      },
      default: {
        color: Fe.getHeaderDefaultColor(D, "color", "", O),
        backgroundColor: Fe.getHeaderDefaultColor(D, "backgroundColor", "", O)
      }
    };
  }
  // prettier-ignore
  static createInitial(D, O, x, B, U) {
    const F = x || D;
    return {
      elements: [],
      processedStyle: [],
      settings: F,
      headerStateColors: Fe.createHeaderStateColors(D, x, B),
      bordersOverwrittenBySiblings: {},
      activeType: ColumnTypesUtils.getActiveType(F),
      cellDropdown: CellDropdown.getDefaultObj(O),
      fireColumnsUpdate: U
    };
  }
  // prettier-ignore
  static updateWithNoSizer(D, O) {
    return Object.assign(D, { columnDropdownCellOverlay: O }), D;
  }
};
_ColumnDetails.MINIMAL_COLUMN_WIDTH = 34;
let ColumnDetails = _ColumnDetails;
class MaximumColumns {
  // the motivation behind minimal column length came from the fact that when we have set a table width and all the columns
  // have become too narrow (24px), upon adding any subsequent columns - the set table width would be ignored and the table
  // would expand - as an infinite amount of columns can't just be added to a table width a preset width
  // the actual minimal column length is usually not reached as dividing table width by its columns rarely produces it
  // originally this was set to 28, however the extra padding on the left column causes the table width to overflow
  // the set limit hence it is set to 34 instead
  // REF-24
  // this is a small effort to toggle off the add new column button when columns with set widths breach the table
  static isStaticContentBreachingSetTableWidth(D, O) {
    if (O)
      return !1;
    const x = D.width || D.maxWidth;
    return x !== void 0 && D.staticWidth > x;
  }
  // prettier-ignore
  static ignoreMinimalColumnWidthCheck(D, O, x) {
    return D.preserveNarrowColumns || !StaticTable.isStaticTableWidth(O, D) || x === 0;
  }
  // prettier-ignore
  static canAddMore(D) {
    const { _tableElementRef: O, _columnsDetails: x, _tableDimensions: B, maxColumns: U, preserveNarrowColumns: F } = D, W = x.length;
    if (U !== void 0 && U > 0 && U === W || MaximumColumns.isStaticContentBreachingSetTableWidth(B, F))
      return !1;
    const G = O;
    return MaximumColumns.ignoreMinimalColumnWidthCheck(B, G, W) ? !0 : (G.offsetWidth - B.staticWidth) / (W + 1) >= ColumnDetails.MINIMAL_COLUMN_WIDTH;
  }
}
const _AddNewColumnEvents = class Me {
  static setHeaderCellStyle(D, O, x) {
    const { default: B, hover: U } = O;
    D.style.color = x ? U.color : B.color, D.style.backgroundColor = x ? U.backgroundColor : B.backgroundColor;
  }
  static setDataCellStyle(D, O) {
    setTimeout(() => {
      D.forEach((x) => {
        x.style.backgroundColor = O;
      });
    });
  }
  // prettier-ignore
  static setDataCellsStyle(D, O, x) {
    const B = D ? x.hover.backgroundColor : x.default.backgroundColor, U = O.slice(1), F = Math.ceil(U.length / Me.NUMBER_OF_HIGHLIGHT_CHUNKS);
    for (let W = 0; W < U.length; W += F) {
      const G = U.slice(W, W + F);
      Me.setDataCellStyle(G, B);
    }
  }
  // prettier-ignore
  static toggleColor(D, O, x) {
    const { data: B, header: U } = x, F = O[0];
    F && Me.setHeaderCellStyle(F, U, D), O.length > 1 && Me.setDataCellsStyle(D, O, B);
  }
  // prettier-ignore
  static setEvents(D, O) {
    const { _addColumnCellsElementsRef: x, _frameComponents: { cellColors: B } } = D;
    O.onmouseenter = Me.toggleColor.bind(this, !0, x, B), O.onmouseleave = Me.toggleColor.bind(this, !1, x, B), O.onclick = InsertNewColumn.insertEvent.bind(D);
  }
};
_AddNewColumnEvents.NUMBER_OF_HIGHLIGHT_CHUNKS = 3;
let AddNewColumnEvents = _AddNewColumnEvents;
const _AddNewColumnElement = class ue {
  // the toggling of the add new column element is not a simple display style change because the following selector:
  // .row > .cell:last-of-type which is responsible for not adding a right-border for the rightmost cell can only
  // detect the last .cell element, so when this button is displayed we want the selector to recognise it and
  // not display a border on the right and not affect the css of the cell before it. When it is not displayed,
  // we want the previous cell to be recognised by the selector. Unfortunately this is not possible as even
  // renaming the class names on this button does not re-trigger selector to identify the previous cell as last.
  // The only way to do this is to remove the cell element when not visible, which is what the code below is doing
  // and re-adding the cell when it is visible. (The cell still remains in the addColumnCellsElementsRef object).
  static setDisplay(D, O, x, B) {
    O ? x.children[B].appendChild(D) : D.remove();
  }
  static createCell(D, O) {
    var B;
    const x = CellElement.createBaseCell(O);
    return x.classList.add(
      CellElement.CELL_CLASS,
      GenericElementUtils.NOT_SELECTABLE_CLASS,
      ue.ADD_COLUMN_CELL_CLASS
    ), Object.assign(x.style, D._defaultColumnsSettings.cellStyle, (B = D._frameComponents.styles) == null ? void 0 : B.default), AddNewColumnEvents.setEvents(D, x), x;
  }
  // prettier-ignore
  static createHeaderCell(D) {
    const { _defaultColumnsSettings: { headerStyles: O }, _frameComponents: { cellColors: x, inheritHeaderColors: B } } = D, U = ue.createCell(D, !0);
    return U.style.width = ue.DEFAULT_WIDTH_PX, U.innerText = "+", Object.assign(U.style, B ? O == null ? void 0 : O.default : {}, x.header.default), U;
  }
  static createDataCell(D) {
    const O = ue.createCell(D, !1);
    return Object.assign(O.style, D._frameComponents.cellColors.data.default), O;
  }
  static isDisplayed(D) {
    return GenericElementUtils.doesElementExistInDom(D[0]);
  }
  static createAndAppendToRow(D, O, x) {
    const { _addColumnCellsElementsRef: B, _columnsDetails: U } = D, F = B.length === 0 || ue.isDisplayed(B), W = x === 0 ? ue.createHeaderCell(D) : ue.createDataCell(D);
    B.splice(x, 0, W);
    const G = U[U.length - 1];
    ColumnSettingsBorderUtils.unsetSubjectBorder(B, G.elements, "left", x), F && (MaximumColumns.canAddMore(D) ? O.appendChild(W) : x === 0 && TableElement.changeStaticWidthTotal(D._tableDimensions, -ue.DEFAULT_WIDTH));
  }
  // prettier-ignore
  static toggleEachCell(D, O, x, B) {
    x.forEach((U, F) => {
      ue.setDisplay(U, D, O, F);
    }), D || setTimeout(() => AddNewColumnEvents.toggleColor(!1, x, B));
  }
  static changeTableWidths(D, O, x) {
    const B = O ? ue.DEFAULT_WIDTH : -ue.DEFAULT_WIDTH;
    TableElement.changeStaticWidthTotal(D._tableDimensions, B), StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, x);
  }
  // prettier-ignore
  static toggle(D, O) {
    const {
      _addColumnCellsElementsRef: x,
      _tableBodyElementRef: B,
      _frameComponents: { displayAddNewColumn: U, cellColors: F }
    } = D;
    if (!U || !B)
      return;
    const W = MaximumColumns.canAddMore(D);
    W !== ue.isDisplayed(x) && (W ? (ue.toggleEachCell(W, B, x, F), ue.changeTableWidths(D, W, O)) : (ue.changeTableWidths(D, W, O), ue.toggleEachCell(W, B, x, F)));
  }
};
_AddNewColumnElement.ADD_COLUMN_CELL_CLASS = "add-column-cell";
_AddNewColumnElement.DEFAULT_WIDTH = 25;
_AddNewColumnElement.DEFAULT_WIDTH_PX = `${_AddNewColumnElement.DEFAULT_WIDTH}px`;
let AddNewColumnElement = _AddNewColumnElement;
class ExtractElements {
  static textCellsArrFromRow(D) {
    return Array.from(D.children).filter(
      (O) => (O.tagName === CellElement.HEADER_TAG || O.tagName === CellElement.DATA_TAG) && !O.classList.contains(AddNewColumnElement.ADD_COLUMN_CELL_CLASS) && !O.classList.contains(IndexColumn.INDEX_CELL_CLASS)
    );
  }
  static textRowsArrFromTBody(D, O, x = 0) {
    return Array.from(D.children).slice(x, O.length);
  }
  static getRightColumnSiblingCell(D) {
    var O;
    return (O = D.nextSibling) == null ? void 0 : O.nextSibling;
  }
}
class ColumnSettingsFrameBorderUtils {
  // prettier-ignore
  static toggleFrameBorder(D, O, x, B) {
    if (D.length > 0) {
      const { subjectBorderStyle: U, siblingBorderStyle: F } = ColumnSettingsBorderUtils.getColumnBorderStyles(x), W = D[0], G = O[0];
      ColumnSettingsBorderUtils.isBorderDisplayed(G, F) ? ColumnSettingsBorderUtils.unsetSubjectBorder(D, O, x, 0) : W.style[U] === ColumnSettingsBorderUtils.UNSET_PX && ResetColumnStyles.applyDefaultStyles(D, B);
    }
  }
  // prettier-ignore
  static updateFrameColumns(D, O, x, B) {
    const U = O || x;
    if (!U)
      return;
    const {
      _defaultColumnsSettings: F,
      _addColumnCellsElementsRef: W,
      _frameComponents: { displayAddNewColumn: G, displayIndexColumn: Y }
    } = D;
    if (!B && G && ColumnSettingsFrameBorderUtils.toggleFrameBorder(
      W,
      U.elements,
      "left",
      F
    ), !x && Y) {
      const J = ExtractElements.textRowsArrFromTBody(D._tableBodyElementRef, D.data, 0).map((Q) => Q.children[0]);
      ColumnSettingsFrameBorderUtils.toggleFrameBorder(J, U.elements, "right", F);
    }
  }
}
const _ColumnSettingsBorderUtils = class de {
  // REF-23
  static overwriteSideBorderIfSiblingsHaveSettings(D, O) {
    const { left: x, right: B } = D.bordersOverwrittenBySiblings;
    O.forEach((U) => {
      x && (U.style.borderLeftWidth = de.UNSET_PX), B && (U.style.borderRightWidth = de.UNSET_PX);
    });
  }
  // prettier-ignore
  static getColumnBorderStyles(D) {
    return { subjectBorderStyle: D === "left" ? "borderLeftWidth" : "borderRightWidth", siblingBorderStyle: D === "left" ? "borderRightWidth" : "borderLeftWidth" };
  }
  static isBorderDisplayed(D, O) {
    return !!(D.style[O] && D.style[O] !== de.UNSET_PX);
  }
  // REF-23
  // prettier-ignore
  static unsetSubjectBorder(D, O, x, B, U) {
    const { subjectBorderStyle: F, siblingBorderStyle: W } = de.getColumnBorderStyles(x), G = D[B], Y = O[B];
    de.isBorderDisplayed(G, F) && de.isBorderDisplayed(Y, W) && (U && (U[x] = !0), D.forEach((X) => {
      ElementStyle.setStyle(X, F, de.UNSET_PX);
    }));
  }
  // prettier-ignore
  static unsetColumnBorder(D, O, x) {
    de.unsetSubjectBorder(
      D.elements,
      O.elements,
      x,
      0,
      D.bordersOverwrittenBySiblings
    );
  }
  // if current column and sibling have custom setting styles
  // REF-23
  // prettier-ignore
  static unsetBorders(D, O, x) {
    D && (D.settings.stylePrecedence ? (O && de.unsetColumnBorder(O, D, "right"), x && (x.settings.stylePrecedence ? de.unsetColumnBorder(D, x, "right") : x.settings.stylePrecedence || de.unsetColumnBorder(x, D, "left"))) : (x && x.settings.stylePrecedence && de.unsetColumnBorder(D, x, "right"), O && O.settings.stylePrecedence && de.unsetColumnBorder(D, O, "left")));
  }
  static resetBorderOverwritingState(D) {
    D && (D.bordersOverwrittenBySiblings.left = !1, D.bordersOverwrittenBySiblings.right = !1);
  }
  // prettier-ignore
  static resetIfBorderOverwritten(D, O, x, B) {
    x != null && x.bordersOverwrittenBySiblings[B] && (x.bordersOverwrittenBySiblings[B] = !1, ColumnSettingsStyleUtils.changeStyleFunc(D, O, D._columnsDetails[O].settings));
  }
  // REF-23
  static updateSiblingColumns(D, O) {
    const { _columnsDetails: x } = D, B = x[O], U = x[O - 1], F = x[O + 1];
    de.resetIfBorderOverwritten(D, O + 1, F, "left"), de.resetIfBorderOverwritten(D, O - 1, U, "right"), de.resetBorderOverwritingState(B), de.unsetBorders(B, U, F), ColumnSettingsFrameBorderUtils.updateFrameColumns(D, B, U, F);
  }
};
_ColumnSettingsBorderUtils.UNSET_PX = "0px";
let ColumnSettingsBorderUtils = _ColumnSettingsBorderUtils;
const _CellElement = class Ce {
  // prettier-ignore
  static setDefaultCellStyle(D, O, x) {
    Object.assign(D.style, O, x);
  }
  static createBaseCell(D) {
    const O = document.createElement(D ? Ce.HEADER_TAG : Ce.DATA_TAG);
    return D && O.classList.add(Ce.HEADER_CELL_CLASS), O.classList.add(Ce.CELL_CLASS), O;
  }
  // prettier-ignore
  static createDataCell(D, O, x, B) {
    const U = Ce.createBaseCell(D);
    return D && B && U.classList.add(GenericElementUtils.NOT_SELECTABLE_CLASS), U.setAttribute("role", "textbox"), Ce.setDefaultCellStyle(U, O, x), U;
  }
  static setCursor(D, O) {
    D.style.cursor = O ? "text" : "default";
  }
  static prepContentEditable(D, O, x = !1) {
    CaretDisplayFix.isIssueBrowser() ? (O && CaretDisplayFix.setTabIndex(D), CaretDisplayFix.removeContentEditable(D)) : D.contentEditable = String(O), x || Ce.setCursor(D, O);
  }
  // prettier-ignore
  // this is used for cases where element could be the cell element or the text inside a select/label cell
  static getCellElement(D) {
    return D.classList.contains(CellTextElement.CELL_TEXT_DIV_CLASS) || D.classList.contains(DateCellInputElement.DATE_INPUT_CONTAINER_CLASS) ? D.parentElement : D.classList.contains(DateCellInputElement.DATE_INPUT_CLASS) || D.classList.contains(DateCellCalendarIconElement.CALENDAR_ICON_CONTAINER_CLASS) ? D.parentElement.parentElement : D;
  }
  static getTextElement(D) {
    var O, x;
    return (O = D.children[0]) != null && O.classList.contains(CellTextElement.CELL_TEXT_DIV_CLASS) ? D.children[0] : (x = D.children[1]) != null && x.classList.contains(CellTextElement.CELL_TEXT_DIV_CLASS) ? D.children[1] : CheckboxCellElement.isCheckboxCell(D) ? D.children[0] : D;
  }
  // The reason why .trim() is used is because innerText/textContent property does not just return the cell text, but
  // additionally the new line characters (\n) which represent <br> elements within the cell that make it difficult
  // to compare cell text to other strings or use them for other programmatic purposes.
  // CAUTION-1 - The returned string should not be used to set text on other cells as .trim() removes \n chars for
  // <br> tags which are used to set the pointer position.
  static getText(D) {
    const O = CheckboxCellElement.getValue(D);
    return O !== void 0 ? O : D.innerText.trim();
  }
  // this is used for case where element could be cell element that contains a text div element,
  // hence we need to set the text into the correct container
  // CAUTION-1 - be careful that the text does not come from above method
  static setText(D, O) {
    if (!CheckboxCellElement.setValue(D, O)) {
      const x = Ce.getTextElement(D);
      x.innerText = O;
    }
  }
  // set text is optional as some elements may only need to toggle the BR padding
  // prettier-ignore
  static setNewText(D, O, x, B, U, F = !0) {
    F && Ce.setText(O, x), B ? setTimeout(() => CaretDisplayFix.toggleCellTextBRPadding(D, O, U)) : CaretDisplayFix.toggleCellTextBRPadding(D, O, U);
  }
  // REF-36
  static setColumnWidth(D, O, x, B) {
    if (!D._tableElementRef)
      return;
    const U = (x == null ? void 0 : x.widths) || (B == null ? void 0 : B.widths);
    if (U != null && U.staticWidth)
      ColumnSettingsWidthUtils.updateColumnWidth(D, O, U, !0);
    else if (U != null && U.initialWidth) {
      const F = ColumnSettingsWidthUtils.getSettingsWidthNumber(D._tableElementRef, U, !1);
      O.style.width = `${F.number}px`;
    } else
      O.style.width = `${D._tableDimensions.newColumnWidth}px`;
  }
  // prettier-ignore
  static createCellElement(D, O, x, B) {
    var le, re, ut;
    const { _defaultColumnsSettings: { cellStyle: U, headerStyles: F }, _columnsDetails: W } = D, G = W[x], Y = (ut = (re = (le = D._defaultColumnsSettings.columnDropdown) == null ? void 0 : le.displaySettings) == null ? void 0 : re.openMethod) == null ? void 0 : ut.cellClick, X = Ce.createDataCell(
      B,
      U,
      B ? F == null ? void 0 : F.default : {},
      Y
    ), { settings: J } = G;
    ColumnSettingsStyleUtils.applySettingsStyleOnCell(J, X, B), ColumnSettingsBorderUtils.overwriteSideBorderIfSiblingsHaveSettings(G, [X]);
    const Q = B ? !Y && J.isHeaderTextEditable : J.isCellTextEditable;
    return Ce.prepContentEditable(X, !!Q, Y), B && Ce.setColumnWidth(D, X, J, D._defaultColumnsSettings), Ce.setNewText(D, X, O, !0, !1), X;
  }
};
_CellElement.CELL_CLASS = "cell";
_CellElement.HEADER_CELL_CLASS = "header-cell";
_CellElement.HEADER_TAG = "TH";
_CellElement.DATA_TAG = "TD";
let CellElement = _CellElement;
const _FilterViaWebWorkers = class We {
  // prettier-ignore
  static processOtherColumnsIfPresent(D, O, x, B) {
    FilterInternalUtils.ACTIVE_WORKERS -= 1, x.length > 1 && B.length > 0 ? We.execute(D, O, x.slice(1), B) : FilterInternalUtils.ACTIVE_WORKERS === 0 && D();
  }
  // cannot use a direct link to a webworker file as parent project may not allow the component to access it
  // const worker = new Worker(new URL('./worker.js', import.meta.url))
  // using a string literal instead, ref:
  // https://stackoverflow.com/questions/10343913/how-to-create-a-web-worker-from-a-string
  static createWorkerBlobURL() {
    const D = new Blob([We.CODE], { type: "application/javascript" });
    return URL.createObjectURL(D);
  }
  static hideRows(D, O, x, B) {
    const { colCells: U } = x[0], { matchingIndexes: F, notMatchingIndexes: W } = B.data;
    W.forEach((G) => {
      U[G].parentElement.classList.add(FilterInternalUtils.HIDDEN_ROW_CLASS);
    }), We.processOtherColumnsIfPresent(D, O, x, F);
  }
  static toggleRows(D, O, x, B) {
    const U = [], { colCells: F } = x[0];
    B.data.forEach((G, Y) => {
      const X = F[Y].parentElement;
      G ? (X.classList.remove(FilterInternalUtils.HIDDEN_ROW_CLASS), U.push(Y)) : X.classList.add(FilterInternalUtils.HIDDEN_ROW_CLASS);
    }), We.processOtherColumnsIfPresent(D, O, x, U);
  }
  // prettier-ignore
  static execute(D, O, x, B) {
    const U = new Worker(O);
    FilterInternalUtils.ACTIVE_WORKERS += 1, U.onmessage = B ? We.hideRows.bind(this, D, O, x) : We.toggleRows.bind(this, D, O, x);
    const F = x[0];
    U.postMessage({
      chunk: F.colCells.map((W) => CellElement.getText(W)),
      filterText: F.filterText,
      isCaseSensitive: F.isCaseSensitive,
      indexArray: B
    });
  }
};
_FilterViaWebWorkers.TRAVERSE_CHUNK = `
    const result = chunk.map((text) => (isCaseSensitive ? text : text.toLocaleLowerCase()).includes(filterText));
    self.postMessage(result);
  `;
_FilterViaWebWorkers.TRAVERSE_MATCHING_INDEXES = `
    const matchingIndexes = [];
    const notMatchingIndexes = [];
    indexArray.forEach((index) => {
      const text = chunk[index];
      const isMatching = (isCaseSensitive ? text : text.toLocaleLowerCase()).includes(filterText);
      if (isMatching) {
        matchingIndexes.push(index);
      } else {
        notMatchingIndexes.push(index);
      }
    });
    self.postMessage({matchingIndexes, notMatchingIndexes});
  `;
_FilterViaWebWorkers.CODE = `
    self.onmessage = function (event) {
      const {chunk, indexArray, filterText, isCaseSensitive} = event.data;
      if (indexArray) {
        ${_FilterViaWebWorkers.TRAVERSE_MATCHING_INDEXES}
      } else {
        ${_FilterViaWebWorkers.TRAVERSE_CHUNK}
      }
    };
  `;
let FilterViaWebWorkers = _FilterViaWebWorkers;
class FilterViaTimeouts {
  static processOtherColumnsIfPresent(D, O, x) {
    FilterInternalUtils.ACTIVE_WORKERS -= 1, O.length > 1 && x.length > 0 ? FilterViaTimeouts.processOtherColumns(D, O.slice(1), x) : FilterInternalUtils.ACTIVE_WORKERS === 0 && D();
  }
  static toggleRow(D, O, x, B) {
    const U = CellElement.getText(D), W = (O.isCaseSensitive ? U : U.toLocaleLowerCase()).includes(O.filterText), G = D.parentElement;
    W ? (G.classList.remove(FilterInternalUtils.HIDDEN_ROW_CLASS), x.push(B)) : G.classList.add(FilterInternalUtils.HIDDEN_ROW_CLASS);
  }
  static processOtherColumns(D, O, x) {
    setTimeout(() => {
      FilterInternalUtils.ACTIVE_WORKERS += 1;
      const B = [], U = O[0];
      x.forEach((F) => {
        const W = U.chunk[F];
        FilterViaTimeouts.toggleRow(W, U, B, F);
      }), FilterViaTimeouts.processOtherColumnsIfPresent(D, O, B);
    });
  }
  static execute(D, O) {
    FilterInternalUtils.ACTIVE_WORKERS += 1, setTimeout(() => {
      const x = [], B = O[0];
      B.chunk.forEach((U, F) => {
        FilterViaTimeouts.toggleRow(U, B, x, F);
      }), FilterViaTimeouts.processOtherColumnsIfPresent(D, O, x);
    });
  }
}
const _FilterInternalUtils = class Ne {
  static finishFiltering(D) {
    D.pagination && (PageButtonContainerElement.repopulateButtons(D), PaginationUtils.displayRowsForDifferentButton(D, 1));
  }
  static getFilterFunc(D) {
    const O = Ne.finishFiltering.bind(this, D);
    return window.Worker ? FilterViaWebWorkers.execute.bind(this, O, FilterViaWebWorkers.createWorkerBlobURL()) : FilterViaTimeouts.execute.bind(this, O);
  }
  static generateDefaultHeaderName(D, O) {
    var x, B, U;
    return O && ((x = D[0]) == null ? void 0 : x.find((W) => W === O)) ? O : ((B = D[0]) == null ? void 0 : B[0]) !== void 0 ? String((U = D[0]) == null ? void 0 : U[0]) : "";
  }
  static addConfig(D, O) {
    var W;
    const { placeholderTemplate: x, defaultColumnHeaderName: B, asyncGetData: U } = O, F = {
      isCaseSensitive: !1,
      placeholderTemplate: x,
      asyncGetData: U,
      defaultColumnHeaderName: B || Ne.generateDefaultHeaderName(D.data)
    };
    return (W = D._visiblityInternal).filters ?? (W.filters = []), D._visiblityInternal.filters.push(F), F;
  }
  // colElements are used to identify active column (not using name as columns can have same names)
  static assignElements(D, O) {
    var U;
    const { data: x, _columnsDetails: B } = D;
    if (x.length !== 0)
      if (O.defaultColumnHeaderName) {
        const F = x[0].findIndex((W) => W === O.defaultColumnHeaderName);
        O.elements = B[F === -1 ? 0 : F].elements, delete O.defaultColumnHeaderName;
      } else
        O.elements && !((U = D.shadowRoot) != null && U.contains(O.elements[0])) && (O.elements = B[0].elements);
  }
  // prettier-ignore
  static resetInput(D, O) {
    const { _visiblityInternal: { filters: x } } = D;
    if (Ne.assignElements(D, O), !O.elements || !x)
      return;
    const B = CellElement.getText(O.elements[0]);
    O.lastRegisteredHeaderName = B, FilterInputElement.setPlaceholder(O.inputElement, B, O.placeholderTemplate), FilterInputEvents.setEvents(D, O, x);
  }
  static unsetFilter(D) {
    D.value !== "" && (D.value = "", D.dispatchEvent(new Event("input")));
  }
  static unsetAllFilters(D) {
    var F, W;
    let O = !1;
    const { data: x, _visiblityInternal: B, _tableBodyElementRef: U } = D;
    return x[0] && x[0].length !== 0 && U && ((F = B.filters) == null || F.forEach((G) => {
      G.inputElement.value !== "" && (G.inputElement.value = "", O = !0);
    }), O && ((W = B.filters) == null || W[0].inputElement.dispatchEvent(new Event("input")))), O;
  }
  // prettier-ignore
  static resetAllInputs(D) {
    const { data: O, _visiblityInternal: { filters: x } } = D;
    if (!O[0] || O[0].length === 0 || !x)
      return FilterInputEvents.unsetEvents(x);
    x.forEach((B) => Ne.resetInput(D, B)), Ne.unsetAllFilters(D);
  }
  static completeReset(D) {
    const O = D._visiblityInternal.filters;
    O && (Array.isArray(D.filter) ? D.filter.forEach((x, B) => {
      O[B].defaultColumnHeaderName = x.defaultColumnHeaderName;
    }) : typeof D.filter == "object" && (O[0].defaultColumnHeaderName = D.filter.defaultColumnHeaderName), Ne.resetAllInputs(D));
  }
  static isContainerRequired(D, O) {
    let x = !1;
    if (Array.isArray(D))
      x = !!D.find((B) => {
        const U = (B.position || FilterElements.DEFAULT_INPUT_POSITION).indexOf(O);
        return U !== void 0 && U >= 0;
      });
    else if (typeof D == "object") {
      const B = (D.position || FilterElements.DEFAULT_INPUT_POSITION).indexOf(O);
      x = B !== void 0 && B >= 0;
    } else if (typeof D == "boolean") {
      const B = FilterElements.DEFAULT_INPUT_POSITION.indexOf(O);
      x = B !== void 0 && B >= 0;
    }
    return x;
  }
  static extractUnfilteredRows(D, O) {
    return Array.from(D.children).slice(0, O).filter((B) => !B.classList.contains(Ne.HIDDEN_ROW_CLASS));
  }
  // prettier-ignore
  static wasHeaderChanged(D, O, x, B) {
    const U = D[x].elements, F = O.find((W) => U === W.elements);
    return F && (F.lastRegisteredHeaderName !== CellElement.getText(U[0]) || B);
  }
};
_FilterInternalUtils.ACTIVE_WORKERS = 0;
_FilterInternalUtils.CHUNK_SIZE = 2;
_FilterInternalUtils.HIDDEN_ROW_CLASS = "filter-hidden-row";
let FilterInternalUtils = _FilterInternalUtils;
class FileImportInputElement {
  // always created as the user may want to trigger the importCSV method without the CSV buttons and need this to work
  static create(D) {
    const O = document.createElement("input");
    return O.type = "file", O.hidden = !0, setTimeout(() => {
      var x;
      (x = D._tableElementRef) == null || x.appendChild(O);
    }), O;
  }
}
class FilesUtils {
  static processStyles(D) {
    const O = { default: {}, hover: { backgroundColor: "#f0f0f0" }, click: { backgroundColor: "#e4e4e4" } };
    return D && (Object.assign(O.default, D.default), Object.assign(O.hover, D.hover), Object.assign(O.click, D.click)), O;
  }
  static createDefault(D) {
    return { inputElementRef: FileImportInputElement.create(D) };
  }
}
FilesUtils.DEFAULT_BUTTON_POSITION = "bottom-left";
const _OuterContainerElements = class se {
  // REF-38
  static getColumnContentContainer(D) {
    return D.children[0].children[0];
  }
  static setContainerHeightBasedOnMiddleColumn(D) {
    if (D.getBoundingClientRect().height === 0) {
      const O = se.getColumnContentContainer(D.children[1]);
      D.style.height = `${O.getBoundingClientRect().height}px`;
    }
  }
  static setHeightsWhenOnlyMiddleColumns(D) {
    setTimeout(() => {
      D.top && se.setContainerHeightBasedOnMiddleColumn(D.top), D.bottom && se.setContainerHeightBasedOnMiddleColumn(D.bottom);
    });
  }
  // REF-38
  static appendChildToColumn(D, O) {
    se.getColumnContentContainer(D).appendChild(O);
  }
  // REF-38
  static addToContainer(D, O, x) {
    const B = D.indexOf("top") >= 0 ? O.top : O.bottom;
    D.indexOf("left") >= 0 ? se.appendChildToColumn(B.children[0], x) : D.indexOf("center") >= 0 ? se.appendChildToColumn(B.children[1], x) : se.appendChildToColumn(B.children[2], x);
  }
  // REF-38
  // need an inner divs in order for the inserted components 'width' properties to work as CONTAINER_CLASS has width: 0px
  static createContainerColumn(D, O) {
    const x = document.createElement("div");
    x.classList.add(se.COLUMN_CLASS, D);
    const B = document.createElement("div");
    B.classList.add(se.COLUMN_INNER_CLASS);
    const U = document.createElement("div");
    return U.classList.add(se.COLUMN_CONTENT_CLASS), B.appendChild(U), x.appendChild(B), x.style.gridColumn = O, x;
  }
  static createContainerElement() {
    const D = document.createElement("div");
    D.classList.add(se.CONTAINER_CLASS);
    const O = se.createContainerColumn(se.LEFT_COLUMN_CLASS, "1");
    D.appendChild(O);
    const x = se.createContainerColumn(se.CENTER_COLUMN_CLASS, "2");
    D.appendChild(x);
    const B = se.createContainerColumn(se.RIGHT_COLUMN_CLASS, "3");
    return D.appendChild(B), D;
  }
  static addContainer(D, O, x) {
    const B = se.createContainerElement();
    B.id = O, x != null && x.style.fontFamily && (B.style.fontFamily = x.style.fontFamily);
    const U = O === se.TOP_CONTAINER_ID ? "beforebegin" : "afterend";
    return D.insertAdjacentElement(U, B), B;
  }
  // can be reused for other positional components
  static isRequired(D, O) {
    return !!Object.keys(D).find((x) => {
      const { position: B } = D[x];
      return B.indexOf(O) >= 0;
    });
  }
  static isContainerRequired(D, O) {
    var B;
    let x = !1;
    return D.pagination && (x = se.isRequired(D._pagination.positions, O)), !x && ((B = D.files) != null && B.buttons) && (x = !!D.files.buttons.find((U) => (U.position || FilesUtils.DEFAULT_BUTTON_POSITION).indexOf(O) >= 0)), !x && D.filter && (x = FilterInternalUtils.isContainerRequired(D.filter, O)), x;
  }
  // we create a top and a bottom container only if they are required
  static create(D) {
    var W;
    const O = {}, x = se.isContainerRequired(D, "top"), B = se.isContainerRequired(D, "bottom"), { _tableElementRef: U } = D, F = ((W = D._overflow) == null ? void 0 : W.overflowContainer) || U;
    if (!F)
      return O;
    if (x) {
      const G = se.addContainer(F, se.TOP_CONTAINER_ID, U);
      O.top = G;
    }
    if (B) {
      const G = se.addContainer(F, se.BOTTOM_CONTAINER_ID, U);
      O.bottom = G;
    }
    return se.setHeightsWhenOnlyMiddleColumns(O), O;
  }
};
_OuterContainerElements.ABSOULUTE_FULL_TABLE_CLASS = "absolute-container";
_OuterContainerElements.CONTAINER_CLASS = "outer-container";
_OuterContainerElements.TOP_CONTAINER_ID = "outer-top-container";
_OuterContainerElements.BOTTOM_CONTAINER_ID = "outer-bottom-container";
_OuterContainerElements.COLUMN_CLASS = "outer-container-column";
_OuterContainerElements.COLUMN_INNER_CLASS = "outer-container-column-inner";
_OuterContainerElements.COLUMN_CONTENT_CLASS = "outer-container-column-content";
_OuterContainerElements.LEFT_COLUMN_CLASS = "outer-container-left-column";
_OuterContainerElements.CENTER_COLUMN_CLASS = "outer-container-center-column";
_OuterContainerElements.RIGHT_COLUMN_CLASS = "outer-container-right-column";
let OuterContainerElements = _OuterContainerElements;
const _OuterDropdownButtonUtils = class ot {
  static processStatefulStyle(D) {
    D.hover ?? (D.hover = D.default), D.click ?? (D.click = D.hover);
  }
  static processAndApplyDefaultStyle(D, O) {
    O && (ot.processStatefulStyle(O), Object.assign(D.style, O.default));
  }
  static createArrow(D, O) {
    const x = document.createElement("div");
    x.classList.add(ot.ARROW_CONTAINER_CLASS, GenericElementUtils.NOT_SELECTABLE_CLASS), D && x.classList.add(...D);
    const B = SVGIconUtils.createSVGElement(ARROW_DOWN_SVG_STRING);
    return B.classList.add(ot.ARROW_ICON_CLASS), O && B.classList.add(...O), x.appendChild(B), x;
  }
};
_OuterDropdownButtonUtils.ARROW_CONTAINER_CLASS = "outer-dropdown-button-arrow-container";
_OuterDropdownButtonUtils.ARROW_ICON_CLASS = "outer-dropdown-button-arrow-icon";
let OuterDropdownButtonUtils = _OuterDropdownButtonUtils;
class RowsPerPageSelectButtonEvents {
  static mouseDown(D, O) {
    var U, F, W, G, Y, X;
    Object.assign(O.style, (F = (U = D.styles.rowsPerPageSelect) == null ? void 0 : U.button) == null ? void 0 : F.click);
    const x = O.children[0];
    Object.assign(x.style, (G = (W = D.styles.rowsPerPageSelect) == null ? void 0 : W.buttonText) == null ? void 0 : G.click);
    const B = O.children[1];
    Object.assign(B.style, (X = (Y = D.styles.rowsPerPageSelect) == null ? void 0 : Y.buttonArrow) == null ? void 0 : X.click);
  }
  static mouseLeave(D, O) {
    RowsPerPageSelectButtonElement.applyStylesOnElements(O, "default", D.rowsPerPageSelect);
  }
  static mouseEnter(D, O) {
    RowsPerPageSelectButtonElement.applyStylesOnElements(O, "hover", D.rowsPerPageSelect);
  }
  static setEvents(D, O) {
    O.onmouseenter = RowsPerPageSelectButtonEvents.mouseEnter.bind(this, D._pagination.styles, O), O.onmouseleave = RowsPerPageSelectButtonEvents.mouseLeave.bind(this, D._pagination.styles, O), O.onmousedown = RowsPerPageSelectButtonEvents.mouseDown.bind(this, D._pagination, O), O.onmouseup = RowsPerPageSelectButtonEvents.mouseEnter.bind(this, D._pagination.styles, O);
  }
}
const _RowsPerPageSelectButtonElement = class ze {
  // prettier-ignore
  static applyStylesOnElements(D, O, x) {
    if (!x)
      return;
    const { button: B, buttonText: U, buttonArrow: F } = x;
    if (B && StatefulCSSEvents.apply(B, B[O], D), U) {
      const W = D.children[0];
      StatefulCSSEvents.apply(U, U[O], W);
    }
    if (F) {
      const W = D.children[1];
      StatefulCSSEvents.apply(F, F[O], W);
    }
  }
  static createButtonArrow(D) {
    var x;
    const O = OuterDropdownButtonUtils.createArrow();
    return OuterDropdownButtonUtils.processAndApplyDefaultStyle(O, (x = D.styles.rowsPerPageSelect) == null ? void 0 : x.buttonArrow), O;
  }
  static updateButtonText(D, O) {
    const x = D.children[0];
    x.innerText = O;
  }
  static createButtonText(D) {
    var W;
    const { isAllRowsOptionSelected: O, rowsPerPageOptionsItemText: x, rowsPerPage: B, styles: U } = D, F = document.createElement("div");
    return F.id = ze.TEXT_ID, F.classList.add(GenericElementUtils.NOT_SELECTABLE_CLASS), OuterDropdownButtonUtils.processAndApplyDefaultStyle(F, (W = U.rowsPerPageSelect) == null ? void 0 : W.buttonText), F.innerText = O ? x[0] : String(B), F;
  }
  static createOptionsButton(D) {
    var x;
    const O = document.createElement("div");
    return O.id = ze.BUTTON_ID, OuterDropdownButtonUtils.processAndApplyDefaultStyle(O, (x = D.styles.rowsPerPageSelect) == null ? void 0 : x.button), O;
  }
  static create(D) {
    const O = ze.createOptionsButton(D._pagination);
    return O.appendChild(ze.createButtonText(D._pagination)), O.appendChild(ze.createButtonArrow(D._pagination)), setTimeout(() => RowsPerPageSelectButtonEvents.setEvents(D, O)), O;
  }
};
_RowsPerPageSelectButtonElement.BUTTON_ID = "rows-per-page-select-button";
_RowsPerPageSelectButtonElement.TEXT_ID = "rows-per-page-select-button-text";
let RowsPerPageSelectButtonElement = _RowsPerPageSelectButtonElement;
class RowsPerPageDropdown {
  static getLeftPropertyToCenterDropdown(D, O) {
    return `${D.offsetLeft + D.offsetWidth / 2 - O / 2}px`;
  }
  static display(D, O, x) {
    const { dropdownWidth: B } = O._pagination, { element: U } = x;
    U.style.left = RowsPerPageDropdown.getLeftPropertyToCenterDropdown(D, B), OuterDropdownSimpleUtils.display(D, O, x);
  }
  static setWidth(D, O) {
    const B = O.rowsPerPageOptionsItemText.reduce((U, F) => isNaN(Number(F)) ? U : Math.max(U, F.length), 1) * 8;
    O.dropdownWidth = O.dropdownWidth + B, D.style.width = `${O.dropdownWidth}px`;
  }
  static create(D, O) {
    const x = OuterDropdownSimpleUtils.hide.bind(this, D._activeOverlayElements), B = RowsPerPageDropdown.display.bind(this, O), U = OuterDropdownElement.create(D, O, "bottom-center", {}, [], x, B);
    return RowsPerPageDropdownItem.populate(D, U.element, O), RowsPerPageDropdown.setWidth(U.element, D._pagination), U;
  }
}
const _RowsPerPageSelectElement = class Ze {
  static createText(D) {
    var x;
    const O = document.createElement("div");
    return O.id = Ze.TEXT_ID, O.style.marginRight = "8px", Object.assign(O.style, (x = D.styles.rowsPerPageSelect) == null ? void 0 : x.prefixText), O.innerText = D.rowsPerPageSelect.prefixText, O;
  }
  static createContainer(D) {
    var x;
    const O = document.createElement("div");
    return O.id = Ze.ID, O.classList.add(PaginationElements.PAGINATION_TEXT_COMPONENT_CLASS), O.style.order = String(D.positions.rowsPerPageSelect.order), Object.assign(O.style, (x = D.styles.rowsPerPageSelect) == null ? void 0 : x.container), O;
  }
  // prettier-ignore
  static create(D, O) {
    const x = Ze.createContainer(D._pagination);
    x.appendChild(Ze.createText(D._pagination));
    const B = RowsPerPageSelectButtonElement.create(D), U = RowsPerPageDropdown.create(D, B);
    return x.appendChild(B), x.appendChild(U.element), OuterContainerElements.addToContainer(
      D._pagination.positions.rowsPerPageSelect.position,
      O,
      x
    ), x;
  }
};
_RowsPerPageSelectElement.ID = "pagination-number-of-rows-select";
_RowsPerPageSelectElement.TEXT_ID = "pagination-number-of-rows-select-text";
let RowsPerPageSelectElement = _RowsPerPageSelectElement;
class PaginationElements {
  static create(D, O) {
    D._pagination.buttonContainer = PageButtonContainerElement.create(D), PageButtonContainerElement.addInitialElements(D, O), D._pagination.rowsPerPageOptionsItemText && RowsPerPageSelectElement.create(D, O), D._pagination.displayNumberOfVisibleRows && (D._pagination.numberOfVisibleRowsElement = NumberOfVisibleRowsElement.create(D, O));
  }
}
PaginationElements.PAGINATION_TEXT_COMPONENT_CLASS = "pagination-text-component";
const _NumberOfVisibleRowsElement = class qe {
  static updateForRelativeRowNumber(D, O) {
    const { activePageNumber: x, rowsPerPage: B, numberOfVisibleRowsElement: U } = D, F = x * B, W = O < 1 ? 0 : Math.max(F - B + 1, 1), G = Math.min(O, F);
    U.innerText = `${W}-${G} of ${O}`;
  }
  static updateForAllRows(D, O) {
    D.innerText = `${Math.min(O, 1)}-${O} of ${O}`;
  }
  static update(D) {
    var G, Y;
    const { _pagination: O, data: x, dataStartsAtHeader: B } = D, { numberOfVisibleRowsElement: U, isAllRowsOptionSelected: F } = O;
    if (!U)
      return;
    const W = ((Y = (G = D._pagination) == null ? void 0 : G.asyncStartData) == null ? void 0 : Y.totalDataRows) || Math.max(B ? x.length : x.length - 1, 0);
    F ? qe.updateForAllRows(U, W) : qe.updateForRelativeRowNumber(D._pagination, W);
  }
  static create(D, O) {
    const x = document.createElement("div");
    x.id = qe.ID, x.classList.add(PaginationElements.PAGINATION_TEXT_COMPONENT_CLASS);
    const { styles: B, positions: U } = D._pagination;
    return x.style.order = String(U.numberOfVisibleRows.order), Object.assign(x.style, B.numberOfVisibleRows), OuterContainerElements.addToContainer(U.numberOfVisibleRows.position, O, x), setTimeout(() => qe.update(D)), x;
  }
};
_NumberOfVisibleRowsElement.ID = "pagination-number-of-visible-rows";
let NumberOfVisibleRowsElement = _NumberOfVisibleRowsElement;
class PageNumberButtonEvents {
  // REF-30
  static markClick(D) {
    D.clickedPageNumberButton = !0, setTimeout(() => D.clickedPageNumberButton = !1);
  }
  static buttonMouseUp(D, O) {
    PageNumberButtonEvents.markClick(this._pagination);
    const x = O.target, { pageButtons: B } = this._pagination.styles;
    this._pagination.activePageNumber === D || PaginationUtils.getAndApplyDataOnButtonClick(this, D), PageButtonStyle.mouseEnter(x, B, !1);
  }
  static setEvents(D, O, x) {
    x.onmouseup = PageNumberButtonEvents.buttonMouseUp.bind(D, O);
  }
}
class PageNumberButtonElement {
  static create(D, O) {
    const x = PageButtonElement.create(D._pagination.styles.pageButtons, !1);
    return x.innerHTML = String(O), setTimeout(() => PageNumberButtonEvents.setEvents(D, O, x)), x;
  }
}
class PaginationUpdatePageButtons {
  static removeLastNumberButton(D, O) {
    O[O.length - 1].remove();
    const x = O[0], B = Number(x.innerText);
    if (B > 1) {
      const U = PageNumberButtonElement.create(D, B - 1);
      x.insertAdjacentElement("beforebegin", U);
    }
  }
  static updateOnRowRemove(D) {
    const O = PaginationUtils.getPageNumberButtons(D._pagination), x = O[O.length - 1];
    Number(x.innerText) > PaginationUtils.getLastPossiblePageNumber(D) ? O.length > 1 && PaginationUpdatePageButtons.removeLastNumberButton(D, O) : D.data.length < (D.dataStartsAtHeader ? 1 : 2) && PageButtonElement.setDisabled(D._pagination);
  }
  static addNewNumberButtonAtEndIfNeeded(D, O) {
    const x = O[O.length - 1], B = PaginationUtils.getLastPossiblePageNumber(D, !0);
    if (Number(x.innerText) < B) {
      const U = PageNumberButtonElement.create(D, B);
      x.insertAdjacentElement("afterend", U);
    }
  }
  static updateOnRowInsert(D) {
    const O = D.dataStartsAtHeader ? 0 : 1;
    if (D.data.length === O)
      PageButtonElement.unsetDisabled(D._pagination);
    else {
      const x = PaginationUtils.getPageNumberButtons(D._pagination);
      x.length < D._pagination.maxNumberOfVisiblePageButtons && PaginationUpdatePageButtons.addNewNumberButtonAtEndIfNeeded(D, x);
    }
  }
  // prettier-ignore
  static shiftLeftwards(D, O, x) {
    const { activePageNumber: B } = D._pagination, U = O[0], F = Number(U.innerText);
    let W = B <= O.length / 2 ? F - 1 : x - B, G = F;
    W > O.length && (W = O.length, G = O.length + 1);
    for (let Y = W - 1; Y >= 0; Y -= 1) {
      const X = PageNumberButtonElement.create(D, G - Y - 1);
      U.insertAdjacentElement("beforebegin", X);
    }
    O.slice(O.length - W).forEach((Y) => Y.remove());
  }
  // prettier-ignore
  static shiftRightwards(D, O, x, B) {
    const { activePageNumber: U } = D._pagination, F = PaginationUtils.getLastPossiblePageNumber(D);
    let W = U > F - O.length / 2 ? F - x : U - B, G = x;
    W > O.length && (W = O.length, G = U - O.length);
    const Y = O[O.length - 1];
    for (let X = W - 1; X >= 0; X -= 1) {
      const J = PageNumberButtonElement.create(D, X + G + 1);
      Y.insertAdjacentElement("afterend", J);
    }
    O.slice(0, W).forEach((X) => X.remove());
  }
  static updateOnNewActive(D) {
    const O = PaginationUtils.getPageNumberButtons(D._pagination), { activePageNumber: x, maxNumberOfVisiblePageButtons: B } = D._pagination;
    if (O.length < B)
      return;
    const U = Number(O[O.length - 1].innerText), F = Math.floor(U - O.length / 2) + 1;
    if (x > F)
      PaginationUpdatePageButtons.shiftRightwards(D, O, U, F);
    else {
      const W = Math.ceil(U - O.length / 2);
      x < W && PaginationUpdatePageButtons.shiftLeftwards(D, O, W);
    }
  }
}
const _LoadingElement = class he {
  static createSpinner(D) {
    const O = document.createElement("span");
    return O.className = "loading-spinner", Object.assign(O.style, D), O;
  }
  static applyTableStyles(D, O, x) {
    D.forEach((B) => {
      O[B] && (x.style[B] = O[B]);
    });
  }
  static removeTableStyles(D, O) {
    D.forEach((x) => {
      delete O.style[x];
    });
  }
  static processCustom(D, O) {
    return D.style.display === "none" && (D.style.display = "block"), Object.assign(D.style, O == null ? void 0 : O.container), D;
  }
  // prettier-ignore
  static createContainer(D, O) {
    const x = document.createElement("div");
    return O && he.applyTableStyles(
      ["width", "minWidth", "maxHeight", "height", "minHeight", "maxHeight", "border", "borderColor", "borderWidth"],
      O,
      x
    ), Object.assign(x.style, D == null ? void 0 : D.container), x;
  }
  static createNew(D, O) {
    const x = he.createContainer(D, O);
    x.classList.add(he.DEFAULT_LOADING_CONTAINER_CLASS);
    const B = he.createSpinner(D == null ? void 0 : D.spinner);
    return x.appendChild(B), x;
  }
  static processInitial(D) {
    const { loadingStyles: O, tableStyle: x } = D, B = D.children[0];
    return B ? he.processCustom(B, O) : he.createNew(O, x);
  }
  static addInitial(D) {
    var O;
    D._activeOverlayElements.loading = he.processInitial(D), (O = D.shadowRoot) == null || O.appendChild(D._activeOverlayElements.loading);
  }
  static update(D, O, x) {
    D.classList.contains(he.DEFAULT_LOADING_CONTAINER_CLASS) && O && (he.removeTableStyles(
      ["width", "minWidth", "maxHeight", "height", "minHeight", "maxHeight", "border", "borderColor", "borderWidth"],
      D
    ), Object.assign(D.style, x == null ? void 0 : x.container)), x != null && x.loadingBackgroundColor && (D.style.backgroundColor = x == null ? void 0 : x.loadingBackgroundColor);
  }
  static addActive(D) {
    var x;
    const { loading: O } = D._activeOverlayElements;
    O && (O.classList.contains(OuterContainerElements.ABSOULUTE_FULL_TABLE_CLASS) || (O.classList.add(OuterContainerElements.ABSOULUTE_FULL_TABLE_CLASS), he.update(O, D.tableStyle, D.loadingStyles)), (x = D._tableElementRef) == null || x.appendChild(O));
  }
};
_LoadingElement.DEFAULT_LOADING_CONTAINER_CLASS = "default-loading-container";
let LoadingElement = _LoadingElement;
class ErrorElement {
  static create() {
    const D = document.createElement("div");
    D.id = "error-container", D.classList.add(OuterContainerElements.ABSOULUTE_FULL_TABLE_CLASS);
    const O = document.createElement("div");
    return O.id = "error-text", O.innerHTML = "Error retrieving data", D.appendChild(O), D;
  }
  static display(D) {
    const { error: O } = D._activeOverlayElements;
    O && D._tableElementRef && D._tableElementRef.appendChild(O);
  }
  static remove(D) {
    var O;
    (O = D._activeOverlayElements.error) == null || O.remove();
  }
}
class PaginationAsyncUtils {
  static displayError(D, O) {
    ErrorElement.display(O), console.error(D), console.error("Error fetching page information");
  }
  // prettier-ignore
  static setNewElementText(D, O, x, B, U) {
    CellEvents.updateCell(
      D,
      O,
      U,
      B,
      { element: x, processText: !1, updateCellEvent: !1, updateTableEvent: !1 }
    ), ColumnTypesUtils.updateDataElements(D, U, B, x);
  }
  static insertData(D, O, x) {
    const B = D.dataStartsAtHeader ? 0 : 1, U = (x - 1) * 10 + B;
    O.length > D._pagination.rowsPerPage && (O = O.slice(0, D._pagination.rowsPerPage)), U + O.length > D.data.length && (O = O.slice(0, O.length - (U + O.length - D.data.length))), O.forEach((F, W) => {
      F.forEach((G, Y) => {
        const X = U + W, J = D._columnsDetails[Y].elements[X];
        PaginationAsyncUtils.setNewElementText(D, G, J, Y, X);
      });
    }), UpdateIndexColumnWidth.update(D);
  }
  static async getAndApplyNewData(D, O, x, B) {
    var W;
    const U = B || x;
    D._pagination.asyncGetId = U, ErrorElement.remove(D), LoadingElement.addActive(D), PageButtonElement.setActive(D, x);
    let F = [[]];
    try {
      if (F = await O.getPageData(x, D._pagination.rowsPerPage), D._pagination.asyncGetId !== U)
        return;
    } catch (G) {
      PaginationAsyncUtils.displayError(G, D);
    }
    PaginationAsyncUtils.insertData(D, F, x), (W = D._activeOverlayElements.loading) == null || W.remove(), PaginationUtils.displayRowsForDifferentButton(D, x);
  }
  static isAsyncPagination(D) {
    return typeof D == "object" && D.async;
  }
  static removeLoadingOverlay(D) {
    var O;
    PaginationAsyncUtils.isAsyncPagination(D.pagination) && ((O = D._activeOverlayElements.loading) == null || O.remove());
  }
  static preprocessTablePropertiesIfAsync(D) {
    var O;
    PaginationAsyncUtils.isAsyncPagination(D.pagination) && (D.displayAddNewRow = !1, D.displayAddNewColumn = !1, D.rowDropdown.displaySettings.isAvailable = !1, D.columnDropdown = { displaySettings: { isAvailable: !1 } }, D.files ?? (D.files = {}), D.files.buttons = (O = D.files.buttons) == null ? void 0 : O.filter((x) => !x.import), D.files.dragAndDrop = !1);
  }
}
const _PaginationUtils = class ne {
  static getLastPossiblePageNumber(D, O = !1) {
    const { _pagination: x, dataStartsAtHeader: B } = D;
    if (x.isAllRowsOptionSelected)
      return 1;
    const U = PaginationInternalUtils.getTotalNumberOfRows(D), F = B ? U + 1 : U, W = O ? F : F - 1;
    return Math.max(Math.ceil(W / x.rowsPerPage), 1);
  }
  static getPageNumberButtons(D) {
    const { buttonContainer: O, numberOfActionButtons: x } = D, B = Array.from(O.children), U = x / 2;
    return B.slice(U, B.length - U);
  }
  static hideRow(D) {
    var O;
    ((O = D.children[0]) == null ? void 0 : O.tagName) === CellElement.HEADER_TAG ? D.classList.add(ne.HIDDEN_ROW_CLASS) : D.style.display = "none";
  }
  static displayRow(D, O) {
    D.children[0].tagName === CellElement.HEADER_TAG ? D.classList.remove(ne.HIDDEN_ROW_CLASS) : D.style.display = "", O.push(D);
  }
  // changes to the page that the row was moved to
  static updateOnRowMove(D, O) {
    const { activePageNumber: x } = D._pagination;
    PaginationRowIndexes.getMaxVisibleRowIndex(D) <= O ? ne.displayRowsForDifferentButton(D, x + 1) : O > 0 && D._tableBodyElementRef && O < PaginationRowIndexes.getVisibleRowRealIndex(D._tableBodyElementRef, D._pagination, 0) && ne.displayRowsForDifferentButton(D, x - 1);
  }
  // prettier-ignore
  static getSiblingVisibleRow(D, O) {
    const x = D == null ? void 0 : D[O];
    if (!(!x || AddNewRowElement.isAddNewRowRow(x)))
      return x.classList.contains(FilterInternalUtils.HIDDEN_ROW_CLASS) ? ne.getSiblingVisibleRow(x, O) : x;
  }
  static updateRowsOnRemoval(D, O) {
    const { visibleRows: x, activePageNumber: B } = D._pagination;
    if (!(B === 1 && O === -1))
      if (x.splice(O, 1), x.length > 0) {
        const U = x[x.length - 1], F = ne.getSiblingVisibleRow(U, "nextSibling");
        F && ne.displayRow(F, x);
      } else
        B > 1 && (ne.displayRowsForDifferentButton(D, B - 1), D._visiblityInternal.filters && ne.getLastPossiblePageNumber(D) !== B - 1 && ne.displayRowsForDifferentButton(D, B));
  }
  static hideLastVisibleRow(D) {
    const { visibleRows: O } = D;
    if (O.length === 0)
      return;
    const x = O[O.length - 1];
    ne.hideRow(x), D.visibleRows.splice(D.visibleRows.length - 1, 1);
  }
  static updateRowsOnNewInsert(D, O, x) {
    const { rowsPerPage: B, visibleRows: U, activePageNumber: F, isAllRowsOptionSelected: W } = D._pagination;
    if (PaginationRowIndexes.getMaxVisibleRowIndex(D) > O && D._tableBodyElementRef) {
      U.length === B && !W && ne.hideLastVisibleRow(D._pagination);
      const G = PaginationRowIndexes.getVisibleRowIndex(D._tableBodyElementRef, D._pagination, O);
      U.splice(G === -1 ? U.length : G, 0, x);
    } else
      ne.hideRow(x), setTimeout(() => {
        const G = ne.getLastPossiblePageNumber(D), Y = F + 1;
        G < Y ? ne.setCorrectRowsAsVisible(D, G) : ne.displayRowsForDifferentButton(D, Y);
      });
  }
  // for removal - we pass visible row index as when filter is set - we need to get it before the element is removed
  static updateOnRowChange(D, O, x) {
    const { dataStartsAtHeader: B, _pagination: U } = D;
    !B && O === 0 && PaginationInternalUtils.getTotalNumberOfRows(D) === 0 || (PaginationVisibleButtonsUtils.unsetStateAndStyles(U), x ? (PaginationUpdatePageButtons.updateOnRowInsert(D), ne.updateRowsOnNewInsert(D, O, x)) : (PaginationUpdatePageButtons.updateOnRowRemove(D), ne.updateRowsOnRemoval(D, O)), PaginationPageActionButtonUtils.toggleActionButtons(D), PaginationVisibleButtonsUtils.setStateAndStyles(D), setTimeout(() => NumberOfVisibleRowsElement.update(D)));
  }
  static initialRowUpdates(D, O, x) {
    const B = D.dataStartsAtHeader ? O + 1 : O;
    B > D._pagination.rowsPerPage ? ne.hideRow(x) : B > 0 && D._pagination.visibleRows.push(x);
  }
  // REF-32
  static updateAddRowRow(D) {
    if (D._stripedRows && D._tableBodyElementRef && D._addRowCellElementRef) {
      const O = D._addRowCellElementRef.parentElement, x = Array.from(D._tableBodyElementRef.children).length - 1, B = ne.getLastPossiblePageNumber(D) !== D._pagination.activePageNumber;
      CustomRowProperties.updateRow(D, O, x, B, x);
    }
  }
  // prettier-ignore
  static setCorrectRowsAsVisible(D, O) {
    const { _pagination: { rowsPerPage: x, visibleRows: B }, _tableBodyElementRef: U, data: F, _visiblityInternal: W } = D, G = W != null && W.filters ? FilterInternalUtils.extractUnfilteredRows(U, F.length) : ExtractElements.textRowsArrFromTBody(U, F);
    let Y = x * (O - 1);
    D.dataStartsAtHeader || (Y += 1), G.slice(Y, Y + x).forEach((X) => {
      ne.displayRow(X, B);
    });
  }
  static hideAllRows(D) {
    D.visibleRows.forEach((O) => ne.hideRow(O)), D.visibleRows = [];
  }
  static displayRowsForDifferentButton(D, O) {
    ne.hideAllRows(D._pagination), ne.setCorrectRowsAsVisible(D, O), PageButtonElement.setActive(D, O), NumberOfVisibleRowsElement.update(D), D._frameComponents.displayAddNewRow && ne.updateAddRowRow(D);
  }
  static getFirstVisibleRow(D) {
    return D.find((O) => !O.classList.contains(FilterInternalUtils.HIDDEN_ROW_CLASS));
  }
  static async getAndApplyDataOnButtonClick(D, O, x) {
    D._pagination.async ? PaginationAsyncUtils.getAndApplyNewData(D, D._pagination.async, O, x) : ne.displayRowsForDifferentButton(D, O);
  }
};
_PaginationUtils.HIDDEN_ROW_CLASS = "hidden-row";
let PaginationUtils = _PaginationUtils;
class PaginationPageActionButtonUtils {
  static setButtonAsEnabled(D, O) {
    PageButtonStyle.setDefault(D, O, !0), D.classList.remove(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS);
  }
  static setButtonAsDisabled(D, O) {
    PageButtonStyle.setDisabled(D, O, !0), D.classList.add(PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS);
  }
  // prettier-ignore
  static toggleRightButtons(D, O, x) {
    const { activePageNumber: B, styles: U } = D._pagination, F = PaginationUtils.getLastPossiblePageNumber(D), W = B === F ? PaginationPageActionButtonUtils.setButtonAsDisabled : PaginationPageActionButtonUtils.setButtonAsEnabled;
    O.slice(O.length - x).forEach((Y) => W(Y, U.pageButtons));
  }
  // prettier-ignore
  static toggleLeftButtons(D, O, x, B) {
    const U = O === 1 ? PaginationPageActionButtonUtils.setButtonAsDisabled : PaginationPageActionButtonUtils.setButtonAsEnabled;
    D.slice(0, x).forEach((W) => U(W, B.pageButtons));
  }
  static toggleActionButtons(D) {
    const { activePageNumber: O, styles: x, numberOfActionButtons: B, buttonContainer: U } = D._pagination, F = Array.from(U.children), W = B / 2;
    PaginationPageActionButtonUtils.toggleLeftButtons(F, O, W, x), PaginationPageActionButtonUtils.toggleRightButtons(D, F, W);
  }
}
class PageButtonEvents {
  static buttonMouseLeave(D, O, x) {
    const B = x.target;
    PageButtonStyle.mouseLeave(B, D, O);
  }
  static buttonMouseEnter(D, O, x) {
    const B = x.target;
    PageButtonStyle.mouseEnter(B, D, O);
  }
  static buttonMouseDown(D, O, x) {
    const B = x.target;
    PageButtonStyle.mouseDown(B, D, O);
  }
  static setEvents(D, O, x) {
    D.onmousedown = PageButtonEvents.buttonMouseDown.bind(this, O, x), D.onmouseenter = PageButtonEvents.buttonMouseEnter.bind(this, O, x), D.onmouseleave = PageButtonEvents.buttonMouseLeave.bind(this, O, x);
  }
}
const _PageButtonElement = class ke {
  static unsetDisabled(D) {
    const O = PaginationUtils.getPageNumberButtons(D)[0], { pageButtons: x } = D.styles;
    PageButtonStyle.setActive(O, x), O.classList.replace(ke.DISABLED_PAGINATION_BUTTON_CLASS, x.activeButtonClass);
  }
  static setDisabled(D) {
    const { buttonContainer: O, styles: x, numberOfActionButtons: B } = D, U = Array.from(O.children);
    for (let W = 0; W < B / 2; W += 1)
      PageButtonStyle.setDisabled(U[W], x.pageButtons, !0), PageButtonStyle.setDisabled(U[U.length - 1 - W], x.pageButtons, !0);
    const F = PaginationUtils.getPageNumberButtons(D)[0];
    PageButtonStyle.setDisabled(F, x.pageButtons, !1), F.classList.remove(x.pageButtons.activeButtonClass), U.forEach((W) => {
      W.classList.add(ke.DISABLED_PAGINATION_BUTTON_CLASS);
    });
  }
  // prettier-ignore
  static programmaticMouseEnterTrigger(D, O, x) {
    const B = D[x], { pageButtons: U } = O.styles;
    B && !B.classList.contains(U.activeButtonClass) && (PageButtonStyle.mouseEnter(B, U, !1), O.programaticallyHoveredPageNumberButton = B, setTimeout(() => delete O.programaticallyHoveredPageNumberButton));
  }
  static setNewActive(D, O) {
    const x = PaginationUtils.getPageNumberButtons(D), B = Number(x[x.length - 1].innerText), U = x.length - (B - O) - 1, F = x[U];
    return F.classList.add(D.styles.pageButtons.activeButtonClass), { newActiveButton: F, numberButtons: x };
  }
  static unsetPreviousActive(D, O) {
    const x = PaginationUtils.getPageNumberButtons(D), B = Number(x[x.length - 1].innerText), U = x.length - (B - D.activePageNumber) - 1, F = x[U], W = x.length - (B - O) - 1;
    return F ? (F.classList.remove(D.styles.pageButtons.activeButtonClass), { previousActiveButton: F, previousLocationOfNewIndex: W }) : { previousLocationOfNewIndex: W };
  }
  // prettier-ignore
  static setActive(D, O) {
    const { _pagination: x } = D, { styles: { pageButtons: B }, clickedPageNumberButton: U } = x, { previousActiveButton: F, previousLocationOfNewIndex: W } = ke.unsetPreviousActive(
      x,
      O
    );
    PaginationVisibleButtonsUtils.unsetStateAndStyles(D._pagination), x.activePageNumber = O, PaginationUpdatePageButtons.updateOnNewActive(D);
    const { newActiveButton: G, numberButtons: Y } = ke.setNewActive(x, O);
    PageButtonStyle.setActive(G, B, F), PaginationPageActionButtonUtils.toggleActionButtons(D), PaginationVisibleButtonsUtils.setStateAndStyles(D), U && ke.programmaticMouseEnterTrigger(Y, x, W);
  }
  static create(D, O) {
    const x = document.createElement("div");
    return x.classList.add(
      ke.PAGINATION_BUTTON_CLASS,
      PaginationElements.PAGINATION_TEXT_COMPONENT_CLASS,
      GenericElementUtils.NOT_SELECTABLE_CLASS
    ), PageButtonStyle.setDefault(x, D, O), setTimeout(() => PageButtonEvents.setEvents(x, D, O)), x;
  }
};
_PageButtonElement.PAGINATION_BUTTON_CLASS = "pagination-button";
_PageButtonElement.DISABLED_PAGINATION_BUTTON_CLASS = "pagination-button-disabled";
_PageButtonElement.ACTIVE_PAGINATION_BUTTON_CLASS = "pagination-button-active";
_PageButtonElement.PRECEDENCE_ACTIVE_PAGINATION_BUTTON_CLASS = "pagination-button-active-precedence";
let PageButtonElement = _PageButtonElement;
const _PaginationVisibleButtonsUtils = class ie {
  static getRightBorderWidthInStyleOverride(D) {
    return D.borderRightWidth ? Number.parseInt(D.borderRightWidth) : D.borderRight ? Number.parseInt(D.borderRight.split(" ")[0]) : -1;
  }
  // if the last button is active page (no action buttons displayed) and it has precedence, the override right border
  // will not take place and it will either have no right border or active style right border:
  // this is problematic as the border difference will cause the entire container to have a different width
  // which will in turn cause the pagination components to shift when the last button is clicked,
  // to prevent this we add the border style that would have been overriden
  static setBorderPaddingForLastPrecedence(D, O) {
    const x = ie.getRightBorderWidthInStyleOverride(O);
    if (isNaN(x) || x === 0)
      return;
    const B = Number.parseInt(getComputedStyle(D).borderRightWidth);
    B > 0 ? D.style.borderRightWidth = `${B + x}px` : D.style.borderRight = `${x}px solid #fafafa01`;
  }
  static setStyle(D, O, x, B) {
    if (!B)
      return;
    const U = new Set(Object.keys(B)), F = D.classList.contains(PageButtonElement.PRECEDENCE_ACTIVE_PAGINATION_BUTTON_CLASS);
    F && O.forEach((W) => U.delete(W)), U.forEach((W) => {
      ElementStyle.setStyle(D, W, B[W]);
    }), x && F && ie.setBorderPaddingForLastPrecedence(D, B);
  }
  // prettier-ignore
  static overrideOnMouseEvent(D, O) {
    const { firstVisibleButtonOverride: x, lastVisibleButtonOverride: B } = O;
    D.classList.contains(ie.FIRST_VISIBLE_CLASS) && ie.setStyle(
      D,
      ie.FIRST_PRECEDENCE_VALUES,
      !1,
      x
    ), D.classList.contains(ie.LAST_VISIBLE_CLASS) && ie.setStyle(
      D,
      ie.LAST_PRECEDENCE_VALUES,
      !0,
      B
    );
  }
  // prettier-ignore
  static unsetStateAndStyles(D) {
    const {
      styles: { pageButtons: { firstVisibleButtonOverride: O, lastVisibleButtonOverride: x } },
      visibleEdgeButtons: B
    } = D;
    B.length !== 0 && (O && ElementStyle.unsetStyle(B[0], O), B[0].classList.remove(ie.FIRST_VISIBLE_CLASS), x && ElementStyle.unsetStyle(B[1], x), B[1].classList.remove(ie.LAST_VISIBLE_CLASS), D.visibleEdgeButtons = []);
  }
  // when the button display property is false - clientWidth is 0
  static isButtonVisible(D) {
    return D.clientWidth > 0 && D.style.visibility !== "hidden";
  }
  // prettier-ignore
  static set(D, O, x) {
    const { styles: { pageButtons: { firstVisibleButtonOverride: B, lastVisibleButtonOverride: U } } } = x, F = D[O];
    if (!F)
      return;
    F.classList.contains(ie.FIRST_VISIBLE_CLASS) || (ie.setStyle(
      F,
      ie.FIRST_PRECEDENCE_VALUES,
      !1,
      B
    ), F.classList.add(ie.FIRST_VISIBLE_CLASS));
    const W = D.findLastIndex(ie.isButtonVisible), G = D[W];
    G.classList.contains(ie.LAST_VISIBLE_CLASS) || (ie.setStyle(
      G,
      ie.LAST_PRECEDENCE_VALUES,
      !0,
      U
    ), G.classList.add(ie.LAST_VISIBLE_CLASS)), x.visibleEdgeButtons = [F, G];
  }
  static setStateAndStyles(D) {
    const { _pagination: O, displayAddNewRow: x } = D, B = Array.from(O.buttonContainer.children), U = B.findIndex(ie.isButtonVisible);
    U === -1 ? setTimeout(() => {
      const F = B.findIndex(ie.isButtonVisible);
      ie.set(B, F, O);
    }) : ie.set(B, U, O), x || RowElement.toggleLastRowClass(D);
  }
};
_PaginationVisibleButtonsUtils.FIRST_VISIBLE_CLASS = "pagination-first-visible-button";
_PaginationVisibleButtonsUtils.LAST_VISIBLE_CLASS = "pagination-last-visible-button";
_PaginationVisibleButtonsUtils.FIRST_PRECEDENCE_VALUES = ["borderLeft", "borderLeftWidth", "borderLeftColor"];
_PaginationVisibleButtonsUtils.LAST_PRECEDENCE_VALUES = ["borderRight", "borderRightWidth", "borderRightColor"];
let PaginationVisibleButtonsUtils = _PaginationVisibleButtonsUtils;
function buildIcon$1(z) {
  return `<?xml version="1.0" encoding="utf-8"?>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: ${z}">
      <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
}
const PREVIOUS_PAGE_ICON_SVG_STRING = buildIcon$1("rotate(180deg)"), NEXT_PAGE_ICON_SVG_STRING = buildIcon$1("");
class PreviousPageButtonEvents {
  static buttonMouseUp(D) {
    const { activePageNumber: O, styles: x } = this._pagination;
    if (O === 1)
      return;
    PaginationUtils.getAndApplyDataOnButtonClick(this, O - 1);
    const B = D.target;
    PageButtonStyle.mouseEnter(B, x.pageButtons, !0);
  }
  static setEvents(D, O) {
    O.onmouseup = PreviousPageButtonEvents.buttonMouseUp.bind(D);
  }
}
class PreviousPageButtonElement {
  static populate(D, O) {
    if (O)
      D.innerHTML = String(O);
    else {
      const x = SVGIconUtils.createSVGElement(PREVIOUS_PAGE_ICON_SVG_STRING);
      x.classList.add("pagination-prev-next-button"), D.appendChild(x);
    }
  }
  static create(D) {
    const { pageButtons: O } = D._pagination.styles, x = PageButtonElement.create(O, !0);
    return PreviousPageButtonElement.populate(x, O.actionButtons.previousText), setTimeout(() => PreviousPageButtonEvents.setEvents(D, x)), x;
  }
}
function buildIcon(z) {
  return `<?xml version="1.0" encoding="utf-8"?>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: ${z}">
      <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
}
const FIRST_PAGE_ICON_SVG_STRING = buildIcon("rotate(180deg)"), LAST_PAGE_ICON_SVG_STRING = buildIcon("");
class FirstPageButtonEvents {
  static buttonMouseUp(D) {
    const O = D.target;
    PageButtonStyle.mouseEnter(O, this._pagination.styles.pageButtons, !0), this._pagination.activePageNumber !== 1 && PaginationUtils.getAndApplyDataOnButtonClick(this, 1);
  }
  static setEvents(D, O) {
    O.onmouseup = FirstPageButtonEvents.buttonMouseUp.bind(D);
  }
}
class FirstPageButtonElement {
  static populate(D, O) {
    if (O)
      D.innerHTML = String(O);
    else {
      const x = SVGIconUtils.createSVGElement(FIRST_PAGE_ICON_SVG_STRING);
      x.classList.add("pagination-first-last-button"), D.appendChild(x);
    }
  }
  static create(D) {
    const { pageButtons: O } = D._pagination.styles, x = PageButtonElement.create(O, !0);
    return FirstPageButtonElement.populate(x, O.actionButtons.firstText), setTimeout(() => FirstPageButtonEvents.setEvents(D, x)), x;
  }
}
class LastPageButtonEvents {
  static buttonMouseUp(D) {
    const O = D.target, { activePageNumber: x, styles: B } = this._pagination;
    PageButtonStyle.mouseEnter(O, B.pageButtons, !0);
    const U = PaginationUtils.getLastPossiblePageNumber(this);
    U <= x || PaginationUtils.getAndApplyDataOnButtonClick(this, U);
  }
  static setEvents(D, O) {
    O.onmouseup = LastPageButtonEvents.buttonMouseUp.bind(D);
  }
}
class LastPageButtonElement {
  static populate(D, O) {
    if (O)
      D.innerHTML = String(O);
    else {
      const x = SVGIconUtils.createSVGElement(LAST_PAGE_ICON_SVG_STRING);
      x.classList.add("pagination-first-last-button"), D.appendChild(x);
    }
  }
  static create(D) {
    const { pageButtons: O } = D._pagination.styles, x = PageButtonElement.create(O, !0);
    return LastPageButtonElement.populate(x, O.actionButtons.lastText), setTimeout(() => LastPageButtonEvents.setEvents(D, x)), x;
  }
}
class NextPageButtonEvents {
  static buttonMouseUp(D) {
    const { activePageNumber: O, styles: x } = this._pagination;
    if (PaginationUtils.getLastPossiblePageNumber(this) <= O)
      return;
    PaginationUtils.getAndApplyDataOnButtonClick(this, O + 1);
    const B = D.target;
    PageButtonStyle.mouseEnter(B, x.pageButtons, !0);
  }
  static setEvents(D, O) {
    O.onmouseup = NextPageButtonEvents.buttonMouseUp.bind(D);
  }
}
class NextPageButtonElement {
  static populate(D, O) {
    if (O)
      D.innerHTML = String(O);
    else {
      const x = SVGIconUtils.createSVGElement(NEXT_PAGE_ICON_SVG_STRING);
      x.classList.add("pagination-prev-next-button"), D.appendChild(x);
    }
  }
  static create(D) {
    const { pageButtons: O } = D._pagination.styles, x = PageButtonElement.create(O, !0);
    return NextPageButtonElement.populate(x, O.actionButtons.nextText), setTimeout(() => NextPageButtonEvents.setEvents(D, x)), x;
  }
}
class PageButtonContainerEvents {
  // REF-31
  static containerMouseLeave(D) {
    const { clickedPageNumberButton: O, programaticallyHoveredPageNumberButton: x, styles: B } = D;
    O && x && PageButtonStyle.mouseLeave(x, B.pageButtons, !1);
  }
  static setEvents(D, O) {
    D.onmouseleave = PageButtonContainerEvents.containerMouseLeave.bind(this, O);
  }
}
const _PageButtonContainerElement = class ge {
  static shouldButtonsBeActive(D) {
    const O = D.dataStartsAtHeader ? 1 : 2;
    return D.data.length >= O;
  }
  static setStyle(D, O) {
    ge.shouldButtonsBeActive(D) ? PageButtonElement.setActive(D, O ?? 1) : PageButtonElement.setDisabled(D._pagination);
  }
  static addNumberButtons(D) {
    const O = PaginationUtils.getLastPossiblePageNumber(D), { maxNumberOfVisiblePageButtons: x, buttonContainer: B } = D._pagination;
    for (let U = 0; U < Math.min(O, x); U += 1) {
      const F = PageNumberButtonElement.create(D, U + 1);
      B.appendChild(F);
    }
  }
  static addButton(D, O) {
    D.buttonContainer.appendChild(O), D.numberOfActionButtons += 1;
  }
  static addButtons(D) {
    const { displayPrevNext: O, displayFirstLast: x } = D._pagination;
    x && ge.addButton(D._pagination, FirstPageButtonElement.create(D)), O && ge.addButton(D._pagination, PreviousPageButtonElement.create(D)), ge.addNumberButtons(D), O && ge.addButton(D._pagination, NextPageButtonElement.create(D)), x && ge.addButton(D._pagination, LastPageButtonElement.create(D));
  }
  static resetState(D) {
    D.activePageNumber = 1, D.numberOfActionButtons = 0, D.visibleEdgeButtons = [];
  }
  static repopulateButtons(D) {
    ge.resetState(D._pagination), D._pagination.buttonContainer.replaceChildren(), ge.addButtons(D), ge.setStyle(D);
  }
  static addInitialElements(D, O) {
    ge.repopulateButtons(D), PaginationVisibleButtonsUtils.setStateAndStyles(D);
    const { positions: x, buttonContainer: B } = D._pagination;
    OuterContainerElements.addToContainer(x.pageButtons.position, O, B);
  }
  static create(D) {
    const O = document.createElement("div");
    O.id = ge.PAGINATION_BUTTON_CONTAINER_ID;
    const { styles: x, positions: B } = D._pagination;
    return O.style.order = String(B.pageButtons.order), Object.assign(O.style, x.pageButtons.container), PageButtonContainerEvents.setEvents(O, D._pagination), O;
  }
};
_PageButtonContainerElement.PAGINATION_BUTTON_CONTAINER_ID = "pagination-button-container";
let PageButtonContainerElement = _PageButtonContainerElement;
class InitialDataProcessing {
  static cleanupDataThatDidNotGetAdded(D, O) {
    var x;
    ((x = D[0]) == null ? void 0 : x.length) - O.length > 0 && D.forEach((B) => B.splice(O.length)), O.length === 0 ? D.splice(0, D.length) : D.length > O[0].elements.length && D.splice(O[0].elements.length);
  }
  static postProcess(D, O) {
    setTimeout(() => InitialDataProcessing.cleanupDataThatDidNotGetAdded(D, O));
  }
  static fillRow(D, O) {
    const x = new Array(O - D.length).fill(EMPTY_STRING);
    D.splice(D.length, O - D.length, ...x);
  }
  static processRowDataByLength(D, O) {
    O === 0 && D.splice(0, D.length), D.forEach((x) => {
      x.length < O && InitialDataProcessing.fillRow(x, O);
    });
  }
  static getMaxRowLength(D) {
    return D.reduce((O, x) => Math.max(O, x.length), 0);
  }
  static removeRowsExceedingLimit(D, O) {
    O !== void 0 && O > 0 && D.length > O && D.splice(O, D.length - 1);
  }
  static removeDuplicateHeaders(D, O) {
    const x = D[0];
    x.reduce((B, U, F) => (B.has(U) ? x[F] = O || "" : B.add(U), B), /* @__PURE__ */ new Set());
  }
  static preProcess(D, O) {
    const { maxRows: x, allowDuplicateHeaders: B, _defaultColumnsSettings: U } = D;
    InitialDataProcessing.removeRowsExceedingLimit(O, x);
    const F = InitialDataProcessing.getMaxRowLength(O);
    InitialDataProcessing.processRowDataByLength(O, F), !B && O.length > 0 && InitialDataProcessing.removeDuplicateHeaders(O, U.defaultText);
  }
}
class PaginationAsyncStartData {
  static fillTotalDataRows(D, O) {
    var F;
    const { totalDataRows: x, data: B, failed: U } = O;
    if (D.data.length < x || U) {
      const W = Math.max(((F = D.data[0]) == null ? void 0 : F.length) || 0, InitialDataProcessing.getMaxRowLength(B)), G = +!D.dataStartsAtHeader, Y = new Array(x - D.data.length + G).fill(
        new Array(W).fill(EMPTY_STRING)
      ), X = D.data.length;
      D.data.splice(D.data.length, 0, ...Y), Y.forEach((J, Q) => {
        const le = InsertNewRow.insertNewRow(D, X + Q, !1, J);
        setTimeout(() => {
          UpdateCellsForRows.updateRowCells(D, le, X + Q, CELL_UPDATE_TYPE.UPDATE, !1);
        });
      }), PageButtonContainerElement.repopulateButtons(D);
    }
  }
  static populate(D, O) {
    const { data: x, totalDataRows: B, failed: U } = O;
    x.length > 0 && B > 0 && (D.data.length > 0 || InitialDataProcessing.getMaxRowLength(x) > 0) && (PaginationAsyncStartData.fillTotalDataRows(D, O), U || PaginationAsyncUtils.insertData(D, x, 1));
  }
  static async get(D, O, x) {
    const { async: B, rowsPerPage: U } = O;
    if (!B)
      return;
    const { rowsPerPage: F } = x, W = typeof U == "number" ? U : F;
    try {
      const [G, Y] = await Promise.all([B.getTotalRows(), B.getPageData(1, W)]);
      return { totalDataRows: G, data: Y };
    } catch (G) {
      return setTimeout(() => PaginationAsyncUtils.displayError(G, D)), { totalDataRows: 0, data: [["", ""]], failed: !0 };
    }
  }
}
class FrameComponentsElements {
  // index and add column cells are added on row insertion
  // CAUTION-4
  static addFrameBodyElements(D) {
    var O, x;
    (x = D._tableBodyElementRef) == null || x.appendChild((O = D._addRowCellElementRef) == null ? void 0 : O.parentElement), ToggleAdditionElements.update(D, !0, AddNewRowElement.toggle);
  }
}
const _SheetJSInternalUtils = class Dt {
  // REF-17
  static async execFuncWithExtractorModule(D) {
    const O = window.XLSX;
    O ? D(O) : console.error(Dt.MODULE_NOT_FOUND_ERROR);
  }
};
_SheetJSInternalUtils.MODULE_NOT_FOUND_ERROR = "xlsx module was not found";
let SheetJSInternalUtils = _SheetJSInternalUtils;
class UpdateAllTableData {
  static toggleAdditionalElements(D) {
    FilterInternalUtils.completeReset(D), ToggleAdditionElements.update(D, !0, AddNewRowElement.toggle), setTimeout(() => {
      D._pagination && D._pagination.activePageNumber !== 1 && PaginationUtils.displayRowsForDifferentButton(D, 1);
    });
  }
  static insertData(D, O, x) {
    InsertMatrix.insert(D, O, x, 0, !0), x === 0 && RootCellElement.convertFromRootCell(D);
  }
  static changeTableData(D, O, x, B) {
    for (let U = D.data.length - 1; U >= x; U -= 1)
      RemoveRow.remove(D, U);
    InitialDataProcessing.preProcess(D, O), D._isPopulatingTable = !0, B ? (UpdateAllTableData.insertData(D, O, x), UpdateAllTableData.toggleAdditionalElements(D), D._isPopulatingTable = !0) : (setTimeout(() => {
      UpdateAllTableData.insertData(D, O, x);
    }), setTimeout(() => {
      UpdateAllTableData.toggleAdditionalElements(D), D._isPopulatingTable = !0;
    }, 6));
  }
  static update(D, O, x, B = !1) {
    if (!Array.isArray(O))
      return;
    let U = !1;
    D._visiblityInternal.filters && (U = FilterInternalUtils.unsetAllFilters(D)), !B && U ? setTimeout(() => UpdateAllTableData.changeTableData(D, O, x, B), 40) : UpdateAllTableData.changeTableData(D, O, x, B);
  }
}
class CSVImport {
  static getPaddedArray(D, O) {
    return D.map((x) => x.concat(Array(O).fill("")).slice(0, O));
  }
  static splitRow(D) {
    const O = /("[^"]*"|[^,]+)(,|$)/g, x = [];
    return D.replace(O, (B, U) => (x.push(U), "")), x;
  }
  static parseDataFromRow(D, O, x) {
    const B = CSVImport.splitRow(D);
    return B.length > 0 && (O.push(B), B.length > x && (x = B.length)), x;
  }
  // TO-DO validation and error handling
  static parseCSV(D) {
    try {
      const O = D.split(/\r\n|\n/), x = [];
      let B = 0;
      return O.forEach((U) => {
        B = CSVImport.parseDataFromRow(U, x, B);
      }), CSVImport.getPaddedArray(x, B);
    } catch {
      return console.error("Incorrect format"), null;
    }
  }
  static getStartRowIndex(D, O) {
    return O && typeof O.tableRowStartIndex == "number" ? O.tableRowStartIndex < 0 || O.tableRowStartIndex > D ? D : O.tableRowStartIndex : 0;
  }
  static processFile(D, O, x) {
    const B = CSVImport.parseCSV(O);
    if (B && x && typeof x.importRowStartIndex == "number" && B.splice(0, x.importRowStartIndex), !B || B.length === 0)
      return;
    const U = CSVImport.getStartRowIndex(D.data.length, x);
    UpdateAllTableData.update(D, B, U);
  }
  static import(D, O, x) {
    const B = new FileReader();
    B.readAsText(O), B.onload = (U) => {
      var F;
      return CSVImport.processFile(D, (F = U.target) == null ? void 0 : F.result, x);
    };
  }
}
class SheetJSImport {
  static import(D, O, x) {
    const B = new FileReader();
    B.readAsBinaryString(O), B.onload = (U) => {
      var W;
      const F = x.read((W = U.target) == null ? void 0 : W.result, { type: "binary" });
      F.SheetNames.forEach((G) => {
        const Y = x.utils.sheet_to_csv(F.Sheets[G]);
        CSVImport.processFile(D, Y);
      });
    };
  }
}
const ACCEPTED_FILE_FORMATS = ["csv", "xls", "xlsx", "ods", "txt"], DEFAULT_FILE_FORMATS = ["csv"];
class FileImportButtonEvents {
  static importFile(D, O, x, B) {
    x.find((U) => O.name.endsWith(U)) && (O.name.endsWith(".csv") ? CSVImport.import(D, O, B) : SheetJSInternalUtils.execFuncWithExtractorModule(SheetJSImport.import.bind(this, D, O)));
  }
  static inputChange(D, O, x) {
    var F;
    const B = x.target, U = (F = B.files) == null ? void 0 : F[0];
    FileImportButtonEvents.importFile(D, U, ACCEPTED_FILE_FORMATS, O), B.value = "";
  }
  static getAcceptedFormats(D) {
    return D != null && D.formats && D.formats.length > 0 ? D.formats : DEFAULT_FILE_FORMATS;
  }
  static triggerImportPrompt(D, O) {
    const x = D._files.inputElementRef, B = FileImportButtonEvents.getAcceptedFormats(O);
    x.accept = B.map((U) => `.${U}`).join(","), x.onchange = FileImportButtonEvents.inputChange.bind(this, D, O == null ? void 0 : O.overwriteOptions), x.click();
  }
  static setEvents(D, O, x) {
    O.onclick = FileImportButtonEvents.triggerImportPrompt.bind(this, D, x);
  }
}
class DragAndDropEvents {
  static async uploadFile(D, O, x) {
    var F, W, G;
    const B = (W = (F = x.dataTransfer) == null ? void 0 : F.files) == null ? void 0 : W[0], U = typeof ((G = D.files) == null ? void 0 : G.dragAndDrop) == "object" ? D.files.dragAndDrop.overwriteOptions : void 0;
    FileImportButtonEvents.importFile(D, B, O, U);
  }
  static toggleOverlayElement(D, O) {
    D.style.display = O ? "block" : "none";
  }
  static getAcceptedFileFormats(D) {
    var x;
    if (typeof (D == null ? void 0 : D.dragAndDrop) == "object" && D.dragAndDrop.formats)
      return D.dragAndDrop.formats;
    const O = (x = D == null ? void 0 : D.buttons) == null ? void 0 : x.filter((B) => B.import).map((B) => typeof B.import == "object" && B.import.formats ? B.import.formats : DEFAULT_FILE_FORMATS).flat(1);
    return O && O.length > 0 ? Array.from(new Set(O)) : DEFAULT_FILE_FORMATS;
  }
  static setEvents(D, O, x) {
    const B = DragAndDropEvents.getAcceptedFileFormats(D.files);
    O.ondragenter = (U) => {
      U.preventDefault(), DragAndDropEvents.toggleOverlayElement(x, !0);
    }, x.ondragleave = (U) => {
      U.preventDefault(), DragAndDropEvents.toggleOverlayElement(x, !1);
    }, x.ondragover = (U) => {
      U.preventDefault();
    }, x.ondrop = (U) => {
      U.preventDefault(), DragAndDropEvents.uploadFile(D, B, U), DragAndDropEvents.toggleOverlayElement(x, !1);
    };
  }
}
class DragAndDropElement {
  static createOverlayElement(D) {
    const O = document.createElement("div");
    return O.id = "drag-and-drop-overlay", typeof D.dragAndDrop == "object" && Object.assign(O.style, D.dragAndDrop.overlayStyle), O;
  }
  static append(D, O) {
    const x = DragAndDropElement.createOverlayElement(D.files);
    DragAndDropEvents.setEvents(D, O, x), O.appendChild(x);
  }
  static isEnabled(D) {
    var O;
    return (D == null ? void 0 : D.dragAndDrop) !== void 0 ? !!D.dragAndDrop : !!((O = D == null ? void 0 : D.buttons) != null && O.find((x) => x.import));
  }
}
const _StickyPropsUtils = class vt {
  static process(D) {
    var O;
    typeof D.stickyHeader == "boolean" ? D._stickyProps.header = D.stickyHeader : (O = D.overflow) != null && O.maxHeight && (D._stickyProps.header = !0);
  }
  // REF-37
  // prettier-ignore
  static moveTopBorderToHeaderCells(D) {
    const { _tableElementRef: O, _tableBodyElementRef: x } = D;
    !O || !x || (x.classList.add(vt.NO_OVERFLOW_STICKY_HEADER_BODY_CLASS), O.style.border && (x.style.borderTop = O.style.border), O.style.borderColor && (x.style.borderTopColor = O.style.borderColor), ElementStyle.moveStyles(
      O,
      x,
      "borderTop",
      "borderTopColor",
      "borderTopWidth",
      "borderTopStyle"
    ), O.style.borderTop = "unset");
  }
};
_StickyPropsUtils.NO_OVERFLOW_STICKY_HEADER_BODY_CLASS = "no-overflow-sticky-header-body";
let StickyPropsUtils = _StickyPropsUtils;
class ColumnSizerSetWidth {
  static getWidthDelta(D, O) {
    return D < O.left ? O.left : D > O.right ? O.right : D;
  }
  static getNewColumnWidth(D, O) {
    const { moveLimits: x, mouseMoveOffset: B, initialOffset: U } = D, F = ColumnSizerSetWidth.getWidthDelta(B, x) - U;
    return Math.max(0, Number.parseFloat(O.style.width) + F);
  }
  static setColumnWidth(D, O) {
    const x = ColumnSizerSetWidth.getNewColumnWidth(D, O);
    O.style.width = `${x}px`;
  }
  // when the user moves the sizer to the start/end of a column in an attempt to completely crush the column,
  // the dom will not allow that and will leave enough space for the column to display its text,
  // the problem is that the widths will be set incorrectly and need to be corrected
  // prettier-ignore
  static correctWidths(D, O, x, B) {
    if (O.offsetWidth !== Math.round(Number.parseFloat(O.style.width))) {
      const U = `${O.offsetWidth}px`, F = `${B - O.offsetWidth}px`;
      O.style.width = U, x.style.width = F, D.wasAutoresized = !0, setTimeout(() => D.wasAutoresized = !1);
    }
  }
  // prettier-ignore
  static setWidths(D, O, x, B) {
    const U = ColumnSizerSetWidth.getNewColumnWidth(D, O), F = Math.max(0, B - U);
    O.style.width = `${U}px`, x.style.width = `${F}px`;
  }
  // prettier-ignore
  static setColumnsWidths(D, O, x) {
    const B = Number.parseFloat(O.style.width), U = Number.parseFloat(x.style.width), F = B + U;
    ColumnSizerSetWidth.setWidths(D, O, x, F), U > B ? ColumnSizerSetWidth.correctWidths(D, O, x, F) : ColumnSizerSetWidth.correctWidths(D, x, O, F);
  }
  // left or right header in respect to the position of the sizer element
  // prettier-ignore
  static set(D, O, x, B, U) {
    U && StaticTable.isStaticTableWidth(O, x) ? ColumnSizerSetWidth.setColumnsWidths(D, B, U) : ColumnSizerSetWidth.setColumnWidth(D, B), setTimeout(() => D.fireColumnsUpdate());
  }
}
class ColumnSizerExtrinsicEvents {
  static moveMovableElement(D, O, x) {
    const { columnSizer: B } = ColumnSizerGenericUtils.getSizerDetailsViaElementId(D.id, O);
    B.movableElement.style.left = `${x}px`;
  }
  // prettier-ignore
  static windowMouseMove(D, O) {
    const { _activeOverlayElements: { selectedColumnSizer: x }, _columnsDetails: B } = D;
    if (x) {
      const { moveLimits: U, element: F } = x;
      x.mouseMoveOffset += O, x.mouseMoveOffset >= U.left && x.mouseMoveOffset <= U.right && ColumnSizerExtrinsicEvents.moveMovableElement(F, B, x.mouseMoveOffset);
    }
  }
  // prettier-ignore
  static setWidth(D, O, x, B, U) {
    ColumnSizerElement.unsetTransitionTime(D.element), ColumnSizerSetWidth.set(D, O, x, B, U);
  }
  // prettier-ignore
  static mouseUp(D) {
    var X;
    const { _activeOverlayElements: O, _columnsDetails: x, _tableDimensions: B, _tableElementRef: U } = D, F = O.selectedColumnSizer, { columnSizer: W, headerCell: G, sizerNumber: Y } = ColumnSizerGenericUtils.getSizerDetailsViaElementId(
      F.element.id,
      x
    );
    ColumnSizerExtrinsicEvents.setWidth(
      F,
      U,
      B,
      G,
      ColumnSizerGenericUtils.findNextResizableColumnHeader(x, Y)
    ), MovableColumnSizerElement.hide(W.movableElement), UpdateRowElement.updateHeaderRowHeight((X = W.element.parentElement) == null ? void 0 : X.parentElement);
  }
  static setSizerStyleToHoverNoAnimation(D, O) {
    const { width: x } = D.styles.hover;
    ColumnSizerElement.setHoverStyle(D, x, !1, O), ColumnSizerElement.unsetBackgroundImage(D.element);
  }
  static mouseUpNotOnSizer(D) {
    const { element: O, styles: x, movableElement: B } = D;
    ColumnSizerExtrinsicEvents.setSizerStyleToHoverNoAnimation(D, B.style.backgroundColor), setTimeout(() => {
      ColumnSizerElement.setTransitionTime(O), ColumnSizerElement.unsetElementsToDefault(O, x.default.width, !1), ColumnSizerElement.hideWhenCellNotHovered(D, !0);
    }), setTimeout(() => {
      ColumnSizerElement.setBackgroundImage(O, x.default.backgroundImage), ColumnSizerElement.setBackgroundColor(O, SEMI_TRANSPARENT_COLOR);
    }, ColumnSizerElement.TRANSITION_TIME_ML);
  }
  // if the user clicks mouse up on the table first - this will not be activated as columnSizer selected will be removed
  // prettier-ignore
  static windowMouseUp(D) {
    const { columnSizer: O } = ColumnSizerGenericUtils.getSizerDetailsViaElementId(
      D._activeOverlayElements.selectedColumnSizer.element.id,
      D._columnsDetails
    );
    ColumnSizerExtrinsicEvents.mouseUp(D), ColumnSizerExtrinsicEvents.mouseUpNotOnSizer(O), delete D._activeOverlayElements.selectedColumnSizer;
  }
  static mouseUpOnSizer(D) {
    ColumnSizerExtrinsicEvents.setSizerStyleToHoverNoAnimation(D), D.isMouseUpOnSizer = !0, setTimeout(() => {
      D.isMouseUpOnSizer = !1, ColumnSizerElement.setTransitionTime(D.element);
    });
  }
  // this method is used to get what exact element was clicked on as window events just returns the component as the target
  // prettier-ignore
  static tableMouseUp(D, O) {
    const x = D._activeOverlayElements.selectedColumnSizer, { columnSizer: B } = ColumnSizerGenericUtils.getSizerDetailsViaElementId(
      x.element.id,
      D._columnsDetails
    );
    ColumnSizerExtrinsicEvents.mouseUp(D), MovableColumnSizerElement.isMovableColumnSizer(O) && !x.wasAutoresized ? ColumnSizerExtrinsicEvents.mouseUpOnSizer(B) : ColumnSizerExtrinsicEvents.mouseUpNotOnSizer(B), delete D._activeOverlayElements.selectedColumnSizer;
  }
}
class TableEvents {
  // not using hoveredElements state as the targetElement will be the element clicked, hence need to use
  // activeOverlayElements.datePickerCell to get the cell of the date picker input
  static closeDatePicker(D, O) {
    D.datePickerCell && (D.datePickerCell !== CellElement.getCellElement(O) && DateCellInputElement.toggle(D.datePickerCell, !1), delete D.datePickerCell);
  }
  // REF-44
  // text blur will not activate when the dropdown has been clicked and will not close if its scrollbar, padding
  // or delete category buttons are clicked. If the user clicks elsewhere on the table, the dropdown is closed
  // programmatically as follows
  // prettier-ignore
  static closeCellDropdown(D, O) {
    const { _focusedElements: x } = D;
    x.cellDropdown && !Dropdown.isPartOfDropdownElement(O) && !O.classList.contains(OptionColorButton.COLOR_BUTTON_CLASS) && x.cell.element !== CellElement.getCellElement(O) && CellWithTextEvents.programmaticBlur(D);
  }
  static onMouseDown(D) {
    const O = D.target;
    UserKeyEventsStateUtils.temporarilyIndicateEvent(this._userKeyEventsState, MOUSE_EVENT.DOWN), TableEvents.closeCellDropdown(this, O), TableEvents.closeDatePicker(this._activeOverlayElements, D.target);
  }
  static onMouseUp(D) {
    this._activeOverlayElements.selectedColumnSizer && ColumnSizerExtrinsicEvents.tableMouseUp(this, D.target);
  }
}
class TableElement {
  static changeStaticWidthTotal(D, O) {
    D.staticWidth += O;
  }
  // prettier-ignore
  static setStaticWidthContentTotal(D) {
    const { _frameComponents: { displayAddNewColumn: O, displayIndexColumn: x }, _tableDimensions: B } = D;
    B.staticWidth = B.border.leftWidth + B.border.rightWidth, O && (B.staticWidth += AddNewColumnElement.DEFAULT_WIDTH), x && (B.staticWidth += IndexColumn.DEFAULT_WIDTH);
  }
  // prettier-ignore
  static addOverlayElements(D, O, x) {
    var W;
    const B = FullTableOverlayElement.create(D);
    x.fullTableOverlay = B;
    const U = ((W = D._overflow) == null ? void 0 : W.overflowContainer) || O;
    U.appendChild(B), DragAndDropElement.isEnabled(D.files) && DragAndDropElement.append(D, U);
    const F = ColumnDropdown.create(D);
    if (O.appendChild(F), x.columnDropdown = F, D.rowDropdown.displaySettings.isAvailable) {
      const G = RowDropdown.create(D);
      O.appendChild(G), x.rowDropdown = G;
    }
  }
  static addCells(D) {
    MaximumColumns.canAddMore(D) && (StaticTableWidthUtils.toggleWidthUsingMaxWidth(D, !0), D.data.map((O, x) => InsertNewRow.insert(D, x, !1, O)), D._pagination.asyncStartData && PaginationAsyncStartData.populate(D, D._pagination.asyncStartData), StaticTableWidthUtils.toggleWidthUsingMaxWidth(D, !1));
  }
  static postProcessColumns(D) {
    StaticTableWidthUtils.changeWidthsBasedOnColumnInsertRemove(D, !0), InitialDataProcessing.postProcess(D.data, D._columnsDetails), setTimeout(() => {
      FireEvents.onColumnsUpdate(D), InsertRemoveColumnSizer.cleanUpCustomColumnSizers(D, D._columnsDetails.length - 1);
    });
  }
  static populateBody(D) {
    var O;
    (O = D._tableBodyElementRef) == null || O.replaceChildren(), StaticTableWidthUtils.setTableWidth(D), TableElement.addCells(D), TableElement.postProcessColumns(D), FrameComponentsElements.addFrameBodyElements(D), D._frameComponents.displayIndexColumn && UpdateIndexColumnWidth.update(D), ToggleAdditionElements.update(D, !0, AddNewColumnElement.toggle), CustomRowProperties.update(D);
  }
  static createTableBody(D) {
    const O = document.createElement("tbody");
    return D && O.classList.add("sticky-header-body"), O;
  }
  static createTableElement(D) {
    var B;
    const O = document.createElement("table");
    O.classList.add("table-controlled-width");
    const x = StringDimensionUtils.removeAllDimensions(JSON.parse(JSON.stringify(D.tableStyle)));
    return Object.assign(O.style, x), (B = O.style).fontFamily || (B.fontFamily = "Inter, sans-serif, Avenir, Helvetica, Arial"), O.onmousedown = TableEvents.onMouseDown.bind(D), O.onmouseup = TableEvents.onMouseUp.bind(D), O;
  }
  // CAUTION-4 - add row cell is created and ref assigned here - then it is added post render in addFrameBodyElements
  static createInfrastructureElements(D) {
    return FrameComponentsColors.setEventColors(D), D._tableElementRef = TableElement.createTableElement(D), D._tableBodyElementRef = TableElement.createTableBody(D._stickyProps.header), D._addRowCellElementRef = AddNewRowElement.create(D), D._tableElementRef.appendChild(D._tableBodyElementRef), D._cellDropdownContainer = CellDropdown.createContainerElement(), D._tableElementRef.appendChild(D._cellDropdownContainer), !D.overflow && D._stickyProps.header && StickyPropsUtils.moveTopBorderToHeaderCells(D), D._tableDimensions.border = TableBorderDimensionsUtils.generateUsingElement(D._tableElementRef), D._tableElementRef;
  }
}
const _OverflowUtils = class De {
  static isOverflowElement(D) {
    return (D == null ? void 0 : D.id) === De.ID;
  }
  // a simple way to not take the border into consideration when doing table width calculation, however if there are issues
  // feel free to investigate a better way
  static unsetBorderDimensions(D, O) {
    O.number -= D.border.leftWidth + D.border.rightWidth, TableElement.changeStaticWidthTotal(D, -D.border.leftWidth), TableElement.changeStaticWidthTotal(D, -D.border.rightWidth), D.border.leftWidth = 0, D.border.rightWidth = 0, D.border.topWidth = 0, D.border.bottomWidth = 0;
  }
  static processNumberDimension(D, O) {
    De.unsetBorderDimensions(D, O), O.number -= De.SCROLLBAR_WIDTH;
  }
  // prettier-ignore
  static moveBorderToOverflowContainer(D, O) {
    ElementStyle.moveStyles(
      O,
      D,
      "borderRight",
      "borderLeft",
      "borderTop",
      "borderBottom",
      "borderRadius",
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ), O.style.border = "unset";
  }
  static adjustStyleForScrollbarWidth(D) {
    (Browser.IS_SAFARI || Browser.IS_FIREFOX) && D.maxHeight && !D.maxWidth && (D.overflowContainer.style.paddingRight = `${De.SCROLLBAR_WIDTH}px`);
  }
  static setDimensions(D, { width: O, height: x }) {
    O && (D.style.overflowX = "auto", D.style.maxWidth = `${O}px`), x && (D.style.overflowY = "auto", D.style.maxHeight = `${x}px`);
  }
  // prettier-ignore
  static getDimensions(D, O) {
    const x = StringDimensionUtils.generateNumberDimensionFromClientString(
      D.parentElement,
      O,
      "maxWidth",
      !0
    );
    x.number -= D._tableDimensions.border.leftWidth + D._tableDimensions.border.rightWidth, x.isPercentage && (O.isWidthPercentage = !0);
    const B = StringDimensionUtils.generateNumberDimensionFromClientString(
      D.parentElement,
      O,
      "maxHeight",
      !1
    );
    return B.number -= D._tableDimensions.border.topWidth + D._tableDimensions.border.bottomWidth, B.isPercentage && (O.isHeightPercentage = !0), { width: x.number, height: B.number };
  }
  static applyDimensions(D) {
    const { _overflow: O } = D;
    if (!O)
      return;
    const x = De.getDimensions(D, O);
    De.setDimensions(O.overflowContainer, x), De.adjustStyleForScrollbarWidth(O);
  }
  static setupContainer(D, O) {
    const x = document.createElement("div");
    D._overflow = { overflowContainer: x, ...D.overflow }, x.id = De.ID, De.moveBorderToOverflowContainer(x, O), x.appendChild(O);
  }
};
_OverflowUtils.ID = "overflow-container";
_OverflowUtils.SCROLLBAR_WIDTH = 15;
let OverflowUtils = _OverflowUtils;
class ElementVisibility {
  // prettier-ignore
  static getDetailsInWindow(D, O, x = !0) {
    const { topWidth: B, leftWidth: U } = x ? O : { topWidth: 0, leftWidth: 0 }, F = D.getBoundingClientRect(), W = (Browser.IS_CHROMIUM ? F.top - B : F.top) + window.scrollY, G = (Browser.IS_CHROMIUM ? F.left - U : F.left) + window.scrollX, Y = D.offsetWidth, X = D.offsetHeight, J = document.body, Q = /* @__PURE__ */ new Set();
    W < window.pageYOffset && Q.add(SIDE.TOP);
    const le = J.clientWidth < J.scrollWidth ? OverflowUtils.SCROLLBAR_WIDTH : 0;
    W + X + B > window.pageYOffset + window.innerHeight - le && Q.add(SIDE.BOTTOM), G < window.pageXOffset && Q.add(SIDE.LEFT);
    const re = J.clientHeight < J.scrollHeight ? OverflowUtils.SCROLLBAR_WIDTH : 0;
    return G + Y + U > window.pageXOffset + window.innerWidth - re && Q.add(SIDE.RIGHT), Q.size > 0 ? { isFullyVisible: !1, blockingSides: Q } : { isFullyVisible: !0 };
  }
  // no real need to take care of multiple blockages for now
  static isVerticallyVisibleInsideParent(D, O) {
    const x = D.parentElement || O, B = x.scrollTop, U = B + x.clientHeight, F = D.offsetTop, W = F + D.clientHeight;
    return F < B ? { isFullyVisible: !1, blockingSides: /* @__PURE__ */ new Set([SIDE.TOP]) } : W > U ? { isFullyVisible: !1, blockingSides: /* @__PURE__ */ new Set([SIDE.BOTTOM]) } : { isFullyVisible: !0 };
  }
}
class OuterDropdownEvents {
  static windowOnMouseDown(D) {
    D._activeOverlayElements.outerContainerDropdown && D._activeOverlayElements.outerContainerDropdown.hide();
  }
  static focusSiblingItem(D, O, x) {
    const B = O == null ? void 0 : O[x];
    if (B)
      DropdownItemNavigation.focusSiblingItem(B, D, !0, !0);
    else if (x === "nextSibling") {
      const U = D.children[0];
      U && DropdownItemNavigation.focusSiblingItem(U, D, !0, !0);
    } else {
      const U = D.children[D.children.length - 1];
      U && DropdownItemNavigation.focusSiblingItem(U, D, !1, !0);
    }
  }
  // prettier-ignore
  static windowOnKeyDownNavigation(D, O) {
    const x = D.getElementsByClassName(DropdownItem.ACTIVE_ITEM_CLASS)[0];
    O === KEYBOARD_KEY.TAB || O === KEYBOARD_KEY.ARROW_DOWN ? x ? OuterDropdownEvents.focusSiblingItem(D, x, "nextSibling") : DropdownItemNavigation.focusSiblingItem(D.children[0], D, !0, !0) : O === KEYBOARD_KEY.ARROW_UP && (x ? OuterDropdownEvents.focusSiblingItem(D, x, "previousSibling") : DropdownItemNavigation.focusSiblingItem(
      D.children[D.children.length - 1],
      D,
      !1,
      !0
    ));
  }
  // the reason why we track window key events is because the table is not actually focused when it is displayed,
  // (unlike column dropdown which has an input), hence initially clicking tab does not focus the dropdown and
  // instead we need to focus it programmatically here. Once focused, the actual dropdown events can take over.
  // prettier-ignore
  static windowOnKeyDown(D, O) {
    const { shadowRoot: x, _activeOverlayElements: { outerContainerDropdown: B } } = D;
    if (!B)
      return;
    O.preventDefault();
    const { element: U, hide: F } = B;
    O.key === KEYBOARD_KEY.ENTER || O.key === KEYBOARD_KEY.ESCAPE ? F() : x != null && x.activeElement || OuterDropdownEvents.windowOnKeyDownNavigation(U, O.key);
  }
  static dropdownOnKeyDown(D, O) {
    O.preventDefault(), O.key === KEYBOARD_KEY.ENTER ? O.target.dispatchEvent(new MouseEvent("mousedown")) : O.key === KEYBOARD_KEY.ESCAPE && D.hide(), DropdownEvents.itemKeyNavigation(this.shadowRoot, D.element, O);
  }
  static set(D, O) {
    O.element.onkeydown = OuterDropdownEvents.dropdownOnKeyDown.bind(D, O);
  }
}
const _OuterDropdownElement = class Ye {
  static hide(D, O) {
    const x = D.outerContainerDropdown;
    x && (Dropdown.hide(x.element), x.button.classList.contains(ToggleableElement.AUTO_STYLING_CLASS) && ToggleableElement.unsetActive(x.button, O), delete D.outerContainerDropdown, DropdownItemHighlightUtils.fadeCurrentlyHighlighted(D));
  }
  static display(D, O) {
    O.button.classList.contains(ToggleableElement.AUTO_STYLING_CLASS) && ToggleableElement.setActive(O.button, O.activeButtonStyle), Dropdown.display(O.element), D._activeOverlayElements.outerContainerDropdown = O;
  }
  static displayReactToBottomVisibility(D, O) {
    O.element.classList.remove(Ye.DROPUP_CLASS), Ye.display(D, O);
    const x = ElementVisibility.getDetailsInWindow(O.element, D._tableDimensions.border, !1);
    !x.isFullyVisible && x.blockingSides.has(SIDE.BOTTOM) && O.element.classList.add(Ye.DROPUP_CLASS);
  }
  static setOrientation(D, O) {
    O.endsWith("right") && (D.style.right = "0px");
  }
  static createElement(D) {
    const O = Dropdown.createBase();
    return O.style.width = "", O.classList.add("outer-container-dropdown"), D && O.classList.add(...D), O;
  }
  // prettier-ignore
  static create(D, O, x, B, U, F, W) {
    const G = Ye.createElement(U), Y = { element: G, hide: F, button: O, activeButtonStyle: B };
    return Ye.setOrientation(G, x), OuterDropdownButtonEvents.set(D, O, x, Y, W), OuterDropdownEvents.set(D, Y), Y;
  }
};
_OuterDropdownElement.DROPUP_CLASS = "active-table-dropup";
let OuterDropdownElement = _OuterDropdownElement;
class OuterDropdownSimpleUtils {
  static hide(D, O) {
    var B;
    OuterDropdownElement.hide(D, {});
    const x = (B = D.outerContainerDropdown) == null ? void 0 : B.element;
    if (x) {
      const U = O || Array.from(x.children);
      OuterDropdownItem.unsetHoverColors(U);
    }
  }
  static getDropdownTopPosition(D) {
    return `${D.offsetTop + D.offsetHeight}px`;
  }
  // this is a custom display function used by dropdowns that do not populate items on display (export, rows per page)
  static display(D, O, x) {
    const { element: B } = x;
    B.style.bottom = "", B.style.top = OuterDropdownSimpleUtils.getDropdownTopPosition(D), OuterDropdownElement.displayReactToBottomVisibility(O, x);
  }
}
class RowsPerPageDropdownItemUtil {
  static updateRowsAndPaginationComponents(D, O, x) {
    RowsPerPageSelectButtonElement.updateButtonText(O, x), PageButtonContainerElement.shouldButtonsBeActive(D) && (PageButtonContainerElement.repopulateButtons(D), PaginationUtils.getAndApplyDataOnButtonClick(D, 1, x));
  }
  static getNewRowsPerPage(D, O) {
    const { _pagination: x, data: B, dataStartsAtHeader: U } = D;
    return x.isAllRowsOptionSelected ? U ? B.length : B.length - 1 : Number(O);
  }
  static setNewRowsPerPage(D, O, x) {
    D._pagination.isAllRowsOptionSelected = x.toLocaleLowerCase() === RowsPerPageDropdownItem.ALL_ITEM_TEXT, D._pagination.rowsPerPage = RowsPerPageDropdownItemUtil.getNewRowsPerPage(D, x), RowsPerPageDropdownItemUtil.updateRowsAndPaginationComponents(D, O, x);
  }
}
class RowsPerPageDropdownItemEvents {
  static action(D, O, x, B) {
    D.rowsPerPage !== Number(B) && RowsPerPageDropdownItemUtil.setNewRowsPerPage(x, O, B);
  }
  static setEvents(D, O, x) {
    const B = RowsPerPageDropdownItemEvents.action.bind(this, D._pagination, x), U = OuterDropdownSimpleUtils.hide;
    O.onmousedown = OuterDropdownItemEvents.itemMouseDownCommon.bind(D, B, U);
  }
}
const _RowsPerPageDropdownItem = class wt {
  // lower case as it will be compared against user set text
  static populate(D, O, x) {
    D._pagination.rowsPerPageOptionsItemText.forEach((U) => {
      const F = { text: String(U) }, W = DropdownItem.addButtonItem(D, O, F, wt.ITEM_CLASS);
      RowsPerPageDropdownItemEvents.setEvents(D, W, x);
    });
    const B = String(D._pagination.rowsPerPage);
    OuterDropdownItem.setActive(Array.from(O.children), B);
  }
};
_RowsPerPageDropdownItem.ITEM_CLASS = "number-of-rows-dropdown-item";
_RowsPerPageDropdownItem.ALL_ITEM_TEXT = "all";
let RowsPerPageDropdownItem = _RowsPerPageDropdownItem;
const _PaginationInternalUtils = class oe {
  static getTotalNumberOfRows(D) {
    const { data: O, _visiblityInternal: x, _tableBodyElementRef: B } = D;
    return x != null && x.filters ? FilterInternalUtils.extractUnfilteredRows(B, O.length).length : O.length;
  }
  static insertNewRowsPerPageOption(D, O) {
    let x = O.findIndex((B) => {
      const U = Number.parseInt(B);
      return isNaN(U) || D < U;
    });
    x === -1 && (x = 0), O.splice(x, 0, String(D));
  }
  static setFirstOptionAsRowsPerPage(D) {
    const { _pagination: O, dataStartsAtHeader: x } = D, B = O.rowsPerPageOptionsItemText[0];
    if (B.toLocaleLowerCase() === RowsPerPageDropdownItem.ALL_ITEM_TEXT) {
      O.isAllRowsOptionSelected = !0;
      const U = oe.getTotalNumberOfRows(D);
      O.rowsPerPage = x ? U : U - 1;
    } else
      O.rowsPerPage = Number(B);
  }
  static processRowsPerPage(D, O) {
    const { rowsPerPageSelect: x } = O;
    if (D._pagination.rowsPerPage = Number.parseInt(String(D._pagination.rowsPerPage)), x || x === void 0) {
      const { rowsPerPageOptionsItemText: B, rowsPerPage: U } = D._pagination;
      if (!B.find((F) => F === String(U))) {
        const F = Number.parseInt(String(U));
        isNaN(F) ? oe.setFirstOptionAsRowsPerPage(D) : oe.insertNewRowsPerPageOption(F, B);
      }
    }
  }
  static processOptionsItemText(D) {
    const O = Number(D);
    return !isNaN(O) && O < 1 ? "2" : String(D);
  }
  // REF-32
  static changeOptionNumberToEven(D) {
    return D.map((O) => {
      const x = Number(O);
      return Number.isNaN(x) ? O : x % 2 === 1 ? x + 1 : x;
    });
  }
  // prettier-ignore
  static setRowsPerPageOptionsText(D) {
    const O = D.pagination, { rowsPerPageSelect: x } = O;
    if (x || x === void 0) {
      const B = D._pagination.rowsPerPageSelect.options;
      let U = x === void 0 || x === !0 || !x.options || x.options.length === 0 ? B : x.options;
      D.stripedRows && (U = oe.changeOptionNumberToEven(U)), D._pagination.rowsPerPageOptionsItemText = U.map((F) => oe.processOptionsItemText(F));
    }
  }
  static processRowsPerPageOptions(D) {
    const O = D.pagination, { rowsPerPageSelect: x } = O;
    x !== void 0 && typeof x != "boolean" && x.prefixText && (D._pagination.rowsPerPageSelect.prefixText = x.prefixText), oe.setRowsPerPageOptionsText(D), delete O.rowsPerPageSelect;
  }
  static setDefaultBackgroundColors(D, O) {
    var F, W, G;
    const { def: x, hover: B, click: U } = O;
    (F = D.click).backgroundColor ?? (F.backgroundColor = D.hover.backgroundColor || D.default.backgroundColor || U), (W = D.hover).backgroundColor ?? (W.backgroundColor = D.default.backgroundColor || B), (G = D.default).backgroundColor ?? (G.backgroundColor = x), ["click", "hover", "default"].forEach((Y) => {
      D[Y].backgroundColor === void 0 && delete D[Y].backgroundColor;
    });
  }
  static setStatefulCSS(D, O) {
    var x, B, U;
    D[O] ?? (D[O] = {}), (x = D[O]).click ?? (x.click = JSON.parse(JSON.stringify(D[O].hover || D[O].default || {}))), (B = D[O]).hover ?? (B.hover = JSON.parse(JSON.stringify(D[O].default || {}))), (U = D[O]).default ?? (U.default = {});
  }
  // prettier-ignore
  static setRowsPerPageOptionsStyle(D) {
    var x;
    oe.setStatefulCSS(D.rowsPerPageSelect, "button");
    const O = { def: "", hover: "#f5f5f5", click: "#f5f5f5" };
    oe.setDefaultBackgroundColors(
      (x = D.rowsPerPageSelect) == null ? void 0 : x.button,
      O
    );
  }
  // activeButtons reuse buttons style
  static mergeButtonsStyleWithActiveStyle(D) {
    const { buttons: O, actionButtons: x, activeButton: B } = D, U = JSON.parse(JSON.stringify(O));
    return U.default.backgroundColor = "#e8e8e8", U.hover.backgroundColor = "#d6d6d6", U.click.backgroundColor = "#c8c8c8", B && (Object.assign(U.default, B.default), U.hover = B.hover, U.click = B.click), U;
  }
  // actionButtons reuse buttons style
  static mergeButtonsStylesWithActionStyles(D) {
    D.actionButtons ?? (D.actionButtons = {});
    const { buttons: O, actionButtons: x } = D, B = JSON.parse(JSON.stringify(O));
    return Object.assign(B.default, x.default), Object.assign(B.hover, x.hover), Object.assign(B.click, x.click), B.previousText = x.previousText, B.nextText = x.nextText, B.firstText = x.firstText, B.lastText = x.lastText, B;
  }
  // prettier-ignore
  static processPageButtonStyles(D) {
    var G, Y, X, J;
    (G = D.styles).pageButtons ?? (G.pageButtons = {});
    const O = D.styles.pageButtons, x = { def: "white", hover: "#f5f5f5", click: "#c8c8c8" };
    oe.setStatefulCSS(O, "buttons"), oe.setDefaultBackgroundColors(D.styles.pageButtons.buttons, x), oe.setStatefulCSS(O, "actionButtons"), oe.setDefaultBackgroundColors(
      D.styles.pageButtons.actionButtons,
      {}
    );
    const B = oe.mergeButtonsStylesWithActionStyles(O);
    D.styles.pageButtons.actionButtons = B;
    const U = oe.mergeButtonsStyleWithActiveStyle(O);
    D.styles.pageButtons.activeButton = U, (Y = D.styles.pageButtons).disabledButtons ?? (Y.disabledButtons = { backgroundColor: "#f9f9f9", color: "#9d9d9d", stroke: "#9d9d9d" });
    const F = {
      borderLeft: "1px solid #0000004d",
      borderTopLeftRadius: "2px",
      borderBottomLeftRadius: "2px"
    };
    (X = D.styles.pageButtons).firstVisibleButtonOverride ?? (X.firstVisibleButtonOverride = F);
    const W = {
      borderRight: "1px solid #0000004d",
      borderTopRightRadius: "2px",
      borderBottomRightRadius: "2px"
    };
    (J = D.styles.pageButtons).lastVisibleButtonOverride ?? (J.lastVisibleButtonOverride = W), D.styles.pageButtons.activeButtonClass = D.styles.pageButtons.activeButtonPrecedence ? PageButtonElement.PRECEDENCE_ACTIVE_PAGINATION_BUTTON_CLASS : PageButtonElement.ACTIVE_PAGINATION_BUTTON_CLASS;
  }
  static processStyle(D, O) {
    var x, B;
    D.styles && Object.assign(O.styles, D.styles), oe.processPageButtonStyles(O), D.rowsPerPageSelect !== !1 && ((x = O.styles).rowsPerPageSelect ?? (x.rowsPerPageSelect = {}), oe.setRowsPerPageOptionsStyle(O.styles)), (B = O.styles).numberOfVisibleRows ?? (B.numberOfVisibleRows = {}), delete D.styles;
  }
  static processPositions(D) {
    Object.keys(D).forEach((O) => {
      const x = D[O];
      oe.POSITIONS.has(x.position) || (x.position = oe.DEFAULT_POSITION);
    });
  }
  static processPosition(D, O) {
    D.positions && Object.assign(O.positions, D.positions), oe.processPositions(O.positions), delete D.positions;
  }
  static async process(D) {
    const { _pagination: O, _activeOverlayElements: x } = D;
    if (!D.pagination)
      return;
    const B = typeof D.pagination == "boolean" ? {} : D.pagination;
    B.async && (LoadingElement.addInitial(D), x.error = ErrorElement.create(), O.asyncStartData = await PaginationAsyncStartData.get(D, B, O)), B.maxNumberOfVisiblePageButtons !== void 0 && B.maxNumberOfVisiblePageButtons < 1 && (B.maxNumberOfVisiblePageButtons = 1), oe.processPosition(B, O), oe.processStyle(B, O), B.rowsPerPageSelect !== !1 && oe.processRowsPerPageOptions(D), Object.assign(O, B), B.displayNumberOfVisibleRows !== !1 && oe.processRowsPerPage(D, B);
  }
  static getDefault() {
    return {
      rowsPerPage: 10,
      rowsPerPageSelect: {
        options: [10, 25, 50, "All"],
        prefixText: "Rows per page:"
      },
      maxNumberOfVisiblePageButtons: 8,
      displayPrevNext: !0,
      displayFirstLast: !0,
      displayNumberOfVisibleRows: !0,
      styles: {},
      // this is going to be populated during the call of processInternal method
      visibleEdgeButtons: [],
      numberOfActionButtons: 0,
      dropdownWidth: 24,
      positions: {
        pageButtons: {
          position: oe.DEFAULT_POSITION,
          order: 3
        },
        numberOfVisibleRows: {
          position: oe.DEFAULT_POSITION,
          order: 2
        },
        rowsPerPageSelect: {
          position: oe.DEFAULT_POSITION,
          order: 1
        }
      },
      visibleRows: [],
      activePageNumber: 1,
      isAllRowsOptionSelected: !1
    };
  }
};
_PaginationInternalUtils.DEFAULT_POSITION = "bottom-right";
_PaginationInternalUtils.POSITIONS = /* @__PURE__ */ new Set([
  "top-left",
  "top-center",
  "top-right",
  "bottom-left",
  "bottom-center",
  _PaginationInternalUtils.DEFAULT_POSITION
]);
let PaginationInternalUtils = _PaginationInternalUtils;
class ActiveOverlayElementsUtils {
  static createNew() {
    return {};
  }
}
class ProgrammaticStructureUpdate {
  static processData(D, O) {
    if (O)
      return D > O.length ? O.concat(DataUtils.createEmptyStringDataArray(D - O.length)) : D < O.length ? O.slice(0, D) : O;
  }
  // if -1 - last row, if above last index - last row, otherwise use the given index
  static processIndex(D, O, x) {
    return D = D > -1 ? D : x, D = D > x ? x : D, !O && D === x ? x - 1 : D;
  }
  // prettier-ignore
  static updateColumn(D, O, x, B) {
    var U;
    x = ProgrammaticStructureUpdate.processIndex(x, O, ((U = D.data[0]) == null ? void 0 : U.length) || 0), D.data.length === 0 ? B && UpdateAllTableData.update(D, B.map((F) => [F]), 0, !0) : O ? (B = ProgrammaticStructureUpdate.processData(D.data.length || 0, B), InsertNewColumn.insert(D, x, B)) : D.data.length > 0 && RemoveColumn.remove(D, x);
  }
  static updatePaginationAsync(D, O) {
    setTimeout(() => {
      var x;
      if (D._pagination) {
        const B = (x = D._pagination) == null ? void 0 : x.activePageNumber;
        O !== B ? PaginationUtils.displayRowsForDifferentButton(D, O) : O !== 1 && (PaginationUtils.displayRowsForDifferentButton(D, 1), PaginationUtils.displayRowsForDifferentButton(D, O));
      }
    });
  }
  static updateRow(D, O, x, B) {
    var U, F;
    if (x = ProgrammaticStructureUpdate.processIndex(x, O, D.data.length), D.data.length === 0)
      B && UpdateAllTableData.update(D, [B], 0, !0);
    else if (O) {
      const W = (U = D._pagination) == null ? void 0 : U.activePageNumber;
      B = ProgrammaticStructureUpdate.processData(((F = D.data[0]) == null ? void 0 : F.length) || 0, B), InsertNewRow.insert(D, x, !0, B), setTimeout(() => ProgrammaticStructureUpdate.updatePaginationAsync(D, W));
    } else
      RemoveRow.remove(D, x);
  }
  static update(D, O) {
    const { structure: x, isInsert: B, index: U, data: F } = O;
    typeof B != "boolean" || typeof U != "number" || (x === "row" ? ProgrammaticStructureUpdate.updateRow(D, B, U, F) : x === "column" && ProgrammaticStructureUpdate.updateColumn(D, B, U, F));
  }
}
class FrameComponentsInternalUtils {
  static set(D) {
    const { frameComponentsStyles: O, _frameComponents: x } = D;
    x.displayAddNewColumn = D.displayAddNewColumn, x.displayAddNewRow = D.displayAddNewRow, x.displayIndexColumn = D.displayIndexColumn, x.styles = O.styles, x.inheritHeaderColors = O.inheritHeaderColors ?? !0;
  }
  static getDefault() {
    return {
      displayAddNewColumn: !0,
      displayAddNewRow: !0,
      displayIndexColumn: !0,
      cellColors: FrameComponentsColors.getDefaultCellColors()
    };
  }
}
class RowDropdownSettingsUtil {
  static postprocessOpenMethod(D, O) {
    var x, B;
    !O.displayIndexColumn && ((x = D.displaySettings.openMethod) != null && x.cellClick) && ((B = D.displaySettings.openMethod) == null || delete B.cellClick, D.displaySettings.openMethod.overlayClick = !0);
  }
  // prettier-ignore
  static preprocessOpenMethod(D, O) {
    O && (D.displaySettings.openMethod === void 0 || Object.keys(D.displaySettings.openMethod).length === 0) && O.openMethod && (D.displaySettings.openMethod = JSON.parse(JSON.stringify(O.openMethod)));
  }
  static process(D) {
    var U;
    const { rowDropdown: O, _frameComponents: x, _defaultColumnsSettings: B } = D;
    O.isInsertUpAvailable ?? (O.isInsertUpAvailable = !0), O.isInsertDownAvailable ?? (O.isInsertDownAvailable = !0), O.isMoveAvailable ?? (O.isMoveAvailable = !0), O.canEditHeaderRow ?? (O.canEditHeaderRow = !0), O.isDeleteAvailable ?? (O.isDeleteAvailable = !0), O.displaySettings ?? (O.displaySettings = {}), RowDropdownSettingsUtil.preprocessOpenMethod(O, (U = B.columnDropdown) == null ? void 0 : U.displaySettings), DropdownDisplaySettingsUtil.process(O.displaySettings), RowDropdownSettingsUtil.postprocessOpenMethod(O, x);
  }
}
class ProgrammaticCellUpdate {
  static updateText(D, O) {
    var W;
    const { newText: x, rowIndex: B, columnIndex: U } = O;
    if (!ObjectUtils.areValuesFullyDefined(x, B, U) || typeof x != "string" && typeof x != "number")
      return;
    const F = (W = D._columnsDetails[U]) == null ? void 0 : W.elements[B];
    !F || x === CellElement.getText(F) || (CellEvents.updateCell(D, x, B, U, { element: F, processText: B > 0 }), ColumnTypesUtils.updateDataElements(D, B, U, F), B === 0 && (Dropdown.isDisplayed(D._activeOverlayElements.columnDropdown) && ColumnDropdown.processTextAndHide(D), HeaderText.onAttemptChange(D, F, U)));
  }
}
class SheetJSExport {
  static getFileName(D, O) {
    return O ? O.endsWith(`.${D}`) ? O : `${O}.${D}` : `table_data.${D}`;
  }
  // not csv
  static export(D, O, x, B) {
    const U = B.utils.book_new(), F = B.utils.aoa_to_sheet(D.data);
    B.utils.book_append_sheet(U, F, "Sheet");
    const W = SheetJSExport.getFileName(O, x);
    B.writeFile(U, W, { bookType: O });
  }
}
class CSVExport {
  static export(D, O) {
    const x = `data:text/csv;charset=utf-8,${D.data.map((F) => F.join(",")).join(`
`)}`, B = encodeURI(x), U = document.createElement("a");
    U.setAttribute("href", B), U.setAttribute("download", O || "table_data.csv"), document.body.appendChild(U), U.click();
  }
}
class FileExportEvents {
  static export(D, O) {
    const x = (O == null ? void 0 : O.format) || "csv";
    if (ACCEPTED_FILE_FORMATS.find((B) => x === B)) {
      const B = O == null ? void 0 : O.fileName;
      x === "csv" ? CSVExport.export(D, B) : SheetJSInternalUtils.execFuncWithExtractorModule(SheetJSExport.export.bind(this, D, x, B));
    }
  }
  static setEvents(D, O, x) {
    var U;
    const B = x ? { format: (U = x.formats) == null ? void 0 : U[0], fileName: x.fileName } : void 0;
    O.onclick = FileExportEvents.export.bind(this, D, B);
  }
}
class FileExportDropdownItemEvents {
  static action(D, O) {
    const x = O.toLowerCase();
    FileExportEvents.export(D, { format: x });
  }
  static setEvents(D, O) {
    const x = FileExportDropdownItemEvents.action, B = OuterDropdownSimpleUtils.hide;
    O.onmousedown = OuterDropdownItemEvents.itemMouseDownCommon.bind(D, x, B);
  }
}
const _FileExportDropdownItem = class bt {
  // prettier-ignore
  static populate(D, O, x) {
    x.forEach((B) => {
      const U = { text: B.toUpperCase() }, F = DropdownItem.addButtonItem(
        D,
        O,
        U,
        bt.ITEM_CLASS,
        StaticDropdown.ITEM_CLASS
      );
      FileExportDropdownItemEvents.setEvents(D, F);
    });
  }
};
_FileExportDropdownItem.ITEM_CLASS = "export-formats-dropdown-item";
let FileExportDropdownItem = _FileExportDropdownItem;
class FileExportDropdown {
  static create(D, O, x) {
    const B = OuterDropdownSimpleUtils.hide.bind(this, D._activeOverlayElements), U = OuterDropdownSimpleUtils.display.bind(this, O), F = OuterDropdownElement.create(D, O, "bottom-right", {}, [], B, U);
    return F.element.classList.add(StaticDropdown.DROPDOWN_CLASS), FileExportDropdownItem.populate(D, F.element, x), F;
  }
}
const _FileExportButtonElement = class Qe {
  static createButtonArrow(D, O) {
    const x = OuterDropdownButtonUtils.createArrow(
      [Qe.ARROW_CONTAINER_CLASS],
      [Qe.ARROW_ICON_CLASS]
    ), B = typeof O == "object" && O.formats && O.buttonArrowStyles;
    return B && (OuterDropdownButtonUtils.processAndApplyDefaultStyle(x, B), setTimeout(() => StatefulCSSEvents.setEvents(D, B, void 0, x))), x;
  }
  // if there is more than 1 format - automatically create a dropdown
  static getDropdownFormats(D) {
    if (typeof D == "object" && D.formats) {
      const { formats: O } = D, x = O.filter((B) => Qe.VALID_FORMATS[B.toLocaleLowerCase()]);
      if (x.length > 1)
        return x;
    }
  }
  // prettier-ignore
  static applyDropdown(D, O, x, B, U) {
    const F = FileExportDropdown.create(D, O, B);
    x.appendChild(F.element), O.appendChild(Qe.createButtonArrow(O, U));
  }
};
_FileExportButtonElement.ARROW_CONTAINER_CLASS = "file-button-arrow-container";
_FileExportButtonElement.ARROW_ICON_CLASS = "file-button-arrow-container-icon";
_FileExportButtonElement.VALID_FORMATS = ["csv", "xls", "xlsx", "ods", "txt"].reduce((z, D) => (z[D] = !0, z), {});
let FileExportButtonElement = _FileExportButtonElement;
const _FileButtonElements = class Xe {
  static setEvents(D, O, x) {
    O.import ? FileImportButtonEvents.setEvents(D, x, typeof O.import == "object" ? O.import : void 0) : O.export && FileExportEvents.setEvents(D, x, typeof O.export == "object" ? O.export : void 0);
  }
  // the main reason for this is to display a dropdown
  static wrapInRelativeContainer(D) {
    const O = document.createElement("div");
    return O.classList.add(Xe.BUTTON_CONTAINER_CLASS), O.appendChild(D), O;
  }
  static createElement(D, O) {
    const { text: x, order: B, styles: U } = D, F = document.createElement("div");
    F.classList.add(Xe.BUTTON_CLASS), F.textContent = x || O, F.style.order = String(B || 0);
    const W = FilesUtils.processStyles(U);
    return Object.assign(F.style, W.default), setTimeout(() => StatefulCSSEvents.setEvents(F, W)), F;
  }
  static create(D, O) {
    var x, B;
    (B = (x = D.files) == null ? void 0 : x.buttons) == null || B.forEach((U) => {
      if (!U.export && !U.import)
        return;
      const F = Xe.createElement(U, U.import ? "Import" : "Export"), W = Xe.wrapInRelativeContainer(F), G = U.export && FileExportButtonElement.getDropdownFormats(U.export);
      G ? FileExportButtonElement.applyDropdown(D, F, W, G, U.export) : setTimeout(() => Xe.setEvents(D, U, F));
      const Y = U.position || FilesUtils.DEFAULT_BUTTON_POSITION;
      OuterContainerElements.addToContainer(Y, O, W);
    });
  }
};
_FileButtonElements.BUTTON_CLASS = "file-button";
_FileButtonElements.BUTTON_CONTAINER_CLASS = "file-button-container";
let FileButtonElements = _FileButtonElements;
class OuterTableComponents {
  static create(D) {
    const O = OuterContainerElements.create(D);
    D.pagination && PaginationElements.create(D, O), D.files && FileButtonElements.create(D, O), D.filter && FilterElements.create(D, O);
  }
}
class WebComponentStyleUtils {
  static add(D, O) {
    if (!(!O || !D))
      try {
        WebComponentStyleUtils.addStyleSheet(D, O);
      } catch {
        WebComponentStyleUtils.addStyleElement(D, O);
      }
  }
  static addStyleSheet(D, O) {
    const x = new CSSStyleSheet();
    x.replaceSync(D), O.adoptedStyleSheets.push(x);
  }
  static addStyleElement(D, O) {
    const x = document.createElement("style");
    x.innerHTML = D, O.appendChild(x);
  }
}
class FocusedElementsUtils {
  static createEmpty() {
    return { cell: FocusedCellUtils.createEmpty() };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2 = (z) => (D, O) => {
  O !== void 0 ? O.addInitializer(() => {
    customElements.define(z, D);
  }) : customElements.define(z, D);
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1 = globalThis, e$2 = t$1.ShadowRoot && (t$1.ShadyCSS === void 0 || t$1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$2 = Symbol(), o$3 = /* @__PURE__ */ new WeakMap();
let n$3 = class {
  constructor(D, O, x) {
    if (this._$cssResult$ = !0, x !== s$2)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = D, this.t = O;
  }
  get styleSheet() {
    let D = this.o;
    const O = this.t;
    if (e$2 && D === void 0) {
      const x = O !== void 0 && O.length === 1;
      x && (D = o$3.get(O)), D === void 0 && ((this.o = D = new CSSStyleSheet()).replaceSync(this.cssText), x && o$3.set(O, D));
    }
    return D;
  }
  toString() {
    return this.cssText;
  }
};
const r$5 = (z) => new n$3(typeof z == "string" ? z : z + "", void 0, s$2), i$2 = (z, ...D) => {
  const O = z.length === 1 ? z[0] : D.reduce((x, B, U) => x + ((F) => {
    if (F._$cssResult$ === !0)
      return F.cssText;
    if (typeof F == "number")
      return F;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + F + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(B) + z[U + 1], z[0]);
  return new n$3(O, z, s$2);
}, S$1 = (z, D) => {
  if (e$2)
    z.adoptedStyleSheets = D.map((O) => O instanceof CSSStyleSheet ? O : O.styleSheet);
  else
    for (const O of D) {
      const x = document.createElement("style"), B = t$1.litNonce;
      B !== void 0 && x.setAttribute("nonce", B), x.textContent = O.cssText, z.appendChild(x);
    }
}, c$2 = e$2 ? (z) => z : (z) => z instanceof CSSStyleSheet ? ((D) => {
  let O = "";
  for (const x of D.cssRules)
    O += x.cssText;
  return r$5(O);
})(z) : z;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: i$1, defineProperty: e$1, getOwnPropertyDescriptor: r$4, getOwnPropertyNames: h$1, getOwnPropertySymbols: o$2, getPrototypeOf: n$2 } = Object, a$1 = globalThis, c$1 = a$1.trustedTypes, l$1 = c$1 ? c$1.emptyScript : "", p$1 = a$1.reactiveElementPolyfillSupport, d$1 = (z, D) => z, u$1 = { toAttribute(z, D) {
  switch (D) {
    case Boolean:
      z = z ? l$1 : null;
      break;
    case Object:
    case Array:
      z = z == null ? z : JSON.stringify(z);
  }
  return z;
}, fromAttribute(z, D) {
  let O = z;
  switch (D) {
    case Boolean:
      O = z !== null;
      break;
    case Number:
      O = z === null ? null : Number(z);
      break;
    case Object:
    case Array:
      try {
        O = JSON.parse(z);
      } catch {
        O = null;
      }
  }
  return O;
} }, f$1 = (z, D) => !i$1(z, D), y = { attribute: !0, type: String, converter: u$1, reflect: !1, hasChanged: f$1 };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), a$1.litPropertyMetadata ?? (a$1.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class b extends HTMLElement {
  static addInitializer(D) {
    this._$Ei(), (this.l ?? (this.l = [])).push(D);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(D, O = y) {
    if (O.state && (O.attribute = !1), this._$Ei(), this.elementProperties.set(D, O), !O.noAccessor) {
      const x = Symbol(), B = this.getPropertyDescriptor(D, x, O);
      B !== void 0 && e$1(this.prototype, D, B);
    }
  }
  static getPropertyDescriptor(D, O, x) {
    const { get: B, set: U } = r$4(this.prototype, D) ?? { get() {
      return this[O];
    }, set(F) {
      this[O] = F;
    } };
    return { get() {
      return B == null ? void 0 : B.call(this);
    }, set(F) {
      const W = B == null ? void 0 : B.call(this);
      U.call(this, F), this.requestUpdate(D, W, x);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(D) {
    return this.elementProperties.get(D) ?? y;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d$1("elementProperties")))
      return;
    const D = n$2(this);
    D.finalize(), D.l !== void 0 && (this.l = [...D.l]), this.elementProperties = new Map(D.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d$1("finalized")))
      return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d$1("properties"))) {
      const O = this.properties, x = [...h$1(O), ...o$2(O)];
      for (const B of x)
        this.createProperty(B, O[B]);
    }
    const D = this[Symbol.metadata];
    if (D !== null) {
      const O = litPropertyMetadata.get(D);
      if (O !== void 0)
        for (const [x, B] of O)
          this.elementProperties.set(x, B);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [O, x] of this.elementProperties) {
      const B = this._$Eu(O, x);
      B !== void 0 && this._$Eh.set(B, O);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(D) {
    const O = [];
    if (Array.isArray(D)) {
      const x = new Set(D.flat(1 / 0).reverse());
      for (const B of x)
        O.unshift(c$2(B));
    } else
      D !== void 0 && O.push(c$2(D));
    return O;
  }
  static _$Eu(D, O) {
    const x = O.attribute;
    return x === !1 ? void 0 : typeof x == "string" ? x : typeof D == "string" ? D.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var D;
    this._$ES = new Promise((O) => this.enableUpdating = O), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (D = this.constructor.l) == null || D.forEach((O) => O(this));
  }
  addController(D) {
    var O;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(D), this.renderRoot !== void 0 && this.isConnected && ((O = D.hostConnected) == null || O.call(D));
  }
  removeController(D) {
    var O;
    (O = this._$EO) == null || O.delete(D);
  }
  _$E_() {
    const D = /* @__PURE__ */ new Map(), O = this.constructor.elementProperties;
    for (const x of O.keys())
      this.hasOwnProperty(x) && (D.set(x, this[x]), delete this[x]);
    D.size > 0 && (this._$Ep = D);
  }
  createRenderRoot() {
    const D = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S$1(D, this.constructor.elementStyles), D;
  }
  connectedCallback() {
    var D;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (D = this._$EO) == null || D.forEach((O) => {
      var x;
      return (x = O.hostConnected) == null ? void 0 : x.call(O);
    });
  }
  enableUpdating(D) {
  }
  disconnectedCallback() {
    var D;
    (D = this._$EO) == null || D.forEach((O) => {
      var x;
      return (x = O.hostDisconnected) == null ? void 0 : x.call(O);
    });
  }
  attributeChangedCallback(D, O, x) {
    this._$AK(D, x);
  }
  _$EC(D, O) {
    var U;
    const x = this.constructor.elementProperties.get(D), B = this.constructor._$Eu(D, x);
    if (B !== void 0 && x.reflect === !0) {
      const F = (((U = x.converter) == null ? void 0 : U.toAttribute) !== void 0 ? x.converter : u$1).toAttribute(O, x.type);
      this._$Em = D, F == null ? this.removeAttribute(B) : this.setAttribute(B, F), this._$Em = null;
    }
  }
  _$AK(D, O) {
    var U;
    const x = this.constructor, B = x._$Eh.get(D);
    if (B !== void 0 && this._$Em !== B) {
      const F = x.getPropertyOptions(B), W = typeof F.converter == "function" ? { fromAttribute: F.converter } : ((U = F.converter) == null ? void 0 : U.fromAttribute) !== void 0 ? F.converter : u$1;
      this._$Em = B, this[B] = W.fromAttribute(O, F.type), this._$Em = null;
    }
  }
  requestUpdate(D, O, x) {
    if (D !== void 0) {
      if (x ?? (x = this.constructor.getPropertyOptions(D)), !(x.hasChanged ?? f$1)(this[D], O))
        return;
      this.P(D, O, x);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(D, O, x) {
    this._$AL.has(D) || this._$AL.set(D, O), x.reflect === !0 && this._$Em !== D && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(D);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (O) {
      Promise.reject(O);
    }
    const D = this.scheduleUpdate();
    return D != null && await D, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var x;
    if (!this.isUpdatePending)
      return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [U, F] of this._$Ep)
          this[U] = F;
        this._$Ep = void 0;
      }
      const B = this.constructor.elementProperties;
      if (B.size > 0)
        for (const [U, F] of B)
          F.wrapped !== !0 || this._$AL.has(U) || this[U] === void 0 || this.P(U, this[U], F);
    }
    let D = !1;
    const O = this._$AL;
    try {
      D = this.shouldUpdate(O), D ? (this.willUpdate(O), (x = this._$EO) == null || x.forEach((B) => {
        var U;
        return (U = B.hostUpdate) == null ? void 0 : U.call(B);
      }), this.update(O)) : this._$EU();
    } catch (B) {
      throw D = !1, this._$EU(), B;
    }
    D && this._$AE(O);
  }
  willUpdate(D) {
  }
  _$AE(D) {
    var O;
    (O = this._$EO) == null || O.forEach((x) => {
      var B;
      return (B = x.hostUpdated) == null ? void 0 : B.call(x);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(D)), this.updated(D);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(D) {
    return !0;
  }
  update(D) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((O) => this._$EC(O, this[O]))), this._$EU();
  }
  updated(D) {
  }
  firstUpdated(D) {
  }
}
b.elementStyles = [], b.shadowRootOptions = { mode: "open" }, b[d$1("elementProperties")] = /* @__PURE__ */ new Map(), b[d$1("finalized")] = /* @__PURE__ */ new Map(), p$1 == null || p$1({ ReactiveElement: b }), (a$1.reactiveElementVersions ?? (a$1.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o$1 = { attribute: !0, type: String, converter: u$1, reflect: !1, hasChanged: f$1 }, r$3 = (z = o$1, D, O) => {
  const { kind: x, metadata: B } = O;
  let U = globalThis.litPropertyMetadata.get(B);
  if (U === void 0 && globalThis.litPropertyMetadata.set(B, U = /* @__PURE__ */ new Map()), U.set(O.name, z), x === "accessor") {
    const { name: F } = O;
    return { set(W) {
      const G = D.get.call(this);
      D.set.call(this, W), this.requestUpdate(F, G, z);
    }, init(W) {
      return W !== void 0 && this.P(F, void 0, z), W;
    } };
  }
  if (x === "setter") {
    const { name: F } = O;
    return function(W) {
      const G = this[F];
      D.call(this, W), this.requestUpdate(F, G, z);
    };
  }
  throw Error("Unsupported decorator location: " + x);
};
function n$1(z) {
  return (D, O) => typeof O == "object" ? r$3(z, D, O) : ((x, B, U) => {
    const F = B.hasOwnProperty(U);
    return B.constructor.createProperty(U, F ? { ...x, wrapped: !0 } : x), F ? Object.getOwnPropertyDescriptor(B, U) : void 0;
  })(z, D, O);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r$2(z) {
  return n$1({ ...z, state: !0, attribute: !1 });
}
class WindowEvents {
  static onKeyDown(D) {
    var U, F;
    Dropdown.isDisplayed((U = this._activeOverlayElements.outerContainerDropdown) == null ? void 0 : U.element) && OuterDropdownEvents.windowOnKeyDown(this, D), Dropdown.isDisplayed(this._activeOverlayElements.rowDropdown) && RowDropdownEvents.windowOnKeyDown(this, D);
    const { rowIndex: O, columnIndex: x, element: B } = this._focusedElements.cell;
    if (!(O === void 0 || x === void 0)) {
      if (O === 0 && !Dropdown.isDisplayed(this._activeOverlayElements.columnDropdown)) {
        if (D.key === KEYBOARD_KEY.ESCAPE)
          return HeaderText.onAttemptChange(this, B, x);
      } else if (Dropdown.isDisplayed(this._activeOverlayElements.columnDropdown) && !((F = this.shadowRoot) != null && F.activeElement))
        return ColumnDropdownEvents.onKeyDown.bind(this)(this._activeOverlayElements.columnDropdown, D);
      O > 0 && this._columnsDetails[x].activeType.cellDropdownProps && SelectCellTextBaseEvents.keyDownText(this, O, x, D);
    }
  }
  static onKeyUp(D) {
    D.key === KEYBOARD_KEY.ESCAPE ? (OptionColorButtonEvents.windowEventClosePicker(this._columnsDetails, this._focusedElements), DateCellInputEvents.escapeKeyInput(this)) : D.key === KEYBOARD_KEY.ENTER && OptionColorButtonEvents.windowEventClosePicker(this._columnsDetails, this._focusedElements);
  }
  // prettier-ignore
  static onMouseDown(D) {
    var U;
    if (OptionColorButtonEvents.windowEventClosePicker(this._columnsDetails, this._focusedElements), Dropdown.isDisplayed((U = this._activeOverlayElements.outerContainerDropdown) == null ? void 0 : U.element) && OuterDropdownEvents.windowOnMouseDown(this), D.target.tagName === ActiveTable._ELEMENT_TAG)
      return;
    const { _activeOverlayElements: { columnDropdown: O, rowDropdown: x }, _focusedElements: B } = this;
    Dropdown.isDisplayed(x) && RowDropdown.hide(this), Dropdown.isDisplayed(O) ? ColumnDropdown.processTextAndHide(this) : B.cellDropdown ? CellWithTextEvents.programmaticBlur(this) : this._activeOverlayElements.datePickerCell && (DateCellInputElement.toggle(this._activeOverlayElements.datePickerCell, !1), delete this._activeOverlayElements.datePickerCell);
  }
  static onMouseUp() {
    this._activeOverlayElements.selectedColumnSizer && ColumnSizerExtrinsicEvents.windowMouseUp(this), DragColumn.windowMouseUp(this), DragRow.windowMouseUp(this);
  }
  static onMouseMove(D) {
    this._activeOverlayElements.selectedColumnSizer && ColumnSizerExtrinsicEvents.windowMouseMove(this, D.movementX), this._focusedElements.colDragEl && DragColumn.windowDrag(this, this._focusedElements.colDragEl, D), this._focusedElements.rowDragEl && DragRow.windowDrag(this, D);
  }
}
class Render {
  // CAUTION-4 overwriting @properties causes the whole table to refresh and subsequently - an infinite render loop
  // prettier-ignore
  static refreshTableState(D) {
    var O;
    (O = D._cellDropdownContainer) == null || O.replaceChildren(), D._columnsDetails.splice(0, D._columnsDetails.length), D._tableDimensions.indexColumnWidth = IndexColumn.DEFAULT_WIDTH, D._addColumnCellsElementsRef.splice(0, D._addColumnCellsElementsRef.length), D._overflow && (D._tableDimensions.border = TableBorderDimensionsUtils.generateUsingElement(D._overflow.overflowContainer));
  }
  static renderTable(D) {
    D._isRendering = !0, TableDimensionsUtils.record(D), Render.refreshTableState(D), D._overflow && OverflowUtils.applyDimensions(D), TableElement.setStaticWidthContentTotal(D), TableDimensionsUtils.setTableDimensions(D), TableElement.populateBody(D), setTimeout(() => D._isRendering = !1);
  }
}
class WindowResize {
  // prettier-ignore
  static resize(D) {
    const { _tableDimensions: O } = this;
    (D.width && window.innerWidth !== O.recordedWindowWidth || D.height && window.innerHeight !== O.recordedWindowHeight) && Render.renderTable(this);
  }
  static extractPostfix(D) {
    if (typeof D == "string") {
      if (D.includes(VW))
        return VW;
      if (D.includes(VH))
        return VH;
    }
    return "";
  }
  static extractDimensionsToObserve(D) {
    const { tableStyle: O, _overflow: x } = D, B = [O.width, O.maxWidth, x == null ? void 0 : x.maxHeight, x == null ? void 0 : x.maxWidth].map(
      (U) => WindowResize.extractPostfix(U)
    );
    return {
      width: !!B.find((U) => U === VW),
      height: !!B.find((U) => U === VH)
    };
  }
  static observeIfRequired(D) {
    const O = WindowResize.extractDimensionsToObserve(D);
    (O.width || O.height) && window.addEventListener("resize", WindowResize.resize.bind(D, O));
  }
}
class WindowElement {
  static setEvents(D) {
    window.addEventListener("keydown", WindowEvents.onKeyDown.bind(D)), window.addEventListener("keyup", WindowEvents.onKeyUp.bind(D)), window.addEventListener("mousedown", WindowEvents.onMouseDown.bind(D)), window.addEventListener("mouseup", WindowEvents.onMouseUp.bind(D)), window.addEventListener("mousemove", WindowEvents.onMouseMove.bind(D)), WindowResize.observeIfRequired(D);
  }
}
const _GoogleFont = class dt {
  static appendStyleSheetToHead() {
    const D = document.getElementsByTagName("head")[0];
    if (!Array.from(D.getElementsByTagName("link")).some(
      (x) => x.getAttribute("href") === dt.FONT_URL
    )) {
      const x = document.createElement("link");
      x.rel = "stylesheet", x.href = dt.FONT_URL, D.appendChild(x);
    }
  }
};
_GoogleFont.FONT_URL = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap";
let GoogleFont = _GoogleFont;
class ParentResize {
  static doesOverflowNeedRerender(D, O) {
    if (!D._overflow)
      return !1;
    const { isHeightPercentage: x, isWidthPercentage: B } = D._overflow;
    return x && D._tableDimensions.recordedParentHeight !== O.offsetHeight || B && D._tableDimensions.recordedParentWidth !== O.offsetWidth;
  }
  static shouldRerenderTable(D) {
    const O = D.parentElement;
    return ParentResize.doesOverflowNeedRerender(D, O) ? !0 : D._tableDimensions.isPercentage && // resize callback gets triggered on multiple occassions when the parent width has not changed:
    // on startup, after table has been resized, when parent height is changed and when column height is changed
    // this condition prevents the table from re-rendering itself when the above occurs
    D._tableDimensions.recordedParentWidth !== O.offsetWidth && // if the parent is resized to a width that does not impact the table width, do not bother re-rendering it
    (D._tableDimensions.maxWidth === void 0 || D.offsetWidth > O.offsetWidth);
  }
  static resizeCallback() {
    const D = this;
    ParentResize.shouldRerenderTable(D) && (D._tableDimensions.preserveNarrowColumns || (D._tableDimensions.preserveNarrowColumns = !0, setTimeout(() => D._tableDimensions.preserveNarrowColumns = !1)), Render.renderTable(D));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = globalThis, i = t.trustedTypes, s$1 = i ? i.createPolicy("lit-html", { createHTML: (z) => z }) : void 0, e = "$lit$", h = `lit$${(Math.random() + "").slice(9)}$`, o = "?" + h, n = `<${o}>`, r$1 = document, l = () => r$1.createComment(""), c = (z) => z === null || typeof z != "object" && typeof z != "function", a = Array.isArray, u = (z) => a(z) || typeof (z == null ? void 0 : z[Symbol.iterator]) == "function", d = `[ 	
\f\r]`, f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, _ = />/g, m = RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), p = /'/g, g = /"/g, $ = /^(?:script|style|textarea|title)$/i, w = Symbol.for("lit-noChange"), T = Symbol.for("lit-nothing"), A = /* @__PURE__ */ new WeakMap(), E = r$1.createTreeWalker(r$1, 129);
function C(z, D) {
  if (!Array.isArray(z) || !z.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return s$1 !== void 0 ? s$1.createHTML(D) : D;
}
const P = (z, D) => {
  const O = z.length - 1, x = [];
  let B, U = D === 2 ? "<svg>" : "", F = f;
  for (let W = 0; W < O; W++) {
    const G = z[W];
    let Y, X, J = -1, Q = 0;
    for (; Q < G.length && (F.lastIndex = Q, X = F.exec(G), X !== null); )
      Q = F.lastIndex, F === f ? X[1] === "!--" ? F = v : X[1] !== void 0 ? F = _ : X[2] !== void 0 ? ($.test(X[2]) && (B = RegExp("</" + X[2], "g")), F = m) : X[3] !== void 0 && (F = m) : F === m ? X[0] === ">" ? (F = B ?? f, J = -1) : X[1] === void 0 ? J = -2 : (J = F.lastIndex - X[2].length, Y = X[1], F = X[3] === void 0 ? m : X[3] === '"' ? g : p) : F === g || F === p ? F = m : F === v || F === _ ? F = f : (F = m, B = void 0);
    const le = F === m && z[W + 1].startsWith("/>") ? " " : "";
    U += F === f ? G + n : J >= 0 ? (x.push(Y), G.slice(0, J) + e + G.slice(J) + h + le) : G + h + (J === -2 ? W : le);
  }
  return [C(z, U + (z[O] || "<?>") + (D === 2 ? "</svg>" : "")), x];
};
class V {
  constructor({ strings: D, _$litType$: O }, x) {
    let B;
    this.parts = [];
    let U = 0, F = 0;
    const W = D.length - 1, G = this.parts, [Y, X] = P(D, O);
    if (this.el = V.createElement(Y, x), E.currentNode = this.el.content, O === 2) {
      const J = this.el.content.firstChild;
      J.replaceWith(...J.childNodes);
    }
    for (; (B = E.nextNode()) !== null && G.length < W; ) {
      if (B.nodeType === 1) {
        if (B.hasAttributes())
          for (const J of B.getAttributeNames())
            if (J.endsWith(e)) {
              const Q = X[F++], le = B.getAttribute(J).split(h), re = /([.?@])?(.*)/.exec(Q);
              G.push({ type: 1, index: U, name: re[2], strings: le, ctor: re[1] === "." ? k : re[1] === "?" ? H : re[1] === "@" ? I : R }), B.removeAttribute(J);
            } else
              J.startsWith(h) && (G.push({ type: 6, index: U }), B.removeAttribute(J));
        if ($.test(B.tagName)) {
          const J = B.textContent.split(h), Q = J.length - 1;
          if (Q > 0) {
            B.textContent = i ? i.emptyScript : "";
            for (let le = 0; le < Q; le++)
              B.append(J[le], l()), E.nextNode(), G.push({ type: 2, index: ++U });
            B.append(J[Q], l());
          }
        }
      } else if (B.nodeType === 8)
        if (B.data === o)
          G.push({ type: 2, index: U });
        else {
          let J = -1;
          for (; (J = B.data.indexOf(h, J + 1)) !== -1; )
            G.push({ type: 7, index: U }), J += h.length - 1;
        }
      U++;
    }
  }
  static createElement(D, O) {
    const x = r$1.createElement("template");
    return x.innerHTML = D, x;
  }
}
function N(z, D, O = z, x) {
  var F, W;
  if (D === w)
    return D;
  let B = x !== void 0 ? (F = O._$Co) == null ? void 0 : F[x] : O._$Cl;
  const U = c(D) ? void 0 : D._$litDirective$;
  return (B == null ? void 0 : B.constructor) !== U && ((W = B == null ? void 0 : B._$AO) == null || W.call(B, !1), U === void 0 ? B = void 0 : (B = new U(z), B._$AT(z, O, x)), x !== void 0 ? (O._$Co ?? (O._$Co = []))[x] = B : O._$Cl = B), B !== void 0 && (D = N(z, B._$AS(z, D.values), B, x)), D;
}
class S {
  constructor(D, O) {
    this._$AV = [], this._$AN = void 0, this._$AD = D, this._$AM = O;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(D) {
    const { el: { content: O }, parts: x } = this._$AD, B = ((D == null ? void 0 : D.creationScope) ?? r$1).importNode(O, !0);
    E.currentNode = B;
    let U = E.nextNode(), F = 0, W = 0, G = x[0];
    for (; G !== void 0; ) {
      if (F === G.index) {
        let Y;
        G.type === 2 ? Y = new M(U, U.nextSibling, this, D) : G.type === 1 ? Y = new G.ctor(U, G.name, G.strings, this, D) : G.type === 6 && (Y = new L(U, this, D)), this._$AV.push(Y), G = x[++W];
      }
      F !== (G == null ? void 0 : G.index) && (U = E.nextNode(), F++);
    }
    return E.currentNode = r$1, B;
  }
  p(D) {
    let O = 0;
    for (const x of this._$AV)
      x !== void 0 && (x.strings !== void 0 ? (x._$AI(D, x, O), O += x.strings.length - 2) : x._$AI(D[O])), O++;
  }
}
class M {
  get _$AU() {
    var D;
    return ((D = this._$AM) == null ? void 0 : D._$AU) ?? this._$Cv;
  }
  constructor(D, O, x, B) {
    this.type = 2, this._$AH = T, this._$AN = void 0, this._$AA = D, this._$AB = O, this._$AM = x, this.options = B, this._$Cv = (B == null ? void 0 : B.isConnected) ?? !0;
  }
  get parentNode() {
    let D = this._$AA.parentNode;
    const O = this._$AM;
    return O !== void 0 && (D == null ? void 0 : D.nodeType) === 11 && (D = O.parentNode), D;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(D, O = this) {
    D = N(this, D, O), c(D) ? D === T || D == null || D === "" ? (this._$AH !== T && this._$AR(), this._$AH = T) : D !== this._$AH && D !== w && this._(D) : D._$litType$ !== void 0 ? this.$(D) : D.nodeType !== void 0 ? this.T(D) : u(D) ? this.k(D) : this._(D);
  }
  S(D) {
    return this._$AA.parentNode.insertBefore(D, this._$AB);
  }
  T(D) {
    this._$AH !== D && (this._$AR(), this._$AH = this.S(D));
  }
  _(D) {
    this._$AH !== T && c(this._$AH) ? this._$AA.nextSibling.data = D : this.T(r$1.createTextNode(D)), this._$AH = D;
  }
  $(D) {
    var U;
    const { values: O, _$litType$: x } = D, B = typeof x == "number" ? this._$AC(D) : (x.el === void 0 && (x.el = V.createElement(C(x.h, x.h[0]), this.options)), x);
    if (((U = this._$AH) == null ? void 0 : U._$AD) === B)
      this._$AH.p(O);
    else {
      const F = new S(B, this), W = F.u(this.options);
      F.p(O), this.T(W), this._$AH = F;
    }
  }
  _$AC(D) {
    let O = A.get(D.strings);
    return O === void 0 && A.set(D.strings, O = new V(D)), O;
  }
  k(D) {
    a(this._$AH) || (this._$AH = [], this._$AR());
    const O = this._$AH;
    let x, B = 0;
    for (const U of D)
      B === O.length ? O.push(x = new M(this.S(l()), this.S(l()), this, this.options)) : x = O[B], x._$AI(U), B++;
    B < O.length && (this._$AR(x && x._$AB.nextSibling, B), O.length = B);
  }
  _$AR(D = this._$AA.nextSibling, O) {
    var x;
    for ((x = this._$AP) == null ? void 0 : x.call(this, !1, !0, O); D && D !== this._$AB; ) {
      const B = D.nextSibling;
      D.remove(), D = B;
    }
  }
  setConnected(D) {
    var O;
    this._$AM === void 0 && (this._$Cv = D, (O = this._$AP) == null || O.call(this, D));
  }
}
class R {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(D, O, x, B, U) {
    this.type = 1, this._$AH = T, this._$AN = void 0, this.element = D, this.name = O, this._$AM = B, this.options = U, x.length > 2 || x[0] !== "" || x[1] !== "" ? (this._$AH = Array(x.length - 1).fill(new String()), this.strings = x) : this._$AH = T;
  }
  _$AI(D, O = this, x, B) {
    const U = this.strings;
    let F = !1;
    if (U === void 0)
      D = N(this, D, O, 0), F = !c(D) || D !== this._$AH && D !== w, F && (this._$AH = D);
    else {
      const W = D;
      let G, Y;
      for (D = U[0], G = 0; G < U.length - 1; G++)
        Y = N(this, W[x + G], O, G), Y === w && (Y = this._$AH[G]), F || (F = !c(Y) || Y !== this._$AH[G]), Y === T ? D = T : D !== T && (D += (Y ?? "") + U[G + 1]), this._$AH[G] = Y;
    }
    F && !B && this.j(D);
  }
  j(D) {
    D === T ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, D ?? "");
  }
}
class k extends R {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(D) {
    this.element[this.name] = D === T ? void 0 : D;
  }
}
class H extends R {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(D) {
    this.element.toggleAttribute(this.name, !!D && D !== T);
  }
}
class I extends R {
  constructor(D, O, x, B, U) {
    super(D, O, x, B, U), this.type = 5;
  }
  _$AI(D, O = this) {
    if ((D = N(this, D, O, 0) ?? T) === w)
      return;
    const x = this._$AH, B = D === T && x !== T || D.capture !== x.capture || D.once !== x.once || D.passive !== x.passive, U = D !== T && (x === T || B);
    B && this.element.removeEventListener(this.name, this, x), U && this.element.addEventListener(this.name, this, D), this._$AH = D;
  }
  handleEvent(D) {
    var O;
    typeof this._$AH == "function" ? this._$AH.call(((O = this.options) == null ? void 0 : O.host) ?? this.element, D) : this._$AH.handleEvent(D);
  }
}
class L {
  constructor(D, O, x) {
    this.element = D, this.type = 6, this._$AN = void 0, this._$AM = O, this.options = x;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(D) {
    N(this, D);
  }
}
const Z = t.litHtmlPolyfillSupport;
Z == null || Z(V, M), (t.litHtmlVersions ?? (t.litHtmlVersions = [])).push("3.1.2");
const j = (z, D, O) => {
  const x = (O == null ? void 0 : O.renderBefore) ?? D;
  let B = x._$litPart$;
  if (B === void 0) {
    const U = (O == null ? void 0 : O.renderBefore) ?? null;
    x._$litPart$ = B = new M(D.insertBefore(l(), U), U, void 0, O ?? {});
  }
  return B._$AI(z), B;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s extends b {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var O;
    const D = super.createRenderRoot();
    return (O = this.renderOptions).renderBefore ?? (O.renderBefore = D.firstChild), D;
  }
  update(D) {
    const O = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(D), this._$Do = j(O, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var D;
    super.connectedCallback(), (D = this._$Do) == null || D.setConnected(!0);
  }
  disconnectedCallback() {
    var D;
    super.disconnectedCallback(), (D = this._$Do) == null || D.setConnected(!1);
  }
  render() {
    return w;
  }
}
var pt;
s._$litElement$ = !0, s.finalized = !0, (pt = globalThis.litElementHydrateSupport) == null || pt.call(globalThis, { LitElement: s });
const r = globalThis.litElementPolyfillSupport;
r == null || r({ LitElement: s });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.0.4");
const activeTableStyle = i$2`
  /* this is used to shrink the width of the active-table element to the shadow-root width */
  :host {
    /* the following property prevents outside styles from affecting this component */
    all: initial;
    /* the following property is used to control the overall component width */
    display: inline-block;
  }

  table {
    border-spacing: 0px;
    position: relative;
    border: 1px solid #00000028;
    background-color: white;
  }

  /* REF-16 */
  .table-controlled-width {
    table-layout: fixed;
    /* fit-content does not work correctly in firefox when there are not enough columns to fit parent */
    width: min-content;
  }

  tbody {
    border-radius: inherit;
  }

  tbody > .row:first-child > *:first-child {
    border-top-left-radius: inherit;
  }

  /* using last-of-type as the last element is a divider which does not help with corner rounding */
  tbody > .row:first-child > .cell:last-of-type {
    border-top-right-radius: inherit;
  }

  #last-visible-row > *:first-child {
    border-bottom-left-radius: inherit;
  }

  #last-visible-row > .cell:last-of-type {
    border-bottom-right-radius: inherit;
  }

  .row {
    color: rgba(0, 0, 0, 0.87);
    font-size: 13px;
    font-weight: 400;
    /* the following is not supported in Firefox (on rows), hence rowHoverStyles will not have the border */
    border-radius: inherit;
  }

  tbody > .row:first-child {
    position: relative;
  }

  .row > *:first-child {
    border-left: none !important;
  }

  .row > .cell:last-of-type {
    border-right: none !important;
  }

  /* REF-25 */
  #last-visible-row > .cell {
    border-bottom: none !important;
  }

  .cell {
    text-align: left;
    padding: 11px 6px 6px;
    font-size: 14px;
    line-height: 17px;
    height: 42.5px;
    box-sizing: border-box;
    outline: none;
    overflow-wrap: anywhere;
    font-size: inherit;
    font-weight: inherit;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: rgba(0, 0, 0, 0.12);
    vertical-align: top;
    text-align: left;
    border-right: 1px solid #00000021;
    color: #222222;
  }

  .cell-text-div {
    outline: none;
    overflow-wrap: anywhere;
    border-radius: 4px;
    width: fit-content;
    /* need padding for the cursor to show up */
    padding-left: 1px;
  }

  .select-cell-text {
    float: left;
  }

  .arrow-down-icon-container {
    position: relative;
  }

  .arrow-down-icon {
    position: absolute;
    right: 2px;
    top: 5px;
    text-align: center;
    cursor: pointer;
  }

  .label-cell-text {
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .cell-divider {
    position: absolute;
    display: flex;
    justify-content: center;
  }

  .cell-divider > * {
    user-select: none;
    /* safari */
    -webkit-user-select: none;
    position: absolute;
    cursor: col-resize;
    justify-content: center;
    height: inherit;
  }

  /* this class needs to be after .cell to have style precendence */
  /* REF-1 */
  .header-cell {
    border-top: none !important;
    cursor: pointer;
    color: #626262;
    padding-top: 12px;
    padding-bottom: 12px;
    font-weight: 500;
  }

  .header-icon-container {
    float: left;
    pointer-events: none;
    /* the height is set to allow the text to be present below the icon when there is not enough space in the cell */
    height: 15px;
  }

  .header-icon-side-text {
    /* cannot use flex as pressing ENTER creates a new div */
    /* cannot use grid as it does not align in Safari */
    display: table-cell;
  }

  .not-selectable {
    user-select: none;
    /* safari */
    -webkit-user-select: none;
  }

  .column-sizer {
    /* need z-index for the sizer to display over header icon */
    z-index: 1;
    background-size: 20px 5px;
    position: absolute;
  }

  .column-sizer-filler {
    height: inherit;
    position: absolute;
    pointer-events: none;
  }

  .column-sizer-overlay {
    background-color: #ff000001;
    z-index: 1;
  }

  .movable-column-sizer {
    z-index: 1;
  }

  .movable-column-sizer-vertical-line {
    width: 1px;
    pointer-events: none;
  }

  #add-new-row-cell {
    padding-top: 8px;
    padding-left: 17px;
    min-height: 28px;
    line-height: 18px;
    font-size: 12px;
    color: #555555;
    vertical-align: middle;
    cursor: pointer;
  }

  .index-cell {
    text-align: center;
    padding: 11px 4px 0px !important;
  }

  .index-cell-overflow {
    overflow: hidden;
    overflow-wrap: normal;
  }

  #temp-invisible-index-number {
    color: #e2e2e200 !important;
  }

  .add-column-cell {
    cursor: pointer;
    text-align: center;
  }

  .header-cell-clone {
    position: absolute;
    cursor: move;
    top: 0px;
  }

  .header-cell-clone-animation {
    transition: 0.25s ease-out;
  }

  .cell-hidden {
    opacity: 0 !important;
  }

  .row-clone {
    position: absolute;
    display: flex;
    opacity: 0.8s;
  }

  .row-clone > * {
    cursor: move !important;
  }

  .row-drag-target-line {
    height: 4px;
    width: 100%;
    position: absolute;
    background-color: #69b0ff;
    pointer-events: none;
  }

  .root-cell {
    text-align: center;
    padding: 0px !important;
    border: none !important;
    // inheriting border radius as when frame components style background is set (add new row component), table border
    // radius is visibly not inherited
    border-radius: inherit;
  }

  .active-table-dropdown {
    position: absolute;
    box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(15 15 15 / 20%) 0px 9px 24px;
    border-radius: 5px;
    background-color: white;
    z-index: 1;
  }

  .active-table-dropup {
    box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 3px 6px,
      rgba(15, 15, 15, 0.2) 0px -2px 24px;
    top: unset !important;
    bottom: 100%;
  }

  .cell-dropdown {
    overflow: auto;
    white-space: nowrap;
  }

  .cell-dropdown::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  .cell-dropdown::-webkit-scrollbar-thumb {
    background-color: #aaaaaa;
    border-radius: 5px;
  }

  .cell-dropdown::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }

  .dropdown-item {
    padding-top: 3px;
    padding-bottom: 3px;
    padding-right: 5px;
    padding-left: 5px;
    color: #4b4b4b;
    position: relative;
    cursor: pointer;
    /* retaining the outline for dropdown input to make it easier to recognise */
    outline: none;
    font-size: 15px;
  }

  .cell-dropdown > .dropdown-item {
    /* the height of cell dropdown items seem to change depending on monitor size which inconsistently triggers overflow,
    this sets it to be consistent but ideally we should not do this and use a different way to allow any font sizes */
    height: 18px;
  }

  .dropdown-item-icon-container {
    display: flex;
    float: left;
    height: 90%;
    align-items: initial;
    padding-top: 2px;
    /* if items are not aligned in center - change align-items to center and revert changes
      in 0805a911cd5c7921aa05b13ffb9387d3d996c133 */
  }

  .dropdown-title-item {
    cursor: default;
    color: #7c7c7c;
    font-weight: 600;
    font-size: 0.75rem;
    margin-top: 2px;
  }

  .dropdown-input-item {
    text-align: center;
  }

  .dropdown-input {
    width: 92%;
    border: 1px solid grey;
    border-radius: 2px;
    color: #2d2d2d;
    font-size: 14px;
    padding: 3px;
    padding-top: 4px;
  }

  .dropdown-item-divider {
    border-bottom: 1px solid #d4d4d4;
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .dropdown-highlightable-item:hover {
    background-color: #eaeaea;
  }

  .active-dropdown-item {
    background-color: #4a69d4;
    color: white;
  }

  /* using different class as standard dropdowns use above class in their functionality */
  .active-static-dropdown-item {
    background-color: #4a69d4;
    color: white;
  }

  .active-dropdown-item:focus {
    background-color: #2148d5 !important;
    color: white !important;
  }

  /* Do not want to set default height incase user has set a font or a font-family so
    setting a placeholder text and making it invisible */
  .dropdown-item-empty {
    color: #ffffae00 !important;
  }

  .dropdown-disabled-item {
    pointer-events: none;
    color: #9e9e9e8a;
  }

  .cell-dropdown-option-button-container {
    position: absolute;
    width: 100%;
    height: 0px;
    top: 5px;
    left: -5px;
    display: none;
  }

  .cell-dropdown-option-button {
    height: 13px;
    width: 13px;
    position: sticky;
    z-index: 1;
    border-radius: 12px;
    opacity: 0.3;
    background-color: white;
  }

  .cell-dropdown-option-button:hover {
    opacity: 1;
  }

  .cell-dropdown-option-button:active {
    background-color: #f8f8f8;
  }

  .cell-dropdown-option-button > div {
    font-size: 12px;
    height: 11px;
    pointer-events: none;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cell-dropdown-option-delete-button-icon {
    font-size: 12.5px;
    width: 13px;
  }

  .cell-dropdown-option-color-button-icon {
    width: 12.5px;
  }

  .outer-container-dropdown {
    z-index: 2;
  }

  .color-input {
    width: 0px;
    height: 0px;
    padding: 0px;
    position: absolute;
    outline: none;
    pointer-events: none;
    opacity: 0;
    /* border unset stops color picker panel from appearing in safari */
  }

  .date-input-container {
    position: relative;
    float: right;
    cursor: pointer;
  }

  .date-input {
    top: 17px;
    width: 0px;
    height: 0px;
    border: unset;
    padding: 0px;
    right: 9px;
    position: absolute;
    outline: none;
  }

  .calender-icon-container {
    position: absolute;
    right: 2px;
    top: -4px;
    width: 15px;
    height: 25px;
    text-align: center;
  }

  #full-table-overlay {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }

  #drag-and-drop-overlay {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    height: calc(100% - 10px);
    width: calc(100% - 10px);
    background-color: #70c6ff4d;
    border: 5px dashed #6dafff;
    display: none;
    z-index: 2;
  }

  .filter-hidden-row {
    display: none;
  }

  .dropdown-cell-overlay {
    cursor: pointer;
    background-color: grey;
  }

  .column-dropdown-cell-overlay {
    transition: height 0.2s;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  .row-dropdown-cell-overlay {
    transition: width 0.2s;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  #pagination-button-container {
    right: 0;
    display: flex;
    width: fit-content;
    height: fit-content;
  }

  .pagination-button {
    border: 1px solid #0000004d;
    border-right: unset;
    color: #353535;
    min-width: 31px;
    height: 30.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 15.5px;
    /* REF-40 */
    stroke: black;
  }

  .pagination-prev-next-button {
    width: 14.25px;
    padding-left: 4px;
  }

  .pagination-first-last-button {
    width: 13px;
  }

  .pagination-button > * {
    pointer-events: none;
  }

  .pagination-button-disabled {
    pointer-events: none;
    color: #7c7c7c;
    /* REF-40 */
    stroke: #7c7c7c;
  }

  .pagination-button > svg > path {
    /* REF-40 */
    stroke: inherit;
  }

  #pagination-number-of-visible-rows {
    padding-top: 6px;
    color: #252525;
    min-width: 82px;
    text-align: center;
    font-size: 15.5px;
    padding-top: 7.5px;
  }

  #pagination-number-of-rows-select {
    position: relative;
    color: #1d1d1d;
    min-width: max-content;
  }

  #pagination-number-of-rows-select-text {
    font-size: 15.5px;
    float: left;
    margin-top: 6px;
  }

  #rows-per-page-select-button {
    display: inline-block;
    background-color: white;
    border: 1px solid #0000004d;
    border-radius: 4px;
    height: 24px;
    padding-top: 3px;
    padding-bottom: 0.5px;
    padding-left: 6px;
    padding-right: 1px;
    margin-top: 1px;
    cursor: pointer;
  }

  .outer-dropdown-button-arrow-container {
    pointer-events: none;
    color: #353535;
    font-size: 16px;
    float: right;
    margin: 1px;
    margin-left: -1px;
    width: 19px;
  }

  .outer-dropdown-button-arrow-icon {
    width: 16px;
    transform: scale(0.9, 1);
    filter: brightness(0) saturate(100%) invert(11%) sepia(3%) saturate(99%) hue-rotate(157deg) brightness(97%)
      contrast(98%);
    padding-top: 2px;
    padding-left: 2px;
  }

  #rows-per-page-select-button-text {
    display: inline-block;
    pointer-events: none;
    padding-top: 1px;
  }

  .number-of-rows-dropdown-item {
    padding-right: 12.5px;
    text-align: right;
  }

  .file-button-container {
    position: relative;
  }

  .file-button {
    border: 1px solid #00000038;
    border-radius: 3px;
    color: #464646;
    text-align: center;
    cursor: pointer;
    user-select: none;
    background-color: #f8f8f9;
    font-size: 14.5px;
    align-items: center;
    display: flex;
    height: 29px;
    padding: 0px 10px 1px;
  }

  .file-button-arrow-container {
    margin-right: -5px;
  }

  .file-button-arrow-container-icon {
    width: 17px;
    padding-top: 5px;
  }

  .export-formats-dropdown-item {
    padding: 4px 10px;
    font-size: 14.5px;
  }

  .hidden-row {
    line-height: 0px;
    height: 0px !important;
    user-select: none;
    pointer-events: none;
  }

  .hidden-row > * {
    line-height: 0px;
    height: 0px;
    padding: 0px !important;
    font-size: 0px;
    border-bottom-width: 0px !important;
  }

  .hidden-row > th > * {
    display: none;
  }

  .outer-container {
    display: grid;
    position: relative;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #outer-top-container > div > div > div > * {
    margin-bottom: 13px;
  }

  #outer-bottom-container > div > div > div > * {
    margin-top: 13px;
  }

  /* REF-38 */
  .outer-container-column {
    display: flex;
    width: 0px;
  }

  .outer-container-column-inner {
    display: flex;
  }

  .outer-container-column-content {
    display: flex;
    /* use -webkit-max-content if the below does not work */
    width: max-content;
  }

  .outer-container-left-column .outer-container-column-content > div {
    margin-right: 10px;
  }

  .outer-container-center-column {
    justify-content: center;
    position: absolute;
  }

  .outer-container-center-column .outer-container-column-content > div {
    margin-left: 5px;
    margin-right: 5px;
  }

  .outer-container-right-column {
    justify-content: end;
  }

  .outer-container-right-column .outer-container-column-content > div {
    margin-left: 10px;
  }

  /* right sibling */
  .pagination-button-active-precedence + div {
    border-left-color: #fafafa01 !important;
  }

  .sticky-header-body > *:first-child {
    top: 0;
    position: sticky !important;
  }

  .sticky-header-body > *:first-child > th {
    background-color: white;
  }

  #overflow-container {
    border: 1px solid #00000026;
  }

  /* REF-37 */
  .no-overflow-sticky-header-body {
    border-top: 1px solid #00000026;
  }

  /* REF-37 */
  .no-overflow-sticky-header-body > *:first-child {
    border-top: inherit;
  }

  /* REF-37 */
  .no-overflow-sticky-header-body > *:first-child > th {
    border-top: inherit !important;
  }

  .filter-rows-container {
    position: relative;
  }

  .filter-rows-input {
    width: 150px;
    height: 20px;
    border: 1px solid #0000002b;
    border-radius: 4px;
    color: rgb(45, 45, 45);
    font-family: inherit;
    padding: 5px 6px;
    font-size: 14px;
  }

  .filter-rows-input::placeholder {
    color: var(--active-table-filter-placeholder-color);
  }

  .filter-rows-dropdown-button {
    position: absolute;
    right: 4px;
    top: 51.6%;
    transform: translateY(-50%);
    cursor: pointer;
    user-select: none;
    filter: brightness(0) saturate(100%) invert(49%) sepia(0%) saturate(974%) hue-rotate(66deg) brightness(97%)
      contrast(96%);
    width: 16px;
    height: 16px;
  }

  .filter-rows-dropdown-button + .filter-rows-case-button {
    right: 15px;
  }

  .filter-rows-case-button + .filter-rows-input {
    padding-right: 30px;
    width: 129px;
  }

  .filter-rows-dropdown-button + .filter-rows-input {
    padding-right: 22px;
    width: 137px;
  }

  .filter-rows-dropdown-button + .filter-rows-case-button + .filter-rows-input {
    padding-right: 45px;
    width: 114px;
  }

  .filter-rows-case-button {
    position: absolute;
    right: 0px;
    top: 49%;
    transform: translate(-50%, -50%);
    color: grey;
    font-size: 13px;
    cursor: pointer;
    user-select: none;
  }

  .filter-rows-dropdown {
    min-width: 100% !important;
    width: max-content !important;
  }

  .filter-rows-dropdown > .dropdown-item {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .default-loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    width: 400px;
    border: 1px solid grey;
  }

  .loading-container-absolute {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .absolute-container {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .loading-spinner {
    width: 60px;
    height: 60px;
    border: 5px solid #38a4ff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  #error-container {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #ff000006;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #error-text {
    font-size: 24px;
    color: red;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
var __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __decorateClass = (z, D, O, x) => {
  for (var B = x > 1 ? void 0 : x ? __getOwnPropDesc(D, O) : D, U = z.length - 1, F; U >= 0; U--)
    (F = z[U]) && (B = (x ? F(D, O, B) : F(B)) || B);
  return x && B && __defProp(D, O, B), B;
};
let ActiveTable = class extends s {
  constructor() {
    super(), this.getData = () => JSON.parse(JSON.stringify(this.data)), this.getColumnsDetails = () => ColumnDetailsUtils.getAllColumnsDetails(this._columnsDetails), this.updateCell = (z) => {
      ProgrammaticCellUpdate.updateText(this, z);
    }, this.updateStructure = (z) => {
      ProgrammaticStructureUpdate.update(this, z);
    }, this.updateData = (z) => {
      UpdateAllTableData.update(this, z, 0);
    }, this.importFile = (z) => FileImportButtonEvents.triggerImportPrompt(this, z), this.exportFile = (z) => FileExportEvents.export(this, z), this.onCellUpdate = () => {
    }, this.onDataUpdate = () => {
    }, this.onColumnsUpdate = () => {
    }, this.onRender = () => {
    }, this.data = [
      // ['Planet', 'Diameter', 'Mass', 'Moons', 'Density'],
      // ['Earth', 12756, 5.97, 1, 5514],
      // ['Mars', 6792, 0.642, 2, 3934],
      // ['Jupiter', 142984, 1898, 79, 1326],
      // ['Saturn', 120536, 568, 82, 687],
      // ['Neptune', 49528, 102, 14, 1638],
    ], this.tableStyle = {}, this.allowDuplicateHeaders = !0, this.displayHeaderIcons = !0, this.spellCheck = !1, this.customColumnsSettings = [], this.dragRows = !0, this.dragColumns = !0, this.preserveNarrowColumns = !0, this.displayAddNewRow = !0, this.displayAddNewColumn = !0, this.displayIndexColumn = { wrapIndexCellText: !1 }, this.frameComponentsStyles = {}, this.dataStartsAtHeader = !1, this.columnResizerColors = {}, this.rowDropdown = { displaySettings: { isAvailable: !0, openMethod: { cellClick: !0 } } }, this.enterKeyMoveDown = !1, this._stickyProps = { header: !1 }, this._defaultColumnsSettings = {}, this._customColumnsSettings = {}, this._columnsDetails = [], this._addColumnCellsElementsRef = [], this._focusedElements = FocusedElementsUtils.createEmpty(), this._hoveredElements = {}, this._activeOverlayElements = ActiveOverlayElementsUtils.createNew(), this._eventFunctions = ElementEvents.getDefault(), this._userKeyEventsState = UserKeyEventsStateUtils.createNew(), this._tableDimensions = TableDimensionsUtils.getDefault(), this._globalItemColors = LabelColorUtils.generateGlobalItemColors(), this._defaultCellHoverColors = CellHighlightUtils.getDefaultHoverProperties(), this._frameComponents = FrameComponentsInternalUtils.getDefault(), this._rowDropdownCellOverlays = [], this._pagination = PaginationInternalUtils.getDefault(), this._files = FilesUtils.createDefault(this), this._visiblityInternal = {}, this._isRendering = !1, this._isPopulatingTable = !1, GoogleFont.appendStyleSheetToHead();
  }
  // CAUTION-4
  render() {
    Render.renderTable(this), this.onDataUpdate(this.data), new ResizeObserver(ParentResize.resizeCallback.bind(this)).observe(this.parentElement), FireEvents.onRender(this);
  }
  async update(z) {
    var O, x;
    PaginationAsyncUtils.preprocessTablePropertiesIfAsync(this), this._isPopulatingTable = !0, StickyPropsUtils.process(this), ColumnSettingsUtils.setUpInternalSettings(this), FrameComponentsInternalUtils.set(this), DefaultColumnTypes.createDropdownItemsForDefaultTypes(), RowDropdownSettingsUtil.process(this), this.pagination && await PaginationInternalUtils.process(this), this.stripedRows && StripedRows.process(this), this.rowHoverStyles && RowHoverEvents.process(this.rowHoverStyles, this._defaultCellHoverColors);
    const D = TableElement.createInfrastructureElements(this);
    this.overflow && OverflowUtils.setupContainer(this, D), TableElement.addOverlayElements(this, D, this._activeOverlayElements), PaginationAsyncUtils.removeLoadingOverlay(this), (x = this.shadowRoot) == null || x.appendChild(((O = this._overflow) == null ? void 0 : O.overflowContainer) || D), OuterTableComponents.create(this), InitialDataProcessing.preProcess(this, this.data), WindowElement.setEvents(this), this.spellcheck = this.spellCheck, this.auxiliaryStyle && this.shadowRoot && WebComponentStyleUtils.add(this.auxiliaryStyle, this.shadowRoot), setTimeout(() => this._isPopulatingTable = !1, 1), super.update(z);
  }
  connectedCallback() {
    Browser.IS_FIREFOX ? setTimeout(() => super.connectedCallback()) : super.connectedCallback();
  }
  // this is used to prevent a bug where the update method is called again (and adds another table) when a new property is
  // added - e.g. an event listener method
  shouldUpdate() {
    return !this._tableElementRef;
  }
};
ActiveTable._ELEMENT_TAG = "ACTIVE-TABLE";
ActiveTable.styles = [activeTableStyle];
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "getData", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "getColumnsDetails", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "updateCell", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "updateStructure", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "updateData", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "importFile", 2);
__decorateClass([
  n$1({ attribute: !1 })
], ActiveTable.prototype, "exportFile", 2);
__decorateClass([
  n$1({ converter: LITElementTypeConverters.convertToFunction })
], ActiveTable.prototype, "onCellUpdate", 2);
__decorateClass([
  n$1({ converter: LITElementTypeConverters.convertToFunction })
], ActiveTable.prototype, "onDataUpdate", 2);
__decorateClass([
  n$1({ converter: LITElementTypeConverters.convertToFunction })
], ActiveTable.prototype, "onColumnsUpdate", 2);
__decorateClass([
  n$1({ converter: LITElementTypeConverters.convertToFunction })
], ActiveTable.prototype, "onRender", 2);
__decorateClass([
  n$1({ type: Array })
], ActiveTable.prototype, "data", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "tableStyle", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "allowDuplicateHeaders", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "displayHeaderIcons", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "spellCheck", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "stickyHeader", 2);
__decorateClass([
  n$1({ type: Array })
], ActiveTable.prototype, "customColumnsSettings", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "rowHoverStyles", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "dragRows", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "dragColumns", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "preserveNarrowColumns", 2);
__decorateClass([
  n$1({ type: Number })
], ActiveTable.prototype, "maxColumns", 2);
__decorateClass([
  n$1({ type: Number })
], ActiveTable.prototype, "maxRows", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "displayAddNewRow", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "displayAddNewColumn", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "displayIndexColumn", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "frameComponentsStyles", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "dataStartsAtHeader", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "columnResizerColors", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "rowDropdown", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "stripedRows", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "overflow", 2);
__decorateClass([
  n$1({ type: String })
], ActiveTable.prototype, "defaultText", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "isDefaultTextRemovable", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "cellStyle", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "rootCell", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "isCellTextEditable", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "headerStyles", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "isHeaderTextEditable", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "headerIconStyle", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "isColumnResizable", 2);
__decorateClass([
  n$1({ type: Array })
], ActiveTable.prototype, "availableDefaultColumnTypes", 2);
__decorateClass([
  n$1({ type: Array })
], ActiveTable.prototype, "customColumnTypes", 2);
__decorateClass([
  n$1({ type: String })
], ActiveTable.prototype, "defaultColumnTypeName", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "columnDropdown", 2);
__decorateClass([
  n$1({
    type: Boolean,
    converter: LITElementTypeConverters.convertToBoolean
  })
], ActiveTable.prototype, "enterKeyMoveDown", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "pagination", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "loadingStyles", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "files", 2);
__decorateClass([
  n$1({ type: Object })
], ActiveTable.prototype, "filter", 2);
__decorateClass([
  n$1({ type: String })
], ActiveTable.prototype, "auxiliaryStyle", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_stickyProps", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_defaultColumnsSettings", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_customColumnsSettings", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_columnsDetails", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_tableElementRef", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_tableBodyElementRef", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_addRowCellElementRef", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_addColumnCellsElementsRef", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_focusedElements", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_hoveredElements", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_activeOverlayElements", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_eventFunctions", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_userKeyEventsState", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_tableDimensions", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_cellDropdownContainer", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_globalItemColors", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_defaultCellHoverColors", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_frameComponents", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_rowDropdownCellOverlays", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_stripedRows", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_overflow", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_pagination", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_files", 2);
__decorateClass([
  r$2()
], ActiveTable.prototype, "_visiblityInternal", 2);
__decorateClass([
  r$2({
    hasChanged() {
      return !1;
    }
  })
], ActiveTable.prototype, "_isRendering", 2);
__decorateClass([
  r$2({
    hasChanged() {
      return !1;
    }
  })
], ActiveTable.prototype, "_isPopulatingTable", 2);
ActiveTable = __decorateClass([
  t$2("active-table")
], ActiveTable);
export {
  ActiveTable
};
